import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const logo = (
    <Box
      sx={{
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 640 640"
        preserveAspectRatio="xMidYMid meet"
      >
        <g>
          <path
            fill="#FDFEFF"
            opacity="1.000000"
            stroke="none"
            d="
M368.000000,641.000000 
	C245.333359,641.000000 123.166710,641.000000 1.000049,641.000000 
	C1.000033,427.666718 1.000033,214.333450 1.000016,1.000135 
	C214.333237,1.000090 427.666473,1.000090 640.999756,1.000045 
	C640.999878,214.333191 640.999878,427.666382 640.999939,640.999756 
	C550.166687,641.000000 459.333344,641.000000 368.000000,641.000000 
M559.880737,272.457794 
	C559.221802,272.001404 558.562866,271.545044 558.000000,271.002106 
	C558.000000,271.002106 557.910461,271.095764 557.909607,270.356750 
	C556.059692,265.832428 552.997498,262.761841 547.988892,262.008881 
	C547.988892,262.008881 547.940369,262.041016 547.979553,261.271820 
	C546.911743,260.607178 545.843872,259.942535 544.853577,259.101685 
	C544.853577,259.101685 544.729065,259.248505 544.830444,258.521912 
	C541.766541,256.761841 538.702637,255.001740 535.278625,253.221176 
	C535.278625,253.221176 534.954956,253.061951 534.883667,252.334671 
	C534.091980,252.000961 533.300293,251.667236 531.983582,251.353561 
	C531.643860,251.272736 531.304077,251.191895 530.906311,250.387482 
	C526.718018,247.958237 522.792969,244.714264 518.289856,243.259537 
	C506.877869,239.572937 495.125458,237.252151 482.994049,237.219223 
	C483.255554,236.124008 483.156525,234.661560 483.837219,233.993317 
	C488.175873,229.733948 493.038422,225.961212 497.050385,221.428131 
	C501.988403,215.848709 506.429626,209.797729 510.674500,203.666031 
	C511.439606,202.560837 510.585022,199.910721 509.822083,198.281082 
	C508.917114,196.348114 507.302002,194.747635 505.926605,192.302200 
	C502.283203,187.871063 498.639771,183.439941 495.000000,179.000000 
	C495.000000,179.000000 494.991241,179.003571 494.698975,178.392715 
	C488.801361,174.592346 482.903748,170.791992 476.518890,166.684738 
	C476.013000,166.122955 475.507111,165.561172 474.917633,164.357300 
	C474.274780,163.911255 473.631927,163.465210 472.328613,163.011963 
	C471.888397,163.006653 471.448212,163.001328 470.900909,162.326996 
	C467.097687,159.431931 463.428253,156.334473 459.449738,153.704559 
	C456.150330,151.523529 452.486786,149.893387 448.330048,147.999695 
	C447.893768,147.988815 447.457458,147.977936 446.995239,147.227051 
	C440.130402,140.506088 431.296875,137.621521 422.420013,135.103668 
	C415.847839,133.239548 408.686371,133.107758 402.406921,130.632538 
	C391.146515,126.193886 379.520294,124.803345 367.678345,123.978310 
	C364.133911,123.731369 360.577850,123.482201 357.067963,122.959793 
	C354.050507,122.510658 351.104828,121.178467 348.103668,121.095444 
	C338.953369,120.842346 329.791595,120.991882 320.634369,121.017891 
	C319.315063,121.021637 317.962463,121.054466 316.683105,121.336403 
	C311.395111,122.501740 306.177521,124.063736 300.844940,124.933014 
	C291.085327,126.523941 281.065430,126.969902 271.557678,129.444244 
	C267.426514,130.519348 263.837128,132.555786 259.472290,131.062927 
	C259.056061,130.920563 258.318939,130.998581 258.040070,131.280380 
	C253.992325,135.369919 249.157410,137.918427 243.532990,139.110626 
	C242.915527,139.241516 242.503342,140.340820 241.502045,140.999725 
	C241.502045,140.999725 241.008148,141.007889 240.217331,141.096832 
	C238.610916,141.401596 236.969528,141.584274 235.404160,142.032379 
	C228.775101,143.930038 222.953644,147.078369 218.502060,153.002899 
	C218.502060,153.002899 218.004852,153.006714 217.180069,152.999878 
	C213.241287,152.682785 209.985703,153.484329 208.321442,158.002106 
	C207.547638,158.334732 206.773819,158.667374 205.359070,159.082397 
	C204.903946,159.720078 204.448837,160.357758 203.471741,161.403961 
	C203.309097,162.261185 203.146454,163.118393 202.324524,163.989838 
	C201.884872,163.998947 201.445221,164.008057 200.339111,164.003830 
	C199.894791,164.002701 199.450485,164.001572 198.616425,163.507797 
	C194.870270,166.332428 191.185608,169.244553 187.349533,171.941269 
	C185.671982,173.120575 183.684723,173.859344 181.838104,174.798172 
	C181.129608,173.208786 180.265930,171.668961 179.739838,170.021332 
	C177.615448,163.367950 176.236618,156.434570 169.013962,152.771408 
	C165.687637,151.084366 163.023239,148.139572 159.853485,146.081055 
	C157.451904,144.521393 154.816437,143.565384 152.909073,147.140045 
	C152.481857,147.940735 151.219315,148.868317 150.423721,148.798477 
	C147.358292,148.529434 144.326309,147.879578 140.783920,147.288635 
	C142.233307,136.828522 138.534576,127.872360 131.220383,121.435364 
	C126.213074,117.028572 125.709953,112.131584 124.838623,106.583717 
	C124.183098,102.409943 124.000374,97.247253 121.472054,94.465149 
	C115.479599,87.871201 109.398582,80.995071 98.943306,80.603760 
	C92.371727,80.357796 86.745537,80.983131 81.987373,85.692070 
	C80.896538,86.771614 80.052910,88.310547 78.756721,88.936226 
	C73.527870,91.460258 70.500648,95.490898 70.078674,101.215599 
	C69.785614,105.191376 70.061600,109.206375 69.991600,113.202240 
	C69.942635,115.997017 71.312218,117.146919 73.998688,117.674789 
	C74.011940,118.117065 74.025185,118.559349 73.517731,119.405304 
	C74.207306,125.418106 77.704811,129.201553 83.062347,131.581543 
	C84.882065,132.389923 87.039116,133.041046 88.266022,134.443069 
	C90.187965,136.639359 91.832840,136.942413 94.719307,136.388367 
	C100.580544,135.263321 109.096291,141.518494 109.802826,147.442627 
	C110.363426,152.143021 110.431023,157.045700 109.730652,161.710388 
	C109.101349,165.901733 107.128448,169.891342 105.774094,173.893524 
	C99.885887,170.807297 94.887688,167.731781 89.518158,165.585052 
	C87.189461,164.654053 83.293396,164.598022 81.520195,165.969208 
	C78.034004,168.665009 73.960037,170.304016 70.675209,173.568558 
	C62.923271,181.272614 56.499863,188.462585 60.678345,200.821030 
	C62.532448,206.304810 63.914696,212.169479 68.480728,215.242035 
	C73.003510,218.285507 78.936882,219.320038 84.352112,220.888535 
	C85.704117,221.280121 87.442986,220.336151 89.693398,220.070465 
	C90.795578,220.380920 91.897758,220.691376 93.097565,221.675339 
	C94.397873,222.450623 95.698174,223.225922 97.418144,224.582565 
	C98.575760,228.271027 100.641312,231.947968 100.688377,235.650543 
	C100.768570,241.959396 99.923882,248.348083 98.768929,254.573578 
	C98.252243,257.358704 97.797234,261.270691 93.059235,261.108521 
	C90.952148,261.036346 88.695694,261.381958 86.720306,262.113708 
	C79.464867,264.801361 71.999084,267.331512 70.580780,276.649780 
	C70.254623,278.792633 70.017212,281.437744 66.557281,281.258331 
	C66.188622,281.239166 65.212463,283.327423 65.370834,284.299042 
	C66.462990,290.999176 67.781761,297.662415 69.027008,304.333893 
	C70.570534,305.020691 73.398735,305.349030 74.114235,306.753601 
	C77.808525,314.005890 84.105049,315.866333 91.377907,315.973114 
	C99.882523,316.098022 109.756958,322.902008 111.021774,331.642365 
	C111.194496,332.835938 112.310844,333.892914 112.989799,335.673157 
	C112.989250,336.113495 112.988701,336.553833 112.217583,337.170258 
	C110.224312,341.294739 111.244011,350.422394 113.988380,353.947937 
	C113.992088,358.965302 113.995789,363.982635 113.426834,369.540314 
	C113.468506,372.132416 111.240685,375.198181 114.990364,377.902771 
	C115.000229,380.266113 115.010086,382.629425 115.010384,385.809479 
	C114.699638,391.742218 120.642319,396.852600 117.317902,403.261688 
	C117.093452,403.694427 118.329140,404.861511 118.849594,405.709259 
	C119.541946,406.836975 120.380249,407.917847 120.842041,409.137634 
	C124.356918,418.421570 127.799164,427.733063 131.254913,437.039337 
	C132.236282,439.682220 132.922302,442.477997 134.237549,444.939850 
	C135.264862,446.862732 137.386414,448.195099 138.443481,450.109222 
	C141.150803,455.011597 143.358795,460.192200 146.116959,465.063080 
	C147.727753,467.907745 150.011765,470.371155 152.067139,473.684784 
	C153.044556,474.456940 154.021973,475.229095 155.069244,476.705109 
	C156.377884,478.138367 157.686523,479.571625 159.109695,481.702026 
	C160.750412,484.644257 161.907333,488.039337 164.141449,490.426117 
	C167.798096,494.332642 172.179626,497.556091 176.201370,501.128479 
	C177.285995,502.091858 178.524078,503.119415 179.088501,504.386261 
	C180.663498,507.921417 183.314209,509.252625 187.070770,509.723633 
	C188.332611,513.545105 191.059753,515.175781 195.001633,515.768127 
	C195.815887,516.839905 196.445679,518.156799 197.480469,518.935486 
	C200.129517,520.928894 203.591263,522.169189 205.592087,524.633057 
	C210.700363,530.923645 217.489410,533.039062 225.072601,534.721863 
	C227.125992,536.156494 229.033951,537.894287 231.262634,538.963562 
	C236.112381,541.290283 240.976807,543.795227 246.110504,545.267395 
	C252.257492,547.030151 258.691528,547.791870 265.664978,548.999207 
	C266.107208,549.003174 266.549408,549.007141 267.116394,549.709229 
	C273.755951,554.545410 281.528412,555.969482 289.405731,556.924805 
	C290.878113,557.103333 292.465118,556.336792 294.661072,556.002380 
	C295.101868,556.009521 295.542633,556.016663 296.097046,556.783081 
	C300.413422,558.188354 304.643097,560.232544 309.068665,560.832886 
	C314.290436,561.541199 319.681610,561.000488 325.800110,561.002563 
	C326.866943,561.002136 327.933807,561.001709 329.800842,561.003784 
	C330.867004,561.002991 331.933197,561.002136 333.799683,561.005249 
	C334.866852,561.004333 335.934052,561.003418 337.725281,561.318542 
	C339.017059,561.516357 340.325012,561.958496 341.598175,561.874390 
	C355.401123,560.963013 369.198578,559.968994 383.840240,559.000549 
	C387.599884,557.972229 391.642242,557.480408 395.009094,555.706543 
	C396.912170,554.703918 397.916351,551.688721 398.939850,549.407104 
	C400.012909,547.015015 400.624817,544.416077 401.333649,542.230103 
	C407.377655,544.269653 412.498047,546.325439 417.801727,547.644226 
	C420.321655,548.270752 424.016876,549.648193 425.873596,545.000610 
	C427.450592,544.890320 429.027618,544.779968 431.979004,544.573486 
	C430.793243,541.193909 429.881195,538.594543 428.980835,535.328552 
	C428.985596,534.884094 428.990356,534.439575 429.640869,534.045105 
	C431.904388,535.079224 433.712372,529.879150 436.374939,533.799316 
	C443.391449,544.130005 460.457886,538.382874 463.226166,526.391602 
	C463.609192,524.732422 462.720245,522.791992 462.483459,520.973572 
	C462.280579,519.415527 462.168457,517.845642 462.016205,516.281006 
	C463.539795,516.976746 465.908691,517.286255 466.434906,518.437805 
	C468.320709,522.564392 471.578888,522.770020 475.411316,523.106262 
	C481.567902,523.646484 486.449249,521.853821 490.398407,517.156738 
	C491.114075,516.305420 492.250854,515.817871 493.155151,515.113464 
	C495.535645,513.259277 498.624176,511.833557 500.129059,509.424133 
	C505.018982,501.595215 505.814392,492.471130 505.874298,483.608490 
	C506.157532,441.710754 506.015411,399.810150 506.720642,358.025818 
	C508.815399,359.012482 510.910126,359.999115 513.078186,361.725250 
	C513.204407,363.954163 513.330627,366.183044 513.489685,368.990692 
	C516.532898,368.990692 519.555176,369.373077 522.429565,368.884796 
	C525.393921,368.381165 528.009338,367.740601 531.197449,368.640045 
	C532.601379,369.036102 535.294556,366.025757 536.905151,364.137695 
	C538.081970,362.758148 538.446106,360.685364 539.815674,359.262878 
	C543.921997,362.493896 547.870056,360.382111 552.397888,359.263123 
	C553.166748,360.245819 553.935547,361.228516 554.713013,362.222168 
	C552.607971,363.909454 550.772888,365.380371 548.654602,367.078247 
	C551.895691,369.606934 553.970520,369.748932 556.215393,366.733185 
	C559.242615,362.666382 561.151733,362.978638 564.289490,367.191650 
	C564.939575,368.064484 566.371582,368.527222 567.525146,368.745422 
	C567.861511,368.808990 569.034607,367.192657 568.861389,366.658752 
	C568.447266,365.382202 567.555847,364.213654 566.683472,363.142944 
	C565.114441,361.217224 563.454285,359.398010 567.613647,358.199036 
	C568.095581,358.758209 568.577515,359.317383 569.116882,360.604492 
	C570.593384,362.362518 572.132019,364.072754 573.531616,365.890015 
	C575.536377,368.492981 577.631226,368.638245 579.371643,365.875977 
	C580.272644,364.446106 580.435181,362.550964 580.959961,360.276703 
	C581.005737,359.886078 581.051575,359.495453 581.730957,359.059052 
	C582.156189,359.057220 582.581360,359.055420 583.125366,359.747437 
	C587.778625,361.965088 586.713745,358.283813 587.305420,355.277771 
	C587.867371,350.270752 588.582397,345.272217 588.861877,340.249481 
	C588.917603,339.248108 587.308838,338.154053 586.192078,336.193817 
	C586.212769,335.563477 586.233459,334.933167 586.417969,333.767487 
	C587.250916,332.782013 588.083923,331.796539 588.916931,330.811096 
	C588.007446,330.197174 587.097900,329.583252 586.084473,328.215546 
	C585.632568,327.137665 585.180603,326.059753 584.629272,324.430054 
	C584.602356,324.057495 584.575439,323.684937 584.798340,322.851135 
	C584.546509,322.535095 584.294678,322.219055 583.631042,321.452667 
	C583.281494,320.950348 582.931885,320.448029 582.778381,319.206665 
	C582.760559,318.186127 582.742798,317.165558 583.358398,315.726868 
	C582.573364,312.125977 581.041687,308.495819 581.181519,304.931213 
	C581.381897,299.824951 578.282654,297.523041 574.782288,294.522034 
	C574.746399,294.173737 574.710510,293.825470 574.821960,292.743286 
	C574.190247,292.182068 573.558533,291.620850 572.423096,290.691559 
	C571.882568,289.573975 571.342102,288.456421 570.929321,286.550537 
	C568.934326,284.050568 566.939331,281.550598 564.396362,278.757965 
	C563.601440,277.824188 562.806519,276.890381 562.013672,275.240631 
	C561.294434,274.539734 560.575195,273.838806 559.993469,272.997375 
	C559.993469,272.997375 559.861450,273.141388 559.880737,272.457794 
M591.857849,358.509644 
	C591.430969,358.206726 591.004089,357.903778 590.577209,357.600861 
	C590.463501,358.049133 590.349792,358.497406 590.236145,358.945648 
	C590.735779,358.999298 591.235474,359.052948 591.857849,358.509644 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M506.024933,357.910553 
	C506.015411,399.810150 506.157532,441.710754 505.874298,483.608490 
	C505.814392,492.471130 505.018982,501.595215 500.129059,509.424133 
	C498.624176,511.833557 495.535645,513.259277 493.155151,515.113464 
	C492.250854,515.817871 491.114075,516.305420 490.398407,517.156738 
	C486.449249,521.853821 481.567902,523.646484 475.411316,523.106262 
	C471.578888,522.770020 468.320709,522.564392 466.434906,518.437805 
	C465.908691,517.286255 463.539795,516.976746 462.016235,516.281006 
	C462.168457,517.845642 462.280579,519.415527 462.483459,520.973572 
	C462.720245,522.791992 463.609192,524.732422 463.226166,526.391602 
	C460.457886,538.382874 443.391449,544.130005 436.374939,533.799316 
	C433.712372,529.879150 431.904388,535.079224 429.311035,533.706299 
	C427.987244,533.424622 426.993256,533.481812 426.092468,533.379761 
	C426.269287,532.978455 426.413025,532.779846 426.724274,532.210815 
	C425.440674,525.381165 422.992676,521.844666 416.946747,521.048645 
	C416.961670,521.033813 416.962097,521.067200 416.880005,520.822388 
	C416.525421,520.377869 416.252899,520.178040 415.735229,519.790405 
	C414.675598,518.692261 413.861176,517.781982 413.035950,516.510132 
	C411.685455,513.953613 410.165558,511.846039 409.048340,509.543091 
	C407.382538,506.109344 404.887115,504.132721 400.924561,503.890167 
	C400.820343,503.786835 400.787384,503.495148 400.845123,503.065582 
	C401.252502,498.150024 398.979980,496.592010 394.878723,497.115479 
	C394.960754,497.063385 394.827820,497.205139 394.883087,496.819458 
	C394.084106,490.652008 390.307159,487.991058 384.952454,487.024658 
	C384.985962,486.998749 384.946777,487.073822 384.969421,486.659485 
	C385.562683,481.357758 382.696899,480.240234 378.626923,480.403107 
	C378.626556,480.362823 378.546112,480.367065 378.682617,479.985229 
	C377.733032,477.492157 377.181915,474.568695 375.454559,473.430878 
	C371.250183,470.661377 369.484222,464.107056 362.649231,464.992096 
	C362.139587,464.776947 361.960693,464.542206 361.932892,463.820923 
	C361.317017,458.622711 358.312103,455.886963 352.897827,455.080872 
	C352.933807,455.034271 352.918640,455.151031 352.814392,454.888245 
	C352.388672,454.449219 352.067230,454.272949 351.474243,453.930542 
	C349.442688,451.900665 347.682648,450.036987 345.953400,447.767456 
	C344.980438,445.213898 344.358429,442.748993 342.892731,440.985046 
	C339.909119,437.394287 336.658997,433.964722 333.139740,430.904510 
	C331.367737,429.363617 328.766785,428.775940 326.457642,427.685486 
	C326.374603,427.613770 326.247437,427.434875 326.464020,427.080872 
	C325.641510,426.062469 324.602417,425.398102 323.486176,424.669128 
	C323.409027,424.604553 323.276459,424.453125 323.467590,424.092438 
	C322.691864,423.195770 321.725006,422.659790 320.510101,422.039856 
	C319.829529,421.669067 319.397003,421.382202 318.962555,420.701599 
	C317.344604,418.277863 315.933472,416.030609 314.064636,414.268890 
	C311.256012,411.621216 308.126801,409.313629 305.091888,406.491455 
	C304.674255,405.075165 304.563141,403.793427 303.877350,403.023376 
	C300.857666,399.632538 297.186066,396.714264 294.697876,392.991638 
	C292.642883,389.917114 290.513672,388.537933 286.744385,388.945923 
	C286.130157,388.804565 285.781158,388.717651 285.350616,388.349152 
	C284.819519,387.425903 284.369904,386.784210 283.919861,385.954163 
	C283.629700,385.660492 283.339935,385.555206 282.827087,385.375977 
	C282.190369,385.078674 281.776764,384.855316 281.313293,384.379272 
	C281.132629,383.809662 281.001770,383.492706 280.910889,382.799377 
	C279.032806,380.552856 277.114716,378.682739 275.094025,376.528381 
	C274.389801,375.763855 273.788116,375.283539 273.133667,374.481781 
	C273.347809,371.772552 271.949158,371.543762 270.077393,371.518738 
	C267.603638,367.722626 265.566925,363.897186 262.663422,360.915863 
	C254.238327,352.264740 245.489990,343.926910 236.804443,335.532410 
	C235.388306,334.163727 233.646790,333.131714 232.155579,331.643311 
	C232.190903,330.605835 232.420044,329.560913 232.018265,329.178070 
	C224.384521,321.903595 216.380463,314.993500 209.056534,307.424042 
	C199.304001,297.344543 190.090286,286.744690 180.577972,276.430267 
	C179.629562,275.401886 178.216507,274.802002 176.915710,273.777283 
	C176.617203,273.263855 176.351669,273.075928 176.009583,272.990265 
	C176.003464,272.993042 176.019012,272.977722 176.016846,272.599640 
	C175.021561,270.806976 174.028412,269.392426 173.007294,267.753845 
	C172.979309,267.529816 172.952362,267.079102 172.980057,266.686951 
	C173.916992,264.881958 174.797348,262.336761 175.741989,262.312683 
	C177.290039,262.273224 179.044037,263.673767 180.422867,264.815277 
	C185.660568,269.151367 190.782654,273.627045 195.965149,278.381958 
	C196.322739,279.473846 196.663162,280.234344 197.039551,281.342651 
	C200.061356,284.115784 203.047150,286.541107 206.016479,288.983215 
	C206.000000,289.000000 206.032333,288.965881 206.054993,289.313782 
	C207.731964,291.094269 209.386292,292.526794 211.020599,293.979675 
	C211.000610,294.000000 211.042923,293.960876 211.032532,294.330231 
	C212.547028,297.678406 213.752441,301.008972 218.259247,301.144897 
	C219.356766,302.189911 220.171631,303.105835 221.023193,304.370819 
	C222.726074,306.468353 224.392227,308.216797 226.313171,310.071289 
	C227.045517,310.451538 227.523071,310.725769 228.031067,311.353394 
	C230.060822,313.793793 232.060104,315.880798 234.294006,317.970337 
	C234.528610,317.972839 234.996872,318.003113 234.999359,318.368652 
	C238.684494,322.812866 242.367157,326.891541 246.161301,331.180298 
	C246.468933,331.652313 246.720840,331.838928 247.055908,332.277069 
	C247.715088,333.075287 248.346863,333.546753 249.188629,334.279297 
	C250.266144,334.693207 251.133682,334.845978 252.010132,335.240906 
	C252.019028,335.483002 252.028137,335.967468 252.020691,336.343872 
	C253.661530,338.158905 255.309845,339.597473 256.973145,341.400146 
	C261.635895,346.657440 266.222321,351.610962 270.952576,356.423065 
	C274.196564,359.723206 277.640533,362.826752 281.290833,366.180573 
	C282.521881,367.700958 283.303436,369.202728 284.417206,370.393921 
	C292.666565,379.217010 300.927582,388.030579 309.296021,396.740448 
	C314.818237,402.487946 320.599426,407.986450 326.129547,413.726624 
	C332.637817,420.482056 338.908936,427.467133 345.459137,434.180634 
	C349.479248,438.300964 353.806396,442.124146 358.038727,446.034210 
	C361.667236,449.386444 365.356903,452.672485 369.018738,456.356384 
	C369.349304,457.637390 369.449280,458.754669 370.047760,459.430511 
	C376.157898,466.330719 382.145599,473.357056 388.567017,479.959625 
	C397.396973,489.038696 406.686066,497.670105 415.563782,506.704254 
	C422.753113,514.020264 429.533600,521.736694 436.667572,529.108948 
	C442.407349,535.040405 449.940491,535.326477 456.041443,529.808655 
	C457.009094,528.933533 456.692078,526.637939 456.787781,524.727661 
	C455.676910,523.918030 454.747223,523.379822 454.010895,522.539490 
	C454.427338,520.203552 455.484100,517.728027 454.691498,516.232605 
	C453.259033,513.530151 450.818573,511.319366 448.630737,509.066711 
	C432.094879,492.040924 415.518097,475.054932 398.963440,457.679047 
	C398.530212,454.206787 397.343658,451.947357 393.588501,452.487488 
	C393.555939,452.439240 393.459076,452.374542 393.596802,452.019043 
	C391.663055,448.195282 390.333588,443.902740 385.080811,443.939514 
	C385.033783,443.962555 385.083557,443.870361 385.066650,443.509949 
	C384.259766,442.562836 383.469788,441.976105 382.678711,441.354309 
	C382.677612,441.319214 382.607391,441.317261 382.702026,440.946320 
	C382.198883,437.216797 380.330505,435.278473 376.800842,435.117554 
	C376.808044,435.029755 376.826752,435.204559 376.776978,434.933685 
	C376.411865,434.510040 376.096527,434.357300 375.825989,434.211975 
	C375.870789,434.219391 375.770386,434.223419 375.803040,433.825745 
	C375.502197,428.331818 372.605896,426.120056 367.497070,426.087463 
	C367.072906,425.812927 366.908752,425.585785 366.846436,424.941223 
	C364.842133,422.795441 362.807739,421.015228 360.762024,419.168274 
	C360.750702,419.101562 360.807861,419.223969 360.747345,418.940674 
	C360.353271,418.496857 360.019745,418.336365 359.499603,418.074921 
	C359.078766,417.797791 358.916443,417.570343 358.873352,416.897186 
	C357.619873,414.647247 356.522278,412.598663 354.978333,410.974243 
	C351.148285,406.944550 346.010651,403.693420 343.525085,399.002594 
	C341.665436,395.493011 340.029755,394.889038 336.960388,395.031921 
	C336.997406,395.003906 336.940796,395.077454 336.930298,394.740479 
	C336.242737,393.966370 335.565674,393.529266 334.936462,393.047241 
	C334.984283,393.002319 334.910461,393.110748 334.908325,392.778839 
	C334.267670,391.963623 333.629120,391.480347 332.882874,390.757080 
	C332.532013,390.264343 332.288849,390.011536 331.975220,389.568756 
	C331.741943,389.141693 331.518402,389.001221 330.993958,388.698944 
	C324.963837,382.841461 319.097809,377.318512 313.399750,371.627411 
	C301.885651,360.127441 290.462769,348.536133 279.009155,336.584778 
	C279.120300,330.607422 274.295654,330.080780 270.905029,328.093811 
	C271.000702,328.005493 270.815552,328.189117 270.871918,327.800476 
	C269.596191,326.292328 268.264069,325.172760 266.964600,324.027191 
	C266.997223,324.001160 266.947998,324.068542 266.937683,323.730896 
	C266.250549,322.956726 265.573792,322.520203 264.944427,322.044556 
	C264.991852,322.005463 264.916534,322.102570 264.918732,321.720154 
	C263.711670,318.521301 263.985962,314.345795 258.984009,314.604492 
	C257.966309,313.832153 257.021790,313.391968 256.042023,312.972565 
	C256.006805,312.993378 256.048157,312.922791 256.053680,312.581421 
	C256.632019,308.060089 254.764343,306.501740 250.865967,307.156219 
	C251.006027,307.037140 250.727417,307.282104 250.792831,306.905273 
	C248.856323,303.418518 247.214783,299.983704 244.770432,297.272736 
	C240.820892,292.892487 235.812729,289.388763 232.295181,284.727386 
	C230.307861,282.093842 228.816437,280.647888 225.367859,281.030640 
	C223.039627,278.947723 220.998474,277.015198 218.953613,274.717346 
	C217.482132,267.517731 211.866608,264.103241 207.035080,260.109161 
	C204.799042,258.260712 202.189484,256.864075 199.850067,255.142365 
	C199.950851,255.022110 199.728928,255.244080 199.842209,254.889008 
	C199.677170,253.105042 199.840912,251.318130 199.031830,250.319031 
	C197.136246,247.978271 194.818787,245.967163 192.593201,243.907898 
	C186.460587,238.233597 180.142944,232.750519 174.179413,226.905197 
	C169.966110,222.775421 166.232452,218.158554 162.243210,213.797058 
	C159.850967,211.181580 157.378952,208.639069 154.923126,205.735260 
	C154.268982,204.933975 153.634491,204.461182 152.988113,203.672989 
	C152.953339,202.937347 152.930435,202.517120 152.971619,201.743820 
	C154.066025,200.960052 155.264694,199.954102 156.097672,200.197845 
	C159.782333,201.276093 163.361877,202.713623 167.022247,204.376038 
	C171.744385,210.302994 176.405853,215.890366 181.138748,221.416595 
	C181.497513,221.835495 182.363251,221.820221 183.001999,222.368958 
	C185.663773,224.830902 188.316879,226.930710 190.976593,229.416550 
	C192.517654,231.854904 193.778961,234.210602 195.647018,235.892349 
	C198.897171,238.818375 202.521790,241.328491 206.206390,244.122879 
	C206.693985,244.431870 206.882233,244.690811 206.990204,245.387894 
	C208.261124,249.867706 210.456360,253.069366 214.994751,253.999969 
	C214.999390,254.000610 215.000748,254.009567 215.006332,254.372650 
	C219.676804,259.485809 224.341705,264.235931 229.212250,269.245361 
	C230.274078,269.674652 231.130295,269.844635 231.994400,270.373199 
	C234.340485,273.147919 236.678650,275.564087 239.010132,277.990112 
	C239.003418,278.000000 239.024857,277.983307 239.021683,278.345825 
	C241.008362,280.474091 242.998215,282.239807 245.206757,284.116730 
	C245.698105,284.428833 245.888245,284.689880 246.036652,285.331360 
	C246.720566,286.097656 247.363663,286.543610 248.003372,286.994812 
	C248.000000,287.000000 248.010605,286.993103 248.040222,287.339294 
	C251.382584,290.787292 254.695297,293.889038 258.253571,297.155792 
	C258.675812,297.872437 258.852478,298.424103 259.059082,299.300354 
	C259.729523,300.078918 260.370087,300.532867 261.336151,300.996857 
	C262.095642,301.022949 262.529572,301.039062 263.009949,301.405243 
	C266.378265,305.492828 269.700165,309.230347 273.012268,312.982910 
	C273.002441,312.997955 273.032623,312.977997 273.055420,313.324829 
	C274.724426,315.107880 276.370636,316.544037 278.258728,317.988770 
	C278.500641,317.997314 278.984406,318.016571 278.992065,318.369446 
	C279.668701,319.479218 280.337738,320.236145 281.003357,320.996521 
	C281.000000,321.000000 281.007141,320.993500 281.037476,321.341431 
	C283.705627,323.797760 286.343445,325.906128 289.091370,328.233185 
	C289.402191,328.724670 289.663910,328.912445 290.024445,329.366638 
	C291.712524,331.471985 293.362823,333.225861 295.007202,334.989258 
	C295.001221,334.998779 295.020050,334.987122 295.052979,335.309967 
	C295.723511,336.088959 296.361145,336.545105 296.999390,337.000610 
	C297.000000,337.000000 296.998779,337.001221 297.002136,337.368225 
	C298.024506,341.961243 301.018616,344.020630 305.139557,345.311340 
	C307.375336,347.497742 309.570221,349.275879 311.522034,351.289642 
	C318.981812,358.986206 326.404907,366.719360 333.757874,374.517883 
	C337.921570,378.933868 341.922211,383.503601 346.033081,388.358734 
	C347.711639,390.141449 349.353363,391.569519 350.997559,392.998779 
	C351.000000,393.000000 351.002991,393.004883 351.054199,393.348328 
	C352.065094,394.131775 353.024750,394.571716 353.991638,395.005859 
	C353.998901,395.000000 353.988617,395.013367 353.994507,395.384766 
	C355.658813,397.512268 357.317200,399.268341 359.015381,401.367432 
	C361.364441,403.812622 363.673737,405.914795 365.991974,408.379639 
	C367.005157,409.823090 368.009399,410.903900 369.313660,412.014282 
	C370.102936,412.359802 370.592224,412.675720 371.117493,413.305481 
	C371.774414,414.072235 372.395355,414.525146 373.043396,415.335693 
	C373.308289,416.304321 373.396729,417.049347 373.806580,417.505920 
	C379.369598,423.703522 384.931763,429.904449 390.678040,435.929230 
	C391.053802,436.323212 392.924683,435.291199 394.350708,435.031616 
	C395.057648,435.441071 395.513916,435.741394 395.968872,436.441010 
	C395.863953,444.647705 403.254913,446.989166 407.006927,451.989746 
	C407.003174,451.997650 407.014923,451.989899 407.152161,452.293701 
	C409.864197,455.059479 412.438995,457.521423 415.256470,459.990845 
	C415.499115,459.998352 415.984222,460.018250 416.020813,460.365875 
	C418.175720,463.446198 420.087860,466.374390 422.455139,468.871002 
	C427.426056,474.113586 432.487946,479.290009 437.795380,484.186981 
	C441.968842,488.037689 446.566467,491.428680 450.983093,495.419189 
	C450.999603,496.870178 451.008728,497.925842 451.049438,499.331482 
	C454.390503,502.784637 457.700012,505.887756 461.379425,508.997437 
	C463.500366,510.668518 465.251404,512.333069 467.043335,514.319092 
	C467.726410,515.091248 468.368591,515.541870 469.409912,516.000977 
	C471.550781,516.507141 473.271332,517.103088 475.038300,517.483459 
	C479.692596,518.485413 484.173370,518.390259 488.322449,514.958862 
	C489.095673,514.283203 489.549591,513.648804 490.252960,513.010559 
	C490.502380,513.006714 491.001221,513.000000 491.398651,512.998535 
	C494.966705,513.352295 495.147644,511.308716 495.152161,508.695068 
	C500.264709,503.568176 501.144348,497.427612 500.947205,490.618744 
	C500.940521,489.870514 500.936493,489.442932 501.238495,488.743683 
	C502.026367,484.387421 502.915894,480.303925 502.926910,476.218079 
	C503.033173,436.833923 503.005493,397.449280 502.945496,358.064911 
	C502.942902,356.359070 502.253967,354.654236 501.897217,352.638885 
	C501.913849,351.915131 501.918091,351.501434 501.949585,350.736298 
	C501.976288,349.915497 501.975677,349.446167 502.190369,348.738159 
	C503.612061,351.636536 504.818512,354.773560 506.024933,357.910553 
z"
          />
          <path
            fill="#F8F9F9"
            opacity="1.000000"
            stroke="none"
            d="
M425.003662,545.004883 
	C424.016876,549.648193 420.321655,548.270752 417.801727,547.644226 
	C412.498047,546.325439 407.377655,544.269653 401.333649,542.230103 
	C400.624817,544.416077 400.012909,547.015015 398.939850,549.407104 
	C397.916351,551.688721 396.912170,554.703918 395.009094,555.706543 
	C391.642242,557.480408 387.599884,557.972229 383.480286,558.645630 
	C385.116302,557.334900 387.100250,556.352844 389.110596,555.428162 
	C395.084869,552.680237 396.705963,548.575256 393.990723,542.601440 
	C393.242737,540.247070 392.966614,537.874268 391.673401,536.384277 
	C387.224854,531.258850 382.590057,526.265503 377.692535,521.569824 
	C374.407288,518.419922 370.557526,515.858826 366.980164,513.017090 
	C367.000000,513.000000 366.965454,513.039429 366.981415,512.676147 
	C364.985260,510.555145 362.973175,508.797394 360.980530,507.019836 
	C361.000000,507.000000 360.960541,507.038635 360.947876,506.707153 
	C360.277100,505.930145 359.619019,505.484680 358.980469,505.019592 
	C359.000000,505.000000 358.960571,505.039246 358.952087,504.685181 
	C356.430511,500.350494 354.543579,495.696594 348.691376,494.899963 
	C347.952606,494.187164 347.468018,493.607727 346.999756,492.659576 
	C344.476715,486.960205 340.263367,483.417786 334.983459,481.013794 
	C334.989746,481.006165 334.978546,481.023407 334.990601,480.657684 
	C334.080475,478.789581 333.385559,477.069000 332.192688,475.826508 
	C328.865356,472.360840 325.214417,469.205078 321.899811,465.728088 
	C308.009735,451.157623 294.186310,436.523529 280.366760,421.886017 
	C278.666687,420.085266 277.069000,418.177124 275.540009,416.227661 
	C270.435272,409.719086 265.122620,403.433167 258.013550,398.568787 
	C256.082947,394.873779 254.934357,390.414551 252.078278,388.492340 
	C246.506042,384.742157 242.314026,380.190613 238.939697,374.557678 
	C238.093170,373.144501 236.516769,372.151794 235.223053,371.026489 
	C231.430466,367.727631 227.599243,364.473022 223.825424,361.153015 
	C223.524307,360.888092 223.442627,360.255005 223.437927,359.791168 
	C223.408035,356.837250 221.360733,355.053192 218.286835,354.308655 
	C217.012375,354.000000 216.002548,352.273041 215.055023,351.049622 
	C214.374390,350.170776 214.196350,348.376709 213.451675,348.158264 
	C208.345779,346.660522 205.142639,343.152405 202.199326,338.966400 
	C199.303360,334.847748 195.851547,331.118042 192.611588,327.244446 
	C191.695862,326.149628 190.756836,325.044220 189.675461,324.123383 
	C185.375320,320.461639 181.004547,316.882904 176.696289,313.230560 
	C176.361954,312.947113 176.421555,312.226898 176.106216,311.888428 
	C174.568954,310.238434 173.053864,308.548920 171.358749,307.070862 
	C170.060913,305.939209 168.541397,305.043671 167.055695,304.150940 
	C165.742035,303.361572 164.338928,302.721039 162.759705,301.907501 
	C162.275284,301.603882 162.088272,301.347809 161.951965,300.660461 
	C161.624298,293.200714 153.731384,291.347229 151.700500,284.919006 
	C155.172592,285.277405 158.159744,286.402863 161.113632,287.609680 
	C163.766098,288.693390 166.382050,289.866455 169.028229,291.228088 
	C169.042328,291.456055 169.049454,291.912781 169.070709,292.248260 
	C169.751022,293.040131 170.410095,293.496521 171.097443,294.173523 
	C171.125702,294.394135 171.128769,294.838959 171.130280,295.198792 
	C173.160751,297.833527 174.999832,300.322083 177.262939,302.333527 
	C180.698471,305.387024 184.428391,308.109253 188.274750,311.131287 
	C188.700623,311.825226 188.884979,312.360046 189.048965,313.276764 
	C193.028580,317.439240 197.028549,321.219849 201.205688,325.248230 
	C202.265076,326.315887 203.147293,327.135712 204.020386,328.331299 
	C206.873672,332.131744 209.582504,335.700256 212.628540,338.952972 
	C220.456497,347.312042 228.315567,355.648712 236.387268,363.770660 
	C243.479263,370.906738 251.105118,377.519348 258.078857,384.763885 
	C266.193207,393.193359 273.638977,402.266846 281.760834,410.688599 
	C295.398468,424.829773 309.314667,438.703186 323.189972,452.613159 
	C324.887054,454.314423 327.053345,455.547668 329.249786,457.000397 
	C329.497375,457.002991 329.992828,457.007690 330.026154,457.360809 
	C331.683075,458.844330 333.306671,459.974731 334.948425,461.423096 
	C334.984222,462.168274 335.001892,462.595490 335.047363,463.313538 
	C335.395325,464.054657 335.715393,464.504974 336.059387,465.305023 
	C338.459442,468.331482 340.797302,471.043427 343.220764,473.676575 
	C346.843536,477.612823 350.457703,481.561218 354.203247,485.379089 
	C357.959198,489.207550 361.955353,492.801117 365.691956,496.647491 
	C369.312012,500.373871 372.682892,504.341034 376.259216,508.111359 
	C380.557495,512.642761 385.002869,517.034668 389.299316,521.567749 
	C393.055023,525.530273 395.129242,531.198792 401.135254,533.331543 
	C404.388733,541.785706 412.006836,542.872681 419.404541,544.986023 
	C421.558502,544.997620 423.281097,545.001221 425.003662,545.004883 
z"
          />
          <path
            fill="#EFF0EE"
            opacity="1.000000"
            stroke="none"
            d="
M505.994659,193.003052 
	C507.302002,194.747635 508.917114,196.348114 509.822083,198.281082 
	C510.585022,199.910721 511.439606,202.560837 510.674500,203.666031 
	C506.429626,209.797729 501.988403,215.848709 497.050385,221.428131 
	C493.038422,225.961212 488.175873,229.733948 483.837219,233.993317 
	C483.156525,234.661560 483.255554,236.124008 482.681183,237.747360 
	C481.244446,239.132050 480.120575,239.988617 478.630737,240.942078 
	C474.076233,242.198914 470.279144,243.767990 469.598602,249.050049 
	C468.821686,250.743622 468.412628,252.365952 467.651917,253.955872 
	C462.645844,252.918167 459.633575,255.702713 456.685730,258.567413 
	C449.598145,265.455078 441.000305,267.451080 434.316101,262.698578 
	C428.593292,258.629608 423.588959,253.535736 418.374420,248.777267 
	C417.210358,247.714966 416.677185,245.974579 415.542450,244.864426 
	C411.039856,240.459473 403.078247,241.637772 399.756927,235.191742 
	C399.628998,234.943481 398.779633,235.142532 398.323639,234.976242 
	C392.824493,232.970749 386.891510,231.679947 381.951813,228.729309 
	C374.992096,224.572083 367.154327,223.964355 359.864258,223.406433 
	C349.396179,222.605286 338.799255,219.822433 328.089783,222.867554 
	C322.985779,224.318832 317.234009,223.630432 312.239655,225.299591 
	C302.468018,228.565414 292.315521,230.436829 282.990631,235.543365 
	C273.991974,240.471222 265.080475,245.318359 258.279205,252.940704 
	C257.140106,254.217285 251.059601,256.666321 255.931213,261.028870 
	C260.192657,264.845001 264.072388,269.086731 268.133179,273.127869 
	C272.162415,277.137604 276.277832,281.063568 280.223511,285.153534 
	C283.561371,288.613434 286.710602,292.255341 290.957092,296.933502 
	C293.253876,297.072327 296.765778,298.326355 297.398193,303.418457 
	C297.501007,304.246246 298.527252,305.025665 299.246155,305.700104 
	C305.244995,311.328186 311.346375,316.849060 317.268951,322.555695 
	C323.068451,328.143768 328.762421,333.845734 334.378998,339.618103 
	C341.070312,346.495026 347.631775,353.498383 354.245819,360.450470 
	C357.508423,363.879791 360.746155,367.332916 364.026642,370.744965 
	C366.226227,373.032806 368.530792,375.221069 370.694946,377.541077 
	C372.318390,379.281342 373.719971,381.228973 375.348480,382.964050 
	C379.300507,387.174652 383.264404,391.377838 387.341095,395.466766 
	C391.672119,399.810760 396.138672,404.019653 401.004486,408.731445 
	C401.564117,407.122986 401.944489,406.536224 401.946869,405.947968 
	C401.989929,395.266632 401.858887,384.583130 402.029724,373.904266 
	C402.212067,362.508362 402.400848,351.099213 403.143555,339.732239 
	C403.432495,335.310577 404.284760,330.362610 409.869446,329.329315 
	C409.498871,330.787842 409.268555,331.922058 409.025787,333.430115 
	C409.016479,334.553955 409.019684,335.303925 408.849731,336.121765 
	C408.607819,336.291168 408.459839,336.454010 408.483246,336.484253 
	C408.625153,336.667664 408.806152,336.820831 408.982422,337.318726 
	C408.981201,338.099487 408.971558,338.545624 408.569183,339.085541 
	C407.781372,341.022400 407.050110,342.864136 407.042755,344.708771 
	C406.959808,365.536163 407.166382,386.367126 406.803589,407.188568 
	C406.745697,410.509766 404.266418,413.788788 402.678650,417.088257 
	C402.450775,417.089203 402.009155,416.976562 401.898621,416.752686 
	C401.573517,416.245148 401.289154,416.087036 400.966858,416.030273 
	C400.998779,416.006104 400.935394,416.049194 400.930115,415.717896 
	C400.271240,414.939484 399.617615,414.492371 398.754333,413.926208 
	C398.283051,413.609253 398.080200,413.362946 397.931763,412.719666 
	C396.917694,411.606781 395.907990,410.842438 394.798492,409.806152 
	C394.120544,409.043976 393.542389,408.553711 392.842316,407.831726 
	C392.411804,407.463959 392.103180,407.327911 391.558655,407.032257 
	C390.858124,406.275940 390.393463,405.679199 389.928223,404.723145 
	C387.980896,402.557251 386.034180,400.750732 383.799713,398.782990 
	C381.684387,396.726532 379.856812,394.831299 377.925934,392.717407 
	C377.621735,392.224213 377.354095,392.055542 376.778870,391.834045 
	C376.034912,391.104187 375.531830,390.533081 375.026764,389.596863 
	C373.055786,387.461121 371.086792,385.690430 369.038147,383.738647 
	C368.958527,383.557556 368.843353,383.179016 368.869751,382.820953 
	C367.217957,381.029327 365.539703,379.595795 363.914307,378.097565 
	C363.967133,378.032867 363.837463,378.138184 363.864929,377.781219 
	C362.544678,376.341064 361.196960,375.257904 359.907715,374.105255 
	C359.966187,374.035767 359.825470,374.150604 359.855896,373.795013 
	C358.227051,371.984406 356.567749,370.529388 354.696228,369.003479 
	C354.484070,368.932556 354.078308,368.744110 353.983215,368.569214 
	C353.722748,368.174652 353.511169,368.017029 353.165131,367.710815 
	C353.076874,367.500122 352.950653,367.061035 352.951843,366.711304 
	C351.629913,365.245911 350.306824,364.130310 348.733582,362.872437 
	C347.984528,362.157623 347.485596,361.585052 346.968140,360.683960 
	C346.293182,359.909271 345.636780,359.463104 344.731384,358.872742 
	C343.988861,358.151459 343.495361,357.574432 342.981079,356.674774 
	C342.326202,355.889526 341.692078,355.426880 340.869873,354.747650 
	C340.124176,354.013733 339.566620,353.496368 338.898499,352.708313 
	C338.191925,351.958832 337.595886,351.480011 336.999908,351.000610 
	C337.000000,351.000000 336.998871,350.999817 336.994629,350.680664 
	C336.555145,349.984833 336.119965,349.608124 335.514832,349.173462 
	C335.344940,349.115540 335.038635,348.928223 335.007507,348.611084 
	C334.337708,347.850464 333.699005,347.407013 332.787933,346.814209 
	C331.702057,345.742645 330.888550,344.820374 330.069733,343.541260 
	C326.617218,339.869446 323.170044,336.554535 319.491058,333.082825 
	C318.753265,332.381348 318.247253,331.836700 317.802124,330.925049 
	C315.597992,328.688446 313.332977,326.818787 310.850098,324.838470 
	C310.354858,324.539886 310.146576,324.293579 309.986023,323.641449 
	C306.558594,320.294769 303.152496,317.295502 299.804443,314.199524 
	C299.862427,314.102844 299.704590,314.263916 299.781921,313.899139 
	C298.497589,312.437561 297.135925,311.340759 295.875488,310.140198 
	C295.976685,310.036469 295.756378,310.224731 295.816528,309.862000 
	C293.665680,307.621674 291.454712,305.744080 289.137451,303.613037 
	C288.928009,303.008362 288.824860,302.657135 288.705261,302.015839 
	C288.359924,301.572968 288.031006,301.420197 287.523682,301.210205 
	C287.345245,301.152985 287.024628,300.958984 287.000366,300.638672 
	C286.339264,299.866211 285.702423,299.414032 284.845581,298.738098 
	C283.664398,297.440887 282.703278,296.367432 281.791290,294.935974 
	C281.154572,294.142761 280.468719,293.707550 279.755066,293.263947 
	C279.727264,293.255524 279.669220,293.253052 279.738586,292.898987 
	C279.571350,291.942719 279.493103,291.183716 279.074860,290.761475 
	C270.525391,282.130066 261.962891,273.510895 253.309021,264.984680 
	C252.593674,264.279877 251.206451,264.256989 249.864716,263.785461 
	C249.292343,263.155914 248.986679,262.658203 248.964111,262.002808 
	C248.835983,260.572357 248.424744,259.299622 248.320923,257.871277 
	C250.358963,255.367691 251.779053,252.682190 253.886185,250.743393 
	C258.024506,246.935608 262.216614,243.003128 266.983612,240.104172 
	C274.320007,235.642670 282.184845,232.055573 289.760101,227.976120 
	C291.015015,227.300323 291.937073,226.006531 293.250275,224.991608 
	C293.487610,224.984894 293.962280,224.972214 294.395569,224.986206 
	C297.847595,224.351822 300.874908,223.740768 303.882416,223.043961 
	C306.603424,222.413513 309.270142,221.479050 312.018799,221.052429 
	C317.057159,220.270416 322.139709,219.774979 327.201202,219.139221 
	C332.666138,218.452759 338.156036,217.010941 343.584503,217.218811 
	C351.193756,217.510147 358.878754,218.479370 366.305664,220.157486 
	C374.357300,221.976746 382.136230,224.987885 390.066956,227.369949 
	C391.638489,227.841980 393.358856,227.818573 395.372925,228.023972 
	C396.816742,228.352814 397.898193,228.681305 399.032318,229.347534 
	C401.393127,231.446289 403.701294,233.207321 406.381073,234.983490 
	C409.505890,236.328064 412.259094,237.657501 415.055267,239.326492 
	C420.065887,243.445053 425.033569,247.224045 430.124023,251.266846 
	C430.830780,252.019821 431.414795,252.509003 432.037201,253.366638 
	C433.580750,257.969604 437.647095,257.891785 441.054138,259.372620 
	C444.767120,260.102325 448.700958,261.522705 451.242188,256.989868 
	C451.483185,256.980988 451.965485,256.973846 452.310150,256.951294 
	C453.435333,255.950226 454.215820,254.971710 455.251099,253.882111 
	C455.992798,253.505341 456.479706,253.239655 457.327637,252.950043 
	C460.135406,250.620071 462.582123,248.314041 465.345337,245.962738 
	C466.109100,245.280548 466.556366,244.643631 467.273224,243.774963 
	C467.703156,242.375137 467.863556,241.207062 468.293579,239.902313 
	C469.371918,239.174576 470.180664,238.583511 471.382080,237.996338 
	C474.633636,238.214294 476.223694,237.078979 476.004028,234.013977 
	C476.001801,234.006546 476.021271,234.006546 476.367859,233.972794 
	C480.809357,230.957733 484.904327,227.976425 489.343964,224.962463 
	C492.123138,222.284882 494.557617,219.639954 497.000305,216.632477 
	C499.004456,213.180069 501.000366,210.090210 502.998260,206.999146 
	C503.000244,206.997910 503.002441,206.981415 503.327026,206.944000 
	C503.771790,205.936188 503.891968,204.965775 504.006683,203.617691 
	C504.004486,202.483093 504.007751,201.726181 504.007965,200.738556 
	C504.004944,200.507843 503.998779,200.045700 504.227783,199.877640 
	C504.463409,199.084946 504.470001,198.460327 504.476562,197.835693 
	C504.301941,198.225555 504.127289,198.615433 503.728699,199.150833 
	C503.324371,199.780884 503.143982,200.265411 502.849304,200.806305 
	C502.734985,200.862686 502.506805,200.976410 502.390076,200.655167 
	C501.681244,199.406723 501.089172,198.479523 500.467804,197.202545 
	C500.272095,195.937057 500.105682,195.021347 499.964447,193.734497 
	C498.895508,191.643845 497.934875,189.819046 496.678955,188.227173 
	C494.203125,185.089005 491.563629,182.079987 489.210876,178.761383 
	C491.283722,178.671326 493.137482,178.837448 494.991241,179.003571 
	C494.991241,179.003571 495.000000,179.000000 495.003967,179.375870 
	C497.254395,185.342667 500.071411,190.460556 505.994659,193.003052 
z"
          />
          <path
            fill="#F6A720"
            opacity="1.000000"
            stroke="none"
            d="
M582.724976,316.145020 
	C582.742798,317.165558 582.760559,318.186127 582.389038,319.678711 
	C582.014343,322.846497 581.609680,325.633148 582.168274,328.211060 
	C582.671448,330.533295 584.230286,332.626801 585.584290,334.742065 
	C585.981445,334.542908 586.117798,334.422852 586.254150,334.302826 
	C586.233459,334.933167 586.212769,335.563477 586.180542,336.564026 
	C586.169006,336.934235 585.828003,336.939026 585.550598,337.243958 
	C585.291992,340.795197 585.310791,344.041504 585.316223,347.476532 
	C585.302856,347.665253 585.101196,347.985382 584.799438,348.001648 
	C584.299072,348.670715 584.100342,349.323517 583.912231,350.361633 
	C582.271240,356.644806 575.998474,358.206757 571.029297,353.553131 
	C570.384766,351.414154 569.743286,349.678833 569.081909,347.576630 
	C569.056091,346.475189 569.050110,345.740631 569.300354,344.780945 
	C568.913147,343.325256 568.269653,342.094727 567.492065,340.503021 
	C567.294861,339.118683 567.231812,338.095551 567.389160,336.881927 
	C567.740479,336.131165 567.871460,335.570831 568.267395,334.788422 
	C568.070312,332.701569 567.608276,330.836792 567.116516,328.528381 
	C566.883423,325.771637 566.760742,323.448151 566.462708,321.147369 
	C565.216675,311.529205 559.970276,303.727448 555.362671,295.489746 
	C548.816345,283.785919 539.046387,275.174988 528.155273,268.630096 
	C518.386047,262.759399 507.141266,258.892670 495.083069,258.867249 
	C489.328125,258.855103 483.513000,257.922180 477.858093,256.759674 
	C476.018280,256.381470 473.762817,254.203964 473.221039,252.393478 
	C472.665100,250.535751 473.274567,246.999619 474.603790,246.171127 
	C477.843018,244.152161 481.754059,242.267715 485.465576,242.120529 
	C498.422302,241.606720 510.447052,245.406830 522.412354,250.382797 
	C537.817017,256.789032 550.465088,266.456848 561.017883,279.051025 
	C569.149109,288.755249 575.427795,299.568451 578.968079,311.863220 
	C579.414490,313.413483 580.873962,314.672058 582.075684,316.124542 
	C582.287354,316.183319 582.724976,316.145020 582.724976,316.145020 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M567.113281,357.951630 
	C563.454285,359.398010 565.114441,361.217224 566.683472,363.142944 
	C567.555847,364.213654 568.447266,365.382202 568.861389,366.658752 
	C569.034607,367.192657 567.861511,368.808990 567.525146,368.745422 
	C566.371582,368.527222 564.939575,368.064484 564.289490,367.191650 
	C561.151733,362.978638 559.242615,362.666382 556.215393,366.733185 
	C553.970520,369.748932 551.895691,369.606934 548.654602,367.078247 
	C550.772888,365.380371 552.607971,363.909454 554.713013,362.222168 
	C553.935547,361.228516 553.166748,360.245819 552.163452,358.716187 
	C555.860168,353.426910 555.947632,347.809601 556.078308,341.999847 
	C556.427246,326.490845 550.278015,313.209991 542.438477,300.469879 
	C541.907288,299.606689 540.206482,299.463196 538.914185,298.880798 
	C538.778687,298.776581 538.652466,298.459137 538.742737,298.081604 
	C535.753723,294.900940 532.674438,292.097870 529.436157,289.222198 
	C529.277161,289.149597 529.054260,288.880280 529.048462,288.501923 
	C528.748047,287.206940 528.738953,285.845764 528.113525,285.444092 
	C523.182800,282.277283 518.454651,278.398315 513.046936,276.464752 
	C505.054596,273.607056 496.643219,271.428589 488.234985,270.415131 
	C483.335571,269.824615 478.094360,272.069641 472.968445,272.680664 
	C469.156708,269.041046 468.442627,265.257874 470.943939,260.860718 
	C471.232300,260.353821 471.023834,259.564270 471.425293,258.972198 
	C478.522858,260.050781 485.240845,261.062927 492.003540,262.360962 
	C492.700928,262.750000 493.353638,262.853119 494.379822,262.962524 
	C495.500061,262.982208 496.246857,262.995636 497.067993,263.375610 
	C500.261658,265.525421 503.398132,267.168610 507.379883,264.963928 
	C508.499756,265.037537 509.245911,265.092529 510.070190,265.495300 
	C511.448212,266.210938 512.748108,266.578827 514.365234,267.099030 
	C519.240051,269.549805 523.870728,271.716309 528.332581,274.187653 
	C532.026062,276.233398 535.520386,278.638885 539.059937,280.941284 
	C539.016968,280.997528 539.117920,280.897675 539.083618,281.265625 
	C542.365417,285.087799 545.681519,288.542053 548.998779,291.998169 
	C549.000000,292.000000 549.003235,292.003510 548.991699,292.373230 
	C552.415466,299.240204 555.830078,305.748657 559.331665,312.209961 
	C559.568420,312.646759 560.460876,312.728210 561.099609,313.267334 
	C561.195007,313.953033 561.239258,314.346313 561.194702,315.103149 
	C561.699524,316.338104 562.293213,317.209534 562.930664,318.395569 
	C563.000732,319.132721 563.026917,319.555298 562.770752,320.211853 
	C563.375305,329.455017 564.233765,338.467224 565.212891,347.466339 
	C565.277954,348.064148 566.260193,348.562134 566.863770,349.419067 
	C566.920105,350.153687 566.928528,350.575745 566.670776,351.245880 
	C566.640808,353.646484 566.877014,355.799072 567.113281,357.951630 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M241.995956,140.990967 
	C242.503342,140.340820 242.915527,139.241516 243.532990,139.110626 
	C249.157410,137.918427 253.992325,135.369919 258.040070,131.280380 
	C258.318939,130.998581 259.056061,130.920563 259.472290,131.062927 
	C263.837128,132.555786 267.426514,130.519348 271.557678,129.444244 
	C281.065430,126.969902 291.085327,126.523941 300.844940,124.933014 
	C306.177521,124.063736 311.395111,122.501740 316.683105,121.336403 
	C317.962463,121.054466 319.315063,121.021637 320.634369,121.017891 
	C329.791595,120.991882 338.953369,120.842346 348.103668,121.095444 
	C351.104828,121.178467 354.050507,122.510658 357.067963,122.959793 
	C360.577850,123.482201 364.133911,123.731369 367.678345,123.978310 
	C379.520294,124.803345 391.146515,126.193886 402.406921,130.632538 
	C408.686371,133.107758 415.847839,133.239548 422.420013,135.103668 
	C431.296875,137.621521 440.130402,140.506088 446.610291,147.608383 
	C443.146729,147.352432 440.068146,146.715149 436.595520,146.055313 
	C426.807343,143.015778 417.413269,139.998779 407.970154,136.614578 
	C406.430176,135.167297 405.076904,133.499817 403.423615,133.112259 
	C397.358582,131.690460 391.211609,130.587296 385.062134,129.564468 
	C377.323944,128.277374 369.577850,126.423241 361.791138,126.170593 
	C345.578949,125.644569 329.334900,125.853554 313.111115,126.150620 
	C310.055695,126.206566 307.033447,128.075272 303.676941,129.087006 
	C302.933258,129.070587 302.508575,129.074661 301.616089,129.052155 
	C290.322693,128.137863 280.309082,132.200272 269.973450,134.256180 
	C268.842590,134.481140 267.982635,136.067947 266.599243,137.029053 
	C261.141266,138.377228 256.081024,139.719452 250.807617,140.797974 
	C247.728271,140.686508 244.862122,140.838730 241.995956,140.990967 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M73.983521,117.011780 
	C71.312218,117.146919 69.942635,115.997017 69.991600,113.202240 
	C70.061600,109.206375 69.785614,105.191376 70.078674,101.215599 
	C70.500648,95.490898 73.527870,91.460258 78.756721,88.936226 
	C80.052910,88.310547 80.896538,86.771614 81.987373,85.692070 
	C86.745537,80.983131 92.371727,80.357796 98.943306,80.603760 
	C109.398582,80.995071 115.479599,87.871201 121.472054,94.465149 
	C124.000374,97.247253 124.183098,102.409943 124.838623,106.583717 
	C125.709953,112.131584 126.213074,117.028572 131.220383,121.435364 
	C138.534576,127.872360 142.233307,136.828522 140.783920,147.288635 
	C144.326309,147.879578 147.358292,148.529434 150.423721,148.798477 
	C151.219315,148.868317 152.481857,147.940735 152.909073,147.140045 
	C154.816437,143.565384 157.451904,144.521393 159.853485,146.081055 
	C163.023239,148.139572 165.687637,151.084366 169.013962,152.771408 
	C176.236618,156.434570 177.615448,163.367950 179.739838,170.021332 
	C180.265930,171.668961 181.129608,173.208786 181.838104,174.798157 
	C183.684723,173.859344 185.671982,173.120575 187.349533,171.941269 
	C191.185608,169.244553 194.870270,166.332428 198.655807,164.066772 
	C196.051468,167.149933 193.284134,169.560562 190.816467,172.246460 
	C189.593323,173.577820 188.921402,175.415588 187.773636,177.037018 
	C187.547180,177.049805 187.093506,177.054092 186.702789,177.036621 
	C185.019547,177.546188 183.643143,177.929886 182.450562,178.627716 
	C179.172897,180.545609 177.248505,179.580017 177.014008,175.735748 
	C176.934280,174.428680 177.277481,173.034378 176.938538,171.815933 
	C175.868179,167.967987 177.071014,163.026581 171.963608,160.654480 
	C170.258835,158.567352 168.589310,156.828201 166.681381,155.078247 
	C166.442993,155.067459 165.967133,155.031021 165.807404,154.702362 
	C156.828629,148.913483 147.798111,150.159729 137.713913,154.716278 
	C138.095657,151.185501 138.515274,148.902084 138.502014,146.621170 
	C138.496902,145.739899 137.509979,144.864304 136.950455,143.666687 
	C136.613159,142.560455 136.295792,141.773666 135.980133,140.747391 
	C135.981857,140.507919 135.957825,140.029556 135.970612,139.592056 
	C137.204849,133.102219 133.425659,129.314774 129.617706,125.737732 
	C124.119347,120.572807 119.825478,115.040321 120.911980,106.846069 
	C121.091263,105.493942 120.449745,103.990906 120.024269,102.607841 
	C118.022896,96.102226 114.007767,91.226326 107.959633,87.625618 
	C105.013153,86.035774 102.121689,83.844589 99.213051,83.821533 
	C94.593254,83.784920 89.167130,82.791191 85.688110,88.122849 
	C76.385101,94.112267 73.433105,102.730095 74.023003,113.383224 
	C74.003220,114.861313 73.993370,115.936546 73.983521,117.011780 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M539.172485,358.921570 
	C538.446106,360.685364 538.081970,362.758148 536.905151,364.137695 
	C535.294556,366.025757 532.601379,369.036102 531.197449,368.640045 
	C528.009338,367.740601 525.393921,368.381165 522.429565,368.884796 
	C519.555176,369.373077 516.532898,368.990692 513.489685,368.990692 
	C513.330627,366.183044 513.204407,363.954163 513.429382,361.347260 
	C525.342651,358.088867 527.321350,355.033081 524.039856,344.634766 
	C523.988159,343.504700 524.012878,342.747131 524.314087,341.743774 
	C524.547241,338.324738 525.241516,334.912354 524.306396,332.028198 
	C522.388062,326.111328 516.072876,321.857727 518.252075,313.239777 
	C515.212097,317.988007 513.557861,314.695038 511.673676,313.825256 
	C509.960541,313.034454 508.325714,312.073944 506.351379,311.149536 
	C505.383484,310.644867 504.720581,310.178864 504.022095,309.424500 
	C503.656250,308.431732 503.325958,307.727325 503.155029,306.708374 
	C504.799408,305.520813 506.284424,304.647736 507.308411,304.045715 
	C508.589233,306.240295 509.496521,307.794922 510.403839,309.349548 
	C511.272491,308.773560 512.141113,308.197540 513.009766,307.621521 
	C513.009766,305.723877 513.009766,303.826263 513.358276,301.959167 
	C518.535583,307.327332 524.606384,312.007141 527.871887,318.172699 
	C531.764648,325.522400 535.336365,333.705963 533.374268,342.733032 
	C533.250732,343.301270 533.528320,344.002136 533.749329,344.592651 
	C535.539490,349.375519 537.360718,354.146759 539.172485,358.921570 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M89.004044,220.006012 
	C87.442986,220.336151 85.704117,221.280121 84.352112,220.888535 
	C78.936882,219.320038 73.003510,218.285507 68.480728,215.242035 
	C63.914696,212.169479 62.532448,206.304810 60.678345,200.821030 
	C56.499863,188.462585 62.923271,181.272614 70.675209,173.568558 
	C73.960037,170.304016 78.034004,168.665009 81.520195,165.969208 
	C83.293396,164.598022 87.189461,164.654053 89.518158,165.585052 
	C94.887688,167.731781 99.885887,170.807297 105.774094,173.893524 
	C107.128448,169.891342 109.101349,165.901733 109.730652,161.710388 
	C110.431023,157.045700 110.363426,152.143021 109.802826,147.442627 
	C109.096291,141.518494 100.580544,135.263321 94.719307,136.388367 
	C91.832840,136.942413 90.187965,136.639359 88.266022,134.443069 
	C87.039116,133.041046 84.882065,132.389923 83.062347,131.581543 
	C77.704811,129.201553 74.207306,125.418106 74.075851,119.348755 
	C76.755981,120.861176 78.877991,122.430130 81.000000,123.999542 
	C81.000000,124.000000 81.000916,124.000000 81.041763,124.325111 
	C82.385498,125.770836 83.688385,126.891441 85.037857,128.376328 
	C87.725975,129.823608 90.367508,130.906616 93.452927,131.991364 
	C94.891548,131.995895 95.886635,131.982574 96.880959,132.004105 
	C103.737076,132.152557 112.091324,138.408554 113.383232,145.112579 
	C114.012405,148.377472 113.340752,151.940979 112.978821,155.339584 
	C112.045174,164.106720 110.956078,172.857300 109.821053,182.535583 
	C106.675743,181.102097 104.344444,180.039597 102.004532,178.611176 
	C99.808167,172.451569 97.327919,170.961594 89.571465,171.022705 
	C87.122536,171.366806 85.078011,171.712585 82.644371,172.037628 
	C81.144005,172.241409 79.840012,172.166702 78.952423,172.738449 
	C72.658829,176.792404 67.180336,181.071518 64.565796,189.004547 
	C61.989300,196.822174 64.087044,202.615067 68.190826,208.689590 
	C72.509140,215.081665 79.799698,214.795807 86.045761,217.305969 
	C87.060944,218.425339 88.032501,219.215668 89.004044,220.006012 
z"
          />
          <path
            fill="#E0B770"
            opacity="1.000000"
            stroke="none"
            d="
M561.283508,314.739594 
	C561.239258,314.346313 561.195007,313.953033 561.114624,312.879089 
	C557.053345,305.466766 553.028259,298.735138 549.003235,292.003510 
	C549.003235,292.003510 549.000000,292.000000 548.984680,291.646729 
	C545.685547,287.828217 542.401733,284.362946 539.117920,280.897675 
	C539.117920,280.897675 539.016968,280.997528 539.014832,280.602051 
	C531.883301,272.501617 522.874390,268.004364 512.789001,264.730530 
	C511.726440,264.355896 510.883392,264.220490 509.748840,263.913086 
	C508.600159,263.590271 507.742950,263.439453 506.572571,263.228394 
	C505.835785,263.132172 505.412109,263.096161 504.791992,262.777344 
	C503.704193,262.404053 502.812866,262.313599 501.563080,262.160645 
	C500.479736,262.049591 499.754883,262.001007 498.740021,261.685303 
	C493.694092,260.927765 488.948181,260.272156 484.180054,259.981506 
	C474.437622,259.387604 470.641937,256.543671 469.966461,248.978821 
	C470.279144,243.767990 474.076233,242.198914 479.046417,240.950256 
	C488.178192,241.204742 496.744507,240.501923 504.820648,242.171021 
	C513.768921,244.020386 522.269043,248.037750 530.964355,251.111053 
	C531.304077,251.191895 531.643860,251.272736 532.385376,251.634979 
	C533.509827,252.298248 534.232361,252.680099 534.954956,253.061951 
	C534.954956,253.061951 535.278625,253.221176 535.576416,253.555878 
	C538.825806,255.676544 541.777466,257.462524 544.729065,259.248505 
	C544.729065,259.248505 544.853577,259.101685 544.873779,259.494446 
	C545.909485,260.605164 546.924927,261.323090 547.940369,262.041016 
	C547.940369,262.041016 547.988892,262.008881 548.096497,262.342865 
	C551.439575,265.483154 554.674988,268.289459 557.910461,271.095764 
	C557.910461,271.095764 558.000000,271.002106 557.991516,271.359497 
	C558.609192,272.191711 559.235291,272.666534 559.861450,273.141388 
	C559.861450,273.141388 559.993469,272.997375 559.968628,273.376831 
	C560.633057,274.489746 561.322327,275.223175 562.011597,275.956604 
	C562.806519,276.890381 563.601440,277.824188 564.700684,279.250946 
	C566.937134,282.275574 568.869385,284.807220 570.801575,287.338837 
	C571.342102,288.456421 571.882568,289.573975 572.704163,291.194641 
	C573.548401,292.290863 574.111511,292.884003 574.674622,293.477173 
	C574.710510,293.825470 574.746399,294.173737 574.889587,295.139221 
	C577.285950,302.526184 579.575012,309.295990 581.864075,316.065765 
	C580.873962,314.672058 579.414490,313.413483 578.968079,311.863220 
	C575.427795,299.568451 569.149109,288.755249 561.017883,279.051025 
	C550.465088,266.456848 537.817017,256.789032 522.412354,250.382797 
	C510.447052,245.406830 498.422302,241.606720 485.465576,242.120529 
	C481.754059,242.267715 477.843018,244.152161 474.603790,246.171127 
	C473.274567,246.999619 472.665100,250.535751 473.221039,252.393478 
	C473.762817,254.203964 476.018280,256.381470 477.858093,256.759674 
	C483.513000,257.922180 489.328125,258.855103 495.083069,258.867249 
	C507.141266,258.892670 518.386047,262.759399 528.155273,268.630096 
	C539.046387,275.174988 548.816345,283.785919 555.362671,295.489746 
	C559.970276,303.727448 565.216675,311.529205 566.462708,321.147369 
	C566.760742,323.448151 566.883423,325.771637 567.070068,328.931702 
	C567.369751,331.522675 567.686096,333.266602 568.002441,335.010529 
	C567.871460,335.570831 567.740479,336.131165 567.076843,336.604065 
	C566.365906,334.894958 566.340271,333.238373 565.979370,331.658417 
	C565.085693,327.746216 564.038635,323.869080 563.053162,319.977875 
	C563.026917,319.555298 563.000732,319.132721 562.984009,318.045349 
	C562.423462,316.500275 561.853455,315.619934 561.283508,314.739594 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M112.990295,335.013153 
	C112.310844,333.892914 111.194496,332.835938 111.021774,331.642365 
	C109.756958,322.902008 99.882523,316.098022 91.377907,315.973114 
	C84.105049,315.866333 77.808525,314.005890 74.114235,306.753601 
	C73.398735,305.349030 70.570534,305.020691 69.027008,304.333893 
	C67.781761,297.662415 66.462990,290.999176 65.370834,284.299042 
	C65.212463,283.327423 66.188622,281.239166 66.557281,281.258331 
	C70.017212,281.437744 70.254623,278.792633 70.580780,276.649780 
	C71.999084,267.331512 79.464867,264.801361 86.720306,262.113708 
	C88.695694,261.381958 90.952148,261.036346 93.059235,261.108521 
	C97.797234,261.270691 98.252243,257.358704 98.768929,254.573578 
	C99.923882,248.348083 100.768570,241.959396 100.688377,235.650543 
	C100.641312,231.947968 98.575760,228.271027 97.210594,223.947968 
	C97.010406,222.854874 97.017769,222.396393 97.374496,221.988922 
	C98.904854,223.298843 100.165131,224.493744 101.246658,225.833008 
	C102.580414,227.484589 103.765396,229.256302 105.017258,231.314087 
	C105.033829,232.102203 105.047806,232.552353 104.763664,233.258255 
	C104.065819,235.254959 103.386604,236.984940 103.317635,238.738892 
	C103.091591,244.488113 103.087364,250.246048 102.995583,256.400665 
	C102.989975,257.866669 102.986664,258.932648 102.714828,260.235901 
	C101.366791,262.013702 100.310364,263.571106 99.199348,265.088562 
	C98.501564,266.041595 97.721909,266.934753 96.659988,267.859192 
	C95.922241,267.795990 95.503479,267.728302 95.046623,267.313782 
	C91.766785,263.580719 83.883644,265.425018 81.868347,270.214447 
	C81.431297,270.593567 81.141205,270.765015 80.525963,270.986755 
	C79.355682,272.244446 75.567787,270.767212 77.142174,274.470154 
	C76.870079,274.912781 76.651093,275.103760 75.949905,275.168549 
	C74.349976,276.316376 72.791069,277.352997 72.125542,278.800415 
	C71.481544,280.200989 71.978355,282.078644 71.592140,283.653046 
	C69.381264,292.665588 73.318405,303.582886 80.927689,308.761810 
	C82.037796,309.517334 83.617569,309.582825 85.283066,310.105835 
	C86.728546,310.162231 87.871002,310.080383 89.405365,310.002228 
	C90.842255,310.021881 91.887245,310.037872 93.019783,310.406616 
	C95.403404,311.513092 97.699471,312.266724 100.039490,313.339111 
	C100.725243,314.101227 101.367035,314.544647 102.004410,314.994019 
	C102.000000,315.000000 102.009506,314.990906 102.158905,315.297729 
	C104.880058,317.399811 107.451813,319.195099 110.242844,321.094513 
	C110.734985,321.397491 110.915611,321.659851 111.008881,322.389099 
	C111.672615,326.866028 112.331459,330.939606 112.990295,335.013153 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M539.494080,359.092224 
	C537.360718,354.146759 535.539490,349.375519 533.749329,344.592651 
	C533.528320,344.002136 533.250732,343.301270 533.374268,342.733032 
	C535.336365,333.705963 531.764648,325.522400 527.871887,318.172699 
	C524.606384,312.007141 518.535583,307.327332 512.986206,301.919067 
	C503.862701,299.680908 496.381104,294.185333 487.071350,294.544159 
	C482.324432,292.758362 477.685486,291.331512 473.027222,289.599915 
	C472.996948,288.889221 472.986023,288.483185 473.379700,288.036774 
	C477.982758,288.970062 482.195160,289.887665 486.376312,290.930634 
	C492.655090,292.496826 498.996063,293.883148 505.162109,295.818787 
	C522.122925,301.142944 530.919189,313.680908 534.623840,330.333130 
	C536.169861,337.282654 536.651855,344.509460 538.685181,351.290009 
	C539.493774,353.986267 542.881836,357.034027 545.653137,357.743378 
	C549.462280,358.718384 551.715820,354.994843 553.085144,351.687103 
	C553.827148,349.894958 554.077271,347.831207 554.211121,345.866913 
	C554.819458,336.937439 553.626892,328.182709 549.973450,320.039032 
	C546.742493,312.836945 542.721741,305.989166 539.049683,298.984985 
	C540.206482,299.463196 541.907288,299.606689 542.438477,300.469879 
	C550.278015,313.209991 556.427246,326.490845 556.078308,341.999847 
	C555.947632,347.809601 555.860168,353.426910 551.882935,358.537964 
	C547.870056,360.382111 543.921997,362.493896 539.494080,359.092224 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M151.992889,473.006104 
	C150.011765,470.371155 147.727753,467.907745 146.116959,465.063080 
	C143.358795,460.192200 141.150803,455.011597 138.443481,450.109222 
	C137.386414,448.195099 135.264862,446.862732 134.237549,444.939850 
	C132.922302,442.477997 132.236282,439.682220 131.254913,437.039337 
	C127.799164,427.733063 124.356918,418.421570 120.842041,409.137634 
	C120.380249,407.917847 119.541946,406.836975 118.849594,405.709259 
	C118.329140,404.861511 117.093452,403.694427 117.317902,403.261688 
	C120.642319,396.852600 114.699638,391.742218 115.355164,385.434937 
	C116.787178,385.377289 117.874397,385.694183 118.972626,386.385071 
	C118.988129,387.507812 118.992630,388.256622 118.997116,389.428772 
	C119.661407,391.902100 120.325714,393.952026 121.014458,396.273438 
	C121.071663,396.723694 121.104439,396.902466 121.135132,397.382324 
	C121.150024,398.084442 121.167000,398.485504 121.129227,399.228271 
	C121.063210,400.029144 121.051941,400.488312 121.035324,401.345520 
	C121.700638,404.899170 121.946167,408.228668 123.148254,411.166870 
	C124.693176,414.942993 127.005943,418.405029 129.002945,422.381348 
	C131.682007,428.838135 134.346054,434.915924 137.011169,441.348083 
	C137.672928,442.468964 138.333603,443.235504 138.997131,444.001007 
	C139.000000,444.000000 138.997665,444.005066 139.001709,444.378845 
	C140.332214,446.839111 141.658676,448.925568 142.992599,451.254944 
	C143.000076,451.497864 143.017258,451.983612 143.050903,452.353699 
	C144.391968,454.146606 145.699387,455.569458 147.262726,457.194855 
	C148.345978,458.932007 149.173294,460.466614 150.005035,462.383789 
	C151.344467,466.173920 152.679474,469.581482 153.677612,472.992249 
	C152.891449,472.999023 152.442169,473.002563 151.992889,473.006104 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M266.991638,549.011108 
	C266.549408,549.007141 266.107208,549.003174 265.112152,548.722168 
	C258.370514,545.967529 252.181686,543.489868 245.851715,540.717651 
	C244.803467,539.299500 243.896378,538.175842 243.318314,537.039551 
	C244.085739,537.030823 244.524109,537.034790 245.138458,537.345947 
	C253.534164,540.110901 261.753906,542.568787 270.059204,545.395691 
	C270.475128,546.115601 270.753418,546.694946 271.143524,546.783875 
	C279.991394,548.799683 288.806274,551.005493 297.723053,552.659973 
	C305.423676,554.088806 313.242767,554.879150 321.392731,555.920044 
	C325.852692,556.272949 329.929443,556.657471 333.894135,557.256226 
	C333.576904,557.733643 333.314697,557.914001 332.596252,558.008057 
	C331.132599,558.005981 330.068237,558.007446 328.603088,558.005432 
	C327.134003,558.002991 326.065735,558.004028 324.597443,558.003906 
	C323.130737,558.001831 322.063995,558.000977 320.767151,557.732239 
	C319.026215,557.643799 317.515411,557.823181 315.559509,558.002808 
	C308.737396,557.343262 302.360413,556.683533 295.983429,556.023743 
	C295.542633,556.016663 295.101868,556.009521 294.155518,555.674316 
	C292.804474,554.898376 292.006226,554.230103 291.106018,554.036926 
	C283.078094,552.314026 275.032227,550.674927 266.991638,549.011108 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M393.996338,542.987793 
	C396.705963,548.575256 395.084869,552.680237 389.110596,555.428162 
	C387.100250,556.352844 385.116302,557.334900 383.058929,558.644165 
	C369.198578,559.968994 355.401123,560.963013 341.598175,561.874390 
	C340.325012,561.958496 339.017059,561.516357 337.363098,560.773193 
	C337.006653,559.195435 337.012390,558.162964 337.476135,557.096680 
	C341.624023,557.054443 345.313904,557.046021 349.301208,557.328125 
	C355.368134,557.736328 361.168976,558.246460 366.892456,557.788818 
	C369.364929,557.591125 373.263672,558.280762 374.362671,554.047974 
	C375.126099,554.041992 375.562408,554.043213 376.161011,554.346558 
	C379.024323,556.903381 380.823273,556.025513 382.001892,552.996948 
	C381.996613,552.981873 381.985016,552.952148 382.359955,552.972168 
	C383.484558,552.989685 384.234222,552.987122 385.390198,552.992798 
	C392.049835,552.615356 392.973816,551.343750 393.266846,543.034546 
	C393.509735,543.014771 393.996338,542.987793 393.996338,542.987793 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M118.961624,386.011108 
	C117.874397,385.694183 116.787178,385.377289 115.359955,385.026550 
	C115.010086,382.629425 115.000229,380.266113 114.993607,377.028320 
	C114.664398,373.769226 114.331947,371.384613 113.999496,369.000000 
	C113.995789,363.982635 113.992088,358.965302 113.993111,353.013855 
	C113.661278,347.051270 113.324715,342.022705 112.988152,336.994171 
	C112.988701,336.553833 112.989250,336.113495 112.990051,335.343140 
	C112.331459,330.939606 111.672615,326.866028 111.369949,322.431580 
	C114.660469,324.319580 115.776245,327.264099 115.067650,331.278625 
	C115.681595,332.783173 116.329041,333.902832 116.980782,335.489380 
	C117.003105,342.290619 117.021141,348.624878 117.026215,355.222931 
	C117.014168,355.662750 117.015068,355.838776 117.005447,356.477142 
	C116.995804,359.920013 116.746956,362.932251 117.119438,365.865601 
	C117.270142,367.052338 118.777191,368.066864 119.745125,369.468567 
	C119.829384,370.200653 119.835533,370.623993 119.567734,371.324310 
	C119.187622,374.064697 119.081467,376.528046 118.703964,379.233398 
	C118.608955,381.653961 118.785294,383.832550 118.961624,386.011108 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M418.973175,544.978027 
	C412.006836,542.872681 404.388733,541.785706 401.180603,533.007080 
	C401.729218,531.900085 402.376282,531.440308 403.024872,530.958191 
	C403.026428,530.935913 403.072144,530.939941 403.087158,531.268066 
	C403.735229,532.067322 404.368225,532.538513 405.127838,533.269592 
	C405.831909,534.021240 406.409363,534.513062 407.030090,535.329346 
	C407.732025,536.093323 408.390686,536.532715 409.419617,537.024170 
	C420.018799,541.402405 420.781067,541.239990 424.267426,533.964478 
	C425.008850,533.769897 425.504059,533.654480 425.999268,533.538940 
	C426.993256,533.481812 427.987244,533.424622 428.988159,533.681274 
	C428.990356,534.439575 428.985596,534.884094 428.616577,535.726929 
	C426.663605,539.932007 424.627869,543.187561 419.866058,543.391663 
	C419.546356,543.405334 419.269806,544.425842 418.973175,544.978027 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M245.992874,541.012207 
	C252.181686,543.489868 258.370514,545.967529 264.780273,548.716187 
	C258.691528,547.791870 252.257492,547.030151 246.110504,545.267395 
	C240.976807,543.795227 236.112381,541.290283 231.262634,538.963562 
	C229.033951,537.894287 227.125992,536.156494 225.037811,534.358887 
	C225.003036,533.995972 225.012726,533.982910 225.418167,533.986694 
	C227.491287,534.439697 229.200241,534.774719 230.818985,535.359497 
	C235.895203,537.193115 240.937469,539.120911 245.992874,541.012207 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M186.991806,509.008545 
	C183.314209,509.252625 180.663498,507.921417 179.088501,504.386261 
	C178.524078,503.119415 177.285995,502.091858 176.201370,501.128479 
	C172.179626,497.556091 167.798096,494.332642 164.141449,490.426117 
	C161.907333,488.039337 160.750412,484.644257 159.060608,481.345276 
	C159.011505,480.988525 159.027451,480.972687 159.393127,480.983337 
	C160.988846,481.918671 162.328064,482.729736 163.429871,483.787964 
	C167.982864,488.160950 172.463928,492.608856 177.016815,497.373413 
	C178.374374,499.148376 179.710175,500.558380 180.993271,502.014801 
	C183.022629,504.318268 185.016708,506.652832 187.017365,508.982605 
	C187.009018,508.990967 186.991806,509.008545 186.991806,509.008545 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M241.748993,140.995346 
	C244.862122,140.838730 247.728271,140.686508 250.742004,141.150528 
	C250.705292,142.034012 250.582199,142.425476 250.327988,142.550598 
	C238.868256,148.191620 227.410095,153.836411 215.906647,159.387299 
	C214.769180,159.936172 213.346359,159.893738 212.136688,159.845551 
	C212.475281,159.042755 212.733154,158.520157 213.188934,157.727936 
	C214.926178,155.974457 216.465515,154.490585 218.004852,153.006714 
	C218.004852,153.006714 218.502060,153.002899 219.124298,152.996948 
	C220.788971,152.561844 221.844879,152.162506 222.871552,151.698471 
	C227.790665,149.475067 232.547363,146.702530 237.677521,145.211578 
	C240.471375,144.399612 241.207718,143.468994 241.008148,141.007889 
	C241.008148,141.007889 241.502045,140.999725 241.748993,140.995346 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M530.935303,250.749268 
	C522.269043,248.037750 513.768921,244.020386 504.820648,242.171021 
	C496.744507,240.501923 488.178192,241.204742 479.412354,240.853363 
	C480.120575,239.988617 481.244446,239.132050 482.677917,238.140839 
	C495.125458,237.252151 506.877869,239.572937 518.289856,243.259537 
	C522.792969,244.714264 526.718018,247.958237 530.935303,250.749268 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M448.984558,148.019180 
	C452.486786,149.893387 456.150330,151.523529 459.449738,153.704559 
	C463.428253,156.334473 467.097687,159.431931 470.626953,162.635803 
	C469.230469,162.301773 468.107910,161.658920 466.638763,160.975891 
	C464.523895,160.632843 462.755615,160.329956 460.638336,159.981812 
	C457.193451,157.964020 454.097565,155.991501 450.944153,153.663269 
	C450.252625,151.544769 449.618591,149.781967 448.984558,148.019180 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M224.996704,534.002625 
	C217.489410,533.039062 210.700363,530.923645 205.592087,524.633057 
	C203.591263,522.169189 200.129517,520.928894 197.480469,518.935486 
	C196.445679,518.156799 195.815887,516.839905 194.999481,515.385498 
	C194.997330,515.002869 195.006577,514.993530 195.329163,515.133667 
	C197.917465,516.594666 200.238205,517.830322 202.438919,519.251892 
	C209.986221,524.127136 217.491440,529.067444 225.012726,533.982910 
	C225.012726,533.982910 225.003036,533.995972 224.996704,534.002625 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M524.116272,345.007263 
	C527.321350,355.033081 525.342651,358.088867 513.392700,360.977539 
	C510.910126,359.999115 508.815399,359.012482 506.372803,357.968201 
	C504.818512,354.773560 503.612061,351.636536 501.933777,348.737488 
	C501.290833,348.967499 501.119751,348.959564 500.948853,348.568207 
	C500.939606,347.162445 500.930145,346.140106 501.190002,345.081909 
	C501.639465,345.034088 501.819641,345.022125 502.253418,344.903473 
	C502.987976,344.535492 503.468933,344.274200 504.232758,344.247528 
	C505.238647,346.846313 505.933319,349.219635 506.690979,351.572662 
	C507.970795,355.547272 509.675690,359.229065 514.813171,358.512756 
	C521.454163,357.586792 522.851990,355.859253 523.244873,349.235687 
	C523.329285,347.813995 523.815308,346.416107 524.116272,345.007263 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M320.997284,558.000122 
	C322.063995,558.000977 323.130737,558.001831 324.598083,558.378174 
	C324.998962,559.502869 324.999146,560.252075 324.999359,561.001282 
	C319.681610,561.000488 314.290436,561.541199 309.068665,560.832886 
	C304.643097,560.232544 300.413422,558.188354 296.040222,556.403442 
	C302.360413,556.683533 308.737396,557.343262 315.861572,558.130981 
	C318.071625,558.172729 319.534454,558.086426 320.997284,558.000122 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M267.054016,549.360168 
	C275.032227,550.674927 283.078094,552.314026 291.106018,554.036926 
	C292.006226,554.230103 292.804474,554.898376 293.824585,555.676392 
	C292.465118,556.336792 290.878113,557.103333 289.405731,556.924805 
	C281.528412,555.969482 273.755951,554.545410 267.054016,549.360168 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M240.612732,141.052368 
	C241.207718,143.468994 240.471375,144.399612 237.677521,145.211578 
	C232.547363,146.702530 227.790665,149.475067 222.871552,151.698471 
	C221.844879,152.162506 220.788971,152.561844 219.372879,152.994064 
	C222.953644,147.078369 228.775101,143.930038 235.404160,142.032379 
	C236.969528,141.584274 238.610916,141.401596 240.612732,141.052368 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M494.845093,178.698151 
	C493.137482,178.837448 491.283722,178.671326 488.897583,178.720551 
	C487.571899,178.290222 486.778625,177.644547 485.936768,176.655121 
	C484.928741,175.874634 483.969238,175.437927 482.723572,174.878082 
	C481.664215,174.480942 480.891052,174.206940 479.948090,173.666611 
	C478.841400,172.281189 477.904449,171.162109 476.977112,169.661789 
	C476.993195,168.517578 476.999664,167.754608 477.006104,166.991638 
	C482.903748,170.791992 488.801361,174.592346 494.845093,178.698151 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M585.101196,347.985382 
	C585.101196,347.985382 585.302856,347.665253 585.581909,347.140167 
	C585.849915,343.389740 585.838989,340.164368 585.828003,336.939026 
	C585.828003,336.939026 586.169006,336.934235 586.318298,337.018494 
	C587.308838,338.154053 588.917603,339.248108 588.861877,340.249481 
	C588.582397,345.272217 587.867371,350.270752 586.774475,355.630798 
	C585.742859,355.940826 585.242249,355.897766 584.778381,355.444763 
	C584.915833,353.376007 585.016479,351.717285 585.166626,349.713074 
	C585.177734,348.906891 585.139465,348.446136 585.101196,347.985382 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M419.404541,544.986023 
	C419.269806,544.425842 419.546356,543.405334 419.866058,543.391663 
	C424.627869,543.187561 426.663605,539.932007 428.610718,536.060181 
	C429.881195,538.594543 430.793243,541.193909 431.979004,544.573486 
	C429.027618,544.779968 427.450592,544.890320 425.438629,545.002747 
	C423.281097,545.001221 421.558502,544.997620 419.404541,544.986023 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M567.363464,358.075317 
	C566.877014,355.799072 566.640808,353.646484 566.965637,351.265808 
	C567.913696,351.107391 568.300720,351.177063 568.721313,351.544617 
	C568.807129,352.239807 568.859375,352.637085 568.907898,353.414124 
	C570.668335,360.655762 575.958679,358.986542 580.793152,358.775574 
	C580.894653,358.885254 581.097412,359.104828 581.097412,359.104828 
	C581.051575,359.495453 581.005737,359.886078 580.552368,360.604462 
	C576.449707,360.580353 572.754517,360.228485 569.059387,359.876587 
	C568.577515,359.317383 568.095581,358.758209 567.363464,358.075317 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M569.088135,360.240540 
	C572.754517,360.228485 576.449707,360.580353 580.538086,360.899109 
	C580.435181,362.550964 580.272644,364.446106 579.371643,365.875977 
	C577.631226,368.638245 575.536377,368.492981 573.531616,365.890015 
	C572.132019,364.072754 570.593384,362.362518 569.088135,360.240540 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M476.762512,166.838196 
	C476.999664,167.754608 476.993195,168.517578 476.623688,169.614319 
	C474.465363,169.722137 472.670074,169.496170 470.660645,169.313416 
	C470.115540,169.451065 469.953308,169.670517 469.983032,170.009094 
	C470.006317,170.003220 469.979309,169.963516 469.858093,169.773621 
	C469.537598,169.359360 469.333191,169.139771 469.060181,168.605255 
	C468.319763,167.870926 467.642761,167.456329 466.850037,166.832886 
	C466.524750,166.381348 466.287628,166.169632 466.053406,165.740616 
	C466.105804,165.327011 466.127655,165.161697 466.391846,164.744202 
	C466.751282,163.333374 466.868317,162.174713 466.985352,161.016068 
	C468.107910,161.658920 469.230469,162.301773 470.680511,162.970306 
	C471.448212,163.001328 471.888397,163.006653 472.703796,163.334106 
	C473.719727,164.103973 474.360474,164.551682 475.001221,164.999405 
	C475.507111,165.561172 476.013000,166.122955 476.762512,166.838196 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M582.075684,316.124542 
	C579.575012,309.295990 577.285950,302.526184 574.979492,295.387115 
	C578.282654,297.523041 581.381897,299.824951 581.181519,304.931213 
	C581.041687,308.495819 582.573364,312.125977 583.041687,315.935944 
	C582.724976,316.145020 582.287354,316.183319 582.075684,316.124542 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M448.657288,148.009430 
	C449.618591,149.781967 450.252625,151.544769 450.552765,153.662079 
	C448.706451,153.776001 447.194031,153.535446 445.503235,153.238510 
	C445.324921,153.182144 444.976044,153.047256 444.940308,152.697174 
	C442.266235,150.257339 439.627899,148.167587 436.989563,146.077850 
	C440.068146,146.715149 443.146729,147.352432 446.623230,147.978378 
	C447.457458,147.977936 447.893768,147.988815 448.657288,148.009430 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M505.960632,192.652618 
	C500.071411,190.460556 497.254395,185.342667 495.002136,179.380280 
	C498.639771,183.439941 502.283203,187.871063 505.960632,192.652618 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M112.602867,337.082214 
	C113.324715,342.022705 113.661278,347.051270 113.992828,352.548035 
	C111.244011,350.422394 110.224312,341.294739 112.602867,337.082214 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M188.000092,177.024246 
	C188.921402,175.415588 189.593323,173.577820 190.816467,172.246460 
	C193.284134,169.560562 196.051468,167.149933 198.850677,164.313095 
	C199.450485,164.001572 199.894791,164.002701 200.636276,164.354462 
	C200.294632,166.152222 199.655807,167.599350 198.815247,169.314804 
	C195.075699,172.063522 191.537903,174.543884 188.000092,177.024246 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M585.323608,334.821167 
	C584.230286,332.626801 582.671448,330.533295 582.168274,328.211060 
	C581.609680,325.633148 582.014343,322.846497 582.291016,320.048218 
	C582.931885,320.448029 583.281494,320.950348 583.815063,321.942627 
	C584.182190,322.725830 584.365356,323.019104 584.548523,323.312378 
	C584.575439,323.684937 584.602356,324.057495 584.471069,324.954956 
	C584.608643,326.650024 584.904480,327.820160 585.176208,329.409058 
	C585.209229,331.492279 585.266418,333.156738 585.323608,334.821167 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M212.991043,157.997559 
	C212.733154,158.520157 212.475281,159.042755 212.027771,160.045990 
	C211.650314,160.782303 211.406143,160.961029 210.740479,161.043518 
	C209.581711,161.681992 208.788116,162.339767 207.746429,162.999588 
	C207.498337,163.001633 207.002136,162.996033 206.655304,163.025620 
	C205.200256,163.362015 204.092041,163.668823 202.983810,163.975616 
	C203.146454,163.118393 203.309097,162.261185 204.054230,161.160034 
	C205.091156,160.277390 205.545578,159.638702 206.000000,159.000000 
	C206.773819,158.667374 207.547638,158.334732 209.058853,158.000763 
	C210.861191,157.998795 211.926117,157.998169 212.991043,157.997559 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M213.188934,157.727936 
	C211.926117,157.998169 210.861191,157.998795 209.396606,157.998474 
	C209.985703,153.484329 213.241287,152.682785 217.592468,153.003296 
	C216.465515,154.490585 214.926178,155.974457 213.188934,157.727936 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M81.000000,123.999084 
	C78.877991,122.430130 76.755981,120.861176 74.336205,119.146919 
	C74.025185,118.559349 74.011940,118.117065 73.991104,117.343285 
	C73.993370,115.936546 74.003220,114.861313 74.373093,113.454590 
	C76.822083,116.748428 78.911041,120.373756 81.000000,123.999084 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M557.910034,270.726257 
	C554.674988,268.289459 551.439575,265.483154 548.082153,262.368134 
	C552.997498,262.761841 556.059692,265.832428 557.910034,270.726257 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M194.990723,515.009644 
	C191.059753,515.175781 188.332611,513.545105 187.031281,509.366089 
	C186.991806,509.008545 187.009018,508.990967 187.379150,508.992828 
	C189.494675,509.667847 191.240067,510.341034 193.017120,511.338959 
	C193.701355,512.773682 194.353973,513.883606 195.006577,514.993530 
	C195.006577,514.993530 194.997330,515.002869 194.990723,515.009644 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M202.654175,163.982727 
	C204.092041,163.668823 205.200256,163.362015 206.627838,163.378098 
	C204.303787,165.482803 201.660385,167.264633 199.016983,169.046463 
	C199.655807,167.599350 200.294632,166.152222 200.969513,164.361130 
	C201.445221,164.008057 201.884872,163.998947 202.654175,163.982727 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M89.348724,220.038239 
	C88.032501,219.215668 87.060944,218.425339 86.475769,217.306396 
	C89.779968,217.372894 93.970428,215.443008 93.822708,220.955994 
	C93.365730,220.983383 93.182838,220.992615 92.999947,221.001831 
	C91.897758,220.691376 90.795578,220.380920 89.348724,220.038239 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M544.779785,258.885193 
	C541.777466,257.462524 538.825806,255.676544 535.756470,253.566116 
	C538.702637,255.001740 541.766541,256.761841 544.779785,258.885193 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M570.865479,286.944702 
	C568.869385,284.807220 566.937134,282.275574 564.974609,279.397278 
	C566.939331,281.550598 568.934326,284.050568 570.865479,286.944702 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M584.741577,355.854736 
	C585.242249,355.897766 585.742859,355.940826 586.620544,355.988892 
	C586.713745,358.283813 587.778625,361.965088 583.079346,359.066345 
	C583.038208,357.941040 583.043152,357.496826 583.186340,356.816925 
	C583.796936,356.339081 584.269287,356.096924 584.741577,355.854736 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M585.584351,334.742065 
	C585.266418,333.156738 585.209229,331.492279 585.423218,329.417480 
	C585.694336,329.007080 586.188416,328.969360 586.188416,328.969360 
	C587.097900,329.583252 588.007446,330.197174 588.916931,330.811096 
	C588.083923,331.796539 587.250916,332.782013 586.336060,334.035156 
	C586.117798,334.422852 585.981445,334.542908 585.584351,334.742065 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M113.713165,369.270142 
	C114.331947,371.384613 114.664398,373.769226 114.992081,376.585449 
	C111.240685,375.198181 113.468506,372.132416 113.713165,369.270142 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M159.003326,480.996704 
	C157.686523,479.571625 156.377884,478.138367 155.034973,476.351929 
	C155.000717,475.998779 155.006287,475.993896 155.380157,475.995911 
	C156.502075,475.998627 157.250122,475.999298 158.276947,476.247864 
	C158.712967,477.988068 158.870209,479.480377 159.027451,480.972687 
	C159.027451,480.972687 159.011505,480.988525 159.003326,480.996704 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M337.018127,557.130493 
	C337.012390,558.162964 337.006653,559.195435 337.001038,560.615173 
	C335.934052,561.003418 334.866852,561.004333 333.399536,560.629272 
	C332.998108,559.505981 332.996826,558.758789 332.995544,558.011536 
	C333.314697,557.914001 333.576904,557.733643 334.270721,557.249634 
	C335.512268,557.062683 336.265198,557.096558 337.018127,557.130493 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M325.399719,561.001953 
	C324.999146,560.252075 324.998962,559.502869 324.998108,558.379395 
	C326.065735,558.004028 327.134003,558.002991 328.601990,558.379089 
	C329.001373,559.504578 329.001007,560.252930 329.000641,561.001282 
	C327.933807,561.001709 326.866943,561.002136 325.399719,561.001953 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M329.400757,561.002563 
	C329.001007,560.252930 329.001373,559.504578 329.002777,558.382568 
	C330.068237,558.007446 331.132599,558.005981 332.596252,558.008057 
	C332.996826,558.758789 332.998108,559.505981 332.999390,560.627258 
	C331.933197,561.002136 330.867004,561.002991 329.400757,561.002563 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M93.048752,221.338593 
	C93.182838,220.992615 93.365730,220.983383 94.148849,220.966309 
	C95.507759,221.284958 96.266449,221.611435 97.025131,221.937912 
	C97.017769,222.396393 97.010406,222.854874 97.000763,223.657288 
	C95.698174,223.225922 94.397873,222.450623 93.048752,221.338593 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M586.136475,328.592468 
	C586.188416,328.969360 585.694336,329.007080 585.447327,328.998657 
	C584.904480,327.820160 584.608643,326.650024 584.520752,325.230896 
	C585.180603,326.059753 585.632568,327.137665 586.136475,328.592468 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M152.030014,473.345428 
	C152.442169,473.002563 152.891449,472.999023 153.923767,472.995300 
	C154.506790,472.995117 154.999390,473.002441 154.999557,473.376404 
	C155.001907,474.498230 155.004105,475.246063 155.006287,475.993896 
	C155.006287,475.993896 155.000717,475.998779 155.000046,476.000000 
	C154.021973,475.229095 153.044556,474.456940 152.030014,473.345428 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M547.959961,261.656433 
	C546.924927,261.323090 545.909485,260.605164 544.835083,259.582550 
	C545.843872,259.942535 546.911743,260.607178 547.959961,261.656433 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M591.796509,358.808105 
	C591.235474,359.052948 590.735779,358.999298 590.236145,358.945679 
	C590.349792,358.497406 590.463501,358.049133 590.577209,357.600861 
	C591.004089,357.903778 591.430969,358.206726 591.796509,358.808105 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M562.012634,275.598633 
	C561.322327,275.223175 560.633057,274.489746 559.899902,273.447083 
	C560.575195,273.838806 561.294434,274.539734 562.012634,275.598633 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M574.748291,293.110229 
	C574.111511,292.884003 573.548401,292.290863 572.956055,291.378662 
	C573.558533,291.620850 574.190247,292.182068 574.748291,293.110229 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M559.871094,272.799591 
	C559.235291,272.666534 558.609192,272.191711 557.943481,271.402771 
	C558.562866,271.545044 559.221802,272.001404 559.871094,272.799591 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M583.048035,357.052612 
	C583.043152,357.496826 583.038208,357.941040 583.019958,358.719421 
	C582.581360,359.055420 582.156189,359.057220 581.414185,359.081940 
	C581.097412,359.104828 580.894653,358.885254 580.938354,358.504700 
	C581.670654,357.766968 582.359375,357.409790 583.048035,357.052612 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M205.679535,159.041199 
	C205.545578,159.638702 205.091156,160.277390 204.315216,160.955765 
	C204.448837,160.357758 204.903946,159.720078 205.679535,159.041199 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M534.919312,252.698303 
	C534.232361,252.680099 533.509827,252.298248 532.647949,251.624954 
	C533.300293,251.667236 534.091980,252.000961 534.919312,252.698303 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M474.959412,164.678345 
	C474.360474,164.551682 473.719727,164.103973 473.034058,163.337708 
	C473.631927,163.465210 474.274780,163.911255 474.959412,164.678345 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M584.673462,323.081757 
	C584.365356,323.019104 584.182190,322.725830 584.020935,322.167786 
	C584.294678,322.219055 584.546509,322.535095 584.673462,323.081757 
z"
          />
          <path
            fill="#B26F32"
            opacity="1.000000"
            stroke="none"
            d="
M366.816315,425.306793 
	C366.908752,425.585785 367.072906,425.812927 367.611389,426.407349 
	C370.532806,429.292084 373.151611,431.757751 375.770386,434.223419 
	C375.770386,434.223419 375.870789,434.219391 375.906525,434.461945 
	C376.237091,434.871185 376.531921,435.037872 376.826752,435.204559 
	C376.826752,435.204559 376.808044,435.029755 376.890320,435.434784 
	C378.850861,437.665619 380.729126,439.491425 382.607391,441.317261 
	C382.607391,441.317261 382.677612,441.319214 382.776489,441.633575 
	C383.611420,442.588745 384.347473,443.229553 385.083557,443.870361 
	C385.083557,443.870361 385.033783,443.962555 385.166229,444.262634 
	C388.018799,447.166656 390.738922,449.770599 393.459076,452.374542 
	C393.459076,452.374542 393.555939,452.439240 393.693420,452.778687 
	C395.538605,454.764252 397.246338,456.410400 398.954071,458.056519 
	C415.518097,475.054932 432.094879,492.040924 448.630737,509.066711 
	C450.818573,511.319366 453.259033,513.530151 454.691498,516.232605 
	C455.484100,517.728027 454.427338,520.203552 453.674622,522.523682 
	C452.113678,523.256897 451.082336,523.703735 449.667969,524.079468 
	C445.616577,521.642700 441.491272,519.759583 438.376770,516.809326 
	C432.242401,510.998444 426.729889,504.536591 420.850555,498.449860 
	C409.319672,486.512146 397.797333,474.564056 386.113342,462.777039 
	C376.182373,452.758514 366.029144,442.960297 355.978088,433.040192 
	C355.981873,433.015778 355.939606,433.033295 355.822449,432.747986 
	C354.784515,431.680603 353.863770,430.898560 352.950409,430.075562 
	C352.957794,430.034607 352.878510,430.059906 352.766113,429.749390 
	C350.786621,427.931580 348.919495,426.424255 347.030334,424.953827 
	C347.008270,424.990723 347.082947,424.948120 347.029419,424.632019 
	C346.330170,423.854828 345.684448,423.393738 345.021240,422.964233 
	C345.003754,422.995758 345.066895,422.960876 345.029541,422.625763 
	C343.320312,420.604736 341.648407,418.918793 339.786743,417.122101 
	C339.596954,417.011322 339.169098,416.910706 339.081665,416.605835 
	C338.361694,415.808777 337.729156,415.316559 337.022278,414.498535 
	C332.579559,409.797516 328.211243,405.422363 323.737488,400.777283 
	C323.111694,400.292328 322.591339,400.077301 322.062866,399.904358 
	C322.054810,399.946442 322.138397,399.927612 322.113281,399.635315 
	C321.713745,398.935883 321.339294,398.528717 320.862946,397.876404 
	C320.481812,397.425781 320.202576,397.220337 319.838867,396.737213 
	C319.160522,396.001404 318.566650,395.543213 317.855103,394.785645 
	C316.501465,393.320068 315.265533,392.153870 313.940552,390.748779 
	C313.571136,390.332733 313.290771,390.155579 312.875000,389.683777 
	C311.171417,387.917877 309.603210,386.446564 307.897278,384.704590 
	C307.217102,384.226288 306.674713,384.018646 306.083771,383.827637 
	C306.035248,383.844269 306.134308,383.871002 306.066040,383.606903 
	C305.702942,383.133270 305.408081,382.923737 304.976624,382.445099 
	C304.251770,381.386688 303.663544,380.597351 302.926086,379.533264 
	C301.899231,378.738739 301.021576,378.218933 300.026672,377.470154 
	C299.610840,376.825378 299.312256,376.409515 298.953918,375.736328 
	C298.598114,375.314575 298.302032,375.150177 297.779297,374.855286 
	C297.122253,374.429932 296.691895,374.135040 296.187561,373.519897 
	C295.104919,372.076874 294.096283,370.954041 292.958618,369.571808 
	C292.250519,368.809052 291.671387,368.305695 290.935059,367.511536 
	C284.888245,361.110382 278.998596,355.000061 273.020508,348.570251 
	C269.298950,344.456512 265.665863,340.662231 262.026001,336.510193 
	C262.485687,334.408752 262.952240,332.665070 263.512085,330.572571 
	C261.020996,331.114014 259.063232,331.539520 257.025879,331.789246 
	C256.946289,331.613434 256.877808,331.233612 256.891357,330.855042 
	C254.843628,325.939331 251.943329,322.307861 246.515869,320.935486 
	C244.440033,318.655914 242.639557,316.547852 240.803894,314.140411 
	C240.477798,313.588989 240.186935,313.336945 239.897186,313.118591 
	C239.898300,313.152283 239.831421,313.160950 239.861145,312.802155 
	C237.120911,310.021484 234.350952,307.599640 231.430115,305.172974 
	C231.279236,305.168182 231.009735,305.032104 231.006927,304.613159 
	C231.676575,299.356934 228.812317,298.612396 224.907761,298.858093 
	C224.835739,298.727814 224.818558,298.430511 224.851532,298.049377 
	C221.785522,294.836700 218.686569,292.005157 215.434601,289.151459 
	C215.281601,289.129272 215.012985,288.976135 215.009827,288.563049 
	C215.705688,283.379547 212.801590,282.685089 209.055573,282.553406 
	C208.673126,281.294983 208.530533,280.206421 207.926941,279.527832 
	C204.201126,275.338867 200.584274,271.016510 196.515106,267.179810 
	C192.613113,263.500732 188.206039,260.357300 183.976318,256.625610 
	C182.633072,251.154312 177.983231,249.977402 174.022095,247.604980 
	C173.338486,246.830063 172.725616,246.357498 172.041992,245.580795 
	C171.343826,244.822113 170.716400,244.367554 170.038345,243.627747 
	C169.662643,242.889618 169.337540,242.436752 168.900177,241.769318 
	C168.588623,241.287201 168.331772,241.097672 167.905518,240.769958 
	C167.592941,240.285446 167.334564,240.095474 167.009750,239.614380 
	C165.014404,237.482590 163.027924,235.720215 161.025208,233.591400 
	C158.264145,230.849319 155.519348,228.473709 152.490906,226.008118 
	C151.730179,225.309097 151.253113,224.700058 151.050293,223.917694 
	C151.324860,223.143127 151.586761,222.297363 151.286942,221.976624 
	C144.984421,215.233627 138.656418,208.512848 132.208527,201.909668 
	C131.535904,201.220840 130.079636,201.297226 128.993164,201.009888 
	C128.999390,201.001221 128.981155,201.010880 128.990265,200.640961 
	C127.681541,196.678085 126.060066,193.403961 121.251404,193.068207 
	C120.515190,192.309387 120.070709,191.652527 119.850266,190.944275 
	C119.919144,190.707779 119.763992,190.522690 119.656876,190.345551 
	C119.704918,190.353500 119.634399,190.286331 119.727768,189.890121 
	C118.531204,185.317200 117.241264,181.140503 115.953751,176.635620 
	C116.015602,175.874893 116.075035,175.442368 116.493744,174.921204 
	C117.561623,170.210999 118.270233,165.589432 118.991241,160.982971 
	C119.003639,160.998093 118.964752,160.994644 119.259773,160.736572 
	C120.035042,155.638107 120.912605,150.790436 120.824242,145.960434 
	C120.781471,143.622040 118.926048,141.316818 117.805756,138.766953 
	C117.628418,138.211334 117.637817,137.888275 117.800476,137.177811 
	C116.531288,135.553528 115.210037,134.319580 113.878967,133.085770 
	C113.869148,133.085892 113.849152,133.116318 113.895325,132.696198 
	C114.480202,129.460098 113.398460,128.143951 110.478378,127.605591 
	C105.121574,126.617989 99.841957,125.211739 93.663239,123.778999 
	C95.355843,123.368515 96.241364,123.153763 97.500313,122.937180 
	C103.313675,122.490112 106.701469,119.005104 110.054260,114.926697 
	C111.274246,114.088165 112.143715,113.271965 113.153374,112.324165 
	C113.752975,113.238007 114.334351,114.124069 115.003769,115.344559 
	C116.045181,116.803978 116.998535,117.928963 117.976883,119.028633 
	C118.001877,119.003326 117.944946,119.044533 117.961029,119.370575 
	C118.579742,120.271156 119.182373,120.845703 119.928635,121.696388 
	C121.112984,122.970207 122.153709,123.967888 123.181007,125.279099 
	C123.784775,126.029915 124.401962,126.467216 125.234467,127.164467 
	C130.909424,132.001480 133.862900,137.700211 133.175018,145.383057 
	C132.321503,150.852386 131.596024,155.910004 130.594421,161.231781 
	C130.003540,162.784622 129.661087,164.067261 129.378265,165.362915 
	C126.321518,179.366928 129.682724,188.461884 140.848099,196.386322 
	C142.931488,198.608765 144.881989,200.515945 146.943085,202.725586 
	C159.226379,215.286392 171.358810,227.585129 183.590561,239.784271 
	C188.864090,245.043747 194.343216,250.097092 199.728928,255.244080 
	C199.728928,255.244080 199.950851,255.022110 199.915146,255.467743 
	C206.238739,262.303131 212.598022,268.692871 218.957321,275.082642 
	C220.998474,277.015198 223.039627,278.947723 225.431091,281.378418 
	C234.096756,290.345032 242.412094,298.813568 250.727417,307.282104 
	C250.727417,307.282104 251.006027,307.037140 250.940109,307.474182 
	C252.598846,309.581757 254.323502,311.252258 256.048157,312.922791 
	C256.048157,312.922791 256.006805,312.993378 256.093384,313.256775 
	C256.733368,314.035400 257.286804,314.550598 258.005463,315.359772 
	C260.419312,317.803345 262.667908,319.952942 264.916534,322.102570 
	C264.916534,322.102570 264.991852,322.005463 265.002777,322.350830 
	C265.658478,323.153656 266.303223,323.611115 266.947998,324.068542 
	C266.947998,324.068542 266.997223,324.001160 267.018951,324.351990 
	C268.298981,325.864899 269.557251,327.027008 270.815552,328.189117 
	C270.815552,328.189117 271.000702,328.005493 270.990875,328.415375 
	C273.654785,331.544342 276.328522,334.263428 279.002258,336.982483 
	C290.462769,348.536133 301.885651,360.127441 313.399750,371.627411 
	C319.097809,377.318512 324.963837,382.841461 331.047546,388.903320 
	C331.495850,389.640808 331.730652,389.771667 332.045685,389.758698 
	C332.288849,390.011536 332.532013,390.264343 332.869568,391.080811 
	C333.612793,392.133209 334.261627,392.621979 334.910461,393.110748 
	C334.910461,393.110748 334.984283,393.002319 334.997559,393.355286 
	C335.654144,394.164673 336.297455,394.621063 336.940796,395.077454 
	C336.940796,395.077454 336.997406,395.003906 337.012939,395.367065 
	C344.294312,402.917328 351.560181,410.104462 358.826050,417.291565 
	C358.916443,417.570343 359.078766,417.797791 359.601959,418.329529 
	C360.196564,418.864746 360.502197,419.044342 360.807861,419.223969 
	C360.807861,419.223969 360.750702,419.101562 360.854797,419.484070 
	C362.911377,421.679993 364.863861,423.493378 366.816315,425.306793 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M278.984406,318.016571 
	C278.984406,318.016571 278.500641,317.997314 278.217651,317.636292 
	C276.300629,315.842834 274.666626,314.410431 273.032623,312.977997 
	C273.032623,312.977997 273.002441,312.997955 273.004486,312.621033 
	C271.873444,310.533325 270.790802,308.786316 269.594513,307.120941 
	C268.107208,305.050354 266.526001,303.047211 265.010040,300.990051 
	C265.034729,300.965179 265.084412,300.915680 265.395081,300.940887 
	C266.447815,300.731873 267.189911,300.497650 268.239136,300.375732 
	C271.048920,303.287659 273.551544,306.087311 276.161194,309.173889 
	C276.817627,309.670410 277.367035,309.880005 278.205383,310.234985 
	C279.967957,311.946411 281.441620,313.512421 282.916870,315.442810 
	C283.995392,316.834778 285.072357,317.862396 286.353271,318.908386 
	C286.557159,318.926788 286.957397,319.013367 286.988892,319.338074 
	C287.661987,320.129517 288.303589,320.596283 289.191650,321.312897 
	C292.185333,324.399139 294.932495,327.235535 297.484436,330.272278 
	C297.924377,331.289581 298.559570,332.106567 299.348541,333.186157 
	C300.680847,334.487030 301.859406,335.525299 303.038391,336.949646 
	C303.391907,338.059937 303.586151,338.940765 304.122253,339.484528 
	C310.718506,346.174774 317.318939,352.862701 324.050323,359.415710 
	C324.993530,360.333923 326.641846,360.527863 328.254822,361.214233 
	C330.228760,363.289581 331.911621,365.207855 333.346252,367.284790 
	C331.465851,371.396423 334.214691,371.701782 336.986633,372.385101 
	C341.369080,377.148346 345.689484,381.566010 350.044006,386.308746 
	C350.724396,387.084961 351.370728,387.536102 352.300751,388.131226 
	C353.723663,389.515503 354.862854,390.755859 355.997040,392.396240 
	C355.991821,393.862518 355.991608,394.928772 355.732178,395.889954 
	C354.978210,395.527679 354.483398,395.270508 353.988617,395.013367 
	C353.988617,395.013367 353.998901,395.000000 353.946167,394.659241 
	C352.929932,393.880615 351.966461,393.442749 351.002991,393.004883 
	C351.002991,393.004883 351.000000,393.000000 350.994263,392.638000 
	C349.324432,390.851990 347.660370,389.428040 345.996277,388.004059 
	C341.922211,383.503601 337.921570,378.933868 333.757874,374.517883 
	C326.404907,366.719360 318.981812,358.986206 311.522034,351.289642 
	C309.570221,349.275879 307.375336,347.497742 305.109985,344.965424 
	C302.284821,341.880066 299.641815,339.440643 296.998779,337.001221 
	C296.998779,337.001221 297.000000,337.000000 296.960144,336.680115 
	C296.286835,335.902527 295.653442,335.444824 295.020050,334.987122 
	C295.020050,334.987122 295.001221,334.998779 294.970215,334.643921 
	C293.288391,332.531097 291.637543,330.773132 289.986694,329.015167 
	C289.663910,328.912445 289.402191,328.724670 289.063293,327.885132 
	C286.285767,325.210114 283.646454,323.101807 281.007141,320.993500 
	C281.007141,320.993500 281.000000,321.000000 280.999146,320.642517 
	C280.326996,319.528900 279.655701,318.772736 278.984406,318.016571 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M395.970184,436.041748 
	C395.513916,435.741394 395.057648,435.441071 394.356140,435.023499 
	C394.110870,434.906250 394.094666,434.882263 394.110962,434.576752 
	C394.137268,433.862488 394.147278,433.453705 394.375427,432.830872 
	C393.732635,431.735748 392.871735,430.854736 391.818542,429.700867 
	C389.090607,426.615051 386.554962,423.802124 384.043304,420.688690 
	C384.394348,419.920074 384.721436,419.451996 385.358948,419.117981 
	C388.397400,421.236450 391.125366,423.220886 394.036194,425.333313 
	C394.449463,425.654449 394.640961,425.880585 394.823303,426.493774 
	C395.952118,428.455902 396.834290,430.279053 398.183350,431.638977 
	C412.734711,446.307373 427.349731,460.912720 441.976318,475.506287 
	C443.898956,477.424561 445.983551,479.180511 448.191650,481.142761 
	C448.639465,481.476990 448.841187,481.719666 449.015076,482.349457 
	C452.381744,486.010712 455.704102,489.349731 459.086395,492.626862 
	C460.660370,494.151978 462.350708,495.556976 464.182190,497.152130 
	C464.616974,497.498077 464.810272,497.745514 464.983398,498.377930 
	C467.294373,501.003204 469.415710,503.477692 471.894165,505.518524 
	C477.605011,510.221100 478.027832,510.119751 484.021118,505.566406 
	C487.919739,502.604431 491.859955,499.697235 495.836304,497.132935 
	C495.909790,497.995239 495.928436,498.490112 495.803345,499.283417 
	C492.987549,502.052612 490.243744,504.450836 487.658752,507.009491 
	C482.523651,512.092285 476.343201,512.518555 470.636993,508.228882 
	C469.667480,507.500000 468.238220,507.382721 467.010559,506.988892 
	C466.999756,506.994934 467.017731,506.973114 467.024628,506.606750 
	C465.993896,505.178436 464.956238,504.116486 463.640228,502.890869 
	C461.956879,501.789093 460.551880,500.850983 459.124237,499.684326 
	C459.101593,499.455780 459.065918,498.996399 459.061310,498.625854 
	C458.903473,497.621002 458.959534,496.777039 458.565643,496.383820 
	C452.679901,490.508362 446.759430,484.666931 440.785950,478.880676 
	C439.315033,477.455872 437.625519,476.256744 435.896667,474.648407 
	C429.843353,468.222656 423.929810,462.102295 417.863770,455.684784 
	C415.803162,453.592377 413.895050,451.797150 411.957520,449.655487 
	C408.264465,445.883179 404.600830,442.457275 400.598053,438.951599 
	C398.829346,437.928467 397.399780,436.985107 395.970184,436.041748 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M495.947113,498.984985 
	C495.928436,498.490112 495.909790,497.995239 495.885864,496.729248 
	C496.232117,494.008667 496.887634,492.059326 496.888885,490.109619 
	C496.904266,466.387695 496.823425,442.665710 496.831299,418.493225 
	C496.874329,414.692566 496.853638,411.342438 496.917725,407.531250 
	C496.947052,389.384521 496.891632,371.698883 496.864929,353.690552 
	C496.846252,352.939392 496.798828,352.510925 496.851135,351.631470 
	C497.078369,348.432739 497.205811,345.685059 497.607117,342.932800 
	C498.246033,342.924896 498.611084,342.921509 499.209900,343.103149 
	C499.936005,343.898010 500.428345,344.507904 500.920685,345.117767 
	C500.930145,346.140106 500.939606,347.162445 500.732361,348.754730 
	C500.984558,349.912354 501.453430,350.500061 501.922302,351.087738 
	C501.918091,351.501434 501.913849,351.915131 501.513123,352.749207 
	C500.739014,354.851044 500.034271,356.532043 500.031738,358.214081 
	C499.968811,400.082489 499.968628,441.951019 500.018494,483.819458 
	C500.020538,485.551819 500.614349,487.283417 500.932495,489.015381 
	C500.936493,489.442932 500.940521,489.870514 500.580017,490.711670 
	C499.147064,493.748566 498.078644,496.371826 496.744385,498.993652 
	C496.301453,498.989777 496.124268,498.987396 495.947113,498.984985 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M369.019531,455.987793 
	C365.356903,452.672485 361.667236,449.386444 358.038727,446.034210 
	C353.806396,442.124146 349.479248,438.300964 345.459137,434.180634 
	C338.908936,427.467133 332.637817,420.482056 326.129547,413.726624 
	C320.599426,407.986450 314.818237,402.487946 309.296021,396.740448 
	C300.927582,388.030579 292.666565,379.217010 284.417206,370.393921 
	C283.303436,369.202728 282.521881,367.700958 281.296448,365.919006 
	C281.009857,365.320801 281.013336,365.146545 281.286438,364.865356 
	C282.067261,364.474701 282.578430,364.191040 283.365845,364.072510 
	C284.227539,367.868561 287.437561,368.002472 290.029083,369.344879 
	C291.051575,371.097717 292.040070,372.511383 293.139313,374.157318 
	C293.532837,374.572174 293.815643,374.754761 294.123169,375.270966 
	C296.095520,377.405426 298.043213,379.206268 300.134766,381.311096 
	C307.829834,389.879913 315.317322,398.204285 322.958344,406.385284 
	C326.980438,410.691620 331.212402,414.808075 335.460022,418.895538 
	C338.484375,421.805847 341.733978,424.480530 344.808624,427.340454 
	C348.578644,430.847137 352.271027,434.437347 356.151184,438.295868 
	C358.970490,441.255524 361.620361,443.926270 364.304749,446.561859 
	C367.186401,449.391174 370.100525,452.187378 372.831940,455.244507 
	C372.103943,455.661072 371.544495,455.831146 370.657288,455.999390 
	C369.892883,455.994293 369.456207,455.991058 369.019531,455.987793 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M369.018738,456.356384 
	C369.456207,455.991058 369.892883,455.994293 370.850159,456.276001 
	C371.955017,457.131317 372.521423,457.727631 373.126343,458.281860 
	C377.402985,462.200073 381.687531,466.109619 386.102905,470.280151 
	C386.818390,471.032623 387.400482,471.526947 388.017334,472.358337 
	C389.689423,474.469788 391.326691,476.244110 393.003143,478.362549 
	C395.684540,481.147675 398.326752,483.588776 401.078552,486.251343 
	C401.390076,486.751709 401.657562,486.934875 402.024506,487.364990 
	C405.027527,490.811035 407.996704,493.914429 411.185669,497.283905 
	C413.635864,499.998718 415.866333,502.447449 418.095703,505.253662 
	C421.040253,508.092010 423.985901,510.572815 426.949707,513.415527 
	C429.891144,517.262573 432.373322,521.300781 435.859222,524.080322 
	C439.484100,526.970581 443.897034,529.357727 448.341187,530.490662 
	C450.060394,530.929016 452.787537,527.287781 455.111298,525.581055 
	C455.606140,525.217651 456.343445,525.184448 456.969055,524.999084 
	C456.692078,526.637939 457.009094,528.933533 456.041443,529.808655 
	C449.940491,535.326477 442.407349,535.040405 436.667572,529.108948 
	C429.533600,521.736694 422.753113,514.020264 415.563782,506.704254 
	C406.686066,497.670105 397.396973,489.038696 388.567017,479.959625 
	C382.145599,473.357056 376.157898,466.330719 370.047760,459.430511 
	C369.449280,458.754669 369.349304,457.637390 369.018738,456.356384 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M501.238495,488.743683 
	C500.614349,487.283417 500.020538,485.551819 500.018494,483.819458 
	C499.968628,441.951019 499.968811,400.082489 500.031738,358.214081 
	C500.034271,356.532043 500.739014,354.851044 501.500671,353.059265 
	C502.253967,354.654236 502.942902,356.359070 502.945496,358.064911 
	C503.005493,397.449280 503.033173,436.833923 502.926910,476.218079 
	C502.915894,480.303925 502.026367,484.387421 501.238495,488.743683 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M318.964508,421.095367 
	C319.397003,421.382202 319.829529,421.669067 320.626343,422.326996 
	C321.752594,423.283081 322.514526,423.868103 323.276459,424.453125 
	C323.276459,424.453125 323.409027,424.604553 323.563416,424.933105 
	C324.561035,425.986053 325.404236,426.710480 326.247437,427.434875 
	C326.247437,427.434875 326.374603,427.613770 326.524384,427.979858 
	C333.090302,434.955048 339.506439,441.564178 345.922577,448.173309 
	C347.682648,450.036987 349.442688,451.900665 351.567993,454.201691 
	C352.261749,454.809662 352.590210,454.980347 352.918640,455.151031 
	C352.918640,455.151031 352.933807,455.034271 353.043030,455.380798 
	C356.066437,458.558685 358.980652,461.389984 361.894867,464.221283 
	C361.960693,464.542206 362.139587,464.776947 362.778015,465.305206 
	C368.265045,470.578949 373.405579,475.473022 378.546112,480.367065 
	C378.546112,480.367065 378.626556,480.362823 378.711670,480.710693 
	C380.846771,483.063660 382.896790,485.068726 384.946777,487.073822 
	C384.946777,487.073822 384.985962,486.998749 384.981201,487.315765 
	C385.042755,488.015869 385.109131,488.398926 384.796722,488.849091 
	C383.320496,488.338470 381.997711,487.985260 381.162201,487.146576 
	C375.789154,481.752869 370.580750,476.195129 365.206635,470.802490 
	C358.492279,464.064972 351.686737,457.417938 344.890198,450.762878 
	C338.548981,444.553711 331.981812,438.562164 325.871643,432.134918 
	C321.965515,428.026062 318.709015,423.299652 315.477905,418.916351 
	C316.851227,419.686859 317.907867,420.391113 318.964508,421.095367 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M199.842209,254.889008 
	C194.343216,250.097092 188.864090,245.043747 183.590561,239.784271 
	C171.358810,227.585129 159.226379,215.286392 147.059875,202.435760 
	C147.363098,201.567596 147.660126,201.291718 148.297394,201.155243 
	C150.060959,201.562057 151.484238,201.829483 152.907532,202.096893 
	C152.930435,202.517120 152.953339,202.937347 153.021423,203.995270 
	C153.692001,205.109894 154.317398,205.586838 154.942780,206.063782 
	C157.378952,208.639069 159.850967,211.181580 162.243210,213.797058 
	C166.232452,218.158554 169.966110,222.775421 174.179413,226.905197 
	C180.142944,232.750519 186.460587,238.233597 192.593201,243.907898 
	C194.818787,245.967163 197.136246,247.978271 199.031830,250.319031 
	C199.840912,251.318130 199.677170,253.105042 199.842209,254.889008 
z"
          />
          <path
            fill="#E6D4C3"
            opacity="1.000000"
            stroke="none"
            d="
M177.019104,274.003265 
	C178.216507,274.802002 179.629562,275.401886 180.577972,276.430267 
	C190.090286,286.744690 199.304001,297.344543 209.056534,307.424042 
	C216.380463,314.993500 224.384521,321.903595 232.018265,329.178070 
	C232.420044,329.560913 232.190903,330.605835 232.014908,331.782928 
	C231.774323,332.223328 231.492844,332.502472 231.224396,332.318604 
	C229.073456,330.567413 227.190979,329.000031 225.239563,327.187836 
	C224.816269,326.603241 224.461914,326.263519 223.971649,325.643494 
	C222.763824,324.469696 221.691910,323.576202 220.441254,322.454285 
	C219.707687,321.701996 219.152863,321.178192 218.459137,320.338989 
	C215.686172,317.577637 213.052124,315.131683 210.372070,312.679932 
	C210.326065,312.674194 210.254303,312.732910 210.209045,312.445251 
	C209.864716,311.916901 209.565643,311.676239 209.283691,311.304565 
	C209.300797,311.173553 209.133331,310.969177 209.019165,310.651672 
	C206.967239,308.520569 205.029480,306.706940 203.045624,304.943054 
	C202.999496,304.992828 203.103516,304.906158 202.964844,304.602661 
	C196.952057,298.259644 191.111359,292.187103 185.189438,286.194794 
	C182.318954,283.290222 179.296219,280.536072 176.268112,277.758331 
	C176.193787,277.802856 176.295715,277.662720 176.242294,277.345459 
	C175.468246,275.929688 174.747620,274.831238 174.218399,273.532837 
	C174.946198,273.214478 175.482605,273.096100 176.019012,272.977722 
	C176.019012,272.977722 176.003464,272.993042 176.111359,273.216614 
	C176.420364,273.720886 176.686981,273.908569 177.019104,274.003265 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M497.010193,498.995117 
	C498.078644,496.371826 499.147064,493.748566 500.582672,491.032349 
	C501.144348,497.427612 500.264709,503.568176 494.808960,508.729065 
	C493.210327,510.380249 492.105774,511.690125 491.001221,513.000000 
	C491.001221,513.000000 490.502380,513.006714 489.932068,513.047607 
	C488.908844,513.725708 488.455994,514.362854 488.003113,515.000000 
	C484.173370,518.390259 479.692596,518.485413 475.038300,517.483459 
	C473.271332,517.103088 471.550781,516.507141 469.365051,515.681519 
	C468.281525,514.901550 467.641968,514.449585 467.002441,513.997559 
	C465.251404,512.333069 463.500366,510.668518 461.341003,508.649536 
	C459.284363,505.536163 457.636047,502.777252 456.381500,500.010559 
	C457.565796,499.972839 458.356354,499.942841 459.146881,499.912842 
	C460.551880,500.850983 461.956879,501.789093 463.651428,503.213135 
	C463.944794,504.130096 463.948608,504.561157 463.732178,505.171539 
	C464.006592,505.902588 464.501190,506.454346 465.332825,507.010101 
	C466.119171,507.000427 466.568451,506.986786 467.017731,506.973114 
	C467.017731,506.973114 466.999756,506.994934 467.139313,507.303223 
	C470.304199,512.546753 474.284119,517.058594 480.407135,514.689331 
	C485.436829,512.743103 489.877197,508.963470 494.115112,505.438934 
	C495.741547,504.086273 496.083130,501.188721 497.010193,498.995117 
z"
          />
          <path
            fill="#E6D4C3"
            opacity="1.000000"
            stroke="none"
            d="
M231.914993,332.083710 
	C233.646790,333.131714 235.388306,334.163727 236.804443,335.532410 
	C245.489990,343.926910 254.238327,352.264740 262.663422,360.915863 
	C265.566925,363.897186 267.603638,367.722626 269.951538,371.647156 
	C269.866730,372.131805 269.613190,372.386932 269.328308,372.223938 
	C266.407257,369.663635 263.771149,367.266327 261.145691,364.901764 
	C261.156372,364.934540 261.157379,364.859924 261.095306,364.528229 
	C254.137985,357.365417 247.242722,350.534302 240.278656,343.739899 
	C240.209854,343.776611 240.298447,343.648224 240.248901,343.325562 
	C238.189255,340.951538 236.179153,338.900208 234.145416,336.832062 
	C234.121796,336.815277 234.182938,336.824158 234.121277,336.508179 
	C233.204025,334.962280 232.348434,333.732391 231.492844,332.502472 
	C231.492844,332.502472 231.774323,332.223328 231.914993,332.083710 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M195.947968,278.050568 
	C190.782654,273.627045 185.660568,269.151367 180.422867,264.815277 
	C179.044037,263.673767 177.290039,262.273224 175.741989,262.312683 
	C174.797348,262.336761 173.916992,264.881958 172.631210,266.674164 
	C171.555969,267.009033 170.857285,266.964539 170.103104,266.603516 
	C170.019836,265.859039 169.992050,265.431183 170.258575,264.727295 
	C170.696472,261.632050 170.840042,258.812805 171.375702,255.996323 
	C173.540466,256.306854 175.313126,256.614624 177.315598,256.934540 
	C177.545395,256.946716 178.004059,256.984955 178.041916,257.310333 
	C178.734497,258.074371 179.389221,258.513031 180.022888,258.975830 
	C180.001831,259.000000 180.048782,258.954926 180.067459,259.315857 
	C181.379639,260.456177 182.673157,261.235596 184.123062,262.302246 
	C185.547745,264.357666 186.816040,266.125854 188.188904,268.215881 
	C189.877487,269.682007 191.461517,270.826233 193.321533,272.101044 
	C194.393600,272.824524 195.189682,273.417419 195.984406,274.408234 
	C195.992142,275.867157 196.001251,276.928162 195.995010,278.004578 
	C195.979645,278.019958 195.947968,278.050568 195.947968,278.050568 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M450.975708,495.023865 
	C446.566467,491.428680 441.968842,488.037689 437.795380,484.186981 
	C432.487946,479.290009 427.426056,474.113586 422.455139,468.871002 
	C420.087860,466.374390 418.175720,463.446198 416.394958,460.358826 
	C417.479950,460.010712 418.227386,460.017273 419.016846,460.368988 
	C422.713135,464.471436 426.367432,468.228729 430.050537,472.335327 
	C431.723236,474.123810 433.367065,475.562988 435.124817,477.253662 
	C436.485382,478.342499 437.731995,479.179810 438.987701,480.391968 
	C440.326416,481.850159 441.656036,482.933533 443.133545,484.316193 
	C445.870453,488.060791 448.459442,491.506073 451.030304,494.969543 
	C451.012177,494.987701 450.975708,495.023865 450.975708,495.023865 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M259.029175,298.975769 
	C258.852478,298.424103 258.675812,297.872437 258.216309,296.804077 
	C254.625870,293.189270 251.318237,290.091187 248.010605,286.993103 
	C248.010605,286.993103 248.000000,287.000000 247.960571,286.675110 
	C247.279373,285.903839 246.637604,285.457458 245.995834,285.011078 
	C245.888245,284.689880 245.698105,284.428833 245.178192,283.771362 
	C242.962250,281.537628 240.993546,279.760468 239.024857,277.983307 
	C239.024857,277.983307 239.003418,278.000000 239.003723,277.625061 
	C238.341660,275.482910 237.679306,273.715759 237.390533,271.963623 
	C238.512222,271.985931 239.260345,271.993195 240.305359,272.170197 
	C243.044388,274.915955 245.486511,277.491943 247.928589,280.412781 
	C248.618149,281.847321 249.307800,282.937012 250.128906,284.249939 
	C250.822586,284.395172 251.384781,284.317169 252.217133,284.396973 
	C253.976730,286.059204 255.466202,287.563629 256.955627,289.412842 
	C257.393402,290.467682 257.831207,291.177765 258.436310,292.175537 
	C260.986359,294.330414 263.369110,296.197632 265.525818,298.272339 
	C265.227966,299.291809 265.156189,300.103729 265.084412,300.915680 
	C265.084412,300.915680 265.034729,300.965179 264.673340,300.987915 
	C263.862457,301.025482 263.412994,301.040344 262.963531,301.055176 
	C262.529572,301.039062 262.095642,301.022949 261.293945,300.678650 
	C260.293884,299.892242 259.661530,299.433990 259.029175,298.975769 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M228.000610,311.000000 
	C227.523071,310.725769 227.045517,310.451538 226.294617,309.702881 
	C225.746078,306.136078 224.145737,304.325165 220.986481,304.021729 
	C220.171631,303.105835 219.356766,302.189911 218.235840,300.789520 
	C215.634140,298.190308 213.338531,296.075592 211.042923,293.960876 
	C211.042923,293.960876 211.000610,294.000000 211.007507,293.614471 
	C209.353714,291.807922 207.693024,290.386902 206.032333,288.965881 
	C206.032333,288.965881 206.000000,289.000000 205.978729,288.634949 
	C204.350296,285.814514 202.743134,283.359070 201.487503,280.924194 
	C203.398941,281.962616 204.939148,283.012390 206.524323,283.989227 
	C208.064758,284.938507 209.651276,285.812988 211.257889,286.718262 
	C211.298218,286.716217 211.378311,286.705963 211.295517,287.056152 
	C216.479248,292.600220 221.745789,297.794037 227.050629,303.334534 
	C229.088684,306.756714 231.088425,309.832306 232.738617,312.905609 
	C230.926239,312.268890 229.463425,311.634460 228.000610,311.000000 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M281.016815,364.972321 
	C281.013336,365.146545 281.009857,365.320801 281.000732,365.756592 
	C277.640533,362.826752 274.196564,359.723206 270.952576,356.423065 
	C266.222321,351.610962 261.635895,346.657440 256.852539,341.102661 
	C255.802658,339.280304 254.888367,338.119476 254.150482,336.721985 
	C254.884232,336.328461 255.441544,336.171631 256.260101,336.223480 
	C259.989990,339.636261 263.458649,342.840363 267.209747,346.177887 
	C268.312195,347.233276 269.132172,348.155273 269.965942,349.435303 
	C273.649078,353.531158 277.318390,357.268921 280.993866,361.003357 
	C281.000000,361.000000 280.993530,361.010620 280.990234,361.407104 
	C280.996857,362.859833 281.006836,363.916077 281.016815,364.972321 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M456.787811,524.727661 
	C456.343445,525.184448 455.606140,525.217651 455.111298,525.581055 
	C452.787537,527.287781 450.060394,530.929016 448.341187,530.490662 
	C443.897034,529.357727 439.484100,526.970581 435.859222,524.080322 
	C432.373322,521.300781 429.891144,517.262573 426.971680,513.398438 
	C426.975464,513.019409 427.015869,512.984009 427.234558,512.876343 
	C427.726196,512.569458 427.913086,512.308533 428.008301,511.991638 
	C428.002686,511.997314 427.990540,512.010437 428.336487,512.063354 
	C433.383728,517.695435 437.352356,524.086609 444.706787,526.746704 
	C447.326416,527.694214 450.110352,528.799805 450.051025,524.150635 
	C451.082336,523.703735 452.113678,523.256897 453.481262,522.825806 
	C454.747223,523.379822 455.676910,523.918030 456.787811,524.727661 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M250.792831,306.905273 
	C242.412094,298.813568 234.096756,290.345032 225.718170,281.528778 
	C228.816437,280.647888 230.307861,282.093842 232.295181,284.727386 
	C235.812729,289.388763 240.820892,292.892487 244.770432,297.272736 
	C247.214783,299.983704 248.856323,303.418518 250.792831,306.905273 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M231.986496,270.014648 
	C231.130295,269.844635 230.274078,269.674652 229.209778,268.881439 
	C224.334686,263.508667 219.667709,258.759125 215.000748,254.009567 
	C215.000748,254.009567 214.999390,254.000610 214.853516,253.697357 
	C212.134460,250.599274 209.561295,247.804443 206.988129,245.009628 
	C206.882233,244.690811 206.693985,244.431870 206.072784,243.797058 
	C205.481277,242.233566 205.240372,241.105835 205.301270,240.122101 
	C213.624832,248.220367 221.611816,256.210297 229.705551,264.090576 
	C230.924698,265.277557 232.642151,265.952698 234.068878,266.933228 
	C234.008636,267.001831 234.136871,266.870575 234.109833,267.203033 
	C234.403152,268.352600 234.723526,269.169739 234.661926,269.993469 
	C233.515457,270.004974 232.750977,270.009796 231.986496,270.014648 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M426.092468,533.379761 
	C425.504059,533.654480 425.008850,533.769897 423.854675,533.943115 
	C412.412872,536.969421 407.695099,531.358826 401.386719,520.997681 
	C402.981628,521.921631 404.266571,522.781921 405.425140,523.787720 
	C408.211395,526.206604 410.772186,528.921082 413.736542,531.088745 
	C416.656799,533.224182 420.707611,531.854309 422.769135,528.685425 
	C424.256653,530.069336 425.436737,531.347046 426.616821,532.624756 
	C426.413025,532.779846 426.269287,532.978455 426.092468,533.379761 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M182.993332,222.006775 
	C182.363251,221.820221 181.497513,221.835495 181.138748,221.416595 
	C176.405853,215.890366 171.744385,210.302994 167.033981,204.362839 
	C167.002945,203.994720 167.023605,203.968155 167.399292,203.974060 
	C168.528687,203.970016 169.282394,203.960068 170.174042,204.237732 
	C171.541672,205.682358 172.771362,206.839340 174.050812,208.338318 
	C175.044678,209.133087 175.988785,209.585831 177.093079,210.314651 
	C178.138977,211.086212 179.024704,211.581680 180.188904,212.212982 
	C181.278580,213.265610 182.089767,214.182404 182.877350,215.311035 
	C182.853760,215.522858 182.779617,215.944138 182.456543,216.023773 
	C182.432297,218.058502 182.731110,220.013611 183.020905,221.978134 
	C183.011902,221.987564 182.993332,222.006775 182.993332,222.006775 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M345.953400,447.767456 
	C339.506439,441.564178 333.090302,434.955048 326.607422,428.051575 
	C328.766785,428.775940 331.367737,429.363617 333.139740,430.904510 
	C336.658997,433.964722 339.909119,437.394287 342.892731,440.985046 
	C344.358429,442.748993 344.980438,445.213898 345.953400,447.767456 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M358.873352,416.897186 
	C351.560181,410.104462 344.294312,402.917328 336.975952,395.395050 
	C340.029755,394.889038 341.665436,395.493011 343.525085,399.002594 
	C346.010651,403.693420 351.148285,406.944550 354.978333,410.974243 
	C356.522278,412.598663 357.619873,414.647247 358.873352,416.897186 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M287.009583,389.000305 
	C290.513672,388.537933 292.642883,389.917114 294.697876,392.991638 
	C297.186066,396.714264 300.857666,399.632538 303.877350,403.023376 
	C304.563141,403.793427 304.674255,405.075165 304.993805,406.590179 
	C304.937744,407.058960 304.742249,407.252686 304.439270,407.129944 
	C302.226349,405.235016 300.316406,403.462769 298.378967,401.697144 
	C298.351471,401.703735 298.299927,401.680389 298.245117,401.426758 
	C297.898438,401.015503 297.606567,400.857880 297.313965,400.669647 
	C297.313202,400.639038 297.311829,400.577850 297.237366,400.251648 
	C293.778473,396.283752 290.394012,392.642029 287.009583,389.000305 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M218.953613,274.717346 
	C212.598022,268.692871 206.238739,262.303131 199.814362,255.587982 
	C202.189484,256.864075 204.799042,258.260712 207.035080,260.109161 
	C211.866608,264.103241 217.482132,267.517731 218.953613,274.717346 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M394.105469,434.914368 
	C392.924683,435.291199 391.053802,436.323212 390.678040,435.929230 
	C384.931763,429.904449 379.369598,423.703522 373.806580,417.505920 
	C373.396729,417.049347 373.308289,416.304321 373.374420,415.333740 
	C374.120239,414.978455 374.562103,414.982819 375.042297,415.310120 
	C376.058533,416.417877 377.036469,417.202698 378.202911,418.254578 
	C379.907074,419.376251 381.422729,420.230896 382.949219,421.457703 
	C386.671600,426.180664 390.383118,430.531464 394.094666,434.882263 
	C394.094666,434.882263 394.110870,434.906250 394.105469,434.914368 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M152.971619,201.743835 
	C151.484238,201.829483 150.060959,201.562057 148.317978,200.750214 
	C149.470108,199.132004 150.894989,197.237411 152.423233,197.149994 
	C155.937378,196.948990 159.501846,197.627502 163.317688,198.088013 
	C164.391449,198.817459 165.193375,199.407974 165.997528,200.347565 
	C166.341019,201.787155 166.682312,202.877655 167.023605,203.968155 
	C167.023605,203.968155 167.002945,203.994720 166.991211,204.007904 
	C163.361877,202.713623 159.782333,201.276093 156.097672,200.197845 
	C155.264694,199.954102 154.066025,200.960052 152.971619,201.743835 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M255.998871,336.014832 
	C255.441544,336.171631 254.884232,336.328461 253.899078,336.615784 
	C252.990204,336.486694 252.509171,336.227081 252.028137,335.967468 
	C252.028137,335.967468 252.019028,335.483002 251.978958,334.901062 
	C250.965851,333.540161 249.992813,332.761230 248.687653,331.975098 
	C247.913193,331.962067 247.470856,331.956207 247.028519,331.950317 
	C246.720840,331.838928 246.468933,331.652313 246.150589,330.818054 
	C244.341354,327.174683 242.654327,324.103699 241.013672,320.985107 
	C241.060059,320.937469 241.152618,320.842072 241.493088,320.887939 
	C243.496750,321.676056 245.159943,322.418304 246.880905,323.506836 
	C249.969482,327.551880 253.000305,331.250702 256.020142,335.216034 
	C256.005707,335.659973 256.002289,335.837402 255.998871,336.014832 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M378.682617,479.985229 
	C373.405579,475.473022 368.265045,470.578949 362.995728,465.371765 
	C369.484222,464.107056 371.250183,470.661377 375.454559,473.430878 
	C377.181915,474.568695 377.733032,477.492157 378.682617,479.985229 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M204.999451,239.978088 
	C205.240372,241.105835 205.481277,242.233566 205.855804,243.687134 
	C202.521790,241.328491 198.897171,238.818375 195.647018,235.892349 
	C193.778961,234.210602 192.517654,231.854904 190.985794,229.407135 
	C190.988373,229.011688 191.003510,228.996567 191.313904,229.149811 
	C193.088654,229.867233 194.553024,230.431427 196.233795,231.100967 
	C196.722534,231.398056 196.911911,231.651749 197.014206,232.344864 
	C197.276352,235.811691 199.057541,237.108414 202.318466,237.117065 
	C203.394272,238.163818 204.196854,239.070953 204.999451,239.978088 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M395.968872,436.441010 
	C397.399780,436.985107 398.829346,437.928467 400.608765,439.329590 
	C402.982849,442.852203 405.007141,445.917023 407.023315,449.356995 
	C407.013702,450.482056 407.012177,451.231934 407.010681,451.981842 
	C403.254913,446.989166 395.863953,444.647705 395.968872,436.441010 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M318.962555,420.701599 
	C317.907867,420.391113 316.851227,419.686859 315.470398,418.933105 
	C315.146210,418.883636 315.133270,418.884888 315.030823,418.601990 
	C314.299774,417.859253 313.671112,417.399384 313.023712,416.970581 
	C313.004944,417.001648 313.059357,416.953217 312.930115,416.644836 
	C310.226227,413.860657 307.651581,411.384857 305.051453,408.958008 
	C305.026001,409.006989 305.100800,408.925537 305.066315,408.641785 
	C304.935303,407.989563 304.838776,407.621124 304.742249,407.252686 
	C304.742249,407.252686 304.937744,407.058960 305.035828,406.960205 
	C308.126801,409.313629 311.256012,411.621216 314.064636,414.268890 
	C315.933472,416.030609 317.344604,418.277863 318.962555,420.701599 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M407.006897,451.989746 
	C407.012177,451.231934 407.013702,450.482056 407.388489,449.365479 
	C409.170166,449.333160 410.578552,449.667542 411.986938,450.001892 
	C413.895050,451.797150 415.803162,453.592377 417.856537,456.038086 
	C418.326172,457.800354 418.650513,458.912079 418.974854,460.023834 
	C418.227386,460.017273 417.479950,460.010712 416.358337,460.011169 
	C415.984222,460.018250 415.499115,459.998352 415.250488,459.623108 
	C413.866852,455.147858 411.533234,452.366821 407.014923,451.989899 
	C407.014923,451.989899 407.003174,451.997650 407.006897,451.989746 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M400.787384,503.495148 
	C400.787384,503.495148 400.820343,503.786835 400.996460,504.218506 
	C403.539337,507.343323 405.906128,510.036438 408.176025,512.826050 
	C408.079163,512.922607 407.886139,513.114441 407.539581,513.068237 
	C402.624268,508.599335 398.011353,504.220154 393.544830,499.696472 
	C393.010040,499.154816 393.270935,497.827576 393.445801,496.898560 
	C394.094971,497.023499 394.461395,497.114319 394.827820,497.205139 
	C394.827820,497.205139 394.960754,497.063385 394.937286,497.446106 
	C396.871674,499.717621 398.829529,501.606384 400.787384,503.495148 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M215.006332,254.372650 
	C219.667709,258.759125 224.334686,263.508667 229.004135,268.622131 
	C224.341705,264.235931 219.676804,259.485809 215.006332,254.372650 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M240.967285,321.032715 
	C242.654327,324.103699 244.341354,327.174683 246.039093,330.607941 
	C242.367157,326.891541 238.684494,322.812866 235.344467,318.397736 
	C237.447159,319.051758 239.207230,320.042236 240.967285,321.032715 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M408.272919,512.729553 
	C405.906128,510.036438 403.539337,507.343323 401.100677,504.321838 
	C404.887115,504.132721 407.382538,506.109344 409.048340,509.543091 
	C410.165558,511.846039 411.685455,513.953613 412.740356,516.395752 
	C411.061340,515.338440 409.667114,514.033997 408.272919,512.729553 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M426.724274,532.210815 
	C425.436737,531.347046 424.256653,530.069336 422.745117,528.682800 
	C422.413605,528.574036 422.370880,528.554138 422.299683,528.238281 
	C420.536163,526.227844 418.843872,524.533203 417.149750,522.825684 
	C417.147919,522.812683 417.182831,522.801147 417.159729,522.508423 
	C417.068359,521.831604 417.000092,521.447510 416.931824,521.063477 
	C422.992676,521.844666 425.440674,525.381165 426.724274,532.210815 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M286.744385,388.945923 
	C290.394012,392.642029 293.778473,396.283752 296.879395,400.355042 
	C292.691986,396.894897 288.788116,393.005157 285.019958,388.992798 
	C285.155670,388.870209 285.432129,388.630737 285.432129,388.630737 
	C285.781158,388.717651 286.130157,388.804565 286.744385,388.945923 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M394.883087,496.819458 
	C394.461395,497.114319 394.094971,497.023499 393.437500,496.915527 
	C393.146423,496.898346 393.134674,496.884460 393.074097,496.550934 
	C390.395569,493.754608 387.777649,491.291809 385.152771,488.815979 
	C385.145782,488.802917 385.175476,488.782013 385.175476,488.782013 
	C385.109131,488.398926 385.042755,488.015869 384.947693,487.341675 
	C390.307159,487.991058 394.084106,490.652008 394.883087,496.819458 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M263.009949,301.405243 
	C263.412994,301.040344 263.862457,301.025482 264.648621,301.012787 
	C266.526001,303.047211 268.107208,305.050354 269.594513,307.120941 
	C270.790802,308.786316 271.873444,310.533325 273.014282,312.605988 
	C269.700165,309.230347 266.378265,305.492828 263.009949,301.405243 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M375.803040,433.825745 
	C373.151611,431.757751 370.532806,429.292084 367.799683,426.506531 
	C372.605896,426.120056 375.502197,428.331818 375.803040,433.825745 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M201.135956,280.903656 
	C202.743134,283.359070 204.350296,285.814514 205.995209,288.618195 
	C203.047150,286.541107 200.061356,284.115784 197.378784,281.340820 
	C198.134354,280.982666 198.586670,280.974121 199.378143,280.971313 
	C200.170090,280.947357 200.622910,280.917694 201.086975,280.899780 
	C201.098206,280.911499 201.135956,280.903656 201.135956,280.903656 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M248.040222,287.339294 
	C251.318237,290.091187 254.625870,293.189270 257.970764,296.639099 
	C254.695297,293.889038 251.382584,290.787292 248.040222,287.339294 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M361.932892,463.820923 
	C358.980652,461.389984 356.066437,458.558685 353.007080,455.427429 
	C358.312103,455.886963 361.317017,458.622711 361.932892,463.820923 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M416.946747,521.048645 
	C417.000092,521.447510 417.068359,521.831604 416.794373,522.543091 
	C413.596771,519.618530 410.741455,516.366516 407.886139,513.114441 
	C407.886139,513.114441 408.079163,512.922607 408.176025,512.826050 
	C409.667114,514.033997 411.061340,515.338440 412.751129,516.757263 
	C413.861176,517.781982 414.675598,518.692261 415.790680,520.052734 
	C416.381561,520.690979 416.671844,520.879089 416.962097,521.067200 
	C416.962097,521.067200 416.961670,521.033813 416.946747,521.048645 
z"
          />
          <path
            fill="#EFF0EE"
            opacity="1.000000"
            stroke="none"
            d="
M455.987732,500.018311 
	C457.636047,502.777252 459.284363,505.536163 460.971100,508.643005 
	C457.700012,505.887756 454.390503,502.784637 451.393250,499.369568 
	C452.807465,499.368073 453.909393,499.678528 455.255371,499.995483 
	C455.499451,500.001923 455.987732,500.018311 455.987732,500.018311 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M297.002136,337.368225 
	C299.641815,339.440643 302.284821,341.880066 304.957397,344.665405 
	C301.018616,344.020630 298.024506,341.961243 297.002136,337.368225 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M279.009155,336.584778 
	C276.328522,334.263428 273.654785,331.544342 270.895203,328.503662 
	C274.295654,330.080780 279.120300,330.607422 279.009155,336.584778 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M190.979172,229.021103 
	C188.316879,226.930710 185.663773,224.830902 183.001999,222.368942 
	C182.993332,222.006775 183.011902,221.987564 183.418350,221.986481 
	C184.888733,221.990204 185.952682,221.994995 187.230759,222.107849 
	C187.712112,222.412048 187.897537,222.667526 188.001068,223.339874 
	C189.001801,225.463776 190.002655,227.230164 191.003510,228.996567 
	C191.003510,228.996567 190.988373,229.011688 190.979172,229.021103 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M231.994400,270.373169 
	C232.750977,270.009796 233.515457,270.004974 234.918579,270.118225 
	C236.043793,270.807068 236.530380,271.377808 237.016968,271.948578 
	C237.679306,273.715759 238.341660,275.482910 239.010422,277.615173 
	C236.678650,275.564087 234.340485,273.147919 231.994400,270.373169 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M393.596802,452.019043 
	C390.738922,449.770599 388.018799,447.166656 385.213257,444.239563 
	C390.333588,443.902740 391.663055,448.195282 393.596802,452.019043 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M211.032532,294.330231 
	C213.338531,296.075592 215.634140,298.190308 217.953171,300.660400 
	C213.752441,301.008972 212.547028,297.678406 211.032532,294.330231 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M375.003937,414.987183 
	C374.562103,414.982819 374.120239,414.978455 373.347351,414.976074 
	C372.395355,414.525146 371.774414,414.072235 371.379578,413.048828 
	C371.734650,410.987671 371.863617,409.497040 372.297302,408.147949 
	C374.406769,410.188721 376.211487,412.087891 377.999023,414.002960 
	C377.981842,414.018860 377.948730,414.051270 377.618042,414.039215 
	C376.526215,414.347198 375.765076,414.667206 375.003937,414.987183 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M400.845123,503.065582 
	C398.829529,501.606384 396.871674,499.717621 394.855255,497.498199 
	C398.979980,496.592010 401.252502,498.150024 400.845123,503.065582 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M407.152161,452.293701 
	C411.533234,452.366821 413.866852,455.147858 415.007874,459.615601 
	C412.438995,457.521423 409.864197,455.059479 407.152161,452.293701 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M241.013672,320.985107 
	C239.207230,320.042236 237.447159,319.051758 235.341980,318.032196 
	C234.996872,318.003113 234.528610,317.972839 234.280655,317.567078 
	C234.045410,316.083496 234.058121,315.005646 234.417923,313.973816 
	C236.894211,316.293945 239.023422,318.567993 241.152618,320.842072 
	C241.152618,320.842072 241.060059,320.937469 241.013672,320.985107 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M264.918732,321.720154 
	C262.667908,319.952942 260.419312,317.803345 258.309662,315.325439 
	C258.651489,314.976959 258.854309,314.956787 259.057129,314.936646 
	C263.985962,314.345795 263.711670,318.521301 264.918732,321.720154 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M206.990204,245.387894 
	C209.561295,247.804443 212.134460,250.599274 214.848877,253.696716 
	C210.456360,253.069366 208.261124,249.867706 206.990204,245.387894 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M384.969421,486.659485 
	C382.896790,485.068726 380.846771,483.063660 378.712036,480.750977 
	C382.696899,480.240234 385.562683,481.357758 384.969421,486.659485 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M234.070831,313.927795 
	C234.058121,315.005646 234.045410,316.083496 234.046051,317.564575 
	C232.060104,315.880798 230.060822,313.793793 228.031067,311.353394 
	C229.463425,311.634460 230.926239,312.268890 232.835068,313.133606 
	C233.475250,313.648621 233.738510,313.836578 234.070831,313.927795 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M281.037476,321.341431 
	C283.646454,323.101807 286.285767,325.210114 288.953156,327.666443 
	C286.343445,325.906128 283.705627,323.797760 281.037476,321.341431 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M365.983032,408.016968 
	C363.673737,405.914795 361.364441,403.812622 359.025360,401.357422 
	C358.995575,401.004425 359.013092,400.986969 359.331207,401.014435 
	C360.435272,401.359589 361.221222,401.677277 362.154175,402.291656 
	C363.559509,404.365936 364.817841,406.143555 366.052948,407.945129 
	C366.029694,407.969116 365.983032,408.016968 365.983032,408.016968 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M256.053680,312.581421 
	C254.323502,311.252258 252.598846,309.581757 250.800049,307.593262 
	C254.764343,306.501740 256.632019,308.060089 256.053680,312.581421 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M353.994507,395.384766 
	C354.483398,395.270508 354.978210,395.527679 356.014648,396.016022 
	C357.366730,396.839417 358.177216,397.431580 358.990326,398.393799 
	C358.999695,399.504883 359.006378,400.245941 359.013062,400.986969 
	C359.013092,400.986969 358.995575,401.004425 358.985596,401.014404 
	C357.317200,399.268341 355.658813,397.512268 353.994507,395.384766 
z"
          />
          <path
            fill="#E6D4C3"
            opacity="1.000000"
            stroke="none"
            d="
M275.196594,376.812592 
	C277.114716,378.682739 279.032806,380.552856 280.600830,382.719299 
	C279.216858,382.298706 278.182953,381.581879 277.139893,380.885437 
	C277.130737,380.905823 277.129028,380.895294 277.070435,380.581512 
	C276.257660,379.263367 275.503479,378.259003 274.860535,377.143494 
	C274.971710,377.032379 275.196594,376.812592 275.196594,376.812592 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M371.992584,408.006378 
	C371.863617,409.497040 371.734650,410.987671 371.343597,412.734985 
	C370.592224,412.675720 370.102936,412.359802 369.309509,411.664124 
	C368.670532,410.183563 368.335663,409.082764 368.208069,407.723358 
	C369.276245,407.310669 370.137146,407.156555 371.216370,407.111786 
	C371.707550,407.421143 371.893524,407.682892 371.992584,408.006378 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M382.702026,440.946320 
	C380.729126,439.491425 378.850861,437.665619 376.883118,435.522583 
	C380.330505,435.278473 382.198883,437.216797 382.702026,440.946320 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M239.021683,278.345825 
	C240.993546,279.760468 242.962250,281.537628 244.959503,283.660156 
	C242.998215,282.239807 241.008362,280.474091 239.021683,278.345825 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M176.016846,272.599670 
	C175.482605,273.096100 174.946198,273.214478 173.980545,273.435852 
	C173.105316,273.294983 172.659332,273.051147 172.226410,272.841614 
	C172.239502,272.875916 172.235962,272.795868 172.231689,272.489838 
	C172.123322,271.786896 172.019241,271.390015 172.189270,270.796875 
	C172.654022,269.726379 172.844650,268.852112 173.035278,267.977844 
	C174.028412,269.392426 175.021561,270.806976 176.016846,272.599670 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M221.023193,304.370819 
	C224.145737,304.325165 225.746078,306.136078 226.039825,309.596802 
	C224.392227,308.216797 222.726074,306.468353 221.023193,304.370819 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M366.846436,424.941223 
	C364.863861,423.493378 362.911377,421.679993 360.866089,419.550812 
	C362.807739,421.015228 364.842133,422.795441 366.846436,424.941223 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M455.011292,499.989014 
	C453.909393,499.678528 452.807465,499.368073 451.361725,499.019531 
	C451.008728,497.925842 450.999603,496.870178 450.983093,495.419189 
	C450.975708,495.023865 451.012177,494.987701 451.349884,495.011169 
	C452.787628,495.692963 453.887695,496.351288 454.991760,497.382080 
	C455.000916,498.499359 455.006104,499.244171 455.011292,499.989014 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M346.033081,388.358734 
	C347.660370,389.428040 349.324432,390.851990 350.991821,392.636780 
	C349.353363,391.569519 347.711639,390.141449 346.033081,388.358734 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M398.963440,457.679047 
	C397.246338,456.410400 395.538605,454.764252 393.725983,452.826904 
	C397.343658,451.947357 398.530212,454.206787 398.963440,457.679047 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M273.055420,313.324829 
	C274.666626,314.410431 276.300629,315.842834 277.975708,317.627747 
	C276.370636,316.544037 274.724426,315.107880 273.055420,313.324829 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M290.024445,329.366638 
	C291.637543,330.773132 293.288391,332.531097 294.976196,334.634399 
	C293.362823,333.225861 291.712524,331.471985 290.024445,329.366638 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M206.054993,289.313782 
	C207.693024,290.386902 209.353714,291.807922 211.027496,293.594147 
	C209.386292,292.526794 207.731964,291.094269 206.054993,289.313782 
z"
          />
          <path
            fill="#EFF0EE"
            opacity="1.000000"
            stroke="none"
            d="
M491.398651,512.998535 
	C492.105774,511.690125 493.210327,510.380249 494.658020,509.036407 
	C495.147644,511.308716 494.966705,513.352295 491.398651,512.998535 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M252.020691,336.343872 
	C252.509171,336.227081 252.990204,336.486694 253.722656,336.852478 
	C254.888367,338.119476 255.802658,339.280304 256.837555,340.738586 
	C255.309845,339.597473 253.661530,338.158905 252.020691,336.343872 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M270.871918,327.800476 
	C269.557251,327.027008 268.298981,325.864899 266.986328,324.377991 
	C268.264069,325.172760 269.596191,326.292328 270.871918,327.800476 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M277.149048,380.865051 
	C278.182953,381.581879 279.216858,382.298706 280.560822,383.095673 
	C281.001770,383.492706 281.132629,383.809662 281.198822,384.495697 
	C281.134155,384.864807 280.904205,385.096649 280.535339,385.056122 
	C279.160645,383.632080 278.154846,382.248566 277.149048,380.865051 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M368.000824,407.981934 
	C368.335663,409.082764 368.670532,410.183563 369.009521,411.634552 
	C368.009399,410.903900 367.005157,409.823090 365.991974,408.379639 
	C365.983032,408.016968 366.029694,407.969116 366.372314,407.962006 
	C367.143585,407.963898 367.572205,407.972931 368.000824,407.981934 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M173.007294,267.753845 
	C172.844650,268.852112 172.654022,269.726379 171.905838,270.625977 
	C170.951721,269.407532 170.555145,268.163818 170.158585,266.920074 
	C170.857285,266.964539 171.555969,267.009033 172.603516,267.066315 
	C172.952362,267.079102 172.979309,267.529816 173.007294,267.753845 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M281.248657,384.748383 
	C281.776764,384.855316 282.190369,385.078674 282.986237,385.622986 
	C283.552399,386.010101 283.736359,386.076294 283.920319,386.142517 
	C284.369904,386.784210 284.819519,387.425903 285.350616,388.349182 
	C285.432129,388.630737 285.155670,388.870209 284.679443,388.913361 
	C283.103546,387.669891 282.003876,386.383270 280.904205,385.096649 
	C280.904205,385.096649 281.134155,384.864807 281.248657,384.748383 
z"
          />
          <path
            fill="#E6D4C3"
            opacity="1.000000"
            stroke="none"
            d="
M269.992615,372.003387 
	C271.949158,371.543762 273.347809,371.772552 273.030823,374.588623 
	C272.980743,375.016907 272.772919,375.228546 272.478088,375.126587 
	C271.326569,374.145386 270.469879,373.266144 269.613190,372.386932 
	C269.613190,372.386932 269.866730,372.131805 269.992615,372.003387 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M199.039001,280.965576 
	C198.586670,280.974121 198.134354,280.982666 197.342804,280.993011 
	C196.663162,280.234344 196.322739,279.473846 195.965149,278.381958 
	C195.947968,278.050568 195.979645,278.019958 196.373672,278.009460 
	C197.526550,277.981476 198.285400,277.963989 199.022675,277.970978 
	C199.001114,277.995453 199.053314,277.957184 199.033264,278.333740 
	C199.021820,279.462036 199.030411,280.213806 199.039001,280.965576 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M249.019775,331.982269 
	C249.992813,332.761230 250.965851,333.540161 251.970062,334.658936 
	C251.133682,334.845978 250.266144,334.693207 249.197403,333.939911 
	C249.004059,332.887024 249.011917,332.434662 249.019775,331.982269 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M326.464020,427.080872 
	C325.404236,426.710480 324.561035,425.986053 323.640564,424.997681 
	C324.602417,425.398102 325.641510,426.062469 326.464020,427.080872 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M278.992065,318.369446 
	C279.655701,318.772736 280.326996,319.528900 281.002502,320.639038 
	C280.337738,320.236145 279.668701,319.479218 278.992065,318.369446 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M351.054199,393.348328 
	C351.966461,393.442749 352.929932,393.880615 353.938904,394.665100 
	C353.024750,394.571716 352.065094,394.131775 351.054199,393.348328 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M385.066650,443.509949 
	C384.347473,443.229553 383.611420,442.588745 382.777588,441.668671 
	C383.469788,441.976105 384.259766,442.562836 385.066650,443.509949 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M323.467590,424.092438 
	C322.514526,423.868103 321.752594,423.283081 320.874390,422.410950 
	C321.725006,422.659790 322.691864,423.195770 323.467590,424.092438 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M258.984009,314.604492 
	C258.854309,314.956787 258.651489,314.976959 258.144440,315.031494 
	C257.286804,314.550598 256.733368,314.035400 256.128601,313.235962 
	C257.021790,313.391968 257.966309,313.832153 258.984009,314.604492 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M246.036652,285.331360 
	C246.637604,285.457458 247.279373,285.903839 247.963943,286.669922 
	C247.363663,286.543610 246.720566,286.097656 246.036652,285.331360 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M295.052979,335.309967 
	C295.653442,335.444824 296.286835,335.902527 296.959534,336.680725 
	C296.361145,336.545105 295.723511,336.088959 295.052979,335.309967 
z"
          />
          <path
            fill="#EFF0EE"
            opacity="1.000000"
            stroke="none"
            d="
M467.043335,514.319092 
	C467.641968,514.449585 468.281525,514.901550 468.965912,515.673035 
	C468.368591,515.541870 467.726410,515.091248 467.043335,514.319092 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M266.937683,323.730896 
	C266.303223,323.611115 265.658478,323.153656 264.955353,322.389954 
	C265.573792,322.520203 266.250549,322.956726 266.937683,323.730896 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M334.908325,392.778839 
	C334.261627,392.621979 333.612793,392.133209 332.977264,391.320740 
	C333.629120,391.480347 334.267670,391.963623 334.908325,392.778839 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M336.930298,394.740479 
	C336.297455,394.621063 335.654144,394.164673 334.949707,393.400208 
	C335.565674,393.529266 336.242737,393.966370 336.930298,394.740479 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M154.923126,205.735260 
	C154.317398,205.586838 153.692001,205.109894 153.033295,204.310669 
	C153.634491,204.461182 154.268982,204.933975 154.923126,205.735260 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M248.687653,331.975098 
	C249.011917,332.434662 249.004059,332.887024 248.987427,333.678802 
	C248.346863,333.546753 247.715088,333.075287 247.055908,332.277100 
	C247.470856,331.956207 247.913193,331.962067 248.687653,331.975098 
z"
          />
          <path
            fill="#E6D4C3"
            opacity="1.000000"
            stroke="none"
            d="
M273.083618,374.910065 
	C273.788116,375.283539 274.389801,375.763855 275.094025,376.528381 
	C275.196594,376.812592 274.971710,377.032379 274.576294,377.045624 
	C273.711548,376.448761 273.242249,375.838654 272.772919,375.228546 
	C272.772919,375.228546 272.980743,375.016907 273.083618,374.910065 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M259.059082,299.300354 
	C259.661530,299.433990 260.293884,299.892242 260.968445,300.668640 
	C260.370087,300.532867 259.729523,300.078918 259.059082,299.300354 
z"
          />
          <path
            fill="#EFF0EE"
            opacity="1.000000"
            stroke="none"
            d="
M488.322449,514.958862 
	C488.455994,514.362854 488.908844,513.725708 489.682617,513.051514 
	C489.549591,513.648804 489.095673,514.283203 488.322449,514.958862 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M501.949585,350.736298 
	C501.453430,350.500061 500.984558,349.912354 500.732178,349.138153 
	C501.119751,348.959564 501.290833,348.967499 501.718506,348.976135 
	C501.975677,349.446167 501.976288,349.915497 501.949585,350.736298 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M360.747345,418.940674 
	C360.502197,419.044342 360.196564,418.864746 359.788544,418.430511 
	C360.019745,418.336365 360.353271,418.496857 360.747345,418.940674 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M176.915710,273.777283 
	C176.686981,273.908569 176.420364,273.720886 176.117493,273.213806 
	C176.351669,273.075928 176.617203,273.263855 176.915710,273.777283 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M376.776978,434.933685 
	C376.531921,435.037872 376.237091,434.871185 375.861755,434.454529 
	C376.096527,434.357300 376.411865,434.510040 376.776978,434.933685 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M352.814392,454.888245 
	C352.590210,454.980347 352.261749,454.809662 351.839539,454.367859 
	C352.067230,454.272949 352.388672,454.449219 352.814392,454.888245 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M331.975220,389.568756 
	C331.730652,389.771667 331.495850,389.640808 331.287659,389.161743 
	C331.518402,389.001221 331.741943,389.141693 331.975220,389.568756 
z"
          />
          <path
            fill="#E6D4C3"
            opacity="1.000000"
            stroke="none"
            d="
M283.919861,385.954163 
	C283.736359,386.076294 283.552399,386.010101 283.209351,385.696899 
	C283.339935,385.555206 283.629700,385.660492 283.919861,385.954163 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M416.880005,520.822388 
	C416.671844,520.879089 416.381561,520.690979 416.035858,520.240601 
	C416.252899,520.178040 416.525421,520.377869 416.880005,520.822388 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M171.128769,294.838959 
	C171.128769,294.838959 171.125702,294.394135 171.048309,293.855652 
	C170.330429,292.849030 169.689941,292.380920 169.049454,291.912781 
	C169.049454,291.912781 169.042328,291.456055 169.135239,290.951202 
	C164.492416,283.495209 156.671326,282.902527 149.510361,281.139130 
	C148.399017,280.865509 146.521103,282.264679 145.598755,283.385071 
	C145.238602,283.822571 146.602203,285.600159 147.059006,286.813232 
	C147.449081,287.849091 147.665024,288.950531 147.641739,289.910431 
	C145.805008,288.537506 144.238815,287.327881 142.772522,286.007294 
	C138.251892,281.935791 133.769394,277.821930 129.132507,273.531738 
	C128.785690,273.092621 128.540848,272.892273 128.147659,272.417419 
	C125.849731,269.013977 123.405869,266.078735 121.528587,262.817352 
	C117.571342,255.942505 119.241623,248.453995 120.550583,241.431595 
	C122.809135,229.314819 122.784332,218.716812 111.361565,210.442245 
	C107.995399,208.003799 106.373497,202.506699 105.036171,198.083603 
	C103.378616,192.601425 102.848404,186.778397 102.200623,181.118805 
	C103.706284,183.704681 105.040016,186.207657 105.935165,188.858719 
	C107.506187,193.511444 105.264923,199.255325 110.123657,203.352203 
	C111.904396,206.297897 113.381989,209.043213 115.245529,211.495209 
	C116.381721,212.990189 118.366821,213.833191 119.531998,215.314133 
	C124.772484,221.974899 125.269394,229.842117 124.552612,237.985718 
	C123.816467,239.735123 123.439651,241.378723 123.046799,243.393280 
	C123.022057,244.506760 123.013336,245.249298 122.738358,246.198654 
	C122.333839,247.279999 122.195587,248.154526 122.040382,249.469421 
	C122.028275,252.261597 122.033127,254.613373 122.022568,257.345398 
	C123.209518,262.380646 125.112801,266.575775 130.009201,269.892303 
	C130.009201,266.441040 130.009201,263.716858 130.017029,260.586731 
	C131.257095,250.589355 135.294937,242.954498 144.525955,238.687042 
	C145.959946,238.024109 146.907272,236.308517 148.404266,235.019470 
	C148.133789,233.143967 147.784332,231.195251 146.887299,229.544022 
	C145.465637,226.927170 143.677658,224.509323 142.387573,222.040741 
	C144.828812,223.381378 146.927155,224.688522 149.145081,226.258575 
	C149.846924,227.005585 150.429199,227.489716 151.043381,228.328186 
	C153.258392,232.339218 157.255508,235.244141 155.478607,240.326416 
	C144.308563,239.381500 135.992737,245.004044 133.427841,255.159943 
	C130.648651,266.164307 136.604736,276.026215 145.156281,277.369080 
	C146.276138,277.683746 147.149872,277.774445 148.438995,277.963135 
	C152.885483,278.443176 156.916580,278.825226 161.151489,279.402039 
	C161.893646,279.746094 162.431992,279.895447 163.152100,280.321960 
	C166.557861,283.402496 169.781830,286.205902 173.111084,289.106171 
	C173.216370,289.203033 173.497208,289.257721 173.627472,289.579224 
	C181.835159,298.275208 189.912582,306.649658 198.082581,315.248108 
	C198.365601,315.752899 198.625153,315.935669 199.077591,316.330688 
	C200.779221,318.122314 202.357025,319.603577 203.962234,321.042419 
	C203.989624,320.999939 203.914032,321.067169 203.972046,321.398987 
	C206.016998,323.861847 208.003937,325.992950 209.871353,328.321655 
	C209.546265,328.764191 209.288330,328.925232 208.615845,328.960632 
	C206.845627,328.597778 205.437561,328.276672 204.029510,327.955566 
	C203.147293,327.135712 202.265076,326.315887 201.176483,324.889099 
	C197.579422,319.884155 195.020981,314.616425 189.069336,312.894897 
	C188.884979,312.360046 188.700623,311.825226 188.133850,310.816711 
	C184.647629,306.771454 181.738586,303.000824 178.367462,299.702454 
	C176.324310,297.703400 173.565857,296.435394 171.128769,294.838959 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M204.020386,328.331329 
	C205.437561,328.276672 206.845627,328.597778 208.660156,329.312683 
	C210.116425,331.366547 210.909225,333.280060 212.256805,334.646393 
	C222.722824,345.258270 233.279144,355.781372 243.851395,366.287842 
	C245.715179,368.140015 247.880783,369.688843 249.740891,371.544281 
	C256.866913,378.652161 263.925201,385.827911 271.153625,393.283081 
	C275.193420,397.730438 279.088318,401.872986 282.996460,406.386963 
	C284.019531,407.483582 285.029297,408.208801 286.270691,408.961670 
	C286.502319,408.989380 286.965363,409.046448 287.013916,409.360809 
	C287.694580,410.127502 288.326752,410.579865 289.098663,411.312317 
	C289.549500,412.355652 289.860565,413.118866 290.264984,414.206482 
	C292.562683,416.362000 294.767090,418.193054 296.985748,420.012054 
	C297.000000,420.000000 296.975922,420.028290 297.015991,420.343811 
	C297.678467,421.126587 298.300842,421.593872 298.985901,422.364502 
	C299.706787,423.434967 300.364990,424.202118 301.046967,425.323792 
	C303.034210,427.128998 304.997711,428.579681 307.011566,430.342651 
	C307.715088,431.423706 308.368225,432.192474 309.043396,433.310242 
	C310.716309,435.101257 312.367188,436.543213 314.161530,438.259460 
	C315.214142,439.342102 316.123230,440.150452 317.050781,441.308228 
	C320.374908,444.775665 323.680573,447.893707 327.125183,451.278625 
	C327.852783,452.350372 328.441406,453.155212 329.015076,454.339966 
	C329.000793,455.479218 329.001495,456.238495 329.002197,456.997803 
	C327.053345,455.547668 324.887054,454.314423 323.189972,452.613159 
	C309.314667,438.703186 295.398468,424.829773 281.760834,410.688599 
	C273.638977,402.266846 266.193207,393.193359 258.078857,384.763885 
	C251.105118,377.519348 243.479263,370.906738 236.387268,363.770660 
	C228.315567,355.648712 220.456497,347.312042 212.628540,338.952972 
	C209.582504,335.700256 206.873672,332.131744 204.020386,328.331329 
z"
          />
          <path
            fill="#EDEFEA"
            opacity="1.000000"
            stroke="none"
            d="
M162.975327,302.014771 
	C164.338928,302.721039 165.742035,303.361572 167.055695,304.150940 
	C168.541397,305.043671 170.060913,305.939209 171.358749,307.070862 
	C173.053864,308.548920 174.568954,310.238434 176.106216,311.888428 
	C176.421555,312.226898 176.361954,312.947113 176.696289,313.230560 
	C181.004547,316.882904 185.375320,320.461639 189.675461,324.123383 
	C190.756836,325.044220 191.695862,326.149628 192.611588,327.244446 
	C195.851547,331.118042 199.303360,334.847748 202.199326,338.966400 
	C205.142639,343.152405 208.345779,346.660522 213.451675,348.158264 
	C214.196350,348.376709 214.374390,350.170776 215.055023,351.049622 
	C216.002548,352.273041 217.012375,354.000000 218.286835,354.308655 
	C221.360733,355.053192 223.408035,356.837250 223.437927,359.791168 
	C223.442627,360.255005 223.524307,360.888092 223.825424,361.153015 
	C227.599243,364.473022 231.430466,367.727631 235.223053,371.026489 
	C236.516769,372.151794 238.093170,373.144501 238.939697,374.557678 
	C242.314026,380.190613 246.506042,384.742157 252.078278,388.492340 
	C254.934357,390.414551 256.082947,394.873779 257.799927,398.666992 
	C257.306976,399.306671 257.115570,399.544830 256.757324,399.726105 
	C255.674301,399.033356 254.856323,398.476471 253.976639,397.602112 
	C252.653168,396.174316 251.391388,395.063965 250.153320,393.712524 
	C250.177048,393.471436 250.116653,392.990387 250.335480,392.782776 
	C249.700043,392.052551 248.845764,391.529968 247.716522,390.858032 
	C246.539703,389.587067 245.637863,388.465454 244.800537,386.976990 
	C243.582291,385.403931 242.299545,384.197693 240.856964,382.703400 
	C238.465347,380.274506 236.233566,378.133636 233.862854,375.777039 
	C233.417786,375.433350 233.111649,375.305389 232.538177,374.998779 
	C231.078125,373.332642 229.885376,371.845184 228.665558,370.046448 
	C228.109238,369.476715 227.580017,369.218231 226.780609,368.816162 
	C225.941910,367.851807 225.373413,367.031067 224.761200,365.938293 
	C224.402969,365.515350 224.088440,365.364441 223.488892,365.112030 
	C222.483032,364.321655 221.762161,363.632751 221.032928,362.581482 
	C220.036194,361.464844 219.047821,360.710541 218.030945,359.976501 
	C218.002441,359.996735 218.043671,359.940216 218.038773,359.578613 
	C217.045929,358.460968 216.057968,357.704956 214.859344,356.733826 
	C214.022736,355.761200 213.396820,355.003693 212.804535,353.892212 
	C212.152206,353.139069 211.466248,352.739929 210.755127,352.302856 
	C210.729980,352.264954 210.700668,352.178772 210.687866,351.928406 
	C210.389938,351.552063 210.104813,351.426117 209.777283,351.284790 
	C209.734848,351.269409 209.659744,351.219330 209.724960,350.865234 
	C209.087219,350.115295 208.384262,349.719421 207.393219,349.201660 
	C206.036270,348.097656 204.967392,347.115601 203.823883,345.886475 
	C203.476898,345.440002 203.204559,345.240601 202.802917,344.740387 
	C200.769379,342.630585 198.865158,340.821594 196.922974,338.690125 
	C196.245712,337.931366 195.606430,337.495087 194.972137,337.032593 
	C194.977112,337.006409 194.940765,337.045807 194.925278,336.716980 
	C194.261978,335.938477 193.614182,335.488831 192.983398,335.024841 
	C193.000412,335.010468 192.960999,335.025421 192.949188,334.699799 
	C192.298660,333.915680 191.659943,333.457214 190.756989,332.869385 
	C190.009659,332.139679 189.526550,331.539368 189.037094,330.569366 
	C187.697311,329.125824 186.363876,328.051910 184.743546,326.822418 
	C182.996109,325.059753 181.535568,323.452667 180.058975,321.487488 
	C178.384033,319.741608 176.725159,318.353882 174.799133,316.831665 
	C173.948151,315.910706 173.364319,315.124237 172.722687,314.027771 
	C172.119553,313.473358 171.574234,313.229034 170.752167,312.825500 
	C169.303497,311.461456 168.131531,310.256592 166.944397,308.725708 
	C166.299149,307.929779 165.669098,307.459869 164.954041,306.814880 
	C164.869049,306.639771 164.714523,306.282501 164.693329,305.952545 
	C164.106537,304.419983 163.540939,303.217377 162.975327,302.014771 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M403.023315,530.980469 
	C402.376282,531.440308 401.729218,531.900085 401.036804,532.684448 
	C395.129242,531.198792 393.055023,525.530273 389.299316,521.567749 
	C385.002869,517.034668 380.557495,512.642761 376.259216,508.111359 
	C372.682892,504.341034 369.312012,500.373871 365.691956,496.647491 
	C361.955353,492.801117 357.959198,489.207550 354.203247,485.379089 
	C350.457703,481.561218 346.843536,477.612823 343.220764,473.676575 
	C340.797302,471.043427 338.459442,468.331482 336.421082,465.317017 
	C338.366486,466.012177 339.995758,467.013153 341.575989,468.086365 
	C343.424103,469.341492 345.229492,470.659668 347.261414,472.071411 
	C347.730072,472.395660 347.917511,472.652435 348.049072,473.311462 
	C349.705566,475.110718 351.344696,476.561127 352.991486,478.005768 
	C352.999146,478.000000 352.988129,478.013275 352.986389,478.378113 
	C355.989349,482.164001 358.994049,485.585052 362.037537,489.359253 
	C363.713684,490.811798 365.351074,491.911224 366.994263,493.005310 
	C367.000000,493.000000 366.989380,493.011597 366.991241,493.375977 
	C370.686981,497.475830 374.380829,501.211304 378.363525,505.104065 
	C380.798920,507.472961 382.945557,509.684570 385.099915,512.231262 
	C385.749939,513.037476 386.392303,513.508545 387.327393,514.135010 
	C391.063812,517.541992 394.507507,520.793579 397.957092,524.431702 
	C397.808929,527.639282 398.979828,529.198914 402.096710,529.274658 
	C402.490295,530.008362 402.756805,530.494385 403.023315,530.980469 
z"
          />
          <path
            fill="#F7E6C8"
            opacity="1.000000"
            stroke="none"
            d="
M257.022400,399.861938 
	C257.115570,399.544830 257.306976,399.306671 257.810303,399.049316 
	C265.122620,403.433167 270.435272,409.719086 275.540009,416.227661 
	C277.069000,418.177124 278.666687,420.085266 280.366760,421.886017 
	C294.186310,436.523529 308.009735,451.157623 321.899811,465.728088 
	C325.214417,469.205078 328.865356,472.360840 332.192688,475.826508 
	C333.385559,477.069000 334.080475,478.789581 334.646271,480.631775 
	C332.802979,479.676422 331.242889,478.455414 329.841766,477.073273 
	C323.844574,471.157349 317.894257,465.193878 311.700653,459.087891 
	C311.050385,458.584320 310.626282,458.240540 310.133240,457.563568 
	C308.392944,455.803375 306.721619,454.376434 305.025146,452.974731 
	C305.000000,453.000000 305.050415,452.950195 305.013885,452.631897 
	C304.338104,451.849487 303.698853,451.385315 303.031738,450.958801 
	C303.003845,450.996429 303.078064,450.939178 303.026611,450.605469 
	C299.340515,446.474030 295.705872,442.676239 291.969147,438.671997 
	C291.679688,438.207947 291.434937,438.028870 291.064728,437.596130 
	C289.419403,435.768768 287.842102,434.273499 286.183533,432.849304 
	C286.102203,432.920349 286.229187,432.745667 286.190063,432.436188 
	C285.452667,431.387634 284.754333,430.648529 283.963135,429.699738 
	C283.698425,429.224152 283.466278,429.030762 283.104675,428.576294 
	C281.426636,426.714783 279.817688,425.186829 278.149414,423.395508 
	C277.728271,422.756561 277.366425,422.381012 276.897705,421.694641 
	C275.616089,420.450165 274.441345,419.516479 273.218750,418.321899 
	C272.833344,417.677673 272.495819,417.294312 272.075684,416.581543 
	C270.043610,414.415436 268.094147,412.578705 266.086243,410.565247 
	C266.027740,410.388519 265.820435,410.079254 265.737610,409.797485 
	C265.142761,409.247803 264.630707,408.979889 264.063538,408.541138 
	C264.008392,408.370270 263.801788,408.076599 263.750305,407.790100 
	C263.106323,407.046265 262.513885,406.588928 261.936371,406.090790 
	C261.951324,406.049988 261.870972,406.083038 261.778656,405.770569 
	C260.105377,403.997498 258.524414,402.536926 256.962891,401.036865 
	C256.982300,400.997437 256.915131,401.054260 256.936737,400.755707 
	C256.979675,400.258759 257.001038,400.060333 257.022400,399.861938 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M311.926819,459.247742 
	C317.894257,465.193878 323.844574,471.157349 329.841766,477.073273 
	C331.242889,478.455414 332.802979,479.676422 334.634216,480.997498 
	C334.978546,481.023407 334.989746,481.006165 335.034668,481.346619 
	C339.047516,485.467468 343.015442,489.247864 346.983398,493.028290 
	C347.468018,493.607727 347.952606,494.187164 348.732727,495.236328 
	C352.338989,498.817108 355.649780,501.928192 358.960571,505.039246 
	C358.960571,505.039246 359.000000,505.000000 359.018219,505.336060 
	C359.677795,506.127655 360.319183,506.583130 360.960541,507.038635 
	C360.960541,507.038635 361.000000,507.000000 361.015076,507.359070 
	C363.008606,509.491882 364.987030,511.265656 366.965454,513.039429 
	C366.965454,513.039429 367.000000,513.000000 367.015869,513.355225 
	C368.757294,516.028137 370.482849,518.345764 371.851746,520.750977 
	C370.894104,520.597534 370.141754,520.510559 369.715332,520.091797 
	C364.890625,515.353943 360.168335,510.511078 355.315582,505.802521 
	C347.614929,498.330719 339.763123,491.013611 332.121857,483.482300 
	C328.472534,479.885498 325.677155,475.188202 321.550171,472.375732 
	C317.388153,469.539337 314.417572,466.171753 312.010742,461.651917 
	C311.978821,460.620087 311.952820,459.933899 311.926819,459.247742 
z"
          />
          <path
            fill="#EDEFEA"
            opacity="1.000000"
            stroke="none"
            d="
M147.957977,290.022949 
	C147.665024,288.950531 147.449081,287.849091 147.059006,286.813232 
	C146.602203,285.600159 145.238602,283.822571 145.598755,283.385071 
	C146.521103,282.264679 148.399017,280.865509 149.510361,281.139130 
	C156.671326,282.902527 164.492416,283.495209 169.121124,290.723236 
	C166.382050,289.866455 163.766098,288.693390 161.113632,287.609680 
	C158.159744,286.402863 155.172592,285.277405 151.700500,284.919006 
	C153.731384,291.347229 161.624298,293.200714 161.574844,300.658325 
	C160.474182,301.029755 159.719513,301.031860 158.708466,300.903687 
	C157.955124,300.200714 157.458191,299.628021 156.944427,298.721313 
	C156.262299,297.945160 155.596985,297.503052 154.966614,297.031921 
	C155.001556,297.002930 154.936996,297.068054 154.961334,296.695251 
	C152.969376,294.562683 150.953079,292.802948 148.723862,290.926270 
	C148.248428,290.602173 148.064102,290.340057 147.957977,290.022949 
z"
          />
          <path
            fill="#F7E6C8"
            opacity="1.000000"
            stroke="none"
            d="
M372.208405,520.663330 
	C370.482849,518.345764 368.757294,516.028137 366.996033,513.372375 
	C370.557526,515.858826 374.407288,518.419922 377.692535,521.569824 
	C382.590057,526.265503 387.224854,531.258850 391.673401,536.384277 
	C392.966614,537.874268 393.242737,540.247070 393.990723,542.601440 
	C393.996338,542.987793 393.509735,543.014771 392.974365,543.006348 
	C392.244446,542.977173 392.049866,542.956421 391.882507,542.592285 
	C391.054779,540.775330 390.199829,539.301880 389.311676,537.795898 
	C389.278503,537.763428 389.195679,537.721497 389.099182,537.497253 
	C388.792511,537.005066 388.521484,536.832642 388.086975,536.450684 
	C386.654541,534.818604 385.324768,533.491699 383.899536,531.879761 
	C383.234192,531.046387 382.664368,530.498047 382.002441,529.699463 
	C381.606964,529.279602 381.303558,529.109985 380.849426,528.676758 
	C379.613953,527.552124 378.529236,526.691101 377.338501,525.499023 
	C375.536804,523.731689 373.841095,522.295288 372.177734,520.815369 
	C372.210052,520.771790 372.208405,520.663330 372.208405,520.663330 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M171.130280,295.198792 
	C173.565857,296.435394 176.324310,297.703400 178.367462,299.702454 
	C181.738586,303.000824 184.647629,306.771454 187.892334,310.657623 
	C184.428391,308.109253 180.698471,305.387024 177.262939,302.333527 
	C174.999832,300.322083 173.160751,297.833527 171.130280,295.198792 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M189.048965,313.276764 
	C195.020981,314.616425 197.579422,319.884155 200.999329,324.641296 
	C197.028549,321.219849 193.028580,317.439240 189.048965,313.276764 
z"
          />
          <path
            fill="#F7E6C8"
            opacity="1.000000"
            stroke="none"
            d="
M346.999756,492.659576 
	C343.015442,489.247864 339.047516,485.467468 335.028381,481.354248 
	C340.263367,483.417786 344.476715,486.960205 346.999756,492.659576 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M347.053406,471.950470 
	C345.229492,470.659668 343.424103,469.341492 341.575989,468.086365 
	C339.995758,467.013153 338.366486,466.012177 336.397186,464.967255 
	C335.715393,464.504974 335.395325,464.054657 335.361206,463.270599 
	C336.086151,462.303375 336.525146,461.669952 337.315948,461.050537 
	C340.796295,464.693176 343.924866,468.321808 347.053406,471.950470 
z"
          />
          <path
            fill="#F7E6C8"
            opacity="1.000000"
            stroke="none"
            d="
M358.952087,504.685181 
	C355.649780,501.928192 352.338989,498.817108 348.986877,495.369659 
	C354.543579,495.696594 356.430511,500.350494 358.952087,504.685181 
z"
          />
          <path
            fill="#F7E6C8"
            opacity="1.000000"
            stroke="none"
            d="
M366.981415,512.676147 
	C364.987030,511.265656 363.008606,509.491882 360.995636,507.378876 
	C362.973175,508.797394 364.985260,510.555145 366.981415,512.676147 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M158.964859,301.033997 
	C159.719513,301.031860 160.474182,301.029755 161.605957,301.029785 
	C162.088272,301.347809 162.275284,301.603882 162.759705,301.907501 
	C163.540939,303.217377 164.106537,304.419983 164.372437,305.867859 
	C162.370102,304.420105 160.667480,302.727020 158.964859,301.033997 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M334.930298,461.105103 
	C333.306671,459.974731 331.683075,458.844330 330.369110,457.356781 
	C331.134583,456.988007 331.590454,456.976379 332.329285,457.111389 
	C333.424927,458.477203 334.237610,459.696350 335.022369,460.964233 
	C334.994446,461.012939 334.930298,461.105103 334.930298,461.105103 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M332.046265,456.964752 
	C331.590454,456.976379 331.134583,456.988007 330.335785,457.003662 
	C329.992828,457.007690 329.497375,457.002991 329.249786,457.000397 
	C329.001495,456.238495 329.000793,455.479218 329.351624,454.381897 
	C330.484192,455.017487 331.265228,455.991119 332.046265,456.964752 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M169.070709,292.248260 
	C169.689941,292.380920 170.330429,292.849030 171.020050,293.635071 
	C170.410095,293.496521 169.751022,293.040131 169.070709,292.248260 
z"
          />
          <path
            fill="#F7E6C8"
            opacity="1.000000"
            stroke="none"
            d="
M360.947876,506.707153 
	C360.319183,506.583130 359.677795,506.127655 358.998657,505.355652 
	C359.619019,505.484680 360.277100,505.930145 360.947876,506.707153 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M336.964142,461.036530 
	C336.525146,461.669952 336.086151,462.303375 335.333344,462.979736 
	C335.001892,462.595490 334.984222,462.168274 334.948425,461.423096 
	C334.930298,461.105103 334.994446,461.012939 335.341187,460.977722 
	C336.113342,460.973846 336.538757,461.005188 336.964142,461.036530 
z"
          />
          <path
            fill="#FDFEFF"
            opacity="1.000000"
            stroke="none"
            d="
M472.975098,288.077179 
	C472.986023,288.483185 472.996948,288.889221 473.006409,289.984528 
	C472.450958,292.524994 471.897003,294.376160 471.025024,297.290039 
	C476.711090,296.449860 481.945190,295.676453 487.179321,294.903076 
	C496.381104,294.185333 503.862701,299.680908 512.637695,301.888489 
	C513.009766,303.826263 513.009766,305.723877 513.009766,307.621521 
	C512.141113,308.197540 511.272491,308.773560 510.403839,309.349548 
	C509.496521,307.794922 508.589233,306.240295 507.308411,304.045715 
	C506.284424,304.647736 504.799408,305.520813 502.828979,306.561707 
	C498.882294,305.167877 495.421021,303.606201 492.183136,301.774872 
	C493.488983,301.073730 494.571381,300.642212 495.876007,300.122131 
	C493.834290,298.580170 492.216309,297.358246 490.083862,295.747742 
	C488.112946,297.460724 486.058899,299.245941 483.580750,301.031067 
	C480.111481,301.692719 477.066284,302.354431 473.618256,303.017944 
	C470.978729,303.505127 468.742035,303.990448 467.303375,304.302643 
	C466.626862,306.928192 466.166626,309.058289 465.522034,311.131073 
	C464.671906,313.865021 464.915741,316.018799 468.357300,317.120850 
	C470.794525,319.290802 472.934875,321.305298 476.075409,324.261169 
	C473.237244,325.016144 471.329712,325.958466 469.431915,325.939148 
	C465.307770,325.897217 461.184357,325.040344 457.068298,325.095154 
	C446.282227,325.238770 435.483612,325.436432 424.724152,326.137329 
	C419.778076,326.459534 414.912079,328.010986 410.009766,329.005005 
	C404.284760,330.362610 403.432495,335.310577 403.143555,339.732239 
	C402.400848,351.099213 402.212067,362.508362 402.029724,373.904266 
	C401.858887,384.583130 401.989929,395.266632 401.946869,405.947968 
	C401.944489,406.536224 401.564117,407.122986 401.004486,408.731445 
	C396.138672,404.019653 391.672119,399.810760 387.341095,395.466766 
	C383.264404,391.377838 379.300507,387.174652 375.348480,382.964050 
	C373.719971,381.228973 372.318390,379.281342 370.694946,377.541077 
	C368.530792,375.221069 366.226227,373.032806 364.026642,370.744965 
	C360.746155,367.332916 357.508423,363.879791 354.245819,360.450470 
	C347.631775,353.498383 341.070312,346.495026 334.378998,339.618103 
	C328.762421,333.845734 323.068451,328.143768 317.268951,322.555695 
	C311.346375,316.849060 305.244995,311.328186 299.246155,305.700104 
	C298.527252,305.025665 297.501007,304.246246 297.398193,303.418457 
	C296.765778,298.326355 293.253876,297.072327 290.957092,296.933502 
	C286.710602,292.255341 283.561371,288.613434 280.223511,285.153534 
	C276.277832,281.063568 272.162415,277.137604 268.133179,273.127869 
	C264.072388,269.086731 260.192657,264.845001 255.931213,261.028870 
	C251.059601,256.666321 257.140106,254.217285 258.279205,252.940704 
	C265.080475,245.318359 273.991974,240.471222 282.990631,235.543365 
	C292.315521,230.436829 302.468018,228.565414 312.239655,225.299591 
	C317.234009,223.630432 322.985779,224.318832 328.089783,222.867554 
	C338.799255,219.822433 349.396179,222.605286 359.864258,223.406433 
	C367.154327,223.964355 374.992096,224.572083 381.951813,228.729309 
	C386.891510,231.679947 392.824493,232.970749 398.323639,234.976242 
	C398.779633,235.142532 399.628998,234.943481 399.756927,235.191742 
	C403.078247,241.637772 411.039856,240.459473 415.542450,244.864426 
	C416.677185,245.974579 417.210358,247.714966 418.374420,248.777267 
	C423.588959,253.535736 428.593292,258.629608 434.316101,262.698578 
	C441.000305,267.451080 449.598145,265.455078 456.685730,258.567413 
	C459.633575,255.702713 462.645844,252.918167 467.800964,254.249451 
	C469.216370,256.018921 470.131042,257.462341 471.045715,258.905792 
	C471.023834,259.564270 471.232300,260.353821 470.943939,260.860718 
	C468.442627,265.257874 469.156708,269.041046 472.719116,272.889038 
	C471.367310,275.307373 470.226318,277.159180 468.775635,279.041870 
	C468.128143,279.480774 467.790283,279.888824 467.452423,280.296875 
	C467.987366,280.528839 468.522339,280.760773 469.065735,281.364532 
	C469.405487,283.151642 469.736786,284.566895 469.810333,286.162292 
	C469.559265,287.054199 469.565948,287.765961 469.572662,288.477722 
	C470.048584,288.036835 470.524506,287.595917 471.250397,287.133240 
	C471.662964,287.072113 471.825531,287.032745 472.166046,287.161224 
	C472.561646,287.572296 472.772003,287.821655 472.975098,288.077179 
M470.482788,273.588684 
	C470.482788,273.588684 470.416412,273.477478 470.482788,273.588684 
z"
          />
          <path
            fill="#F6A71E"
            opacity="1.000000"
            stroke="none"
            d="
M248.681000,262.160522 
	C248.986679,262.658203 249.292343,263.155914 249.890778,264.090546 
	C250.770615,265.347412 251.357697,266.167358 251.739853,267.112091 
	C251.983994,267.523834 252.433060,267.810791 253.141510,268.201111 
	C253.875183,268.855743 254.349487,269.406982 254.522491,270.016785 
	C254.871063,270.688263 255.520966,271.301239 256.308167,272.081787 
	C256.622925,272.477692 256.814972,272.692963 257.043060,273.260834 
	C261.378754,278.206757 265.652588,282.826630 270.056274,287.319214 
	C270.636627,287.911316 271.880463,287.853027 272.863647,288.108276 
	C272.910278,288.120544 272.946899,288.209747 273.047668,288.391113 
	C273.323364,288.797943 273.545776,288.957123 273.856354,289.063843 
	C273.897064,289.077637 273.914062,289.161865 273.936279,289.530365 
	C274.472626,291.242279 274.656738,292.886597 275.559021,293.876038 
	C279.107788,297.767639 282.811157,301.528198 286.626801,305.159088 
	C287.511047,306.000488 289.065033,306.138062 290.300537,306.646667 
	C290.290222,306.693848 290.259521,306.785370 290.197815,307.134583 
	C291.434540,308.322968 292.733002,309.162079 294.319275,310.048737 
	C294.990173,310.139069 295.373291,310.181885 295.756378,310.224731 
	C295.756378,310.224731 295.976685,310.036469 295.878021,310.427673 
	C295.852539,311.197845 295.925751,311.576843 295.760803,312.135620 
	C296.357635,312.886658 297.192627,313.457916 298.307983,314.075439 
	C298.960419,314.169159 299.332520,314.216553 299.704590,314.263916 
	C299.704590,314.263916 299.862427,314.102844 299.850189,314.504639 
	C300.559082,315.931213 301.280243,316.955994 301.998047,318.353180 
	C302.993347,319.484406 303.991974,320.243225 304.995117,321.000671 
	C304.999664,320.999298 304.997650,321.009583 304.996674,321.376648 
	C305.449158,322.770447 305.658051,324.041107 306.397522,324.782654 
	C310.000519,328.395813 313.682953,331.937653 317.494324,335.328186 
	C318.227936,335.980774 319.664215,335.843475 320.960266,336.267212 
	C321.405853,336.709381 321.667511,336.954895 321.949158,337.554688 
	C324.406769,341.189850 326.549194,344.760315 329.384674,347.650940 
	C331.313019,349.616791 334.212158,350.630432 336.796936,352.258423 
	C336.916748,352.446930 337.069824,352.866638 337.074097,353.225037 
	C341.074493,360.054443 345.637146,365.950775 352.911438,369.498322 
	C353.564026,370.980316 353.944611,372.330566 354.807648,373.204315 
	C363.737061,382.244720 372.721802,391.230988 381.766602,400.155884 
	C382.615845,400.993866 383.980164,401.309937 385.092255,401.883636 
	C385.079193,401.898956 385.096039,401.914825 385.098877,402.255249 
	C385.783661,403.032990 386.465576,403.470276 387.343689,404.015381 
	C387.779297,404.308929 387.969086,404.536072 388.103882,405.170776 
	C390.702881,408.056122 393.307281,410.575317 395.987976,413.444519 
	C397.644684,414.938416 399.225128,416.082367 400.863129,417.582275 
	C401.967255,419.614014 403.013794,421.289795 403.767609,423.169342 
	C401.465210,426.190369 399.862061,424.516327 397.901184,423.128815 
	C396.513031,422.146637 394.605377,418.853027 392.668732,422.910828 
	C389.897614,420.841797 387.423401,418.942261 384.973969,417.020935 
	C384.998779,416.999146 384.957245,417.049988 384.980011,416.674683 
	C383.362061,414.847931 381.721344,413.396484 379.789215,411.799438 
	C378.019287,410.073334 376.540802,408.492828 375.049988,406.553528 
	C373.286804,404.523346 371.535919,402.851959 369.588318,401.058075 
	C369.145782,400.738617 368.955170,400.497955 368.851318,399.852112 
	C363.873779,394.699219 358.864685,389.907806 353.649475,385.004333 
	C353.184631,384.701965 352.992096,384.459137 352.886475,383.803650 
	C348.752319,378.804382 344.659271,374.106506 340.374146,369.590881 
	C339.749634,368.932739 338.207947,369.144867 336.990906,368.803772 
	C336.891113,368.653198 336.760254,368.316467 336.813904,367.957031 
	C332.197906,362.357208 327.629791,357.020477 322.800354,351.931763 
	C321.231598,350.278778 318.979401,349.274414 316.819977,347.861847 
	C316.324371,347.551147 316.129669,347.291229 316.017120,346.607056 
	C315.433960,345.098785 315.081390,343.731934 314.229706,342.843597 
	C305.739746,333.988312 297.278564,325.100555 288.592102,316.439789 
	C276.083252,303.967926 263.329102,291.742340 250.802200,279.288361 
	C241.089737,269.632477 231.564911,259.787933 222.239166,249.783875 
	C221.877213,247.634537 221.312988,245.689484 220.439316,243.895096 
	C220.367767,243.748169 218.188156,244.627625 216.688049,244.882538 
	C214.239410,242.496094 212.090775,240.257294 210.407730,238.011993 
	C217.388596,236.576828 222.824677,238.763336 226.450409,244.005661 
	C228.006760,246.255905 227.678177,249.804321 228.240173,252.756424 
	C228.295883,253.048996 228.590851,253.296051 228.950439,253.820389 
	C232.102859,253.589951 235.574738,254.454727 237.645340,250.371887 
	C238.126953,249.422272 240.513565,249.438782 241.863861,249.368042 
	C240.329926,255.600327 241.432861,258.943848 245.631958,260.973083 
	C246.826935,261.470764 247.753967,261.815643 248.681000,262.160522 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M409.869446,329.329315 
	C414.912079,328.010986 419.778076,326.459534 424.724152,326.137329 
	C435.483612,325.436432 446.282227,325.238770 457.068298,325.095154 
	C461.184357,325.040344 465.307770,325.897217 469.431915,325.939148 
	C471.329712,325.958466 473.237244,325.016144 476.075409,324.261169 
	C472.934875,321.305298 470.794525,319.290802 468.344604,316.703674 
	C467.208588,310.471436 470.610931,306.742004 474.021088,303.016113 
	C477.066284,302.354431 480.111481,301.692719 483.804749,301.159637 
	C484.652344,301.747955 484.851807,302.207642 484.656921,302.784729 
	C481.999664,303.344086 479.606506,303.459229 477.501770,304.298004 
	C473.474670,305.902802 470.012939,308.588837 470.304047,313.352966 
	C470.574036,317.772339 473.680023,320.147705 477.978424,321.289154 
	C482.924438,322.602539 487.828033,324.153259 492.621887,325.944061 
	C499.972076,328.689819 502.990112,334.594147 503.330933,342.041656 
	C502.715942,342.016785 502.363434,341.994354 502.010162,341.593170 
	C501.563568,339.851501 501.117798,338.488586 500.671997,337.125702 
	C500.106720,337.213715 499.541443,337.301697 498.976166,337.389709 
	C498.976166,339.232513 498.976166,341.075317 498.976166,342.918121 
	C498.611084,342.921509 498.246033,342.924896 497.530914,342.517029 
	C497.002289,332.779877 497.002289,332.779877 488.628967,332.798889 
	C487.207275,332.733978 486.171539,332.729004 484.783386,332.491577 
	C460.026337,332.232635 435.621674,332.206085 410.920227,332.210876 
	C410.095062,332.513580 409.566681,332.784943 409.038269,333.056305 
	C409.268555,331.922058 409.498871,330.787842 409.869446,329.329315 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M411.216980,332.179535 
	C435.621674,332.206085 460.026337,332.232635 484.545746,332.822540 
	C482.086700,333.912750 479.506927,334.915192 476.940186,334.882904 
	C466.573334,334.752594 456.210052,334.031921 445.846283,334.047668 
	C435.394012,334.063538 424.942230,334.681763 414.492126,335.084961 
	C413.899384,335.107880 413.323730,335.573700 412.962585,335.734375 
	C412.962585,339.635864 412.953674,343.271942 412.964020,346.907990 
	C413.034607,371.724854 413.144196,396.541840 413.086792,421.358398 
	C413.083679,422.698700 411.989197,424.490601 410.853943,425.233429 
	C409.912170,425.849640 408.078827,425.484924 406.793884,425.074463 
	C405.763306,424.745270 404.962891,423.695557 404.060333,422.965607 
	C403.013794,421.289795 401.967255,419.614014 400.905884,417.529480 
	C400.891083,417.120789 400.981506,417.019409 401.239441,417.033234 
	C401.667969,417.023560 401.838562,417.000061 402.009155,416.976562 
	C402.009155,416.976562 402.450775,417.089203 402.743225,417.394226 
	C403.747833,418.430756 404.459991,419.162292 405.261353,420.228516 
	C406.630493,421.362457 407.910431,422.161621 409.943726,423.431213 
	C410.316498,417.927734 410.849091,413.487274 410.879974,409.043274 
	C411.058014,383.422485 411.117401,357.800873 411.216980,332.179535 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M395.010590,228.023621 
	C393.358856,227.818573 391.638489,227.841980 390.066956,227.369949 
	C382.136230,224.987885 374.357300,221.976746 366.305664,220.157486 
	C358.878754,218.479370 351.193756,217.510147 343.584503,217.218811 
	C338.156036,217.010941 332.666138,218.452759 327.201202,219.139221 
	C322.139709,219.774979 317.057159,220.270416 312.018799,221.052429 
	C309.270142,221.479050 306.603424,222.413513 303.882416,223.043961 
	C300.874908,223.740768 297.847595,224.351822 294.462219,224.633942 
	C298.580688,222.510178 303.055511,220.725830 307.554230,219.003845 
	C311.042664,217.668579 314.560974,216.411270 318.429199,215.084335 
	C319.524445,215.037292 320.256409,215.025208 321.052277,215.368408 
	C323.761871,215.180542 326.407623,214.637436 329.462524,214.068695 
	C331.237854,214.006210 332.604065,213.969345 334.257690,214.242218 
	C339.700653,214.351273 344.856232,214.150574 350.452271,213.950958 
	C353.238831,214.010086 355.584930,214.068161 358.019653,214.475128 
	C364.522644,216.418854 370.935638,218.019440 377.359711,219.574173 
	C377.516022,219.612015 377.795868,219.139404 378.406921,218.922394 
	C381.197479,219.620026 383.599213,220.300140 386.042542,221.351471 
	C387.018646,222.472153 387.913025,223.279663 388.895966,223.959015 
	C390.909027,225.350281 392.969574,226.672806 395.010590,228.023621 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M415.012299,238.986923 
	C412.259094,237.657501 409.505890,236.328064 406.379700,234.612473 
	C405.314789,232.509079 404.622864,230.791840 403.967773,229.030762 
	C404.004669,228.986908 404.076752,228.897873 404.444763,228.923752 
	C408.859406,231.120865 413.257904,232.826233 416.878845,235.561035 
	C424.243652,241.123459 431.471771,246.938217 438.215393,253.228806 
	C443.432404,258.095367 448.183044,256.595917 453.161774,248.700073 
	C454.805695,247.194962 456.278473,245.961929 458.091125,244.793060 
	C458.972595,244.253052 459.514221,243.648849 460.266174,242.930054 
	C460.738770,242.616653 460.927002,242.362885 461.371643,242.013214 
	C462.723328,241.568466 463.744415,241.164658 464.830444,240.826935 
	C464.895325,240.893021 465.025543,241.024811 465.013672,241.396301 
	C465.001587,242.511856 465.001404,243.255920 464.993408,244.244263 
	C464.985626,244.488510 464.973694,244.977112 464.607361,245.021759 
	C459.519592,245.589539 458.287689,249.322769 456.966583,252.973969 
	C456.479706,253.239655 455.992798,253.505341 454.911163,253.915298 
	C453.532776,255.030991 452.749146,256.002411 451.965485,256.973846 
	C451.965485,256.973846 451.483185,256.980988 450.823975,256.987183 
	C447.110260,257.329956 444.055725,257.666595 440.699707,257.849731 
	C437.598389,256.130188 434.798584,254.564163 431.998779,252.998169 
	C431.414795,252.509003 430.830780,252.019821 430.093597,250.919861 
	C425.709106,245.553101 421.958008,240.163971 415.012299,238.986923 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M293.012939,224.998322 
	C291.937073,226.006531 291.015015,227.300323 289.760101,227.976120 
	C282.184845,232.055573 274.320007,235.642670 266.983612,240.104172 
	C262.216614,243.003128 258.024506,246.935608 253.886185,250.743393 
	C251.779053,252.682190 250.358963,255.367691 247.977280,257.861450 
	C246.639877,257.991974 245.953506,257.976715 245.098541,257.771637 
	C244.842789,257.437714 244.755661,257.293610 244.775391,256.771484 
	C245.861191,254.883621 246.840103,253.373734 248.185974,251.881943 
	C249.314911,250.861755 250.076859,249.823456 250.889862,248.455505 
	C252.296432,246.751816 253.651962,245.377808 255.373932,244.003586 
	C257.122833,242.620499 258.505280,241.237625 260.117554,239.606522 
	C263.553253,237.230118 266.759125,235.101913 270.347229,232.981079 
	C273.160614,231.671432 275.591797,230.354431 278.321289,229.002213 
	C279.017395,228.921539 279.415253,228.876068 280.181732,228.859955 
	C282.040619,227.601562 283.530823,226.313828 285.309692,224.888046 
	C286.397339,224.479218 287.196259,224.208450 288.235168,224.227982 
	C289.987762,224.678299 291.500336,224.838318 293.012939,224.998322 
z"
          />
          <path
            fill="#E4CEA1"
            opacity="1.000000"
            stroke="none"
            d="
M410.920227,332.210876 
	C411.117401,357.800873 411.058014,383.422485 410.879974,409.043274 
	C410.849091,413.487274 410.316498,417.927734 409.943726,423.431213 
	C407.910431,422.161621 406.630493,421.362457 405.637390,420.229065 
	C406.943787,417.949890 408.835510,416.011658 408.850586,414.058929 
	C409.043915,389.037720 408.968872,364.014496 408.961914,338.991760 
	C408.971558,338.545624 408.981201,338.099487 409.004028,337.086792 
	C409.017242,336.520203 409.022858,336.053925 409.022888,336.053925 
	C409.019684,335.303925 409.016479,334.553955 409.025818,333.430115 
	C409.566681,332.784943 410.095062,332.513580 410.920227,332.210876 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M408.569183,339.085541 
	C408.968872,364.014496 409.043915,389.037720 408.850586,414.058929 
	C408.835510,416.011658 406.943787,417.949890 405.548218,419.894348 
	C404.459991,419.162292 403.747833,418.430756 402.971130,417.393250 
	C404.266418,413.788788 406.745697,410.509766 406.803589,407.188568 
	C407.166382,386.367126 406.959808,365.536163 407.042755,344.708771 
	C407.050110,342.864136 407.781372,341.022400 408.569183,339.085541 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M385.105316,401.868317 
	C383.980164,401.309937 382.615845,400.993866 381.766602,400.155884 
	C372.721802,391.230988 363.737061,382.244720 354.807648,373.204315 
	C353.944611,372.330566 353.564026,370.980316 352.975159,369.431274 
	C352.990814,369.011322 353.120087,368.878998 353.364380,368.878845 
	C353.608643,368.878662 354.078308,368.744110 354.078308,368.744110 
	C354.078308,368.744110 354.484070,368.932556 354.751221,369.336670 
	C356.620758,371.210693 358.223114,372.680664 359.825470,374.150604 
	C359.825470,374.150604 359.966187,374.035767 359.969849,374.427216 
	C361.261505,375.925171 362.549469,377.031677 363.837463,378.138184 
	C363.837463,378.138184 363.967133,378.032867 363.973022,378.424194 
	C365.600403,380.269989 367.221893,381.724487 368.843353,383.179016 
	C368.843353,383.179016 368.958527,383.557556 369.111145,384.062164 
	C371.185455,386.365173 373.107086,388.163544 375.028748,389.961945 
	C375.531830,390.533081 376.034912,391.104187 376.844604,392.081604 
	C377.443848,392.637268 377.736511,392.786682 378.029236,392.936096 
	C379.856812,394.831299 381.684387,396.726532 383.788757,399.100647 
	C384.412109,400.342468 384.758728,401.105377 385.105316,401.868317 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M251.944763,266.987305 
	C251.357697,266.167358 250.770615,265.347412 250.157471,264.222412 
	C251.206451,264.256989 252.593674,264.279877 253.309021,264.984680 
	C261.962891,273.510895 270.525391,282.130066 279.074860,290.761475 
	C279.493103,291.183716 279.571350,291.942719 279.426849,292.824524 
	C277.335205,291.790070 275.624634,290.475983 273.914062,289.161865 
	C273.914062,289.161865 273.897064,289.077637 273.800232,288.847473 
	C273.528717,288.337769 273.276550,288.201904 272.946899,288.209747 
	C272.946899,288.209747 272.910278,288.120544 272.800720,287.779053 
	C267.467957,282.590057 262.244812,277.742615 257.021637,272.895142 
	C256.814972,272.692963 256.622925,272.477692 256.211914,271.798035 
	C255.593491,270.883911 255.208649,270.421082 254.823807,269.958252 
	C254.349487,269.406982 253.875183,268.855743 253.094177,267.940125 
	C252.506592,267.379639 252.225677,267.183472 251.944763,266.987305 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M471.425293,258.972198 
	C470.131042,257.462341 469.216370,256.018921 468.152649,254.281860 
	C468.412628,252.365952 468.821686,250.743622 469.598602,249.050049 
	C470.641937,256.543671 474.437622,259.387604 484.180054,259.981506 
	C488.948181,260.272156 493.694092,260.927765 498.571808,261.939056 
	C498.126953,262.642944 497.560303,262.825989 496.993683,263.009033 
	C496.246857,262.995636 495.500061,262.982208 494.204254,262.722839 
	C493.089813,262.342987 492.524323,262.209045 491.958862,262.075073 
	C485.240845,261.062927 478.522858,260.050781 471.425293,258.972198 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M480.117859,173.932953 
	C480.891052,174.206940 481.664215,174.480942 482.861145,175.167297 
	C484.185028,176.052719 485.085175,176.525787 485.985352,176.998871 
	C486.778625,177.644547 487.571899,178.290222 488.678528,178.976715 
	C491.563629,182.079987 494.203125,185.089005 496.678955,188.227173 
	C497.934875,189.819046 498.895508,191.643845 499.617188,193.706146 
	C497.847351,193.023132 496.449951,191.997314 494.966095,190.651901 
	C493.165375,188.638931 491.451080,186.945541 489.737122,184.984894 
	C489.459320,184.530594 489.181213,184.343567 488.739258,183.879364 
	C487.086975,182.714233 485.598602,181.826279 484.017639,180.642303 
	C482.993286,179.540894 482.061523,178.735489 481.022583,177.662537 
	C480.317780,176.932632 479.720123,176.470291 479.330627,175.841400 
	C479.624756,175.164841 479.710724,174.654831 479.877441,174.092560 
	C479.958221,174.040329 480.117859,173.932953 480.117859,173.932953 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M293.250275,224.991608 
	C291.500336,224.838318 289.987762,224.678299 288.457458,223.948166 
	C298.315186,220.625137 308.190582,217.872238 318.065979,215.119324 
	C314.560974,216.411270 311.042664,217.668579 307.554230,219.003845 
	C303.055511,220.725830 298.580688,222.510178 294.028931,224.619934 
	C293.962280,224.972214 293.487610,224.984894 293.250275,224.991608 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M273.936279,289.530365 
	C275.624634,290.475983 277.335205,291.790070 279.357483,293.178619 
	C279.669220,293.253052 279.727264,293.255524 279.813019,293.560913 
	C280.513245,294.342194 281.127686,294.818085 281.742157,295.293976 
	C282.703278,296.367432 283.664398,297.440887 284.847595,299.067261 
	C285.721313,300.066498 286.372986,300.512726 287.024628,300.958984 
	C287.024628,300.958984 287.345245,301.152985 287.639526,301.430969 
	C288.137573,301.985626 288.400208,302.184631 288.721680,302.305908 
	C288.824860,302.657135 288.928009,303.008362 289.151611,303.915588 
	C289.618317,305.180908 289.964600,305.890228 290.310852,306.599518 
	C289.065033,306.138062 287.511047,306.000488 286.626801,305.159088 
	C282.811157,301.528198 279.107788,297.767639 275.559021,293.876038 
	C274.656738,292.886597 274.472626,291.242279 273.936279,289.530365 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M352.927094,369.078369 
	C345.637146,365.950775 341.074493,360.054443 337.396790,353.258636 
	C338.146484,352.948883 338.577789,352.963928 339.009064,352.978973 
	C339.566620,353.496368 340.124176,354.013733 340.877930,355.073700 
	C341.716705,356.076660 342.359283,356.537018 343.001831,356.997375 
	C343.495361,357.574432 343.988861,358.151459 344.763916,359.193237 
	C345.692535,360.109467 346.339630,360.560974 346.986694,361.012482 
	C347.485596,361.585052 347.984528,362.157623 348.760895,363.210693 
	C350.342438,364.814453 351.646545,365.937744 352.950653,367.061035 
	C352.950653,367.061035 353.076874,367.500122 353.094910,367.945312 
	C353.112915,368.390472 353.120087,368.878998 353.120087,368.878998 
	C353.120087,368.878998 352.990814,369.011322 352.927094,369.078369 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M336.677155,352.069885 
	C334.212158,350.630432 331.313019,349.616791 329.384674,347.650940 
	C326.549194,344.760315 324.406769,341.189850 322.274139,337.616516 
	C325.077820,339.515381 327.576447,341.706757 330.075043,343.898132 
	C330.888550,344.820374 331.702057,345.742645 332.794189,347.142731 
	C333.728119,348.056458 334.383362,348.492340 335.038635,348.928223 
	C335.038635,348.928223 335.344940,349.115540 335.585205,349.455261 
	C336.216583,350.196564 336.607727,350.598206 336.998871,350.999817 
	C336.998871,350.999817 337.000000,351.000000 336.927094,351.270142 
	C336.795166,351.716827 336.736145,351.893372 336.677155,352.069885 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M320.776337,336.070557 
	C319.664215,335.843475 318.227936,335.980774 317.494324,335.328186 
	C313.682953,331.937653 310.000519,328.395813 306.397522,324.782654 
	C305.658051,324.041107 305.449158,322.770447 305.308136,321.491882 
	C307.082825,322.156372 308.545074,323.072632 310.007324,323.988892 
	C310.146576,324.293579 310.354858,324.539886 310.942932,325.160339 
	C313.416199,327.492554 315.578735,329.392303 317.741272,331.292023 
	C318.247253,331.836700 318.753265,332.381348 319.559753,333.378571 
	C320.165649,334.577606 320.470978,335.324066 320.776337,336.070557 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M395.372925,228.023972 
	C392.969574,226.672806 390.909027,225.350281 388.895966,223.959015 
	C387.913025,223.279663 387.018646,222.472153 386.426544,221.347290 
	C392.538208,223.613892 398.307465,226.255890 404.076752,228.897888 
	C404.076752,228.897873 404.004669,228.986908 403.558289,229.007599 
	C401.734467,229.022125 400.357056,229.015961 398.979645,229.009796 
	C397.898193,228.681305 396.816742,228.352814 395.372925,228.023972 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M415.055267,239.326492 
	C421.958008,240.163971 425.709106,245.553101 429.970825,250.656067 
	C425.033569,247.224045 420.065887,243.445053 415.055267,239.326492 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M502.996277,207.000366 
	C501.000366,210.090210 499.004456,213.180069 496.657410,216.668320 
	C494.869354,217.712250 493.432434,218.357773 492.001221,218.636536 
	C493.040619,216.218033 494.074310,214.166290 495.472931,212.071655 
	C496.886261,210.675385 497.934692,209.322052 499.094849,207.750366 
	C499.411743,207.258408 499.680359,207.080658 500.385437,207.000641 
	C501.504425,207.001801 502.250366,207.001083 502.996277,207.000366 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M488.999268,224.995117 
	C484.904327,227.976425 480.809357,230.957733 476.389526,233.621094 
	C476.374023,232.182449 476.683350,231.061752 477.263916,229.890106 
	C477.954895,229.525711 478.374634,229.212280 479.151917,228.901947 
	C483.007568,226.268265 486.505707,223.631485 489.973694,221.340546 
	C489.628784,222.789291 489.314026,223.892212 488.999268,224.995117 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M476.992676,229.941071 
	C476.683350,231.061752 476.374023,232.182449 476.042969,233.654846 
	C476.021271,234.006546 476.001801,234.006546 475.638123,234.009003 
	C473.846100,235.338425 472.417755,236.665421 470.989380,237.992432 
	C470.180664,238.583511 469.371918,239.174576 467.993958,240.013641 
	C466.625000,240.516037 465.825287,240.770432 465.025543,241.024811 
	C465.025543,241.024811 464.895325,240.893021 464.941284,240.508011 
	C466.363861,238.102982 467.740509,236.082962 469.301697,233.831909 
	C470.298859,233.024261 471.111511,232.447632 472.274231,231.877563 
	C474.080444,231.236450 475.536591,230.588760 476.992676,229.941071 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M457.327637,252.950027 
	C458.287689,249.322769 459.519592,245.589539 464.621796,245.279602 
	C465.011383,245.664520 465.020142,245.836273 465.028870,246.008011 
	C462.582123,248.314041 460.135406,250.620071 457.327637,252.950027 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M320.960266,336.267212 
	C320.470978,335.324066 320.165649,334.577606 319.791565,333.535370 
	C323.170044,336.554535 326.617218,339.869446 330.069733,343.541260 
	C327.576447,341.706757 325.077820,339.515381 322.254211,337.262207 
	C321.667511,336.954895 321.405853,336.709381 320.960266,336.267212 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M309.986023,323.641449 
	C308.545074,323.072632 307.082825,322.156372 305.309113,321.124817 
	C304.997650,321.009583 304.999664,320.999298 304.902954,320.699677 
	C303.871307,319.593628 302.936340,318.787201 302.001373,317.980774 
	C301.280243,316.955994 300.559082,315.931213 299.792175,314.601318 
	C303.152496,317.295502 306.558594,320.294769 309.986023,323.641449 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M489.343964,224.962463 
	C489.314026,223.892212 489.628784,222.789291 490.094055,221.076111 
	C490.828217,219.978302 491.411865,219.490799 491.995514,219.003296 
	C493.432434,218.357773 494.869354,217.712250 496.649170,217.030884 
	C494.557617,219.639954 492.123138,222.284882 489.343964,224.962463 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M395.911682,413.094543 
	C393.307281,410.575317 390.702881,408.056122 388.406677,405.221863 
	C389.119537,404.965424 389.524170,405.023956 389.928802,405.082489 
	C390.393463,405.679199 390.858124,406.275940 391.683807,407.260864 
	C392.351288,407.787201 392.657776,407.925323 392.964233,408.063446 
	C393.542389,408.553711 394.120544,409.043976 394.814362,410.110352 
	C395.354614,411.374420 395.779205,412.062347 396.131348,412.836823 
	C396.058868,412.923370 395.911682,413.094543 395.911682,413.094543 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M441.001221,258.003235 
	C444.055725,257.666595 447.110260,257.329956 450.583008,256.996063 
	C448.700958,261.522705 444.767120,260.102325 441.058136,259.115723 
	C440.999786,258.345367 441.000519,258.174316 441.001221,258.003235 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M440.699707,257.849731 
	C441.000519,258.174316 440.999786,258.345367 440.995056,258.773315 
	C437.647095,257.891785 433.580750,257.969604 432.037201,253.366638 
	C434.798584,254.564163 437.598389,256.130188 440.699707,257.849731 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M399.032318,229.347534 
	C400.357056,229.015961 401.734467,229.022125 403.521393,229.051453 
	C404.622864,230.791840 405.314789,232.509079 406.008087,234.597351 
	C403.701294,233.207321 401.393127,231.446289 399.032318,229.347534 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M495.052521,190.971497 
	C496.449951,191.997314 497.847351,193.023132 499.592041,194.077286 
	C500.105682,195.021347 500.272095,195.937057 500.320251,197.330063 
	C500.201965,197.807343 499.925171,198.071426 499.583374,198.005341 
	C497.845245,195.616669 496.448883,193.294083 495.052521,190.971497 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M290.300537,306.646667 
	C289.964600,305.890228 289.618317,305.180908 289.257935,304.169067 
	C291.454712,305.744080 293.665680,307.621674 295.816528,309.862000 
	C295.373291,310.181885 294.990173,310.139069 294.197052,309.742065 
	C292.611176,308.520355 291.435364,307.652863 290.259521,306.785370 
	C290.259521,306.785370 290.290222,306.693848 290.300537,306.646667 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M317.802124,330.925049 
	C315.578735,329.392303 313.416199,327.492554 311.160828,325.270996 
	C313.332977,326.818787 315.597992,328.688446 317.802124,330.925049 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M389.928223,404.723145 
	C389.524170,405.023956 389.119537,404.965424 388.412109,404.855774 
	C387.969086,404.536072 387.779297,404.308929 387.215942,403.748596 
	C386.293396,402.887573 385.694733,402.401184 385.096039,401.914825 
	C385.096039,401.914825 385.079193,401.898956 385.092255,401.883636 
	C384.758728,401.105377 384.412109,400.342468 384.076477,399.261871 
	C386.034180,400.750732 387.980896,402.557251 389.928223,404.723145 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M471.382080,237.996338 
	C472.417755,236.665421 473.846100,235.338425 475.640381,234.016418 
	C476.223694,237.078979 474.633636,238.214294 471.382080,237.996338 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M375.026764,389.596863 
	C373.107086,388.163544 371.185455,386.365173 369.190796,384.243286 
	C371.086792,385.690430 373.055786,387.461121 375.026764,389.596863 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M245.267151,257.961426 
	C245.953506,257.976715 246.639877,257.991974 247.669861,258.017090 
	C248.424744,259.299622 248.835983,260.572357 248.964111,262.002808 
	C247.753967,261.815643 246.826935,261.470764 245.582184,260.616638 
	C245.265366,259.392059 245.266266,258.676727 245.267151,257.961426 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M502.998291,206.999146 
	C502.250366,207.001083 501.504425,207.001801 500.500732,206.681351 
	C500.573456,205.296387 500.903900,204.232605 501.448914,202.932327 
	C501.944580,202.122696 502.225708,201.549561 502.506805,200.976410 
	C502.506805,200.976410 502.734985,200.862686 503.105743,200.889099 
	C503.654663,200.933441 503.832825,200.951355 504.010986,200.969269 
	C504.007751,201.726181 504.004486,202.483093 503.742920,203.821472 
	C503.323853,205.262436 503.163147,206.121918 503.002441,206.981415 
	C503.002441,206.981415 503.000244,206.997910 502.998291,206.999146 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M359.855896,373.795013 
	C358.223114,372.680664 356.620758,371.210693 354.963409,369.407593 
	C356.567749,370.529388 358.227051,371.984406 359.855896,373.795013 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M368.869751,382.820953 
	C367.221893,381.724487 365.600403,380.269989 363.920197,378.488892 
	C365.539703,379.595795 367.217957,381.029327 368.869751,382.820953 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M502.390076,200.655167 
	C502.225708,201.549561 501.944580,202.122696 501.148956,202.970001 
	C500.093323,203.497391 499.552185,203.750610 499.015015,203.622086 
	C499.321045,201.517380 499.623108,199.794403 499.925171,198.071426 
	C499.925171,198.071426 500.201965,197.807343 500.349548,197.679825 
	C501.089172,198.479523 501.681244,199.406723 502.390076,200.655167 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M400.848328,417.173553 
	C399.225128,416.082367 397.644684,414.938416 395.987976,413.444519 
	C395.911682,413.094543 396.058868,412.923370 396.414307,412.917175 
	C397.158508,412.963379 397.547302,413.015808 397.936096,413.068207 
	C398.080200,413.362946 398.283051,413.609253 398.849487,414.203369 
	C399.747955,415.082733 400.341675,415.565979 400.935394,416.049194 
	C400.935394,416.049194 400.998779,416.006104 400.955566,416.272461 
	C400.912354,416.538849 400.981506,417.019409 400.981506,417.019409 
	C400.981506,417.019409 400.891083,417.120789 400.848328,417.173553 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M299.781921,313.899170 
	C299.332520,314.216553 298.960419,314.169159 298.210175,313.788910 
	C297.220978,312.955994 296.609955,312.455933 295.998962,311.955841 
	C295.925751,311.576843 295.852539,311.197845 295.776825,310.531403 
	C297.135925,311.340759 298.497589,312.437561 299.781921,313.899170 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M465.013672,241.396301 
	C465.825287,240.770432 466.625000,240.516037 467.724365,240.150314 
	C467.863556,241.207062 467.703156,242.375137 466.939423,243.773254 
	C465.891113,244.002213 465.446167,244.001099 465.001221,244.000000 
	C465.001404,243.255920 465.001587,242.511856 465.013672,241.396301 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M363.864929,377.781219 
	C362.549469,377.031677 361.261505,375.925171 359.911377,374.496704 
	C361.196960,375.257904 362.544678,376.341064 363.864929,377.781219 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M352.951843,366.711304 
	C351.646545,365.937744 350.342438,364.814453 349.011017,363.352936 
	C350.306824,364.130310 351.629913,365.245911 352.951843,366.711304 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M397.931763,412.719666 
	C397.547302,413.015808 397.158508,412.963379 396.486755,412.830627 
	C395.779205,412.062347 395.354614,411.374420 394.914154,410.382263 
	C395.907990,410.842438 396.917694,411.606781 397.931763,412.719666 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M452.310150,256.951294 
	C452.749146,256.002411 453.532776,255.030991 454.656372,254.026382 
	C454.215820,254.971710 453.435333,255.950226 452.310150,256.951294 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M503.327026,206.944000 
	C503.163147,206.121918 503.323853,205.262436 503.748352,204.199158 
	C503.891968,204.965775 503.771790,205.936188 503.327026,206.944000 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M287.000366,300.638672 
	C286.372986,300.512726 285.721313,300.066498 285.067627,299.291046 
	C285.702423,299.414032 286.339264,299.866211 287.000366,300.638672 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M281.791290,294.935974 
	C281.127686,294.818085 280.513245,294.342194 279.840820,293.569336 
	C280.468719,293.707550 281.154572,294.142761 281.791290,294.935974 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M464.993408,244.244263 
	C465.446167,244.001099 465.891113,244.002213 466.669861,244.005020 
	C466.556366,244.643631 466.109100,245.280548 465.345337,245.962738 
	C465.020142,245.836273 465.011383,245.664520 464.988159,245.234940 
	C464.973694,244.977112 464.985626,244.488510 464.993408,244.244263 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M342.981079,356.674774 
	C342.359283,356.537018 341.716705,356.076660 341.066040,355.290253 
	C341.692078,355.426880 342.326202,355.889526 342.981079,356.674774 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M346.968140,360.683960 
	C346.339630,360.560974 345.692535,360.109467 345.012939,359.337463 
	C345.636780,359.463104 346.293182,359.909271 346.968140,360.683960 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M335.007507,348.611084 
	C334.383362,348.492340 333.728119,348.056458 333.066589,347.292053 
	C333.699005,347.407013 334.337708,347.850464 335.007507,348.611084 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M503.952698,199.005310 
	C504.127289,198.615433 504.301941,198.225555 504.476562,197.835693 
	C504.470001,198.460327 504.463409,199.084946 504.220093,199.617096 
	C503.973175,199.351517 503.962921,199.178421 503.952698,199.005310 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M400.930115,415.717896 
	C400.341675,415.565979 399.747955,415.082733 399.059113,414.322388 
	C399.617615,414.492371 400.271240,414.939484 400.930115,415.717896 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M336.796936,352.258423 
	C336.736145,351.893372 336.795166,351.716827 336.927002,351.270752 
	C337.595886,351.480011 338.191925,351.958832 338.898499,352.708313 
	C338.577789,352.963928 338.146484,352.948883 337.392517,352.900269 
	C337.069824,352.866638 336.916748,352.446930 336.796936,352.258423 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M336.994629,350.680664 
	C336.607727,350.598206 336.216583,350.196564 335.755096,349.513184 
	C336.119965,349.608124 336.555145,349.984833 336.994629,350.680664 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M503.728699,199.150848 
	C503.962921,199.178421 503.973175,199.351517 503.991089,199.785156 
	C503.998779,200.045700 504.004944,200.507843 504.007965,200.738556 
	C503.832825,200.951355 503.654663,200.933441 503.220062,200.832733 
	C503.143982,200.265411 503.324371,199.780884 503.728699,199.150848 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M408.849731,336.121765 
	C409.022858,336.053925 409.017242,336.520203 408.995667,336.752136 
	C408.806152,336.820831 408.625153,336.667664 408.483246,336.484253 
	C408.459839,336.454010 408.607819,336.291168 408.849731,336.121765 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M401.239441,417.033234 
	C400.981506,417.019409 400.912354,416.538849 400.923645,416.296631 
	C401.289154,416.087036 401.573517,416.245148 401.898621,416.752686 
	C401.838562,417.000061 401.667969,417.023560 401.239441,417.033234 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M353.364380,368.878845 
	C353.120087,368.878998 353.112915,368.390472 353.183167,368.155975 
	C353.511169,368.017029 353.722748,368.174652 353.983215,368.569214 
	C354.078308,368.744110 353.608643,368.878662 353.364380,368.878845 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M288.705261,302.015839 
	C288.400208,302.184631 288.137573,301.985626 287.817963,301.488159 
	C288.031006,301.420197 288.359924,301.572968 288.705261,302.015839 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M392.842316,407.831726 
	C392.657776,407.925323 392.351288,407.787201 391.919678,407.420471 
	C392.103180,407.327911 392.411804,407.463959 392.842316,407.831726 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M377.925903,392.717407 
	C377.736511,392.786682 377.443848,392.637268 377.085449,392.240356 
	C377.354095,392.055542 377.621735,392.224213 377.925903,392.717407 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M562.770874,320.211853 
	C564.038635,323.869080 565.085693,327.746216 565.979370,331.658417 
	C566.340271,333.238373 566.365906,334.894958 566.856445,336.794525 
	C567.231812,338.095551 567.294861,339.118683 567.314514,340.875488 
	C567.298218,342.683502 567.325256,343.757874 567.244629,345.252380 
	C567.029907,346.817169 566.922852,347.961884 566.815796,349.106567 
	C566.260193,348.562134 565.277954,348.064148 565.212891,347.466339 
	C564.233765,338.467224 563.375305,329.455017 562.770874,320.211853 
z"
          />
          <path
            fill="#E0B770"
            opacity="1.000000"
            stroke="none"
            d="
M583.186340,356.816925 
	C582.359375,357.409790 581.670654,357.766968 580.836792,358.395020 
	C575.958679,358.986542 570.668335,360.655762 569.188110,353.495361 
	C569.992126,353.450226 570.512268,353.703491 571.032349,353.956787 
	C575.998474,358.206757 582.271240,356.644806 584.217041,350.375610 
	C584.713135,350.022369 584.915161,350.040466 585.117126,350.058533 
	C585.016479,351.717285 584.915833,353.376007 584.778381,355.444763 
	C584.269287,356.096924 583.796936,356.339081 583.186340,356.816925 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M567.352295,344.832275 
	C567.325256,343.757874 567.298218,342.683502 567.448669,341.236633 
	C568.269653,342.094727 568.913147,343.325256 569.015137,344.768005 
	C568.099854,344.930908 567.726074,344.881592 567.352295,344.832275 
z"
          />
          <path
            fill="#E0B770"
            opacity="1.000000"
            stroke="none"
            d="
M567.244629,345.252380 
	C567.726074,344.881592 568.099854,344.930908 568.758911,344.993164 
	C569.050110,345.740631 569.056091,346.475189 569.040588,347.991394 
	C568.908691,349.597626 568.798218,350.422180 568.687744,351.246765 
	C568.300720,351.177063 567.913696,351.107391 567.231812,351.017761 
	C566.928528,350.575745 566.920105,350.153687 566.863770,349.419067 
	C566.922852,347.961884 567.029907,346.817169 567.244629,345.252380 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M568.721313,351.544617 
	C568.798218,350.422180 568.908691,349.597626 569.060486,348.358276 
	C569.743286,349.678833 570.384766,351.414154 571.029297,353.553101 
	C570.512268,353.703491 569.992126,353.450226 569.191895,353.115662 
	C568.859375,352.637085 568.807129,352.239807 568.721313,351.544617 
z"
          />
          <path
            fill="#E0B770"
            opacity="1.000000"
            stroke="none"
            d="
M585.550598,337.243958 
	C585.838989,340.164368 585.849915,343.389740 585.595215,346.951447 
	C585.310791,344.041504 585.291992,340.795197 585.550598,337.243958 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M568.267395,334.788422 
	C567.686096,333.266602 567.369751,331.522675 567.099854,329.375397 
	C567.608276,330.836792 568.070312,332.701569 568.267395,334.788422 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M585.166626,349.713074 
	C584.915161,350.040466 584.713135,350.022369 584.206421,349.990295 
	C584.100342,349.323517 584.299072,348.670715 584.799438,348.001648 
	C585.139465,348.446136 585.177734,348.906891 585.166626,349.713074 
z"
          />
          <path
            fill="#B26F32"
            opacity="1.000000"
            stroke="none"
            d="
M473.379700,288.036774 
	C472.772003,287.821655 472.561646,287.572296 472.191895,286.721893 
	C471.710999,275.105743 474.573303,271.792633 484.778717,272.098114 
	C488.871521,272.220642 493.013641,272.866150 497.004517,273.815186 
	C508.710144,276.598877 519.418213,281.630646 529.054260,288.880280 
	C529.054260,288.880280 529.277161,289.149597 529.568604,289.531372 
	C532.790894,292.761780 535.721680,295.610474 538.652466,298.459137 
	C538.652466,298.459137 538.778687,298.776581 538.914185,298.880798 
	C542.721741,305.989166 546.742493,312.836945 549.973450,320.039032 
	C553.626892,328.182709 554.819458,336.937439 554.211121,345.866913 
	C554.077271,347.831207 553.827148,349.894958 553.085144,351.687103 
	C551.715820,354.994843 549.462280,358.718384 545.653137,357.743378 
	C542.881836,357.034027 539.493774,353.986267 538.685181,351.290009 
	C536.651855,344.509460 536.169861,337.282654 534.623840,330.333130 
	C530.919189,313.680908 522.122925,301.142944 505.162109,295.818787 
	C498.996063,293.883148 492.655090,292.496826 486.376312,290.930634 
	C482.195160,289.887665 477.982758,288.970062 473.379700,288.036774 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M529.048462,288.501923 
	C519.418213,281.630646 508.710144,276.598877 497.004517,273.815186 
	C493.013641,272.866150 488.871521,272.220642 484.778717,272.098114 
	C474.573303,271.792633 471.710999,275.105743 472.013916,286.554047 
	C471.825531,287.032745 471.662964,287.072113 471.058472,286.965790 
	C470.433716,286.540802 470.250885,286.261475 470.068054,285.982178 
	C469.736786,284.566895 469.405487,283.151642 469.075806,281.034363 
	C469.080048,279.891907 469.082672,279.451447 469.085327,279.010986 
	C470.226318,277.159180 471.367310,275.307373 472.757629,273.247253 
	C478.094360,272.069641 483.335571,269.824615 488.234985,270.415131 
	C496.643219,271.428589 505.054596,273.607056 513.046936,276.464752 
	C518.454651,278.398315 523.182800,282.277283 528.113525,285.444092 
	C528.738953,285.845764 528.748047,287.206940 529.048462,288.501923 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M513.008484,264.969757 
	C522.874390,268.004364 531.883301,272.501617 539.057800,280.545776 
	C535.520386,278.638885 532.026062,276.233398 528.332581,274.187653 
	C523.870728,271.716309 519.240051,269.549805 514.238525,266.849609 
	C513.532593,265.955139 513.270569,265.462463 513.008484,264.969757 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M548.991699,292.373230 
	C553.028259,298.735138 557.053345,305.466766 561.063354,312.586670 
	C560.460876,312.728210 559.568420,312.646759 559.331665,312.209961 
	C555.830078,305.748657 552.415466,299.240204 548.991699,292.373230 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M539.083618,281.265625 
	C542.401733,284.362946 545.685547,287.828217 548.983459,291.644897 
	C545.681519,288.542053 542.365417,285.087799 539.083618,281.265625 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M538.742737,298.081604 
	C535.721680,295.610474 532.790894,292.761780 529.727661,289.603943 
	C532.674438,292.097870 535.753723,294.900940 538.742737,298.081604 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M497.067993,263.375610 
	C497.560303,262.825989 498.126953,262.642944 498.861786,262.206177 
	C499.754883,262.001007 500.479736,262.049591 501.638306,262.456146 
	C503.044159,262.896149 504.016327,262.978149 504.988464,263.060181 
	C505.412109,263.096161 505.835785,263.132172 506.601501,263.501709 
	C506.964478,264.205292 506.985321,264.575287 507.006165,264.945312 
	C503.398132,267.168610 500.261658,265.525421 497.067993,263.375610 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M512.789001,264.730530 
	C513.270569,265.462463 513.532593,265.955139 513.921387,266.697266 
	C512.748108,266.578827 511.448212,266.210938 510.087830,265.229187 
	C510.031647,264.438568 510.035980,264.261810 510.040314,264.085083 
	C510.883392,264.220490 511.726440,264.355896 512.789001,264.730530 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M561.194702,315.103149 
	C561.853455,315.619934 562.423462,316.500275 562.940186,317.730774 
	C562.293213,317.209534 561.699524,316.338104 561.194702,315.103149 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M509.748840,263.913086 
	C510.035980,264.261810 510.031647,264.438568 510.009705,264.881409 
	C509.245911,265.092529 508.499756,265.037537 507.379883,264.963928 
	C506.985321,264.575287 506.964478,264.205292 506.914673,263.561951 
	C507.742950,263.439453 508.600159,263.590271 509.748840,263.913086 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M492.003540,262.360962 
	C492.524323,262.209045 493.089813,262.342987 493.830811,262.716614 
	C493.353638,262.853119 492.700928,262.750000 492.003540,262.360962 
z"
          />
          <path
            fill="#E2D4BD"
            opacity="1.000000"
            stroke="none"
            d="
M198.815247,169.314804 
	C201.660385,167.264633 204.303787,165.482803 206.974670,163.348511 
	C207.002136,162.996033 207.498337,163.001633 208.102158,163.008087 
	C209.505859,162.363968 210.305756,161.713394 211.105637,161.062836 
	C211.406143,160.961029 211.650314,160.782303 211.947052,160.326202 
	C213.346359,159.893738 214.769180,159.936172 215.906647,159.387299 
	C227.410095,153.836411 238.868256,148.191620 250.327988,142.550598 
	C250.582199,142.425476 250.705292,142.034012 250.955170,141.414230 
	C256.081024,139.719452 261.141266,138.377228 267.024719,137.033340 
	C270.831665,136.294968 273.779572,135.278946 276.807922,134.890350 
	C280.839691,134.373016 284.934143,134.344101 288.766602,134.387665 
	C283.854736,135.768387 279.167969,136.826065 274.502899,137.972183 
	C251.878143,143.530579 230.709976,152.567734 211.057663,165.041565 
	C204.800995,169.012833 198.959579,173.638336 192.846832,178.127380 
	C192.765533,178.290314 192.674133,178.642807 192.339020,178.726013 
	C189.224350,181.116135 186.593903,183.644989 183.610855,185.648972 
	C181.738342,186.906876 178.727097,188.642853 177.291199,187.951996 
	C173.631653,186.191254 171.163177,183.257416 170.968948,178.323273 
	C170.734100,172.357483 169.055679,166.448517 168.235413,160.373810 
	C169.296631,160.824310 170.124451,161.415985 171.103180,162.348572 
	C172.462982,167.969086 173.407791,173.332413 175.038925,178.478180 
	C175.539261,180.056641 178.425156,182.387756 179.344452,182.043015 
	C182.155762,180.988800 184.541946,178.800949 187.093506,177.054092 
	C187.093506,177.054092 187.547180,177.049805 187.773636,177.037018 
	C191.537903,174.543884 195.075699,172.063522 198.815247,169.314804 
z"
          />
          <path
            fill="#E2D4BD"
            opacity="1.000000"
            stroke="none"
            d="
M436.595520,146.055313 
	C439.627899,148.167587 442.266235,150.257339 444.571472,152.680206 
	C425.159058,144.735703 405.719696,137.445236 385.070465,134.304520 
	C374.120392,132.639038 362.994537,132.129272 351.486115,131.052307 
	C341.040222,131.062592 331.056244,131.118378 320.621002,131.087875 
	C317.429932,130.946335 314.690125,130.891068 312.067108,130.454193 
	C313.714661,129.716476 315.234955,129.118866 316.778259,129.051895 
	C320.586853,128.886642 324.468079,129.401276 328.210175,128.869293 
	C344.119507,126.607567 359.855438,128.408493 375.522278,130.789185 
	C386.416687,132.444656 397.191132,134.889557 408.019165,136.981781 
	C417.413269,139.998779 426.807343,143.015778 436.595520,146.055313 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M407.970154,136.614578 
	C397.191132,134.889557 386.416687,132.444656 375.522278,130.789185 
	C359.855438,128.408493 344.119507,126.607567 328.210175,128.869293 
	C324.468079,129.401276 320.586853,128.886642 316.778259,129.051895 
	C315.234955,129.118866 313.714661,129.716476 311.745758,130.515961 
	C310.872253,130.948547 310.436859,130.937775 309.749451,130.661804 
	C307.663544,129.966888 305.829742,129.537201 303.995911,129.107498 
	C307.033447,128.075272 310.055695,126.206566 313.111115,126.150620 
	C329.334900,125.853554 345.578949,125.644569 361.791138,126.170593 
	C369.577850,126.423241 377.323944,128.277374 385.062134,129.564468 
	C391.211609,130.587296 397.358582,131.690460 403.423615,133.112259 
	C405.076904,133.499817 406.430176,135.167297 407.970154,136.614578 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M289.001648,134.105362 
	C284.934143,134.344101 280.839691,134.373016 276.807922,134.890350 
	C273.779572,135.278946 270.831665,136.294968 267.422485,137.027390 
	C267.982635,136.067947 268.842590,134.481140 269.973450,134.256180 
	C280.309082,132.200272 290.322693,128.137863 301.507629,129.424683 
	C300.252869,130.221481 298.581543,130.468185 297.038879,131.053787 
	C294.957947,131.843719 292.975983,132.894424 290.630432,133.902374 
	C289.873413,134.016129 289.437531,134.060745 289.001648,134.105362 
z"
          />
          <path
            fill="#E2D4BD"
            opacity="1.000000"
            stroke="none"
            d="
M290.951569,133.833237 
	C292.975983,132.894424 294.957947,131.843719 297.038879,131.053787 
	C298.581543,130.468185 300.252869,130.221481 301.975372,129.451263 
	C302.508575,129.074661 302.933258,129.070587 303.676941,129.087006 
	C305.829742,129.537201 307.663544,129.966888 309.473694,130.947479 
	C303.283844,132.276642 297.117706,133.054932 290.951569,133.833237 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M133.303070,144.971344 
	C133.862900,137.700211 130.909424,132.001480 125.202606,126.863510 
	C124.368431,125.856934 123.781433,125.411255 123.194435,124.965569 
	C122.153709,123.967888 121.112984,122.970207 119.973328,121.329552 
	C119.231247,120.139229 118.588097,119.591881 117.944946,119.044525 
	C117.944946,119.044533 118.001877,119.003326 117.996284,118.601715 
	C117.657600,113.980858 117.652420,109.699661 116.871452,105.565002 
	C116.383705,102.982727 114.725906,100.621460 113.375671,97.906769 
	C108.029411,90.377289 100.412056,88.917664 92.529015,90.116051 
	C85.208565,91.228905 80.562851,96.215988 78.470848,103.546700 
	C76.345863,110.992981 79.361961,116.717476 83.970093,122.379440 
	C84.014519,123.109306 84.053871,123.525398 83.706863,123.956642 
	C82.547318,123.981194 81.774117,123.990601 81.000916,124.000000 
	C81.000916,124.000000 81.000000,124.000000 81.000000,123.999542 
	C78.911041,120.373756 76.822083,116.748428 74.383026,113.051727 
	C73.433105,102.730095 76.385101,94.112267 86.087051,88.089233 
	C93.872299,85.153191 100.941544,86.141197 108.006950,87.996895 
	C114.007767,91.226326 118.022896,96.102226 120.024269,102.607841 
	C120.449745,103.990906 121.091263,105.493942 120.911980,106.846069 
	C119.825478,115.040321 124.119347,120.572807 129.617706,125.737732 
	C133.425659,129.314774 137.204849,133.102219 135.813721,139.677948 
	C135.755493,140.463181 135.866943,140.725021 135.978409,140.986862 
	C136.295792,141.773666 136.613159,142.560455 136.729965,143.784912 
	C136.335510,144.490067 136.141617,144.757553 135.617554,145.017670 
	C134.625946,144.997330 133.964508,144.984344 133.303070,144.971344 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M135.947723,145.025040 
	C136.141617,144.757553 136.335510,144.490067 136.749878,144.104340 
	C137.509979,144.864304 138.496902,145.739899 138.502014,146.621170 
	C138.515274,148.902084 138.095657,151.185501 137.713913,154.716278 
	C147.798111,150.159729 156.828629,148.913483 165.421326,154.696701 
	C163.131760,154.994354 161.068527,154.969009 158.673218,154.957397 
	C157.910202,154.876495 157.479263,154.781876 156.920853,154.326508 
	C149.210709,150.456314 143.800644,155.978165 137.996979,158.688293 
	C132.912064,154.587982 136.393188,149.554718 135.947723,145.025040 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M186.702789,177.036621 
	C184.541946,178.800949 182.155762,180.988800 179.344452,182.043015 
	C178.425156,182.387756 175.539261,180.056641 175.038925,178.478180 
	C173.407791,173.332413 172.462982,167.969086 171.331268,162.242493 
	C171.605225,161.531143 171.802032,161.266800 171.998840,161.002441 
	C177.071014,163.026581 175.868179,167.967987 176.938538,171.815933 
	C177.277481,173.034378 176.934280,174.428680 177.014008,175.735748 
	C177.248505,179.580017 179.172897,180.545609 182.450562,178.627716 
	C183.643143,177.929886 185.019547,177.546188 186.702789,177.036621 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M107.959633,87.625618 
	C100.941544,86.141197 93.872299,85.153191 86.387619,87.936821 
	C89.167130,82.791191 94.593254,83.784920 99.213051,83.821533 
	C102.121689,83.844589 105.013153,86.035774 107.959633,87.625618 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M159.005310,154.943680 
	C161.068527,154.969009 163.131760,154.994354 165.581055,155.025360 
	C165.967133,155.031021 166.442993,155.067459 166.731598,155.386719 
	C167.044998,156.800461 167.069778,157.894943 166.752884,158.885498 
	C163.942566,157.502289 161.473938,156.222992 159.005310,154.943680 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M167.094559,158.989426 
	C167.069778,157.894943 167.044998,156.800461 166.970001,155.397507 
	C168.589310,156.828201 170.258835,158.567352 171.963608,160.654480 
	C171.802032,161.266800 171.605225,161.531143 171.180344,161.901581 
	C170.124451,161.415985 169.296631,160.824310 168.007477,160.292358 
	C167.395615,159.897858 167.245087,159.443649 167.094559,158.989426 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M135.980133,140.747391 
	C135.866943,140.725021 135.755493,140.463181 135.800934,140.115448 
	C135.957825,140.029556 135.981857,140.507919 135.980133,140.747391 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M503.593414,342.044098 
	C502.990112,334.594147 499.972076,328.689819 492.621887,325.944061 
	C487.828033,324.153259 482.924438,322.602539 477.978424,321.289154 
	C473.680023,320.147705 470.574036,317.772339 470.304047,313.352966 
	C470.012939,308.588837 473.474670,305.902802 477.501770,304.298004 
	C479.606506,303.459229 481.999664,303.344086 485.016846,302.890442 
	C486.517334,302.884918 487.263550,302.891083 488.319641,303.093811 
	C493.772247,305.431213 498.914978,307.572021 504.057678,309.712830 
	C504.720581,310.178864 505.383484,310.644867 506.460938,311.474274 
	C510.298035,315.614532 514.575195,318.928619 516.932922,323.282166 
	C520.081299,329.095459 521.739441,335.715820 524.037598,341.989563 
	C524.012878,342.747131 523.988159,343.504700 524.039856,344.634766 
	C523.815308,346.416107 523.329285,347.813995 523.244873,349.235687 
	C522.851990,355.859253 521.454163,357.586792 514.813171,358.512756 
	C509.675690,359.229065 507.970795,355.547272 506.690979,351.572662 
	C505.933319,349.219635 505.238647,346.846313 504.269165,343.906555 
	C503.879639,342.901978 503.736542,342.473053 503.593414,342.044098 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M524.314087,341.743774 
	C521.739441,335.715820 520.081299,329.095459 516.932922,323.282166 
	C514.575195,318.928619 510.298035,315.614532 506.765930,311.512939 
	C508.325714,312.073944 509.960541,313.034454 511.673676,313.825256 
	C513.557861,314.695038 515.212097,317.988007 518.252075,313.239777 
	C516.072876,321.857727 522.388062,326.111328 524.306396,332.028198 
	C525.241516,334.912354 524.547241,338.324738 524.314087,341.743774 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M504.022095,309.424500 
	C498.914978,307.572021 493.772247,305.431213 488.557343,302.838287 
	C489.643341,302.272278 490.801514,302.158417 491.959717,302.044525 
	C495.421021,303.606201 498.882294,305.167877 502.669647,306.876221 
	C503.325958,307.727325 503.656250,308.431732 504.022095,309.424500 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M109.983261,203.028137 
	C105.264923,199.255325 107.506187,193.511444 105.935165,188.858719 
	C105.040016,186.207657 103.706284,183.704681 102.131409,180.851074 
	C101.611313,180.211884 101.529831,179.856644 101.589111,179.369858 
	C101.729866,179.238312 102.013138,178.977097 102.013138,178.977097 
	C104.344444,180.039597 106.675743,181.102097 109.821053,182.535583 
	C110.956078,172.857300 112.045174,164.106720 112.978821,155.339584 
	C113.340752,151.940979 114.012405,148.377472 113.383232,145.112579 
	C112.091324,138.408554 103.737076,132.152557 96.880959,132.004105 
	C95.886635,131.982574 94.891548,131.995895 93.417015,131.645569 
	C92.627457,130.190720 92.317703,129.083359 92.386398,128.009338 
	C94.867935,127.761536 96.971016,127.480408 99.378677,127.176208 
	C100.086319,127.204056 100.489395,127.254990 100.994415,127.622559 
	C101.314026,128.181839 101.486015,128.508713 101.755898,128.655060 
	C116.213234,136.495026 119.573250,143.792160 115.558678,161.621475 
	C114.451187,166.540009 115.139450,171.862900 114.999802,177.326996 
	C114.958084,178.087357 114.920311,178.520966 114.524582,179.033875 
	C112.147346,181.685623 112.280090,183.998245 115.042465,186.299973 
	C115.455254,187.308197 115.823494,188.015228 116.014328,188.999908 
	C115.247253,189.525238 114.657593,189.772919 113.654343,190.015991 
	C112.161133,190.856277 110.255592,191.609726 110.150070,192.562515 
	C109.767738,196.014877 109.989471,199.534119 109.983261,203.028137 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M97.374496,221.988922 
	C96.266449,221.611435 95.507759,221.284958 94.422928,220.948181 
	C93.970428,215.443008 89.779968,217.372894 86.432144,216.977356 
	C79.799698,214.795807 72.509140,215.081665 68.190826,208.689590 
	C64.087044,202.615067 61.989300,196.822174 64.565796,189.004547 
	C67.180336,181.071518 72.658829,176.792404 78.952423,172.738449 
	C79.840012,172.166702 81.144005,172.241409 82.634079,172.367798 
	C82.995148,173.382156 82.977402,174.045609 82.629959,174.804535 
	C81.620285,174.974335 80.940300,175.048660 79.980019,175.175598 
	C79.484261,175.525558 79.268799,175.822906 78.811348,176.353271 
	C75.221741,180.076569 70.719246,183.018799 68.751923,187.164154 
	C63.682846,197.845322 68.089378,207.772629 78.130905,210.396790 
	C78.884422,210.711777 79.450607,210.798737 80.410446,210.977890 
	C83.185699,211.493286 85.567291,211.916473 88.029549,212.689758 
	C89.170280,213.682068 90.162956,214.699768 91.301598,214.904083 
	C97.613297,216.036728 104.886108,224.438736 105.014664,230.976120 
	C103.765396,229.256302 102.580414,227.484589 101.246658,225.833008 
	C100.165131,224.493744 98.904854,223.298843 97.374496,221.988922 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M82.959656,174.709076 
	C82.977402,174.045609 82.995148,173.382156 83.023178,172.388519 
	C85.078011,171.712585 87.122536,171.366806 89.733658,171.327332 
	C92.862793,173.426376 95.425331,175.219147 97.609459,176.974884 
	C94.470100,176.342392 91.709152,175.746933 88.561462,175.101685 
	C87.138489,175.097198 86.102280,175.142532 84.716400,175.100723 
	C83.897720,174.912079 83.428688,174.810577 82.959656,174.709076 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M97.987869,177.011917 
	C95.425331,175.219147 92.862793,173.426376 90.138062,171.328995 
	C97.327919,170.961594 99.808167,172.451569 102.004532,178.611176 
	C102.013138,178.977097 101.729866,179.238312 101.367264,179.154984 
	C99.999062,178.385071 98.993469,177.698486 97.987869,177.011917 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M92.007950,127.976013 
	C92.317703,129.083359 92.627457,130.190720 92.973122,131.643845 
	C90.367508,130.906616 87.725975,129.823608 85.446823,128.371765 
	C86.898750,127.984711 87.988304,127.966476 89.442642,127.951553 
	C90.540932,127.961922 91.274445,127.968964 92.007950,127.976013 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M89.077850,127.948242 
	C87.988304,127.966476 86.898750,127.984711 85.400238,128.007507 
	C83.688385,126.891441 82.385498,125.770836 81.041763,124.325111 
	C81.774117,123.990601 82.547318,123.981194 83.997246,124.098648 
	C86.141937,125.466408 87.609894,126.707321 89.077850,127.948242 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M504.791992,262.777344 
	C504.016327,262.978149 503.044159,262.896149 501.996765,262.518616 
	C502.812866,262.313599 503.704193,262.404053 504.791992,262.777344 
z"
          />
          <path
            fill="#E2AF55"
            opacity="1.000000"
            stroke="none"
            d="
M119.841682,371.047302 
	C119.835533,370.623993 119.829384,370.200653 119.847191,368.993835 
	C119.574493,358.926819 119.416367,349.635956 118.923790,340.362854 
	C118.670456,335.593811 118.134682,330.792175 117.177040,326.117828 
	C115.032425,315.649963 103.507103,306.063446 92.945549,306.166260 
	C88.018852,306.214233 83.807961,305.030884 79.832733,301.785400 
	C74.209404,295.327850 71.014313,288.596283 74.284172,280.232666 
	C74.941605,278.551117 75.680435,276.901428 76.381737,275.237030 
	C76.651093,275.103760 76.870079,274.912781 77.435699,274.384094 
	C78.573776,273.763123 79.314850,273.422089 80.116241,273.439331 
	C81.301903,274.092987 82.712067,274.977173 83.508255,274.592041 
	C90.876877,271.027802 97.163567,272.912537 102.956528,278.419586 
	C103.334229,283.320801 104.869469,288.156769 103.717384,292.233246 
	C102.576866,296.268829 98.725159,299.538147 95.828560,303.460571 
	C95.437119,303.141602 95.891838,303.838074 96.373650,303.857361 
	C110.729958,304.431671 122.401291,321.244110 121.068817,334.492065 
	C120.644608,338.709717 121.801674,343.061798 121.765633,347.348389 
	C121.699326,355.234589 121.284981,363.117889 120.721786,371.002869 
	C120.232468,371.018005 120.037071,371.032654 119.841682,371.047302 
M97.195595,297.171143 
	C97.195595,297.171143 97.234383,297.184357 97.925545,297.076324 
	C103.574883,292.562653 104.768265,287.596558 101.704735,281.349762 
	C99.042763,275.921753 93.307610,273.525757 86.957336,275.188599 
	C81.073494,276.729370 77.439896,282.098969 78.016243,288.401550 
	C78.592491,294.703125 82.923927,299.096252 89.678444,299.800140 
	C90.091438,299.754150 90.504433,299.708130 91.657684,299.880402 
	C93.493019,298.983521 95.328346,298.086639 97.195595,297.171143 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M79.979263,302.097198 
	C83.807961,305.030884 88.018852,306.214233 92.945549,306.166260 
	C103.507103,306.063446 115.032425,315.649963 117.177040,326.117828 
	C118.134682,330.792175 118.670456,335.593811 118.923790,340.362854 
	C119.416367,349.635956 119.574493,358.926819 119.769081,368.685059 
	C118.777191,368.066864 117.270142,367.052338 117.119438,365.865601 
	C116.746956,362.932251 116.995804,359.920013 117.177368,356.385193 
	C117.425476,355.719757 117.573387,355.551361 117.542717,355.507355 
	C117.402206,355.305573 117.211716,355.138611 117.039169,354.959167 
	C117.021141,348.624878 117.003105,342.290619 116.993530,335.113037 
	C116.368370,333.144379 115.734764,332.019043 115.101158,330.893677 
	C115.776245,327.264099 114.660469,324.319580 111.365051,322.028198 
	C110.915611,321.659851 110.734985,321.397491 110.233940,320.745239 
	C109.007645,318.864899 108.009529,317.437927 106.977859,315.653503 
	C103.933365,309.112244 98.278465,309.995544 92.932228,310.053833 
	C91.887245,310.037872 90.842255,310.021881 89.173935,309.729675 
	C87.376266,309.275940 86.201935,309.098450 84.859085,308.615631 
	C83.468979,305.974762 78.882767,306.190521 79.979263,302.097198 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M79.832733,301.785400 
	C78.882767,306.190521 83.468979,305.974762 84.845100,308.877686 
	C84.993088,309.619202 84.986557,309.793396 84.980026,309.967590 
	C83.617569,309.582825 82.037796,309.517334 80.927689,308.761810 
	C73.318405,303.582886 69.381264,292.665588 71.592140,283.653046 
	C71.978355,282.078644 71.481544,280.200989 72.125542,278.800415 
	C72.791069,277.352997 74.349976,276.316376 75.949905,275.168549 
	C75.680435,276.901428 74.941605,278.551117 74.284172,280.232666 
	C71.014313,288.596283 74.209404,295.327850 79.832733,301.785400 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M105.017258,231.314087 
	C104.886108,224.438736 97.613297,216.036728 91.301598,214.904083 
	C90.162956,214.699768 89.170280,213.682068 88.360474,212.578796 
	C89.073502,212.089050 89.536263,212.060379 90.214569,212.272263 
	C91.633080,212.396210 92.836067,212.279587 94.325287,212.157425 
	C94.990921,212.175186 95.370323,212.198486 95.857338,212.542633 
	C98.273216,214.939774 100.581467,217.016098 102.922256,219.049622 
	C102.954781,219.006836 102.901070,219.091415 102.912704,219.445831 
	C104.229858,221.251053 105.535378,222.701843 106.912086,224.336273 
	C106.983269,224.519913 107.129959,224.885468 107.082344,225.314575 
	C107.023651,229.496109 107.012573,233.248550 106.740234,236.793167 
	C106.006569,235.391068 105.534172,234.196777 105.061775,233.002502 
	C105.047806,232.552353 105.033829,232.102203 105.017258,231.314087 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M104.763664,233.258255 
	C105.534172,234.196777 106.006569,235.391068 106.749008,237.218292 
	C106.904411,239.542511 106.789757,241.233765 106.416550,242.991455 
	C106.117302,243.707748 106.076607,244.357605 106.032166,245.377396 
	C105.968460,246.484222 105.908501,247.221130 105.512024,248.044159 
	C105.116692,249.752106 105.057869,251.373932 105.007599,253.368271 
	C104.977814,254.483948 104.939461,255.227081 104.583954,255.977325 
	C103.843826,255.989838 103.420853,255.995239 102.997871,256.000641 
	C103.087364,250.246048 103.091591,244.488113 103.317635,238.738892 
	C103.386604,236.984940 104.065819,235.254959 104.763664,233.258255 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M80.851120,270.936462 
	C81.141205,270.765015 81.431297,270.593567 82.265427,270.223999 
	C86.901222,269.237457 90.992973,268.449036 95.084717,267.660645 
	C95.503479,267.728302 95.922241,267.795990 96.953873,268.062744 
	C98.705597,268.529999 99.844437,268.798126 101.097961,269.298737 
	C101.513184,269.951843 101.813728,270.372467 101.690994,270.847107 
	C94.385757,268.762939 87.720108,270.470642 81.001434,271.762268 
	C80.921219,271.302887 80.886169,271.119659 80.851120,270.936462 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M100.983284,269.066284 
	C99.844437,268.798126 98.705597,268.529999 97.272865,268.058289 
	C97.721909,266.934753 98.501564,266.041595 99.199348,265.088562 
	C100.310364,263.571106 101.366791,262.013702 103.011971,260.238708 
	C103.972801,260.017090 104.367966,260.029938 104.831833,260.371765 
	C104.908203,261.147797 104.915863,261.594818 104.672134,262.255920 
	C103.899139,264.994049 105.075020,268.402710 100.983284,269.066284 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M93.019783,310.406616 
	C98.278465,309.995544 103.933365,309.112244 106.611488,315.613647 
	C104.855614,315.617798 103.432564,315.304352 102.009506,314.990906 
	C102.009506,314.990906 102.000000,315.000000 101.962585,314.673828 
	C101.281960,313.905243 100.638748,313.462799 99.995544,313.020386 
	C97.699471,312.266724 95.403404,311.513092 93.019783,310.406616 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M95.046631,267.313812 
	C90.992973,268.449036 86.901222,269.237457 82.412392,270.016327 
	C83.883644,265.425018 91.766785,263.580719 95.046631,267.313812 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M102.158905,315.297729 
	C103.432564,315.304352 104.855614,315.617798 106.645035,315.971130 
	C108.009529,317.437927 109.007645,318.864899 110.014664,320.641113 
	C107.451813,319.195099 104.880058,317.399811 102.158905,315.297729 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M104.763123,260.042786 
	C104.367966,260.029938 103.972801,260.017090 103.280487,260.001434 
	C102.986664,258.932648 102.989975,257.866669 102.995583,256.400665 
	C103.420853,255.995239 103.843826,255.989838 104.623703,256.384796 
	C104.908104,257.871033 104.835617,258.956879 104.763123,260.042786 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M80.525963,270.986755 
	C80.886169,271.119659 80.921219,271.302887 80.986130,271.755981 
	C81.015984,272.025848 81.030701,272.042480 80.791969,272.119568 
	C80.375351,272.470367 80.197464,272.744141 80.017624,273.039795 
	C80.015678,273.061676 80.055939,273.081085 80.055939,273.081055 
	C79.314850,273.422089 78.573776,273.763123 77.539169,274.190247 
	C75.567787,270.767212 79.355682,272.244446 80.525963,270.986755 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M85.283066,310.105835 
	C84.986557,309.793396 84.993088,309.619202 85.013611,309.182983 
	C86.201935,309.098450 87.376266,309.275940 88.782028,309.726013 
	C87.871002,310.080383 86.728546,310.162231 85.283066,310.105835 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M100.039497,313.339111 
	C100.638748,313.462799 101.281960,313.905243 101.966995,314.667877 
	C101.367035,314.544647 100.725243,314.101227 100.039497,313.339111 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M487.071350,294.544159 
	C481.945190,295.676453 476.711090,296.449860 471.025024,297.290039 
	C471.897003,294.376160 472.450958,292.524994 473.025757,290.289246 
	C477.685486,291.331512 482.324432,292.758362 487.071350,294.544159 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M154.999390,473.002441 
	C154.999390,473.002441 154.506790,472.995117 154.260635,472.992065 
	C152.679474,469.581482 151.344467,466.173920 150.309586,462.534485 
	C153.727234,466.683777 156.778717,471.114899 160.020920,475.401733 
	C160.631149,476.208618 162.001831,476.440338 163.333878,477.006409 
	C164.433441,478.042267 165.220749,479.009216 165.759064,480.162201 
	C165.086349,482.880707 165.475601,483.294830 168.278976,483.188232 
	C170.352463,484.932037 172.151855,486.490051 173.939880,488.272461 
	C173.928513,488.496887 173.932571,488.946259 173.641022,489.001099 
	C173.565918,489.704712 173.782349,490.353455 174.312515,491.164429 
	C175.427658,493.208038 176.229065,495.089447 177.015686,496.985229 
	C177.000900,496.999664 176.971436,497.029236 176.971436,497.029236 
	C172.463928,492.608856 167.982864,488.160950 163.429871,483.787964 
	C162.328064,482.729736 160.988846,481.918671 159.393127,480.983337 
	C158.870209,479.480377 158.712967,477.988068 158.147247,475.966858 
	C156.825638,474.626099 155.912506,473.814270 154.999390,473.002441 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M137.010086,440.993744 
	C134.346054,434.915924 131.682007,428.838135 129.010223,421.973450 
	C128.570374,419.495819 128.098511,417.813995 127.715256,416.112244 
	C127.107582,413.414001 126.559174,410.702454 126.266953,408.110809 
	C127.285065,408.516846 128.021896,408.808624 128.831696,409.411163 
	C128.945679,410.145325 128.986725,410.568726 128.770050,411.197754 
	C130.655258,417.536316 132.710999,423.702545 135.029419,429.768402 
	C135.403397,430.746887 136.946655,431.278503 137.974060,432.009583 
	C137.998703,432.002472 137.978745,432.049744 137.971069,432.453674 
	C138.999741,436.882446 140.036118,440.907349 141.053589,444.949829 
	C141.034683,444.967438 140.997147,445.002930 140.739151,444.893860 
	C139.986664,444.524872 139.492172,444.264954 138.997681,444.005066 
	C138.997665,444.005066 139.000000,444.000000 138.995819,443.647095 
	C138.331131,442.527374 137.670609,441.760559 137.010086,440.993744 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M163.021622,476.937439 
	C162.001831,476.440338 160.631149,476.208618 160.020920,475.401733 
	C156.778717,471.114899 153.727234,466.683777 150.305145,462.151917 
	C149.173294,460.466614 148.345978,458.932007 147.267303,456.846375 
	C147.036667,455.830963 147.057419,455.366608 147.413605,454.967163 
	C149.185684,457.024261 150.622345,459.016388 152.197739,461.313721 
	C155.898178,466.725098 159.459900,471.831268 163.021622,476.937439 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M125.985687,407.996521 
	C126.559174,410.702454 127.107582,413.414001 127.715256,416.112244 
	C128.098511,417.813995 128.570374,419.495819 128.995209,421.594482 
	C127.005943,418.405029 124.693176,414.942993 123.148254,411.166870 
	C121.946167,408.228668 121.700638,404.899170 121.402084,401.360504 
	C122.510406,400.993866 123.246613,401.010284 124.183609,401.030090 
	C124.384392,401.033447 124.785324,401.018402 124.831192,401.369385 
	C125.246597,403.812439 125.616142,405.904480 125.985687,407.996521 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M121.183983,398.886536 
	C121.167000,398.485504 121.150024,398.084442 121.417770,397.320526 
	C121.499161,396.282959 121.295822,395.608307 121.080940,394.523254 
	C121.059479,392.745239 121.049561,391.377594 121.228035,389.781616 
	C121.629669,388.034363 121.842911,386.515472 122.337013,385.241272 
	C123.475433,389.949432 124.332993,394.412842 124.892197,398.922821 
	C124.394028,398.983246 124.194229,398.997101 123.640961,398.997070 
	C122.586319,398.950928 121.885155,398.918732 121.183983,398.886536 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M122.056152,384.996582 
	C121.842911,386.515472 121.629669,388.034363 120.962349,389.675446 
	C120.004562,389.533569 119.500847,389.269470 118.997131,389.005402 
	C118.992630,388.256622 118.988129,387.507812 118.972626,386.385071 
	C118.785294,383.832550 118.608955,381.653961 118.970680,379.444153 
	C120.272758,380.629272 121.036781,381.845612 121.871742,383.380005 
	C121.980507,384.130890 122.018333,384.563721 122.056152,384.996582 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M143.017258,451.983612 
	C143.017258,451.983612 143.000076,451.497864 142.964386,450.899719 
	C142.284851,448.535370 141.641006,446.769165 140.997147,445.002930 
	C140.997147,445.002930 141.034683,444.967438 141.385391,445.021484 
	C143.482986,447.725494 145.229874,450.375488 146.634018,452.988678 
	C145.199936,452.629150 144.108597,452.306366 143.017258,451.983612 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M143.050903,452.353699 
	C144.108597,452.306366 145.199936,452.629150 146.651978,453.301666 
	C147.034515,454.068359 147.056351,454.485321 147.078171,454.902252 
	C147.057419,455.366608 147.036667,455.830963 147.011368,456.643799 
	C145.699387,455.569458 144.391968,454.146606 143.050903,452.353699 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M140.739151,444.893860 
	C141.641006,446.769165 142.284851,448.535370 142.956909,450.656830 
	C141.658676,448.925568 140.332214,446.839111 139.001709,444.378845 
	C139.492172,444.264954 139.986664,444.524872 140.739151,444.893860 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M118.997116,389.428772 
	C119.500847,389.269470 120.004562,389.533569 120.773956,389.903809 
	C121.049561,391.377594 121.059479,392.745239 121.047379,394.789978 
	C121.013573,395.645355 121.001793,395.823639 120.990021,396.001953 
	C120.325714,393.952026 119.661407,391.902100 118.997116,389.428772 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M137.011169,441.348083 
	C137.670609,441.760559 138.331131,442.527374 138.992950,443.648102 
	C138.333603,443.235504 137.672928,442.468964 137.011169,441.348083 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M121.129227,399.228271 
	C121.885155,398.918732 122.586319,398.950928 123.640823,399.332703 
	C123.990379,400.130402 123.986603,400.578552 123.982834,401.026703 
	C123.246613,401.010284 122.510406,400.993866 121.407433,400.962463 
	C121.051941,400.488312 121.063210,400.029144 121.129227,399.228271 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M121.014458,396.273438 
	C121.001793,395.823639 121.013573,395.645355 121.058914,395.200317 
	C121.295822,395.608307 121.499161,396.282959 121.419853,397.019409 
	C121.104439,396.902466 121.071663,396.723694 121.014458,396.273438 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M337.476135,557.096680 
	C336.265198,557.096558 335.512268,557.062683 334.382751,557.035400 
	C329.929443,556.657471 325.852692,556.272949 321.390259,555.553040 
	C321.003937,554.480957 321.003326,553.744141 321.439941,552.999634 
	C323.917816,552.970581 325.958405,552.949341 328.410278,552.935425 
	C331.877014,552.636658 334.932526,552.330627 338.055115,552.365234 
	C339.790955,554.604797 341.147430,554.726990 342.437866,552.023804 
	C346.242004,552.318909 349.615448,552.613159 353.447632,552.939148 
	C355.856171,552.976257 357.850647,553.239868 359.742859,552.912415 
	C361.543945,552.600891 363.238220,551.672119 365.433411,551.009766 
	C373.339874,551.027283 380.625366,550.339355 387.294983,546.218323 
	C387.354370,547.603394 387.177765,548.798035 386.675354,550.002319 
	C385.914948,550.022278 385.480408,550.032593 384.702576,550.061035 
	C383.567871,551.036865 382.776428,551.994507 381.985016,552.952148 
	C381.985016,552.952148 381.996613,552.981873 381.596100,552.984863 
	C379.463287,553.340027 377.730988,553.692200 375.998688,554.044434 
	C375.562408,554.043213 375.126099,554.041992 373.922119,554.027161 
	C370.062653,554.343811 366.964264,554.622437 363.880585,555.016174 
	C358.916565,555.650024 353.962189,556.359802 349.003754,557.037537 
	C345.313904,557.046021 341.624023,557.054443 337.476135,557.096680 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M195.329163,515.133667 
	C194.353973,513.883606 193.701355,512.773682 193.035431,511.320312 
	C193.022095,510.976929 193.058563,510.939575 193.435303,510.954559 
	C194.626297,511.061493 195.628372,510.878815 196.225937,511.287567 
	C202.636612,515.672546 208.875397,520.318237 215.396622,524.528015 
	C218.338928,526.427307 221.808929,527.509277 225.274475,528.979858 
	C225.509415,528.997681 225.980225,529.018250 226.039459,529.367371 
	C231.728912,532.161743 237.359100,534.606934 242.989288,537.052185 
	C243.896378,538.175842 244.803467,539.299500 245.851715,540.717651 
	C240.937469,539.120911 235.895203,537.193115 230.818985,535.359497 
	C229.200241,534.774719 227.491287,534.439697 225.418167,533.986694 
	C217.491440,529.067444 209.986221,524.127136 202.438919,519.251892 
	C200.238205,517.830322 197.917465,516.594666 195.329163,515.133667 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M321.002716,553.007446 
	C321.003326,553.744141 321.003937,554.480957 321.007019,555.584717 
	C313.242767,554.879150 305.423676,554.088806 297.723053,552.659973 
	C288.806274,551.005493 279.991394,548.799683 271.143524,546.783875 
	C270.753418,546.694946 270.475128,546.115601 270.086182,545.368347 
	C270.027588,544.971985 270.081421,544.917175 270.507568,544.930786 
	C275.293213,545.599609 279.652679,546.254883 284.347046,546.927368 
	C285.128967,546.944275 285.575958,546.943970 286.250580,547.233887 
	C289.316040,547.682800 292.153870,547.841431 295.348175,548.065002 
	C297.742889,549.472961 299.718475,551.460205 302.359985,548.779419 
	C302.569550,548.801880 302.980133,548.897583 303.140778,549.177002 
	C304.534576,549.631958 305.767731,549.807434 307.373260,549.994507 
	C308.490601,550.019287 309.235565,550.032471 310.032074,550.364258 
	C311.051941,550.784546 312.020233,550.886292 313.322693,550.997559 
	C314.102509,551.009583 314.548218,551.012085 315.073822,551.386963 
	C317.103394,552.175293 319.053040,552.591370 321.002716,553.007446 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M270.000610,544.999329 
	C261.753906,542.568787 253.534164,540.110901 245.165344,537.318420 
	C245.016281,536.983826 245.069168,536.929810 245.475250,536.941650 
	C249.585999,537.622620 253.290665,538.291748 257.237915,539.248352 
	C261.660706,540.678223 265.840881,541.820618 270.022400,543.289734 
	C270.042969,544.050049 270.062195,544.483582 270.081421,544.917175 
	C270.081421,544.917175 270.027588,544.971985 270.000610,544.999329 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M243.318329,537.039551 
	C237.359100,534.606934 231.728912,532.161743 226.449631,529.348694 
	C228.507339,529.420288 230.238617,529.782471 231.915924,530.314758 
	C235.621399,531.490662 239.299698,532.752197 243.321213,533.991943 
	C244.096329,534.009644 244.539322,534.014160 244.987900,534.383484 
	C245.018723,535.475464 245.043945,536.202637 245.069168,536.929810 
	C245.069168,536.929810 245.016281,536.983826 244.989380,537.011353 
	C244.524109,537.034790 244.085739,537.030823 243.318329,537.039551 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M320.767151,557.732239 
	C319.534454,558.086426 318.071625,558.172729 316.306702,558.130798 
	C317.515411,557.823181 319.026215,557.643799 320.767151,557.732239 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M349.301208,557.328125 
	C353.962189,556.359802 358.916565,555.650024 363.880585,555.016174 
	C366.964264,554.622437 370.062653,554.343811 373.594971,554.034424 
	C373.263672,558.280762 369.364929,557.591125 366.892456,557.788818 
	C361.168976,558.246460 355.368134,557.736328 349.301208,557.328125 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M385.045837,550.042847 
	C385.480408,550.032593 385.914948,550.022278 387.039185,549.963989 
	C391.188965,548.858093 391.084473,546.031799 391.238586,543.141724 
	C391.434448,543.046936 391.855255,542.935730 391.855255,542.935730 
	C392.049866,542.956421 392.244446,542.977173 392.731506,543.026123 
	C392.973816,551.343750 392.049835,552.615356 385.396057,552.624878 
	C385.012390,551.513367 385.029114,550.778137 385.045837,550.042847 
z"
          />
          <path
            fill="#DEE1E2"
            opacity="1.000000"
            stroke="none"
            d="
M376.161011,554.346558 
	C377.730988,553.692200 379.463287,553.340027 381.601379,552.999878 
	C380.823273,556.025513 379.024323,556.903381 376.161011,554.346558 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M384.702576,550.061035 
	C385.029114,550.778137 385.012390,551.513367 384.989746,552.616577 
	C384.234222,552.987122 383.484558,552.989685 382.359955,552.972168 
	C382.776428,551.994507 383.567871,551.036865 384.702576,550.061035 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M121.800797,383.061951 
	C121.036781,381.845612 120.272758,380.629272 119.242027,379.202179 
	C119.081467,376.528046 119.187622,374.064697 119.567734,371.324310 
	C120.037071,371.032654 120.232468,371.018005 120.710152,371.326141 
	C121.029572,372.078461 121.066711,372.508026 121.035736,373.372131 
	C121.245354,376.891785 121.523079,379.976868 121.800797,383.061951 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M115.067650,331.278625 
	C115.734764,332.019043 116.368370,333.144379 116.989243,334.646118 
	C116.329041,333.902832 115.681595,332.783173 115.067650,331.278625 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M117.026215,355.222931 
	C117.211716,355.138611 117.402206,355.305573 117.542717,355.507355 
	C117.573387,355.551361 117.425476,355.719757 117.187889,355.922852 
	C117.015068,355.838776 117.014168,355.662750 117.026215,355.222931 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M337.315948,461.050537 
	C336.538757,461.005188 336.113342,460.973846 335.369141,460.929016 
	C334.237610,459.696350 333.424927,458.477203 332.329254,457.111389 
	C331.265228,455.991119 330.484192,455.017487 329.366577,454.001953 
	C328.441406,453.155212 327.852783,452.350372 327.105743,450.933533 
	C326.613007,449.232849 326.278656,448.144196 326.060028,446.939423 
	C326.175751,446.823334 326.406769,446.590759 326.700134,446.734802 
	C330.274841,449.686462 333.556213,452.494080 336.858032,455.476807 
	C336.878510,455.651978 337.013702,455.977722 337.112732,456.298767 
	C340.150818,459.400452 343.089844,462.181061 346.187988,465.036377 
	C346.347076,465.111115 346.694611,465.163940 346.793274,465.491760 
	C348.854584,467.678192 350.817230,469.536835 352.792603,471.554810 
	C352.805298,471.714111 352.941650,472.003235 353.044861,472.328339 
	C358.504059,478.290253 363.751923,484.034851 369.239136,489.540894 
	C379.753967,500.091827 390.404755,510.507202 400.997864,520.988831 
	C400.996582,520.998840 401.019318,521.000183 401.019318,521.000183 
	C407.695099,531.358826 412.412872,536.969421 423.608459,534.022156 
	C420.781067,541.239990 420.018799,541.402405 409.370422,536.701111 
	C408.296265,535.885559 407.641510,535.445251 406.986786,535.004883 
	C406.409363,534.513062 405.831909,534.021240 405.099243,532.946899 
	C404.320099,531.889526 403.696106,531.414734 403.072144,530.939941 
	C403.072144,530.939941 403.026428,530.935913 403.024872,530.958191 
	C402.756805,530.494385 402.490295,530.008362 402.082153,528.934814 
	C400.610748,526.913330 399.280975,525.479248 397.951202,524.045166 
	C394.507507,520.793579 391.063812,517.541992 387.288483,513.814819 
	C386.335266,512.858215 385.713745,512.377197 385.092194,511.896179 
	C382.945557,509.684570 380.798920,507.472961 378.309631,504.763306 
	C374.307770,500.514069 370.648560,496.762848 366.989380,493.011597 
	C366.989380,493.011597 367.000000,493.000000 366.864044,492.697693 
	C365.163086,490.897644 363.598053,489.399841 361.991302,487.563660 
	C358.962402,484.154572 355.975281,481.083923 352.988129,478.013275 
	C352.988129,478.013275 352.999146,478.000000 352.972351,477.658875 
	C351.307617,475.866058 349.669678,474.414337 348.031708,472.962646 
	C347.917511,472.652435 347.730072,472.395660 347.261414,472.071411 
	C343.924866,468.321808 340.796295,464.693176 337.315948,461.050537 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M403.087158,531.268066 
	C403.696106,531.414734 404.320099,531.889526 404.972656,532.687012 
	C404.368225,532.538513 403.735229,532.067322 403.087158,531.268066 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M407.030090,535.329346 
	C407.641510,535.445251 408.296265,535.885559 409.000183,536.649048 
	C408.390686,536.532715 407.732025,536.093323 407.030090,535.329346 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M193.003784,510.995544 
	C191.240067,510.341034 189.494675,509.667847 187.387482,508.984467 
	C185.016708,506.652832 183.022629,504.318268 180.993271,502.014801 
	C179.710175,500.558380 178.374374,499.148376 177.016815,497.373413 
	C176.971436,497.029236 177.000900,496.999664 177.362320,497.028229 
	C179.784943,498.361847 182.119125,499.381165 183.848557,501.033508 
	C187.102814,504.142670 190.008163,507.617035 193.058563,510.939575 
	C193.058563,510.939575 193.022095,510.976929 193.003784,510.995544 
z"
          />
          <path
            fill="#E2D4BD"
            opacity="1.000000"
            stroke="none"
            d="
M445.681580,153.294876 
	C447.194031,153.535446 448.706451,153.776001 450.610291,154.017761 
	C454.097565,155.991501 457.193451,157.964020 460.779449,160.275665 
	C461.845154,161.745621 462.420746,162.876465 462.641663,163.991058 
	C460.574585,163.261063 458.862152,162.547333 456.976593,161.545441 
	C453.096191,158.603165 449.388885,155.949020 445.681580,153.294876 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M462.996307,164.007309 
	C462.420746,162.876465 461.845154,161.745621 461.128448,160.320923 
	C462.755615,160.329956 464.523895,160.632843 466.638763,160.975891 
	C466.868317,162.174713 466.751282,163.333374 466.054443,164.725739 
	C465.028961,164.948380 464.583313,164.937302 463.896088,164.842804 
	C463.435120,164.508698 463.215698,164.257996 462.996307,164.007309 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M499.209900,343.103149 
	C498.976166,341.075317 498.976166,339.232513 498.976166,337.389709 
	C499.541443,337.301697 500.106720,337.213715 500.671997,337.125702 
	C501.117798,338.488586 501.563568,339.851501 502.006165,341.973389 
	C502.001923,343.491638 502.000854,344.250916 501.999786,345.010162 
	C501.819641,345.022125 501.639465,345.034088 501.190002,345.081909 
	C500.428345,344.507904 499.936005,343.898010 499.209900,343.103149 
z"
          />
          <path
            fill="#F3F3F3"
            opacity="1.000000"
            stroke="none"
            d="
M502.253418,344.903473 
	C502.000854,344.250916 502.001923,343.491638 502.006958,342.352173 
	C502.363434,341.994354 502.715942,342.016785 503.330933,342.041656 
	C503.736542,342.473053 503.879639,342.901978 503.986328,343.671936 
	C503.468933,344.274200 502.987976,344.535492 502.253418,344.903473 
z"
          />
          <path
            fill="#EAD8C5"
            opacity="1.000000"
            stroke="none"
            d="
M470.874817,169.270203 
	C472.670074,169.496170 474.465363,169.722137 476.614075,169.995575 
	C477.904449,171.162109 478.841400,172.281189 479.948090,173.666611 
	C480.117859,173.932953 479.958221,174.040329 479.544800,174.090607 
	C478.696442,174.243866 478.261505,174.346863 477.522888,174.334366 
	C476.480652,173.810120 475.742096,173.401367 474.950562,172.659973 
	C474.173798,171.981842 473.449982,171.636353 472.424927,171.209106 
	C471.515503,171.011154 470.907288,170.894958 470.255249,170.560760 
	C470.211456,170.342773 469.979309,169.963516 469.979309,169.963516 
	C469.979309,169.963516 470.006317,170.003220 470.170471,169.933807 
	C470.524597,169.675308 470.704651,169.477249 470.874817,169.270203 
z"
          />
          <path
            fill="#F1EFE7"
            opacity="1.000000"
            stroke="none"
            d="
M485.936768,176.655090 
	C485.085175,176.525787 484.185028,176.052719 483.147308,175.290436 
	C483.969238,175.437927 484.928741,175.874634 485.936768,176.655090 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M462.641663,163.991058 
	C463.215698,164.257996 463.435120,164.508698 463.993652,165.131897 
	C464.896179,165.665909 465.459534,165.827393 466.022888,165.988892 
	C466.287628,166.169632 466.524750,166.381348 466.850067,167.145248 
	C467.007660,168.080170 467.049438,168.493851 467.057220,168.942017 
	C467.023193,168.976486 466.955566,169.045837 466.661621,169.001984 
	C465.963928,168.577255 465.560150,168.196381 465.289429,167.717987 
	C465.229431,167.411911 465.036438,167.203369 464.465607,166.999237 
	C460.723816,166.791504 457.937225,165.731323 456.959869,162.039154 
	C457.023529,161.971008 457.149689,161.833588 457.149689,161.833588 
	C458.862152,162.547333 460.574585,163.261063 462.641663,163.991058 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M469.858093,169.773621 
	C469.979309,169.963516 470.211456,170.342773 469.880249,170.636292 
	C468.684570,170.301819 467.820068,169.673828 466.955566,169.045837 
	C466.955566,169.045837 467.023193,168.976486 467.393921,168.972015 
	C468.217682,168.953354 468.670654,168.939178 469.123657,168.924988 
	C469.333191,169.139771 469.537598,169.359360 469.858093,169.773621 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M469.060181,168.605255 
	C468.670654,168.939178 468.217682,168.953354 467.427979,168.937531 
	C467.049438,168.493851 467.007660,168.080170 466.965820,167.354095 
	C467.642761,167.456329 468.319763,167.870926 469.060181,168.605255 
z"
          />
          <path
            fill="#E2D4BD"
            opacity="1.000000"
            stroke="none"
            d="
M466.053406,165.740616 
	C465.459534,165.827393 464.896179,165.665909 464.235229,165.215302 
	C464.583313,164.937302 465.028961,164.948380 465.812042,164.977905 
	C466.127655,165.161697 466.105804,165.327011 466.053406,165.740616 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M470.660645,169.313416 
	C470.704651,169.477249 470.524597,169.675308 470.147186,169.939682 
	C469.953308,169.670517 470.115540,169.451065 470.660645,169.313416 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M445.503235,153.238510 
	C449.388885,155.949020 453.096191,158.603165 456.976593,161.545441 
	C457.149689,161.833588 457.023529,161.971008 456.598938,161.991577 
	C450.317657,159.006882 444.709137,155.293518 438.555115,153.136673 
	C423.521515,147.867691 408.370239,142.820465 393.000916,138.665787 
	C383.695038,136.150177 373.878967,135.553818 364.322296,133.918839 
	C360.158539,133.206497 356.070465,132.051666 351.948029,131.097794 
	C362.994537,132.129272 374.120392,132.639038 385.070465,134.304520 
	C405.719696,137.445236 425.159058,144.735703 444.607208,153.030304 
	C444.976044,153.047256 445.324921,153.182144 445.503235,153.238510 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M210.740479,161.043518 
	C210.305756,161.713394 209.505859,162.363968 208.350250,163.006042 
	C208.788116,162.339767 209.581711,161.681992 210.740479,161.043518 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M154.999557,473.376404 
	C155.912506,473.814270 156.825638,474.626099 157.868469,475.718933 
	C157.250122,475.999298 156.502075,475.998627 155.380157,475.995911 
	C155.004105,475.246063 155.001907,474.498230 154.999557,473.376404 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M449.667969,524.079468 
	C450.110352,528.799805 447.326416,527.694214 444.706787,526.746704 
	C437.352356,524.086609 433.383728,517.695435 428.285645,511.724152 
	C425.174561,508.350311 423.103943,504.389313 418.096771,504.896149 
	C415.866333,502.447449 413.635864,499.998718 411.320465,496.990417 
	C408.251801,493.160400 405.268066,489.889954 402.284363,486.619507 
	C402.186462,486.753784 402.088562,486.888062 401.990631,487.022308 
	C401.657562,486.934875 401.390076,486.751709 401.065247,485.897949 
	C398.636383,482.537933 396.330444,479.752838 393.874695,476.671082 
	C391.810791,474.923401 389.896667,473.472321 387.982544,472.021240 
	C387.400482,471.526947 386.818390,471.032623 386.114807,469.908142 
	C381.662384,464.518005 377.331421,459.757996 373.000488,454.998016 
	C370.100525,452.187378 367.186401,449.391174 364.304749,446.561859 
	C361.620361,443.926270 358.970490,441.255524 356.151886,437.884644 
	C355.990356,435.800873 355.982330,434.432739 355.974274,433.064606 
	C366.029144,442.960297 376.182373,452.758514 386.113342,462.777039 
	C397.797333,474.564056 409.319672,486.512146 420.850555,498.449860 
	C426.729889,504.536591 432.242401,510.998444 438.376770,516.809326 
	C441.491272,519.759583 445.616577,521.642700 449.667969,524.079468 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M100.892471,127.305916 
	C100.489395,127.254990 100.086319,127.204056 98.979126,127.058281 
	C93.505013,125.330849 88.735016,123.698257 83.965019,122.065674 
	C79.361961,116.717476 76.345863,110.992981 78.470848,103.546700 
	C80.562851,96.215988 85.208565,91.228905 92.529015,90.116051 
	C100.412056,88.917664 108.029411,90.377289 113.533569,98.299950 
	C114.244537,104.301636 114.580132,109.655876 114.915726,115.010124 
	C114.334351,114.124069 113.752975,113.238007 113.153374,112.324165 
	C112.143715,113.271965 111.274246,114.088165 110.111298,114.474884 
	C109.577591,110.294113 110.244545,106.174683 108.903519,102.870117 
	C106.312668,96.485710 100.405548,94.427574 93.052719,96.156403 
	C88.376633,97.255875 84.387466,101.769737 84.184837,106.190689 
	C83.828011,113.975967 87.008751,118.940369 93.674240,121.177475 
	C94.885727,121.584084 95.979019,122.342827 97.126877,122.939011 
	C96.241364,123.153763 95.355843,123.368515 93.663239,123.778999 
	C99.841957,125.211739 105.121574,126.617989 110.478378,127.605591 
	C113.398460,128.143951 114.480202,129.460098 113.599121,132.538879 
	C109.995689,129.034134 106.160797,126.557571 100.892471,127.305916 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M355.978088,433.040192 
	C355.982330,434.432739 355.990356,435.800873 355.997681,437.580231 
	C352.271027,434.437347 348.578644,430.847137 344.808624,427.340454 
	C341.733978,424.480530 338.484375,421.805847 335.460022,418.895538 
	C331.212402,414.808075 326.980438,410.691620 322.958344,406.385284 
	C315.317322,398.204285 307.829834,389.879913 300.148865,381.297852 
	C300.019165,380.980652 300.046539,380.953583 300.395599,380.963593 
	C301.521545,380.585083 302.298431,380.196564 303.075317,379.808014 
	C303.663544,380.597351 304.251770,381.386688 305.039093,382.720459 
	C305.536865,383.466949 305.835602,383.668976 306.134308,383.871002 
	C306.134308,383.871002 306.035248,383.844269 306.192535,384.117981 
	C306.911560,384.586243 307.473297,384.780762 308.035034,384.975281 
	C309.603210,386.446564 311.171417,387.917877 312.977570,389.912079 
	C313.486908,390.619202 313.758240,390.803406 314.029602,390.987640 
	C315.265533,392.153870 316.501465,393.320068 317.903320,395.091919 
	C318.687256,396.136688 319.305267,396.575775 319.923309,397.014862 
	C320.202576,397.220337 320.481812,397.425781 320.898987,398.165558 
	C321.404022,399.109131 321.771210,399.518372 322.138397,399.927612 
	C322.138397,399.927612 322.054810,399.946442 322.176208,400.171875 
	C322.812714,400.613922 323.327820,400.830566 323.842896,401.047180 
	C328.211243,405.422363 332.579559,409.797516 337.028534,414.850159 
	C337.795807,415.988647 338.482452,416.449677 339.169098,416.910706 
	C339.169098,416.910706 339.596954,417.011322 339.797821,417.465637 
	C341.688080,419.600281 343.377502,421.280579 345.066895,422.960876 
	C345.066895,422.960876 345.003754,422.995758 345.046509,423.299561 
	C345.753845,424.051636 346.418396,424.499878 347.082947,424.948120 
	C347.082947,424.948120 347.008270,424.990723 347.044006,425.312256 
	C349.012634,427.109161 350.945557,428.584534 352.878510,430.059906 
	C352.878510,430.059906 352.957794,430.034607 352.977661,430.432587 
	C353.978241,431.564789 354.958923,432.299042 355.939606,433.033295 
	C355.939606,433.033295 355.981873,433.015778 355.978088,433.040192 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M97.500313,122.937180 
	C95.979019,122.342827 94.885727,121.584084 93.674240,121.177475 
	C87.008751,118.940369 83.828011,113.975967 84.184837,106.190689 
	C84.387466,101.769737 88.376633,97.255875 93.052719,96.156403 
	C100.405548,94.427574 106.312668,96.485710 108.903519,102.870117 
	C110.244545,106.174683 109.577591,110.294113 109.760788,114.497208 
	C106.701469,119.005104 103.313675,122.490112 97.500313,122.937180 
M91.068184,101.520363 
	C87.395142,103.745888 87.826286,107.345116 87.993965,110.825569 
	C88.285278,116.872139 92.411835,119.959557 98.854652,119.003304 
	C104.091103,118.226089 108.727371,112.415642 107.822510,107.851601 
	C106.327820,100.312584 98.535103,95.853928 91.068184,101.520363 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M140.715195,196.071091 
	C129.682724,188.461884 126.321518,179.366928 129.378265,165.362915 
	C129.661087,164.067261 130.003540,162.784622 130.943039,161.281265 
	C132.958405,162.698898 134.348999,164.331207 135.675293,166.321716 
	C133.494217,173.855804 133.641815,180.992966 138.702072,186.716904 
	C141.242538,189.590561 145.508636,190.938660 148.782059,193.241379 
	C146.578857,193.286880 144.587936,193.067657 143.420944,192.939163 
	C142.338272,194.192368 141.526733,195.131729 140.715195,196.071091 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M114.067924,190.020615 
	C114.657593,189.772919 115.247253,189.525238 116.330002,189.081894 
	C117.760193,189.352936 118.697296,189.819626 119.634399,190.286331 
	C119.634399,190.286331 119.704918,190.353500 119.608047,190.508728 
	C119.511185,190.663940 119.626236,190.995682 119.626236,190.995682 
	C120.070709,191.652527 120.515190,192.309387 121.393219,193.387054 
	C124.211563,196.208893 126.596359,198.609879 128.981155,201.010880 
	C128.981155,201.010880 128.999390,201.001221 129.049103,201.345490 
	C135.741562,209.103516 142.384323,216.517258 149.019897,224.275665 
	C149.016968,225.078766 149.021225,225.537216 149.025497,225.995667 
	C146.927155,224.688522 144.828812,223.381378 142.120407,221.934662 
	C141.015045,221.509460 140.519745,221.223801 139.987732,220.585480 
	C137.984741,218.463669 136.018448,216.694534 133.923523,214.669373 
	C133.220428,213.925644 132.645935,213.437973 132.058304,212.576294 
	C131.917969,211.403427 132.067429,210.371323 131.620911,209.841766 
	C127.005493,204.368515 122.344604,198.930786 117.559387,193.606293 
	C116.756676,192.713120 115.299438,192.408188 114.129700,191.529572 
	C114.099144,190.825317 114.083534,190.422974 114.067924,190.020615 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M100.994415,127.622559 
	C106.160797,126.557571 109.995689,129.034134 113.552948,132.959015 
	C113.849152,133.116318 113.869148,133.085892 113.939705,133.417999 
	C115.256310,135.022781 116.502357,136.295471 117.748405,137.568161 
	C117.637817,137.888275 117.628418,138.211334 117.848259,139.163757 
	C121.306274,146.718475 119.138802,153.903015 118.964752,160.994644 
	C118.964752,160.994644 119.003639,160.998093 118.709793,161.245758 
	C117.655449,165.998886 116.894958,170.504349 116.134468,175.009827 
	C116.075035,175.442368 116.015602,175.874893 115.717506,176.660583 
	C115.478844,177.013733 115.003761,177.000259 115.003761,177.000259 
	C115.139450,171.862900 114.451187,166.540009 115.558678,161.621475 
	C119.573250,143.792160 116.213234,136.495026 101.755898,128.655060 
	C101.486015,128.508713 101.314026,128.181839 100.994415,127.622559 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M135.739609,165.963516 
	C134.348999,164.331207 132.958405,162.698898 131.219177,161.017120 
	C131.596024,155.910004 132.321503,150.852386 133.175018,145.383057 
	C133.964508,144.984344 134.625946,144.997330 135.617554,145.017670 
	C136.393188,149.554718 132.912064,154.587982 137.996979,158.688293 
	C143.800644,155.978165 149.210709,150.456314 156.490265,154.422607 
	C147.495041,155.112839 139.990982,157.537933 135.739609,165.963516 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M140.848099,196.386322 
	C141.526733,195.131729 142.338272,194.192368 143.420944,192.939163 
	C144.587936,193.067657 146.578857,193.286880 149.225922,193.239716 
	C152.242828,193.042068 154.603622,193.110809 157.051117,193.512115 
	C159.107178,195.212814 161.076523,196.580933 163.045883,197.949066 
	C159.501846,197.627502 155.937378,196.948990 152.423233,197.149994 
	C150.894989,197.237411 149.470108,199.132004 147.977722,200.610825 
	C147.660126,201.291718 147.363098,201.567596 146.949280,202.133301 
	C144.881989,200.515945 142.931488,198.608765 140.848099,196.386322 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M184.020935,256.978485 
	C188.206039,260.357300 192.613113,263.500732 196.515106,267.179810 
	C200.584274,271.016510 204.201126,275.338867 207.926941,279.527832 
	C208.530533,280.206421 208.673126,281.294983 209.023621,282.586975 
	C209.018433,282.979889 208.954773,283.044281 208.665009,282.883911 
	C200.120529,274.279266 191.865814,265.834961 183.713593,257.287659 
	C183.816071,257.184631 184.020935,256.978485 184.020935,256.978485 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M234.417923,313.973816 
	C233.738510,313.836578 233.475250,313.648621 233.184616,313.135925 
	C231.088425,309.832306 229.088684,306.756714 227.175385,303.209381 
	C227.261841,302.737610 227.511353,302.487335 227.768799,302.654602 
	C229.020752,303.558624 230.015244,304.295380 231.009735,305.032104 
	C231.009735,305.032104 231.279236,305.168182 231.566635,305.493164 
	C234.513153,308.265717 237.172287,310.713348 239.831421,313.160950 
	C239.831421,313.160950 239.898300,313.152283 239.953506,313.400757 
	C240.285507,313.912781 240.562302,314.176270 240.839096,314.439789 
	C242.639557,316.547852 244.440033,318.655914 246.585129,321.225769 
	C247.001663,322.078247 247.073578,322.468964 247.065567,322.935577 
	C246.985641,323.011505 246.823151,323.160553 246.823151,323.160553 
	C245.159943,322.418304 243.496750,321.676056 241.493088,320.887939 
	C239.023422,318.567993 236.894211,316.293945 234.417923,313.973816 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M149.027084,223.931000 
	C142.384323,216.517258 135.741562,209.103516 129.042877,201.354172 
	C130.079636,201.297226 131.535904,201.220840 132.208527,201.909668 
	C138.656418,208.512848 144.984421,215.233627 151.286942,221.976624 
	C151.586761,222.297363 151.324860,223.143127 150.759995,223.882996 
	C149.805984,223.991394 149.416534,223.961197 149.027084,223.931000 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M289.995117,369.005737 
	C287.437561,368.002472 284.227539,367.868561 283.314941,363.761902 
	C282.323029,362.527679 281.658295,361.769135 280.993530,361.010620 
	C280.993530,361.010620 281.000000,361.000000 280.969727,360.655914 
	C278.226471,356.610504 275.513489,352.909149 272.877502,349.128174 
	C272.954498,349.048553 273.108978,348.889740 273.108978,348.889740 
	C278.998596,355.000061 284.888245,361.110382 290.814819,367.765289 
	C290.566254,368.541840 290.280670,368.773773 289.995117,369.005737 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M227.137085,302.862732 
	C221.745789,297.794037 216.479248,292.600220 211.585571,287.144806 
	C212.976593,287.580872 213.994797,288.278503 215.012985,288.976135 
	C215.012985,288.976135 215.281601,289.129272 215.567352,289.472778 
	C218.841599,292.687714 221.830078,295.559113 224.818558,298.430511 
	C224.818558,298.430511 224.835739,298.727814 225.023590,299.150513 
	C225.978088,300.544617 226.744720,301.515961 227.511353,302.487335 
	C227.511353,302.487335 227.261841,302.737610 227.137085,302.862732 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M115.003769,115.344559 
	C114.580132,109.655876 114.244537,104.301636 113.751045,98.554207 
	C114.725906,100.621460 116.383705,102.982727 116.871452,105.565002 
	C117.652420,109.699661 117.657600,113.980858 117.971298,118.627029 
	C116.998535,117.928963 116.045181,116.803978 115.003769,115.344559 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M269.952179,349.077271 
	C269.132172,348.155273 268.312195,347.233276 267.186920,345.834869 
	C264.910492,342.592377 262.939362,339.826294 261.234528,337.013123 
	C261.678192,336.933350 261.855499,336.900635 262.032806,336.867950 
	C265.665863,340.662231 269.298950,344.456512 273.020508,348.570251 
	C273.108978,348.889740 272.954498,349.048553 272.528442,349.065369 
	C271.385651,349.080536 270.668915,349.078888 269.952179,349.077271 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M256.031128,334.949493 
	C253.000305,331.250702 249.969482,327.551880 246.880905,323.506836 
	C246.823151,323.160553 246.985641,323.011505 247.382446,323.029144 
	C250.812103,325.775726 253.844955,328.504669 256.877808,331.233612 
	C256.877808,331.233612 256.946289,331.613434 257.118530,332.076294 
	C257.880432,333.345856 258.470093,334.152618 258.680725,334.980560 
	C257.544861,334.984344 256.787994,334.966919 256.031128,334.949493 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M114.999802,177.326996 
	C115.003761,177.000259 115.478844,177.013733 115.715088,176.988770 
	C117.241264,181.140503 118.531204,185.317200 119.727768,189.890121 
	C118.697296,189.819626 117.760193,189.352936 116.507408,188.804260 
	C115.823494,188.015228 115.455254,187.308197 115.295334,186.058746 
	C115.296616,183.329071 115.089584,181.141815 114.882553,178.954575 
	C114.920311,178.520966 114.958084,178.087357 114.999802,177.326996 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M256.891357,330.855042 
	C253.844955,328.504669 250.812103,325.775726 247.462372,322.953217 
	C247.073578,322.468964 247.001663,322.078247 246.860504,321.397278 
	C251.943329,322.307861 254.843628,325.939331 256.891357,330.855042 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M119.259773,160.736572 
	C119.138802,153.903015 121.306274,146.718475 117.933807,139.393372 
	C118.926048,141.316818 120.781471,143.622040 120.824242,145.960434 
	C120.912605,150.790436 120.035042,155.638107 119.259773,160.736572 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M174.092834,247.907303 
	C177.983231,249.977402 182.633072,251.154312 183.976318,256.625610 
	C184.020935,256.978485 183.816071,257.184631 183.419876,257.148468 
	C180.661194,255.129349 178.298691,253.146408 175.830170,250.939545 
	C175.526764,250.428894 175.257706,250.250046 174.866898,249.886810 
	C174.529160,249.078140 174.241501,248.561722 173.988647,248.010864 
	C174.023438,247.976410 174.092834,247.907303 174.092834,247.907303 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M224.851532,298.049377 
	C221.830078,295.559113 218.841599,292.687714 215.720367,289.494995 
	C218.686569,292.005157 221.785522,294.836700 224.851532,298.049377 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M152.774551,226.098099 
	C155.519348,228.473709 158.264145,230.849319 160.953125,233.664566 
	C160.897308,234.104202 160.753143,234.250534 160.469238,234.180725 
	C159.797760,234.058105 159.410187,234.005310 158.869354,233.665283 
	C156.823013,231.579300 154.929932,229.780518 153.015137,227.664993 
	C152.920456,226.931534 152.847504,226.514816 152.774551,226.098099 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M116.493736,174.921204 
	C116.894958,170.504349 117.655449,165.998886 118.697388,161.230637 
	C118.270233,165.589432 117.561623,170.210999 116.493736,174.921204 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M259.059753,334.959351 
	C258.470093,334.152618 257.880432,333.345856 257.198120,332.252075 
	C259.063232,331.539520 261.020996,331.114014 263.512085,330.572571 
	C262.952240,332.665070 262.485687,334.408752 262.026001,336.510193 
	C261.855499,336.900635 261.678192,336.933350 261.111145,336.748413 
	C260.167572,336.006989 259.613647,335.483154 259.059753,334.959351 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M239.861145,312.802155 
	C237.172287,310.713348 234.513153,308.265717 231.717514,305.497925 
	C234.350952,307.599640 237.120911,310.021484 239.861145,312.802155 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M227.768799,302.654602 
	C226.744720,301.515961 225.978088,300.544617 225.095612,299.280823 
	C228.812317,298.612396 231.676575,299.356934 231.006927,304.613159 
	C230.015244,304.295380 229.020752,303.558624 227.768799,302.654602 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M128.990265,200.640961 
	C126.596359,198.609879 124.211563,196.208893 121.684967,193.489044 
	C126.060066,193.403961 127.681541,196.678085 128.990265,200.640961 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M215.009827,288.563049 
	C213.994797,288.278503 212.976593,287.580872 211.668365,286.794617 
	C211.378311,286.705963 211.298218,286.716217 211.205093,286.416138 
	C210.392899,285.092133 209.673828,284.068207 208.954773,283.044281 
	C208.954773,283.044281 209.018433,282.979889 209.050369,282.946320 
	C212.801590,282.685089 215.705688,283.379547 215.009827,288.563049 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M300.005035,380.993896 
	C298.043213,379.206268 296.095520,377.405426 294.397888,375.151276 
	C295.185822,374.412018 295.723694,374.126068 296.261566,373.840118 
	C296.691895,374.135040 297.122253,374.429932 297.887085,375.077118 
	C298.422516,375.706055 298.686554,375.894135 299.013672,375.993683 
	C299.312256,376.409515 299.610840,376.825378 299.984192,377.878784 
	C300.054810,379.328796 300.050659,380.141174 300.046539,380.953583 
	C300.046539,380.953583 300.019165,380.980652 300.005035,380.993896 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M160.969376,234.031036 
	C163.027924,235.720215 165.014404,237.482590 166.904358,239.736450 
	C166.807831,240.227966 166.598450,240.473343 166.313324,240.308319 
	C164.269852,238.179062 162.511490,236.214798 160.753143,234.250534 
	C160.753143,234.250534 160.897308,234.104202 160.969376,234.031036 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M352.766113,429.749390 
	C350.945557,428.584534 349.012634,427.109161 347.066040,425.275330 
	C348.919495,426.424255 350.786621,427.931580 352.766113,429.749390 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M345.029541,422.625763 
	C343.377502,421.280579 341.688080,419.600281 339.987610,417.576416 
	C341.648407,418.918793 343.320312,420.604736 345.029541,422.625763 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M290.029053,369.344849 
	C290.280670,368.773773 290.566254,368.541840 290.972046,368.056122 
	C291.671387,368.305695 292.250519,368.809052 292.932068,369.983643 
	C293.032532,371.744934 293.030579,372.835022 293.028595,373.925079 
	C292.040070,372.511383 291.051575,371.097717 290.029053,369.344849 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M293.139313,374.157318 
	C293.030579,372.835022 293.032532,371.744934 293.061035,370.243042 
	C294.096283,370.954041 295.104919,372.076874 296.187561,373.519897 
	C295.723694,374.126068 295.185822,374.412018 294.373199,374.817657 
	C293.815643,374.754761 293.532837,374.572174 293.139313,374.157318 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M152.490906,226.008118 
	C152.847504,226.514816 152.920456,226.931534 152.677322,227.673615 
	C151.911316,227.990585 151.461395,227.982208 151.011490,227.973846 
	C150.429199,227.489716 149.846924,227.005585 149.145081,226.258575 
	C149.021225,225.537216 149.016968,225.078766 149.019897,224.275665 
	C149.416534,223.961197 149.805984,223.991394 150.485748,224.056305 
	C151.253113,224.700058 151.730179,225.309097 152.490906,226.008118 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M117.800476,137.177811 
	C116.502357,136.295471 115.256310,135.022781 113.949524,133.417877 
	C115.210037,134.319580 116.531288,135.553528 117.800476,137.177811 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M300.395599,380.963593 
	C300.050659,380.141174 300.054810,379.328796 300.101440,378.107758 
	C301.021576,378.218933 301.899231,378.738739 302.926086,379.533264 
	C302.298431,380.196564 301.521545,380.585083 300.395599,380.963593 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M355.822449,432.747986 
	C354.958923,432.299042 353.978241,431.564789 352.970276,430.473541 
	C353.863770,430.898560 354.784515,431.680603 355.822449,432.747986 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M123.181007,125.279099 
	C123.781433,125.411255 124.368431,125.856934 124.987289,126.603561 
	C124.401962,126.467216 123.784775,126.029915 123.181007,125.279099 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M339.081665,416.605835 
	C338.482452,416.449677 337.795807,415.988647 337.102905,415.175964 
	C337.729156,415.316559 338.361694,415.808777 339.081665,416.605835 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M117.961029,119.370567 
	C118.588097,119.591881 119.231247,120.139229 119.829704,121.053413 
	C119.182373,120.845703 118.579742,120.271156 117.961029,119.370567 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M347.029419,424.632019 
	C346.418396,424.499878 345.753845,424.051636 345.064026,423.268036 
	C345.684448,423.393738 346.330170,423.854828 347.029419,424.632019 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M170.088959,243.913010 
	C170.716400,244.367554 171.343826,244.822113 172.009613,245.613922 
	C172.047974,245.951187 171.982788,246.017059 171.710541,245.909698 
	C170.933990,245.225296 170.429688,244.648285 169.966339,244.031738 
	C170.007263,243.992233 170.088959,243.913010 170.088959,243.913010 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M172.080353,245.918060 
	C172.725616,246.357498 173.338486,246.830063 174.022095,247.604980 
	C174.092834,247.907303 174.023438,247.976410 173.721649,247.891022 
	C172.940842,247.209457 172.461807,246.613266 171.982788,246.017059 
	C171.982788,246.017059 172.047974,245.951187 172.080353,245.918060 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M319.838867,396.737213 
	C319.305267,396.575775 318.687256,396.136688 318.020996,395.391296 
	C318.566650,395.543213 319.160522,396.001404 319.838867,396.737213 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M307.897278,384.704590 
	C307.473297,384.780762 306.911560,384.586243 306.241058,384.101379 
	C306.674713,384.018646 307.217102,384.226288 307.897278,384.704590 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M322.113281,399.635315 
	C321.771210,399.518372 321.404022,399.109131 321.000854,398.410706 
	C321.339294,398.528717 321.713745,398.935883 322.113281,399.635315 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M323.737488,400.777283 
	C323.327820,400.830566 322.812714,400.613922 322.184296,400.129791 
	C322.591339,400.077301 323.111694,400.292328 323.737488,400.777283 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M169.012451,241.983871 
	C169.337540,242.436752 169.662643,242.889618 170.038345,243.627747 
	C170.088959,243.913010 170.007263,243.992233 169.719803,243.895950 
	C169.139145,243.325317 168.845947,242.850967 168.668030,242.278839 
	C168.783295,242.181046 169.012451,241.983871 169.012451,241.983871 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M166.913223,240.105896 
	C167.334564,240.095474 167.592941,240.285446 167.805389,240.868317 
	C167.817078,241.182922 167.617676,241.380554 167.441162,241.237305 
	C167.032181,240.898285 166.810120,240.691391 166.598450,240.473343 
	C166.598450,240.473343 166.807831,240.227966 166.913223,240.105896 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M119.850266,190.944275 
	C119.626236,190.995682 119.511185,190.663940 119.560013,190.500763 
	C119.763992,190.522690 119.919144,190.707779 119.850266,190.944275 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M240.803894,314.140411 
	C240.562302,314.176270 240.285507,313.912781 239.952393,313.367065 
	C240.186935,313.336945 240.477798,313.588989 240.803894,314.140411 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M313.940552,390.748779 
	C313.758240,390.803406 313.486908,390.619202 313.112976,390.206726 
	C313.290771,390.155579 313.571136,390.332733 313.940552,390.748779 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M167.917206,241.084549 
	C168.331772,241.097672 168.588623,241.287201 168.900177,241.769318 
	C169.012451,241.983871 168.783295,242.181046 168.501068,242.123993 
	C167.996658,241.857239 167.796265,241.628448 167.617676,241.380554 
	C167.617676,241.380554 167.817078,241.182922 167.917206,241.084549 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M306.066040,383.606903 
	C305.835602,383.668976 305.536865,383.466949 305.175690,382.989563 
	C305.408081,382.923737 305.702942,383.133270 306.066040,383.606903 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M298.953918,375.736328 
	C298.686554,375.894135 298.422516,375.706055 298.113770,375.207581 
	C298.302032,375.150177 298.598114,375.314575 298.953918,375.736328 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M156.964401,193.179550 
	C154.603622,193.110809 152.242828,193.042068 149.438202,192.975006 
	C145.508636,190.938660 141.242538,189.590561 138.702072,186.716904 
	C133.641815,180.992966 133.494217,173.855804 135.675293,166.321716 
	C139.990982,157.537933 147.495041,155.112839 156.617767,154.783356 
	C157.479263,154.781876 157.910202,154.876495 158.673218,154.957397 
	C161.473938,156.222992 163.942566,157.502289 166.752884,158.885498 
	C167.245087,159.443649 167.395615,159.897858 167.774078,160.433533 
	C169.055679,166.448517 170.734100,172.357483 170.968948,178.323273 
	C171.163177,183.257416 173.631653,186.191254 177.291199,187.951996 
	C178.727097,188.642853 181.738342,186.906876 183.610855,185.648972 
	C186.593903,183.644989 189.224350,181.116135 192.418396,179.095718 
	C189.063812,182.983475 185.614517,187.055069 181.362381,189.945740 
	C179.746506,191.044235 175.543579,190.299911 173.833038,188.848145 
	C171.093903,186.523392 169.449310,182.909027 167.114853,179.508835 
	C165.787888,186.592606 158.513336,186.877396 152.164719,190.296066 
	C156.626373,190.964630 159.752014,191.088791 162.668091,191.935059 
	C171.120102,194.387955 174.672241,202.506317 180.438553,208.028854 
	C190.561691,217.724060 200.137238,227.991013 209.942139,238.018494 
	C212.090775,240.257294 214.239410,242.496094 216.828506,245.173019 
	C218.831543,247.083176 220.394119,248.555191 221.956696,250.027206 
	C231.564911,259.787933 241.089737,269.632477 250.802200,279.288361 
	C263.329102,291.742340 276.083252,303.967926 288.592102,316.439789 
	C297.278564,325.100555 305.739746,333.988312 314.229706,342.843597 
	C315.081390,343.731934 315.433960,345.098785 315.702698,346.494263 
	C312.693451,344.091248 310.088684,341.337219 307.263153,338.832153 
	C306.099213,337.800232 304.460632,337.303650 303.037933,336.563568 
	C301.859406,335.525299 300.680847,334.487030 299.342590,332.831787 
	C298.681793,331.500549 298.180725,330.786224 297.679657,330.071930 
	C294.932495,327.235535 292.185333,324.399139 289.171326,320.979950 
	C288.255493,319.935913 287.606445,319.474640 286.957397,319.013367 
	C286.957397,319.013367 286.557159,318.926788 286.307373,318.583679 
	C285.010193,317.186493 283.962738,316.132477 282.915314,315.078430 
	C281.441620,313.512421 279.967957,311.946411 278.096863,309.950012 
	C277.151001,309.308716 276.602600,309.097809 276.054169,308.886932 
	C273.551544,306.087311 271.048920,303.287659 268.170044,300.046082 
	C267.113159,299.091064 266.432526,298.577972 265.751892,298.064850 
	C263.369110,296.197632 260.986359,294.330414 258.438477,291.837463 
	C257.834137,290.497192 257.394897,289.782623 256.955658,289.068054 
	C255.466202,287.563629 253.976730,286.059204 252.162323,284.124512 
	C251.567810,283.455139 251.298264,283.216034 250.898132,282.692871 
	C249.821243,281.628540 248.874939,280.848267 247.928650,280.067963 
	C245.486511,277.491943 243.044388,274.915955 240.191116,271.855286 
	C237.898956,269.870636 236.017914,268.370605 234.136871,266.870575 
	C234.136871,266.870575 234.008636,267.001831 234.021362,266.599030 
	C233.569305,265.520203 233.196060,264.752899 232.626358,264.181488 
	C218.568039,250.081711 204.499863,235.991623 190.387634,221.945877 
	C189.489243,221.051712 188.219833,220.530304 187.076813,219.638275 
	C187.030609,219.441071 186.893570,219.059845 186.816040,218.746048 
	C185.459305,217.321243 184.180115,216.210220 182.900940,215.099197 
	C182.089767,214.182404 181.278580,213.265610 180.198578,211.867874 
	C178.975616,210.556610 178.021469,209.726288 176.963470,208.690323 
	C176.704880,208.211624 176.496094,207.989319 176.170990,207.482452 
	C174.137573,205.380661 172.166428,203.614212 170.179977,201.862305 
	C170.164688,201.876831 170.133438,201.863022 170.088623,201.526123 
	C166.553009,197.100266 163.706619,191.959045 156.964401,193.179550 
M165.916061,172.769180 
	C164.503464,165.913651 160.309814,161.449371 154.858490,160.997986 
	C147.071167,160.353180 140.553009,165.480988 140.106949,172.602997 
	C139.632736,180.174088 144.959213,186.594666 152.308548,186.841812 
	C158.135345,187.037750 166.348297,183.089050 165.916061,172.769180 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M375.062286,406.912323 
	C376.540802,408.492828 378.019287,410.073334 379.885468,412.115234 
	C380.836395,413.728149 381.399597,414.879730 381.637878,416.008606 
	C380.214020,415.319641 379.115112,414.653351 378.016235,413.987061 
	C376.211487,412.087891 374.406769,410.188721 372.297302,408.147949 
	C371.893524,407.682892 371.707550,407.421143 371.074738,406.808075 
	C367.816772,403.591187 364.918793,400.787354 361.876648,397.688049 
	C359.822357,395.593811 357.912201,393.795013 356.002045,391.996216 
	C354.862854,390.755859 353.723663,389.515503 352.258911,387.810516 
	C351.292206,386.891815 350.651062,386.437775 350.009918,385.983704 
	C345.689484,381.566010 341.369080,377.148346 337.005066,372.042969 
	C336.973602,370.899719 336.985748,370.444153 337.305298,370.120300 
	C342.697083,374.889252 347.781433,379.526489 352.865784,384.163757 
	C352.992096,384.459137 353.184631,384.701965 353.715485,385.337433 
	C358.931641,390.592926 363.875702,395.403259 368.819763,400.213593 
	C368.955170,400.497955 369.145782,400.738617 369.665985,401.380737 
	C371.647675,403.521362 373.354980,405.216827 375.062286,406.912323 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M303.038391,336.949646 
	C304.460632,337.303650 306.099213,337.800232 307.263153,338.832153 
	C310.088684,341.337219 312.693451,344.091248 315.701599,346.857788 
	C316.129669,347.291229 316.324371,347.551147 316.930298,348.177795 
	C320.828217,352.755859 324.395996,356.906464 327.963776,361.057098 
	C326.641846,360.527863 324.993530,360.333923 324.050323,359.415710 
	C317.318939,352.862701 310.718506,346.174774 304.122253,339.484528 
	C303.586151,338.940765 303.391907,338.059937 303.038391,336.949646 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M328.254822,361.214233 
	C324.395996,356.906464 320.828217,352.755859 317.150116,348.289307 
	C318.979401,349.274414 321.231598,350.278778 322.800354,351.931763 
	C327.629791,357.020477 332.197906,362.357208 336.490631,367.868073 
	C335.273987,367.801086 334.434235,367.463593 333.594482,367.126099 
	C331.911621,365.207855 330.228760,363.289581 328.254822,361.214233 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M333.346252,367.284790 
	C334.434235,367.463593 335.273987,367.801086 336.436981,368.227539 
	C336.760254,368.316467 336.891113,368.653198 336.948059,369.060791 
	C337.002655,369.641785 337.000275,369.815186 336.997894,369.988586 
	C336.985748,370.444153 336.973602,370.899719 336.943024,371.697418 
	C334.214691,371.701782 331.465851,371.396423 333.346252,367.284790 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M355.997040,392.396240 
	C357.912201,393.795013 359.822357,395.593811 361.859955,397.703094 
	C361.987396,398.013611 361.955200,398.044769 361.585083,398.032379 
	C360.472565,398.021240 359.730103,398.022491 358.987671,398.023743 
	C358.177216,397.431580 357.366730,396.839417 356.273834,396.121155 
	C355.991608,394.928772 355.991821,393.862518 355.997040,392.396240 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M282.916870,315.442810 
	C283.962738,316.132477 285.010193,317.186493 286.103485,318.565247 
	C285.072357,317.862396 283.995392,316.834778 282.916870,315.442810 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M265.525818,298.272339 
	C266.432526,298.577972 267.113159,299.091064 267.862885,299.933777 
	C267.189911,300.497650 266.447815,300.731873 265.395081,300.940887 
	C265.156189,300.103729 265.227966,299.291809 265.525818,298.272339 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M297.484436,330.272278 
	C298.180725,330.786224 298.681793,331.500549 299.188812,332.569183 
	C298.559570,332.106567 297.924377,331.289581 297.484436,330.272278 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M350.044006,386.308746 
	C350.651062,386.437775 351.292206,386.891815 351.975220,387.666565 
	C351.370728,387.536102 350.724396,387.084961 350.044006,386.308746 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M286.988892,319.338074 
	C287.606445,319.474640 288.255493,319.935913 288.924866,320.730103 
	C288.303589,320.596283 287.661987,320.129517 286.988892,319.338074 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M276.161194,309.173889 
	C276.602600,309.097809 277.151001,309.308716 277.807922,309.804565 
	C277.367035,309.880005 276.817627,309.670410 276.161194,309.173889 
z"
          />
          <path
            fill="#FAA61E"
            opacity="1.000000"
            stroke="none"
            d="
M403.767609,423.169342 
	C404.962891,423.695557 405.763306,424.745270 406.793884,425.074463 
	C408.078827,425.484924 409.912170,425.849640 410.853943,425.233429 
	C411.989197,424.490601 413.083679,422.698700 413.086792,421.358398 
	C413.144196,396.541840 413.034607,371.724854 412.964020,346.907990 
	C412.953674,343.271942 412.962585,339.635864 412.962585,335.734375 
	C413.323730,335.573700 413.899384,335.107880 414.492126,335.084961 
	C424.942230,334.681763 435.394012,334.063538 445.846283,334.047668 
	C456.210052,334.031921 466.573334,334.752594 476.940186,334.882904 
	C479.506927,334.915192 482.086700,333.912750 484.898132,333.054993 
	C486.171539,332.729004 487.207275,332.733978 488.662292,333.159332 
	C490.053528,334.053558 491.025543,334.527405 492.034912,335.359650 
	C493.050598,337.145081 494.028961,338.572083 495.011047,340.459717 
	C495.015259,344.612396 495.015747,348.304352 494.667847,352.189636 
	C493.879791,353.739380 493.058136,355.095123 493.055817,356.452271 
	C492.987457,396.677704 492.981934,436.903320 493.083862,477.128601 
	C493.087128,478.422394 494.323212,479.713013 494.990906,481.436829 
	C495.268921,489.228638 492.274536,495.385834 487.536835,500.668915 
	C482.166107,506.657867 474.992889,506.362671 469.600281,500.535156 
	C468.469910,499.313629 466.525360,498.845459 464.955994,498.030151 
	C464.810272,497.745514 464.616974,497.498077 464.188904,496.785889 
	C459.823242,491.564117 455.679077,486.812592 451.409485,482.176605 
	C451.011169,481.744080 449.818909,482.042755 448.995300,482.001923 
	C448.841187,481.719666 448.639465,481.476990 448.195618,480.777100 
	C444.296600,475.707977 440.889893,470.848450 436.819733,466.628784 
	C430.287781,459.856964 423.321320,453.503845 416.530121,446.982483 
	C409.289642,440.029633 402.039429,433.086853 394.793457,426.139709 
	C394.640961,425.880585 394.449463,425.654449 393.996704,425.041443 
	C393.504852,424.107788 393.235260,423.594055 392.965637,423.080322 
	C394.605377,418.853027 396.513031,422.146637 397.901184,423.128815 
	C399.862061,424.516327 401.465210,426.190369 403.767609,423.169342 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M464.983398,498.377930 
	C466.525360,498.845459 468.469910,499.313629 469.600281,500.535156 
	C474.992889,506.362671 482.166107,506.657867 487.536835,500.668915 
	C492.274536,495.385834 495.268921,489.228638 495.001495,480.967743 
	C495.012665,461.383972 494.974762,442.700745 495.102020,424.018616 
	C495.113586,422.323273 496.187195,420.635193 496.767578,418.943726 
	C496.823425,442.665710 496.904266,466.387695 496.888885,490.109619 
	C496.887634,492.059326 496.232117,494.008667 495.831055,496.361847 
	C491.859955,499.697235 487.919739,502.604431 484.021118,505.566406 
	C478.027832,510.119751 477.605011,510.221100 471.894165,505.518524 
	C469.415710,503.477692 467.294373,501.003204 464.983398,498.377930 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M394.823303,426.493774 
	C402.039429,433.086853 409.289642,440.029633 416.530121,446.982483 
	C423.321320,453.503845 430.287781,459.856964 436.819733,466.628784 
	C440.889893,470.848450 444.296600,475.707977 447.997131,480.645996 
	C445.983551,479.180511 443.898956,477.424561 441.976318,475.506287 
	C427.349731,460.912720 412.734711,446.307373 398.183350,431.638977 
	C396.834290,430.279053 395.952118,428.455902 394.823303,426.493774 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M496.744385,498.993652 
	C496.083130,501.188721 495.741547,504.086273 494.115112,505.438934 
	C489.877197,508.963470 485.436829,512.743103 480.407135,514.689331 
	C474.284119,517.058594 470.304199,512.546753 467.150116,507.297180 
	C468.238220,507.382721 469.667480,507.500000 470.636993,508.228882 
	C476.343201,512.518555 482.523651,512.092285 487.658752,507.009491 
	C490.243744,504.450836 492.987549,502.052612 495.803345,499.283417 
	C496.124268,498.987396 496.301453,498.989777 496.744385,498.993652 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M454.987762,497.009613 
	C453.887695,496.351288 452.787628,495.692963 451.368011,494.993011 
	C448.459442,491.506073 445.870453,488.060791 443.004517,484.023193 
	C441.477936,482.292999 440.228271,481.155090 438.978607,480.017151 
	C437.731995,479.179810 436.485382,478.342499 435.364746,477.088623 
	C435.647644,476.126801 435.804596,475.581512 435.980835,475.016174 
	C436.000153,474.996124 436.036499,474.953857 436.036499,474.953857 
	C437.625519,476.256744 439.315033,477.455872 440.785950,478.880676 
	C446.759430,484.666931 452.679901,490.508362 458.565643,496.383820 
	C458.959534,496.777039 458.903473,497.621002 458.754852,498.493469 
	C457.297913,498.157623 456.142853,497.583618 454.987762,497.009613 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M419.016846,460.368988 
	C418.650513,458.912079 418.326172,457.800354 418.009033,456.335266 
	C423.929810,462.102295 429.843353,468.222656 435.896667,474.648438 
	C436.036499,474.953857 436.000153,474.996124 435.641357,474.970276 
	C433.528961,473.958313 431.775330,472.972168 430.021698,471.986023 
	C426.367432,468.228729 422.713135,464.471436 419.016846,460.368988 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M449.015076,482.349457 
	C449.818909,482.042755 451.011169,481.744080 451.409485,482.176605 
	C455.679077,486.812592 459.823242,491.564117 463.995056,496.650208 
	C462.350708,495.556976 460.660370,494.151978 459.086395,492.626862 
	C455.704102,489.349731 452.381744,486.010712 449.015076,482.349457 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M411.957520,449.655487 
	C410.578552,449.667542 409.170166,449.333160 407.396606,448.990295 
	C405.007141,445.917023 402.982849,442.852203 400.947876,439.409363 
	C404.600830,442.457275 408.264465,445.883179 411.957520,449.655487 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M394.110962,434.576752 
	C390.383118,430.531464 386.671600,426.180664 383.219360,421.428009 
	C383.658875,421.013824 383.839111,421.001495 384.019348,420.989197 
	C386.554962,423.802124 389.090607,426.615051 391.839111,430.035614 
	C392.753723,431.443817 393.455536,432.244385 394.157318,433.044952 
	C394.147278,433.453705 394.137268,433.862488 394.110962,434.576752 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M384.043304,420.688690 
	C383.839111,421.001495 383.658875,421.013824 383.208496,421.055847 
	C381.422729,420.230896 379.907074,419.376251 378.200012,417.860352 
	C377.988617,416.149811 377.968658,415.100525 377.948730,414.051270 
	C377.948730,414.051270 377.981842,414.018860 377.999023,414.002960 
	C379.115112,414.653351 380.214020,415.319641 381.934143,416.133850 
	C383.355957,416.537842 384.156616,416.793915 384.957245,417.049988 
	C384.957245,417.049988 384.998779,416.999146 384.964294,417.345093 
	C384.969360,418.121979 385.008942,418.552917 385.048523,418.983887 
	C384.721436,419.451996 384.394348,419.920074 384.043304,420.688690 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M385.358948,419.117950 
	C385.008942,418.552917 384.969360,418.121979 384.939453,417.366852 
	C387.423401,418.942261 389.897614,420.841797 392.668762,422.910828 
	C393.235260,423.594055 393.504852,424.107788 393.813904,424.913452 
	C391.125366,423.220886 388.397400,421.236450 385.358948,419.117950 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M454.991760,497.382080 
	C456.142853,497.583618 457.297913,498.157623 458.759460,498.864014 
	C459.065918,498.996399 459.101593,499.455780 459.124237,499.684326 
	C458.356354,499.942841 457.565796,499.972839 456.381500,500.010559 
	C455.987732,500.018311 455.499451,500.001923 455.255371,499.995483 
	C455.006104,499.244171 455.000916,498.499359 454.991760,497.382080 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M463.952393,504.992218 
	C463.948608,504.561157 463.944794,504.130096 463.929779,503.376770 
	C464.956238,504.116486 465.993896,505.178436 467.024628,506.606750 
	C466.568451,506.986786 466.119171,507.000427 465.313232,506.706848 
	C464.621857,505.930450 464.287140,505.461334 463.952393,504.992218 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M394.375427,432.830872 
	C393.455536,432.244385 392.753723,431.443817 392.031403,430.308472 
	C392.871735,430.854736 393.732635,431.735748 394.375427,432.830872 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M496.831299,418.493225 
	C496.187195,420.635193 495.113586,422.323273 495.102020,424.018616 
	C494.974762,442.700745 495.012665,461.383972 494.995178,480.536011 
	C494.323212,479.713013 493.087128,478.422394 493.083862,477.128601 
	C492.981934,436.903320 492.987457,396.677704 493.055817,356.452271 
	C493.058136,355.095123 493.879791,353.739380 494.957947,352.195251 
	C495.981415,352.032532 496.366394,352.057495 496.751404,352.082458 
	C496.798828,352.510925 496.846252,352.939392 496.603424,354.005157 
	C496.219391,371.840027 496.117554,389.037567 496.065826,406.235260 
	C496.064056,406.820190 496.565857,407.406586 496.832947,407.992279 
	C496.853638,411.342438 496.874329,414.692566 496.831299,418.493225 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M496.917694,407.531250 
	C496.565857,407.406586 496.064056,406.820190 496.065826,406.235260 
	C496.117554,389.037567 496.219391,371.840027 496.574707,354.327820 
	C496.891632,371.698883 496.947052,389.384521 496.917694,407.531250 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M496.851135,351.631470 
	C496.366394,352.057495 495.981415,352.032532 495.306335,352.001953 
	C495.015747,348.304352 495.015259,344.612396 495.019684,340.108215 
	C495.633057,336.724396 495.646942,334.571838 491.997559,335.001221 
	C491.025543,334.527405 490.053528,334.053558 489.048218,333.219269 
	C497.002289,332.779877 497.002289,332.779877 497.257080,342.521545 
	C497.205811,345.685059 497.078369,348.432739 496.851135,351.631470 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M372.831940,455.244507 
	C377.331421,459.757996 381.662384,464.518005 385.981415,469.649963 
	C381.687531,466.109619 377.402985,462.200073 373.126343,458.281860 
	C372.521423,457.727631 371.955017,457.131317 371.177917,456.277863 
	C371.544495,455.831146 372.103943,455.661072 372.831940,455.244507 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M280.990234,361.407104 
	C281.658295,361.769135 282.323029,362.527679 283.038696,363.596771 
	C282.578430,364.191040 282.067261,364.474701 281.286438,364.865356 
	C281.006836,363.916077 280.996857,362.859833 280.990234,361.407104 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M418.095703,505.253662 
	C423.103943,504.389313 425.174561,508.350311 427.939667,511.671265 
	C427.990540,512.010437 428.002686,511.997314 427.788940,512.099731 
	C427.299896,512.399231 427.113434,512.659851 427.015869,512.984009 
	C427.015869,512.984009 426.975464,513.019409 426.953491,513.036499 
	C423.985901,510.572815 421.040253,508.092010 418.095703,505.253662 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M402.024506,487.364990 
	C402.088562,486.888062 402.186462,486.753784 402.284363,486.619507 
	C405.268066,489.889954 408.251801,493.160400 411.100708,496.724304 
	C407.996704,493.914429 405.027527,490.811035 402.024506,487.364990 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M394.024536,476.967773 
	C396.330444,479.752838 398.636383,482.537933 400.955627,485.676453 
	C398.326752,483.588776 395.684540,481.147675 393.233765,478.247498 
	C393.624969,477.514832 393.824768,477.241302 394.024536,476.967773 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M393.874725,476.671112 
	C393.824768,477.241302 393.624969,477.514832 393.194580,477.903412 
	C391.326691,476.244110 389.689423,474.469788 388.017334,472.358337 
	C389.896667,473.472321 391.810791,474.923401 393.874725,476.671112 
z"
          />
          <path
            fill="#B36D2C"
            opacity="1.000000"
            stroke="none"
            d="
M346.694611,465.163940 
	C346.694611,465.163940 346.347076,465.111115 346.184570,464.656860 
	C345.121704,459.230774 342.009491,456.389221 337.013702,455.977722 
	C337.013702,455.977722 336.878510,455.651978 336.888794,455.103699 
	C330.420258,447.381287 324.015930,440.138000 317.440277,433.053741 
	C311.625732,426.789551 305.874664,420.426025 299.595734,414.649658 
	C296.275970,411.595673 294.144348,406.759247 288.907593,406.135193 
	C288.998108,406.073029 288.802948,406.173065 288.860413,405.798828 
	C286.260254,402.275696 283.840912,398.875061 280.866730,396.060791 
	C278.647064,393.960510 275.710632,392.617737 273.050964,390.952057 
	C273.008484,390.966492 273.061707,390.894257 273.044006,390.538116 
	C270.363800,386.671600 267.941467,382.941956 264.983093,379.701752 
	C260.435303,374.720734 255.674347,369.907227 250.708344,365.344208 
	C247.038437,361.972198 242.897827,359.112396 238.744934,355.923462 
	C238.245407,355.625671 238.063171,355.362793 237.957947,354.672791 
	C235.644653,351.581818 233.603256,348.574280 230.992767,346.189697 
	C227.432892,342.937836 223.439224,340.160919 219.470551,337.136414 
	C219.309601,337.092438 219.046997,336.886505 219.033661,336.528137 
	C217.254761,334.494324 215.489197,332.818848 213.539963,331.046021 
	C213.126541,330.775421 212.969879,330.551147 212.822815,329.988281 
	C212.444962,329.488983 212.130585,329.277191 211.618118,328.960144 
	C211.169449,328.664551 211.014847,328.414856 210.947067,327.745880 
	C208.596634,325.279755 206.255325,323.173462 203.914032,321.067169 
	C203.914032,321.067169 203.989624,320.999939 203.985733,320.638306 
	C204.318344,316.480499 202.071289,315.736298 198.953781,316.020325 
	C198.625153,315.935669 198.365601,315.752899 198.086456,314.873962 
	C197.572906,313.042908 197.488647,311.483582 196.669403,310.628448 
	C190.075821,303.746216 183.375763,296.964325 176.605316,290.255707 
	C175.916229,289.572876 174.549484,289.574005 173.497208,289.257721 
	C173.497208,289.257721 173.216370,289.203033 173.109070,288.738953 
	C170.789474,285.427032 168.686569,282.479767 166.268570,279.818909 
	C165.808777,279.312927 164.101852,279.940308 162.970337,280.044800 
	C162.431992,279.895447 161.893646,279.746094 160.964172,279.056366 
	C156.389893,278.299011 152.206741,278.082062 148.023590,277.865112 
	C147.149872,277.774445 146.276138,277.683746 145.306885,277.067993 
	C146.155594,275.650177 147.099854,274.757385 148.380157,273.886780 
	C149.154907,274.003845 149.593628,274.098755 150.337006,274.447479 
	C160.212418,275.641083 161.599472,274.937439 162.780579,268.394012 
	C162.783203,268.243225 162.954147,267.994690 163.320282,267.964783 
	C166.127075,266.699921 167.834793,266.992493 169.044113,269.819183 
	C169.567535,271.042664 171.139999,271.817322 172.235962,272.795868 
	C172.235962,272.795868 172.239502,272.875916 172.155365,273.224487 
	C173.479385,274.936249 174.887543,276.299500 176.295715,277.662720 
	C176.295715,277.662720 176.193787,277.802856 176.155792,278.155792 
	C175.435303,280.759308 174.752792,283.009888 173.689148,286.517334 
	C176.056229,284.871338 177.259827,284.034393 178.680618,283.046448 
	C185.141449,289.548370 191.333435,295.936859 197.739471,302.102997 
	C199.134415,303.445709 201.295349,303.992706 203.103516,304.906189 
	C203.103516,304.906158 202.999496,304.992828 203.018921,305.360901 
	C202.402405,310.578491 205.477142,311.111969 209.133331,310.969177 
	C209.133331,310.969177 209.300797,311.173553 209.294037,311.621582 
	C209.609604,312.290741 209.931961,312.511810 210.254303,312.732910 
	C210.254303,312.732910 210.326065,312.674194 210.258087,313.042023 
	C212.992752,315.824677 215.795395,318.239532 218.598053,320.654358 
	C219.152863,321.178192 219.707687,321.701996 220.090759,322.637543 
	C218.961227,324.406006 218.003418,325.762756 217.045624,327.119507 
	C217.351089,327.468567 217.656540,327.817627 217.962006,328.166687 
	C220.010529,327.419067 222.059036,326.671448 224.107559,325.923798 
	C224.461914,326.263519 224.816269,326.603241 225.174255,327.577026 
	C227.540543,331.750214 228.895859,336.342529 234.182938,336.824158 
	C234.182938,336.824158 234.121796,336.815277 234.093384,337.209778 
	C236.142792,339.618958 238.220627,341.633575 240.298447,343.648224 
	C240.298447,343.648224 240.209854,343.776611 240.186951,344.113525 
	C240.515396,345.368896 240.633743,346.505310 241.255890,347.170441 
	C245.328934,351.524719 249.363312,355.935486 253.720383,359.994995 
	C255.856216,361.984985 258.657349,363.260864 261.157379,364.859924 
	C261.157379,364.859924 261.156372,364.934540 261.100006,365.281799 
	C264.165833,369.311523 267.099670,373.180420 270.486206,376.601227 
	C272.297760,378.431244 274.889435,379.489014 277.129028,380.895294 
	C277.129028,380.895294 277.130737,380.905823 277.139893,380.885437 
	C278.154846,382.248566 279.160645,383.632080 280.535339,385.056122 
	C282.003876,386.383270 283.103546,387.669891 284.543732,389.035950 
	C288.788116,393.005157 292.691986,396.894897 296.953857,400.681244 
	C297.311829,400.577850 297.313202,400.639038 297.320862,400.956055 
	C297.652313,401.408844 297.976135,401.544617 298.299927,401.680389 
	C298.299927,401.680389 298.351471,401.703735 298.248749,402.075806 
	C300.464294,404.607117 302.782562,406.766327 305.100800,408.925537 
	C305.100800,408.925537 305.026001,409.006989 305.025452,409.333313 
	C306.550232,413.360779 308.072418,417.065338 313.059357,416.953217 
	C313.059357,416.953217 313.004944,417.001648 313.054382,417.305115 
	C313.780334,418.034027 314.456787,418.459442 315.133270,418.884888 
	C315.133270,418.884888 315.146210,418.883636 315.153748,418.866882 
	C318.709015,423.299652 321.965515,428.026062 325.871643,432.134918 
	C331.981812,438.562164 338.548981,444.553711 344.890198,450.762878 
	C351.686737,457.417938 358.492279,464.064972 365.206635,470.802490 
	C370.580750,476.195129 375.789154,481.752869 381.162201,487.146576 
	C381.997711,487.985260 383.320496,488.338470 384.796692,488.849091 
	C385.175476,488.782013 385.145782,488.802917 385.099731,489.194031 
	C386.282715,493.639740 388.483246,496.618774 393.134674,496.884460 
	C393.134674,496.884460 393.146423,496.898346 393.154724,496.881409 
	C393.270935,497.827576 393.010040,499.154816 393.544830,499.696472 
	C398.011353,504.220154 402.624268,508.599335 407.539581,513.068237 
	C410.741455,516.366516 413.596771,519.618530 416.817444,522.835876 
	C417.182831,522.801147 417.147919,522.812683 417.101318,523.206177 
	C417.572357,526.597229 418.859924,528.768555 422.370880,528.554138 
	C422.370880,528.554138 422.413605,528.574036 422.437622,528.576660 
	C420.707611,531.854309 416.656799,533.224182 413.736542,531.088745 
	C410.772186,528.921082 408.211395,526.206604 405.425140,523.787720 
	C404.266571,522.781921 402.981628,521.921631 401.386719,520.997681 
	C401.019318,521.000183 400.996582,520.998840 401.008057,520.607422 
	C400.495209,518.906311 400.309479,517.262390 399.395905,516.337036 
	C385.160217,501.917938 370.849274,487.572815 356.472443,473.294403 
	C355.664764,472.492249 354.135223,472.416870 352.941650,472.003235 
	C352.941650,472.003235 352.805298,471.714111 352.838013,471.174744 
	C350.811981,468.811554 348.753296,466.987762 346.694611,465.163940 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M202.964844,304.602661 
	C201.295349,303.992706 199.134415,303.445709 197.739471,302.102997 
	C191.333435,295.936859 185.141449,289.548370 178.680618,283.046448 
	C177.259827,284.034393 176.056229,284.871338 173.689148,286.517334 
	C174.752792,283.009888 175.435303,280.759308 176.230118,278.111267 
	C179.296219,280.536072 182.318954,283.290222 185.189438,286.194794 
	C191.111359,292.187103 196.952057,298.259644 202.964844,304.602661 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M234.121277,336.508179 
	C228.895859,336.342529 227.540543,331.750214 225.243179,327.821899 
	C227.190979,329.000031 229.073456,330.567413 231.224396,332.318604 
	C232.348434,333.732391 233.204025,334.962280 234.121277,336.508179 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M218.459137,320.338989 
	C215.795395,318.239532 212.992752,315.824677 210.304077,313.047791 
	C213.052124,315.131683 215.686172,317.577637 218.459137,320.338989 
z"
          />
          <path
            fill="#A87342"
            opacity="1.000000"
            stroke="none"
            d="
M223.971649,325.643494 
	C222.059036,326.671448 220.010529,327.419067 217.962006,328.166687 
	C217.656540,327.817627 217.351089,327.468567 217.045624,327.119507 
	C218.003418,325.762756 218.961227,324.406006 220.269501,322.865997 
	C221.691910,323.576202 222.763824,324.469696 223.971649,325.643494 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M209.019165,310.651672 
	C205.477142,311.111969 202.402405,310.578491 203.065033,305.311157 
	C205.029480,306.706940 206.967239,308.520569 209.019165,310.651672 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M176.242294,277.345459 
	C174.887543,276.299500 173.479385,274.936249 172.142273,273.190186 
	C172.659332,273.051147 173.105316,273.294983 173.789154,273.635803 
	C174.747620,274.831238 175.468246,275.929688 176.242294,277.345459 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M210.209045,312.445251 
	C209.931961,312.511810 209.609604,312.290741 209.276917,311.752594 
	C209.565643,311.676239 209.864716,311.916901 210.209045,312.445251 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M463.732178,505.171539 
	C464.287140,505.461334 464.621857,505.930450 464.976196,506.702820 
	C464.501190,506.454346 464.006592,505.902588 463.732178,505.171539 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M261.095306,364.528229 
	C258.657349,363.260864 255.856216,361.984985 253.720383,359.994995 
	C249.363312,355.935486 245.328934,351.524719 241.255890,347.170441 
	C240.633743,346.505310 240.515396,345.368896 240.255768,344.076843 
	C247.242722,350.534302 254.137985,357.365417 261.095306,364.528229 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M277.070435,380.581512 
	C274.889435,379.489014 272.297760,378.431244 270.486206,376.601227 
	C267.099670,373.180420 264.165833,369.311523 261.089325,365.249023 
	C263.771149,367.266327 266.407257,369.663635 269.328308,372.223938 
	C270.469879,373.266144 271.326569,374.145386 272.478088,375.126587 
	C273.242249,375.838654 273.711548,376.448761 274.465088,377.156738 
	C275.503479,378.259003 276.257660,379.263367 277.070435,380.581512 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M240.248901,343.325562 
	C238.220627,341.633575 236.142792,339.618958 234.117004,337.226562 
	C236.179153,338.900208 238.189255,340.951538 240.248901,343.325562 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M148.044113,273.864594 
	C147.099854,274.757385 146.155594,275.650177 145.060730,276.844055 
	C136.604736,276.026215 130.648651,266.164307 133.427841,255.159943 
	C135.992737,245.004044 144.308563,239.381500 155.727295,240.519470 
	C157.243240,240.929871 158.073929,241.112579 159.136215,241.525391 
	C165.865662,245.798660 169.996811,251.093567 169.164139,259.306946 
	C168.976318,261.159668 169.674118,263.102142 169.964264,265.003296 
	C169.992050,265.431183 170.019836,265.859039 170.103104,266.603516 
	C170.555145,268.163818 170.951721,269.407532 171.631714,270.822205 
	C172.019241,271.390015 172.123322,271.786896 172.231689,272.489838 
	C171.139999,271.817322 169.567535,271.042664 169.044113,269.819183 
	C167.834793,266.992493 166.127075,266.699921 163.369553,267.582214 
	C166.097519,259.341370 165.092163,254.881851 159.285858,250.520599 
	C154.630890,247.024170 148.438309,246.958130 144.072739,250.358414 
	C138.823181,254.447159 136.905151,260.281189 140.084244,266.213593 
	C141.737976,269.299591 145.328491,271.347656 148.044113,273.864594 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M170.258575,264.727295 
	C169.674118,263.102142 168.976318,261.159668 169.164139,259.306946 
	C169.996811,251.093567 165.865662,245.798660 159.262604,241.206070 
	C159.112473,238.421936 159.067551,236.187225 159.022614,233.952499 
	C159.410187,234.005310 159.797760,234.058105 160.469238,234.180725 
	C162.511490,236.214798 164.269852,238.179062 166.313324,240.308319 
	C166.810120,240.691391 167.032181,240.898285 167.441162,241.237305 
	C167.796265,241.628448 167.996658,241.857239 168.385803,242.221771 
	C168.845947,242.850967 169.139145,243.325317 169.678864,243.935455 
	C170.429688,244.648285 170.933990,245.225296 171.710526,245.909698 
	C172.461807,246.613266 172.940842,247.209457 173.686859,247.925476 
	C174.241501,248.561722 174.529160,249.078140 174.614838,250.137390 
	C170.499634,250.663467 170.913208,253.439255 170.983612,255.993546 
	C170.840042,258.812805 170.696472,261.632050 170.258575,264.727295 
z"
          />
          <path
            fill="#CAB6A5"
            opacity="1.000000"
            stroke="none"
            d="
M208.665009,282.883911 
	C209.673828,284.068207 210.392899,285.092133 211.164764,286.418182 
	C209.651276,285.812988 208.064758,284.938507 206.524323,283.989227 
	C204.939148,283.012390 203.398941,281.962616 201.487503,280.924194 
	C201.135956,280.903656 201.098206,280.911499 201.075378,280.557556 
	C200.386139,279.454773 199.719727,278.705994 199.053314,277.957184 
	C199.053314,277.957184 199.001114,277.995453 198.989090,277.645203 
	C197.979965,276.200073 196.982864,275.105194 195.985764,274.010315 
	C195.189682,273.417419 194.393600,272.824524 193.276123,271.750122 
	C191.331253,270.143768 189.707794,269.018890 188.084335,267.894012 
	C186.816040,266.125854 185.547745,264.357666 183.995453,261.999451 
	C182.490555,260.591248 181.269669,259.773071 180.048782,258.954926 
	C180.048782,258.954926 180.001831,259.000000 179.975708,258.657410 
	C179.301071,257.871521 178.652573,257.428253 178.004059,256.984955 
	C178.004059,256.984955 177.545395,256.946716 177.253815,256.570679 
	C176.620209,254.517578 176.278214,252.840515 175.936203,251.163452 
	C178.298691,253.146408 180.661194,255.129349 183.317398,257.251495 
	C191.865814,265.834961 200.120529,274.279266 208.665009,282.883911 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M175.830170,250.939545 
	C176.278214,252.840515 176.620209,254.517578 177.024017,256.558502 
	C175.313126,256.614624 173.540466,256.306854 171.375702,255.996323 
	C170.913208,253.439255 170.499634,250.663467 174.664917,250.429657 
	C175.257706,250.250046 175.526764,250.428894 175.830170,250.939545 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M188.188904,268.215881 
	C189.707794,269.018890 191.331253,270.143768 193.000122,271.619568 
	C191.461517,270.826233 189.877487,269.682007 188.188904,268.215881 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M195.984406,274.408234 
	C196.982864,275.105194 197.979965,276.200073 199.010651,277.620728 
	C198.285400,277.963989 197.526550,277.981476 196.389038,277.994080 
	C196.001251,276.928162 195.992142,275.867157 195.984406,274.408234 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M180.067459,259.315857 
	C181.269669,259.773071 182.490555,260.591248 183.839050,261.712189 
	C182.673157,261.235596 181.379639,260.456177 180.067459,259.315857 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M178.041916,257.310333 
	C178.652573,257.428253 179.301071,257.871521 179.996765,258.633240 
	C179.389221,258.513031 178.734497,258.074371 178.041916,257.310333 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M430.050537,472.335327 
	C431.775330,472.972168 433.528961,473.958313 435.622070,474.990326 
	C435.804596,475.581512 435.647644,476.126801 435.250824,476.837097 
	C433.367065,475.562988 431.723236,474.123810 430.050537,472.335327 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M438.987701,480.391968 
	C440.228271,481.155090 441.477936,482.292999 442.856628,483.723907 
	C441.656036,482.933533 440.326416,481.850159 438.987701,480.391968 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M234.109833,267.203033 
	C236.017914,268.370605 237.898956,269.870636 239.894226,271.685547 
	C239.260345,271.993195 238.512222,271.985931 237.390533,271.963623 
	C236.530380,271.377808 236.043793,270.807068 235.300568,270.111572 
	C234.723526,269.169739 234.403152,268.352600 234.109833,267.203033 
z"
          />
          <path
            fill="#C7BAA0"
            opacity="1.000000"
            stroke="none"
            d="
M247.928589,280.412781 
	C248.874939,280.848267 249.821243,281.628540 250.672134,282.809631 
	C250.383621,283.482544 250.190536,283.754639 249.997437,284.026703 
	C249.307800,282.937012 248.618149,281.847321 247.928589,280.412781 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M250.128906,284.249939 
	C250.190536,283.754639 250.383621,283.482544 250.802734,283.093689 
	C251.298264,283.216034 251.567810,283.455139 251.892181,283.966675 
	C251.384781,284.317169 250.822586,284.395172 250.128906,284.249939 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M256.955627,289.412842 
	C257.394897,289.782623 257.834137,290.497192 258.271210,291.549805 
	C257.831207,291.177765 257.393402,290.467682 256.955627,289.412842 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M269.965942,349.435303 
	C270.668915,349.078888 271.385651,349.080536 272.451447,349.144989 
	C275.513489,352.909149 278.226471,356.610504 280.963623,360.659271 
	C277.318390,357.268921 273.649078,353.531158 269.965942,349.435303 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M258.680725,334.980560 
	C259.613647,335.483154 260.167572,336.006989 260.844849,336.795502 
	C262.939362,339.826294 264.910492,342.592377 266.904480,345.701477 
	C263.458649,342.840363 259.989990,339.636261 256.260101,336.223480 
	C256.002289,335.837402 256.005707,335.659973 256.020142,335.216034 
	C256.787994,334.966919 257.544861,334.984344 258.680725,334.980560 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M427.234558,512.876343 
	C427.113434,512.659851 427.299896,512.399231 427.794586,512.094055 
	C427.913086,512.308533 427.726196,512.569458 427.234558,512.876343 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M187.123016,219.835495 
	C188.219833,220.530304 189.489243,221.051712 190.387634,221.945877 
	C204.499863,235.991623 218.568039,250.081711 232.626358,264.181488 
	C233.196060,264.752899 233.569305,265.520203 234.081589,266.530426 
	C232.642151,265.952698 230.924698,265.277557 229.705551,264.090576 
	C221.611816,256.210297 213.624832,248.220367 205.301270,240.122101 
	C204.196854,239.070953 203.394272,238.163818 202.172424,236.825760 
	C200.174881,234.919022 198.596588,233.443207 197.018311,231.967407 
	C196.911911,231.651749 196.722534,231.398056 196.088593,230.801773 
	C193.151733,227.925629 190.576462,225.453995 188.001190,222.982376 
	C187.897537,222.667526 187.712112,222.412048 187.228821,221.746735 
	C187.049500,220.796875 187.086258,220.316193 187.123016,219.835495 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M170.195267,201.847763 
	C172.166428,203.614212 174.137573,205.380661 175.800049,207.542435 
	C174.994598,207.957260 174.497818,207.976791 174.001053,207.996307 
	C172.771362,206.839340 171.541672,205.682358 170.173126,203.886505 
	C170.087936,202.781006 170.141602,202.314392 170.195267,201.847763 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M187.076813,219.638275 
	C187.086258,220.316193 187.049500,220.796875 187.014679,221.638687 
	C185.952682,221.994995 184.888733,221.990204 183.427368,221.977051 
	C182.731110,220.013611 182.432297,218.058502 182.570663,216.371765 
	C184.303085,217.446686 185.598328,218.253265 186.893570,219.059845 
	C186.893570,219.059845 187.030609,219.441071 187.076813,219.638275 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M170.179977,201.862305 
	C170.141602,202.314392 170.087936,202.781006 170.035187,203.598877 
	C169.282394,203.960068 168.528687,203.970016 167.399292,203.974060 
	C166.682312,202.877655 166.341019,201.787155 166.300140,200.487793 
	C167.778168,200.806976 168.955811,201.334991 170.133438,201.863022 
	C170.133438,201.863022 170.164688,201.876831 170.179977,201.862305 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M186.816040,218.746048 
	C185.598328,218.253265 184.303085,217.446686 182.893738,216.292114 
	C182.779617,215.944138 182.853760,215.522858 182.877350,215.311035 
	C184.180115,216.210220 185.459305,217.321243 186.816040,218.746048 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M177.067307,208.895966 
	C178.021469,209.726288 178.975616,210.556610 179.920105,211.732025 
	C179.024704,211.581680 178.138977,211.086212 177.123367,210.028351 
	C177.018097,209.275970 177.042694,209.085968 177.067307,208.895966 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M176.963470,208.690323 
	C177.042694,209.085968 177.018097,209.275970 176.963196,209.752258 
	C175.988785,209.585831 175.044678,209.133087 174.050812,208.338318 
	C174.497818,207.976791 174.994598,207.957260 175.862305,207.877762 
	C176.496094,207.989319 176.704880,208.211624 176.963470,208.690323 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M305.066315,408.641785 
	C302.782562,406.766327 300.464294,404.607117 298.276245,402.069214 
	C300.316406,403.462769 302.226349,405.235016 304.439270,407.129944 
	C304.838776,407.621124 304.935303,407.989563 305.066315,408.641785 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M298.245117,401.426758 
	C297.976135,401.544617 297.652313,401.408844 297.321594,400.986694 
	C297.606567,400.857880 297.898438,401.015503 298.245117,401.426758 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M377.618042,414.039215 
	C377.968658,415.100525 377.988617,416.149811 378.011475,417.593292 
	C377.036469,417.202698 376.058533,416.417877 375.042297,415.310120 
	C375.765076,414.667206 376.526215,414.347198 377.618042,414.039215 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M170.088623,201.526123 
	C168.955811,201.334991 167.778168,200.806976 166.297928,200.138718 
	C165.193375,199.407974 164.391449,198.817459 163.317688,198.087997 
	C161.076523,196.580933 159.107178,195.212814 157.051117,193.512115 
	C163.706619,191.959045 166.553009,197.100266 170.088623,201.526123 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M188.001068,223.339874 
	C190.576462,225.453995 193.151733,227.925629 195.872192,230.696442 
	C194.553024,230.431427 193.088654,229.867233 191.313904,229.149811 
	C190.002655,227.230164 189.001801,225.463776 188.001068,223.339874 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M197.014206,232.344864 
	C198.596588,233.443207 200.174881,234.919022 201.899200,236.686157 
	C199.057541,237.108414 197.276352,235.811691 197.014206,232.344864 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M312.930115,416.644836 
	C308.072418,417.065338 306.550232,413.360779 305.050903,409.284363 
	C307.651581,411.384857 310.226227,413.860657 312.930115,416.644836 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M315.030823,418.601990 
	C314.456787,418.459442 313.780334,418.034027 313.073181,417.274048 
	C313.671112,417.399384 314.299774,417.859253 315.030823,418.601990 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M422.299683,528.238281 
	C418.859924,528.768555 417.572357,526.597229 417.103149,523.219177 
	C418.843872,524.533203 420.536163,526.227844 422.299683,528.238281 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M393.074097,496.550934 
	C388.483246,496.618774 386.282715,493.639740 385.106689,489.207092 
	C387.777649,491.291809 390.395569,493.754608 393.074097,496.550934 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M199.033264,278.333740 
	C199.719727,278.705994 200.386139,279.454773 201.064148,280.545807 
	C200.622910,280.917694 200.170090,280.947357 199.378143,280.971283 
	C199.030411,280.213806 199.021820,279.462036 199.033264,278.333740 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M362.004089,397.998535 
	C364.918793,400.787354 367.816772,403.591187 370.856415,406.698730 
	C370.137146,407.156555 369.276245,407.310669 368.208069,407.723358 
	C367.572205,407.972931 367.143585,407.963898 366.395569,407.938019 
	C364.817841,406.143555 363.559509,404.365936 362.152832,401.895935 
	C361.988068,400.150574 361.971619,399.097687 361.955200,398.044769 
	C361.955200,398.044769 361.987396,398.013611 362.004089,397.998535 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M361.585083,398.032379 
	C361.971619,399.097687 361.988068,400.150574 362.005829,401.599243 
	C361.221222,401.677277 360.435272,401.359589 359.331177,401.014435 
	C359.006378,400.245941 358.999695,399.504883 358.990326,398.393799 
	C359.730103,398.022491 360.472565,398.021240 361.585083,398.032379 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M113.654343,190.015991 
	C114.083534,190.422974 114.099144,190.825317 114.109726,191.900726 
	C118.998863,199.109543 123.841415,205.685532 128.862152,212.122559 
	C129.400589,212.812897 130.976700,212.693893 132.071442,212.950317 
	C132.645935,213.437973 133.220428,213.925644 133.936157,215.031464 
	C135.051620,217.765991 136.025803,219.882385 136.653290,221.963470 
	C133.773804,219.692780 131.240997,217.457382 128.403702,214.953232 
	C127.844818,227.471130 127.309639,239.458344 126.774460,251.445572 
	C127.125328,251.653122 127.476204,251.860672 127.827072,252.068237 
	C129.203110,249.489868 130.629333,246.936371 131.926315,244.318832 
	C132.347122,243.469574 132.155518,241.861557 132.709549,241.604691 
	C137.740616,239.272156 142.874802,237.162079 148.004822,235.009247 
	C148.030853,235.031540 148.079636,235.079697 148.079651,235.079712 
	C146.907272,236.308517 145.959946,238.024109 144.525955,238.687042 
	C135.294937,242.954498 131.257095,250.589355 129.621826,260.587585 
	C127.825035,260.223053 126.428383,259.456909 125.038536,258.678558 
	C124.033653,258.115784 123.037834,257.536865 122.037979,256.965149 
	C122.033127,254.613373 122.028275,252.261597 122.358330,249.414703 
	C122.797035,247.943680 122.900833,246.967743 123.004623,245.991821 
	C123.013336,245.249298 123.022057,244.506760 123.411179,243.309341 
	C124.165047,241.196259 124.538498,239.538086 124.911949,237.879898 
	C125.269394,229.842117 124.772484,221.974899 119.531998,215.314133 
	C118.366821,213.833191 116.381721,212.990189 115.245529,211.495209 
	C113.381989,209.043213 111.904396,206.297897 110.123657,203.352203 
	C109.989471,199.534119 109.767738,196.014877 110.150070,192.562515 
	C110.255592,191.609726 112.161133,190.856277 113.654343,190.015991 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M158.708466,300.903687 
	C160.667480,302.727020 162.370102,304.420105 164.393616,306.197815 
	C164.714523,306.282501 164.869049,306.639771 164.965118,307.137543 
	C165.693985,308.107483 166.326782,308.579620 166.959579,309.051758 
	C168.131531,310.256592 169.303497,311.461456 170.853394,313.104370 
	C171.747711,313.807587 172.264099,314.072693 172.780487,314.337830 
	C173.364319,315.124237 173.948151,315.910706 174.900482,317.140656 
	C176.870987,319.004639 178.473007,320.425140 180.075027,321.845612 
	C181.535568,323.452667 182.996109,325.059753 184.768402,327.150452 
	C186.401230,328.735718 187.722336,329.837372 189.043442,330.939026 
	C189.526550,331.539368 190.009659,332.139679 190.839539,333.151978 
	C191.777878,334.051086 192.369446,334.538269 192.960999,335.025421 
	C192.960999,335.025421 193.000412,335.010468 193.004242,335.348694 
	C193.652298,336.139862 194.296539,336.592834 194.940765,337.045807 
	C194.940765,337.045807 194.977112,337.006409 195.078751,337.306946 
	C195.773895,338.075897 196.367416,338.544250 196.960938,339.012604 
	C198.865158,340.821594 200.769379,342.630585 202.860001,344.998535 
	C203.330444,345.749481 203.614487,345.941498 203.898529,346.133514 
	C204.967392,347.115601 206.036270,348.097656 207.497787,349.472290 
	C208.480194,350.316315 209.069977,350.767822 209.659744,351.219330 
	C209.659744,351.219330 209.734848,351.269409 209.860275,351.485901 
	C210.159592,351.957825 210.397919,352.116638 210.700668,352.178772 
	C210.700668,352.178772 210.729980,352.264954 210.836700,352.581390 
	C211.552597,353.347290 212.161743,353.796753 212.770889,354.246216 
	C213.396820,355.003693 214.022736,355.761200 214.945404,357.036133 
	C216.175980,358.349152 217.109818,359.144684 218.043671,359.940216 
	C218.043671,359.940216 218.002441,359.996735 218.114914,360.279419 
	C219.165359,361.356018 220.103333,362.149933 221.041290,362.943878 
	C221.762161,363.632751 222.483032,364.321655 223.609192,365.326324 
	C224.221039,365.910706 224.484512,366.100098 224.804916,366.210297 
	C225.373413,367.031067 225.941910,367.851807 226.873596,369.088989 
	C227.722076,369.789490 228.207367,370.073578 228.692642,370.357697 
	C229.885376,371.845184 231.078125,373.332642 232.671753,375.218079 
	C233.382339,375.741638 233.692062,375.867188 234.001785,375.992767 
	C236.233566,378.133636 238.465347,380.274506 240.812668,383.033508 
	C240.958771,384.094421 240.989334,384.537201 240.692230,384.960632 
	C239.242020,384.294281 238.119492,383.647247 236.702011,382.850281 
	C234.634552,381.435944 232.862030,380.171570 231.046906,378.563599 
	C227.640839,374.703186 224.312073,371.152374 220.906723,367.676605 
	C213.606888,360.225739 206.249298,352.831482 198.949295,345.380798 
	C191.052261,337.320770 183.254379,329.162750 175.303513,321.156494 
	C165.261688,311.044739 155.108932,301.043152 144.870087,290.703491 
	C143.510651,289.600616 142.285156,288.788330 141.009949,287.631073 
	C139.864075,286.133087 138.742447,285.002991 137.676605,283.822571 
	C134.747849,280.578949 131.842484,277.314209 129.014648,273.975250 
	C129.101440,273.892670 129.272079,273.724548 129.272079,273.724548 
	C133.769394,277.821930 138.251892,281.935791 142.772522,286.007294 
	C144.238815,287.327881 145.805008,288.537506 147.641739,289.910431 
	C148.064102,290.340057 148.248428,290.602173 148.765533,291.266571 
	C150.992401,293.505249 152.964691,295.286652 154.936996,297.068054 
	C154.936996,297.068054 155.001556,297.002930 155.012726,297.346802 
	C155.669693,298.145538 156.315475,298.600464 156.961243,299.055359 
	C157.458191,299.628021 157.955124,300.200714 158.708466,300.903687 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M97.609467,176.974884 
	C98.993469,177.698486 99.999062,178.385071 101.226501,179.286530 
	C101.529831,179.856644 101.611313,180.211884 101.761993,180.834869 
	C102.848404,186.778397 103.378616,192.601425 105.036171,198.083603 
	C106.373497,202.506699 107.995399,208.003799 111.361565,210.442245 
	C122.784332,218.716812 122.809135,229.314819 120.550583,241.431595 
	C119.241623,248.453995 117.571342,255.942505 121.528587,262.817352 
	C123.405869,266.078735 125.849731,269.013977 128.064484,272.504761 
	C128.092056,272.912506 127.929131,273.090424 127.566818,273.052917 
	C126.326546,272.613007 125.197556,272.433594 124.610535,271.772766 
	C120.135750,266.735046 116.684998,261.123932 117.088165,254.092911 
	C117.437462,248.001053 117.497162,241.730621 119.056435,235.906326 
	C121.697052,226.042908 117.817055,219.262192 110.675011,213.341858 
	C105.911995,209.393570 102.816399,204.765045 102.834160,198.094666 
	C102.845665,193.771317 102.356842,188.948044 100.390068,185.255371 
	C98.339981,181.406281 95.717041,176.799088 89.990448,176.687317 
	C89.633179,176.680359 89.295181,175.686295 88.948212,175.151459 
	C91.709152,175.746933 94.470100,176.342392 97.609467,176.974884 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M210.956192,328.105743 
	C211.014847,328.414856 211.169449,328.664551 211.718292,329.222778 
	C212.306473,329.819122 212.596375,330.047485 212.886292,330.275818 
	C212.969879,330.551147 213.126541,330.775421 213.635498,331.368774 
	C215.625443,333.488159 217.336227,335.187317 219.046997,336.886505 
	C219.046997,336.886505 219.309601,337.092438 219.599945,337.455078 
	C225.918945,343.556427 231.947586,349.295135 237.976227,355.033844 
	C238.063171,355.362793 238.245407,355.625671 238.872482,356.233551 
	C250.156204,368.075348 261.090393,379.506104 271.915039,391.200806 
	C271.539948,391.969269 271.274353,392.473816 271.008759,392.978333 
	C263.925201,385.827911 256.866913,378.652161 249.740891,371.544281 
	C247.880783,369.688843 245.715179,368.140015 243.851395,366.287842 
	C233.279144,355.781372 222.722824,345.258270 212.256805,334.646393 
	C210.909225,333.280060 210.116425,331.366547 209.022308,329.354431 
	C209.288330,328.925232 209.546265,328.764191 210.112656,328.313721 
	C210.473465,328.108215 210.956192,328.105743 210.956192,328.105743 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M173.627472,289.579224 
	C174.549484,289.574005 175.916229,289.572876 176.605316,290.255707 
	C183.375763,296.964325 190.075821,303.746216 196.669403,310.628448 
	C197.488647,311.483582 197.572906,313.042908 197.993896,314.650024 
	C189.912582,306.649658 181.835159,298.275208 173.627472,289.579224 
z"
          />
          <path
            fill="#EFF1F3"
            opacity="1.000000"
            stroke="none"
            d="
M140.024445,220.938141 
	C140.519745,221.223801 141.015045,221.509460 141.777512,221.901184 
	C143.677658,224.509323 145.465637,226.927170 146.887299,229.544022 
	C147.784332,231.195251 148.133789,233.143967 148.404251,235.019470 
	C148.079636,235.079697 148.030853,235.031540 147.796722,234.744995 
	C144.374466,230.651260 141.186325,226.844070 138.152405,222.783768 
	C138.879227,221.999802 139.451828,221.468964 140.024445,220.938141 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M122.022568,257.345398 
	C123.037834,257.536865 124.033653,258.115784 125.038536,258.678558 
	C126.428383,259.456909 127.825035,260.223053 129.613983,260.993530 
	C130.009201,263.716858 130.009201,266.441040 130.009201,269.892303 
	C125.112801,266.575775 123.209518,262.380646 122.022568,257.345398 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M158.869354,233.665283 
	C159.067551,236.187225 159.112473,238.421936 159.031021,240.975983 
	C158.073929,241.112579 157.243240,240.929871 156.163879,240.554108 
	C157.255508,235.244141 153.258392,232.339218 151.043381,228.328171 
	C151.461395,227.982208 151.911316,227.990585 152.699036,227.990356 
	C154.929932,229.780518 156.823013,231.579300 158.869354,233.665283 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M163.152100,280.321930 
	C164.101852,279.940308 165.808777,279.312927 166.268570,279.818909 
	C168.686569,282.479767 170.789474,285.427032 173.003799,288.642090 
	C169.781830,286.205902 166.557861,283.402496 163.152100,280.321930 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M210.947067,327.745880 
	C210.956192,328.105743 210.473465,328.108215 210.232162,328.116119 
	C208.003937,325.992950 206.016998,323.861847 203.972046,321.398987 
	C206.255325,323.173462 208.596634,325.279755 210.947067,327.745880 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M148.438995,277.963104 
	C152.206741,278.082062 156.389893,278.299011 160.760345,278.861633 
	C156.916580,278.825226 152.885483,278.443176 148.438995,277.963104 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M199.077591,316.330688 
	C202.071289,315.736298 204.318344,316.480499 203.958344,320.680786 
	C202.357025,319.603577 200.779221,318.122314 199.077591,316.330688 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M124.552612,237.985718 
	C124.538498,239.538086 124.165047,241.196259 123.427216,242.938385 
	C123.439651,241.378723 123.816467,239.735123 124.552612,237.985718 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M122.738358,246.198654 
	C122.900833,246.967743 122.797035,247.943680 122.375290,248.974319 
	C122.195587,248.154526 122.333839,247.279999 122.738358,246.198654 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M128.175232,272.825195 
	C128.540848,272.892273 128.785690,273.092621 129.132507,273.531738 
	C129.272079,273.724548 129.101440,273.892670 128.813080,273.853516 
	C128.273178,273.616669 128.074646,273.375366 127.929131,273.090424 
	C127.929131,273.090424 128.092056,272.912506 128.175232,272.825195 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M301.023224,424.969238 
	C300.364990,424.202118 299.706787,423.434967 298.976257,422.033203 
	C298.261261,420.941864 297.618591,420.485077 296.975922,420.028290 
	C296.975922,420.028290 297.000000,420.000000 296.966675,419.656982 
	C296.320740,417.826660 295.708160,416.339294 295.433014,414.915527 
	C298.772186,418.001801 301.810333,420.989349 304.768463,424.054077 
	C312.000946,431.547302 319.196381,439.076233 326.406769,446.590759 
	C326.406769,446.590759 326.175751,446.823334 325.723022,446.885010 
	C322.524292,444.950714 319.778320,442.954742 317.032349,440.958801 
	C316.123230,440.150452 315.214142,439.342102 314.128723,437.916077 
	C312.308777,435.852692 310.665070,434.406982 309.021393,432.961243 
	C308.368225,432.192474 307.715088,431.423706 306.888336,430.032013 
	C304.817566,427.929138 302.920410,426.449188 301.023224,424.969238 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M271.153625,393.283081 
	C271.274353,392.473816 271.539948,391.969269 272.174530,391.196594 
	C272.716248,390.917053 272.888977,390.905640 273.061707,390.894257 
	C273.061707,390.894257 273.008484,390.966492 273.152466,391.270935 
	C278.465271,396.441315 283.634094,401.307190 288.802948,406.173065 
	C288.802948,406.173065 288.998108,406.073029 288.936310,406.454224 
	C289.012085,407.463959 289.149628,408.092499 289.195679,408.810181 
	C289.104156,408.899292 288.921692,409.078094 288.596741,409.052490 
	C287.836334,409.033417 287.400848,409.039917 286.965363,409.046448 
	C286.965363,409.046448 286.502319,408.989380 286.133728,408.687012 
	C284.837860,407.594910 283.910553,406.805237 282.983215,406.015564 
	C279.088318,401.872986 275.193420,397.730438 271.153625,393.283081 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M317.050781,441.308228 
	C319.778320,442.954742 322.524292,444.950714 325.607300,447.001099 
	C326.278656,448.144196 326.613007,449.232849 326.966797,450.666626 
	C323.680573,447.893707 320.374908,444.775665 317.050781,441.308228 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M295.095581,414.851959 
	C295.708160,416.339294 296.320740,417.826660 296.952393,419.669067 
	C294.767090,418.193054 292.562683,416.362000 290.658508,414.235535 
	C292.024506,413.926605 293.090332,413.913086 294.354279,414.013550 
	C294.800171,414.318970 294.981232,414.560455 295.095581,414.851959 
z"
          />
          <path
            fill="#C7BAAE"
            opacity="1.000000"
            stroke="none"
            d="
M294.156128,413.899536 
	C293.090332,413.913086 292.024506,413.926605 290.565186,413.911133 
	C289.860565,413.118866 289.549500,412.355652 289.111389,410.985596 
	C288.963470,409.945190 288.942596,409.511658 288.921692,409.078094 
	C288.921692,409.078094 289.104156,408.899292 289.500397,408.930420 
	C291.316467,410.607574 292.736298,412.253540 294.156128,413.899536 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M301.046967,425.323792 
	C302.920410,426.449188 304.817566,427.929138 306.837982,429.719727 
	C304.997711,428.579681 303.034210,427.128998 301.046967,425.323792 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M309.043396,433.310242 
	C310.665070,434.406982 312.308777,435.852692 313.985229,437.641785 
	C312.367188,436.543213 310.716309,435.101257 309.043396,433.310242 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M282.996460,406.386963 
	C283.910553,406.805237 284.837860,407.594910 285.902130,408.659302 
	C285.029297,408.208801 284.019531,407.483582 282.996460,406.386963 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M297.015991,420.343811 
	C297.618591,420.485077 298.261261,420.941864 298.913574,421.729889 
	C298.300842,421.593872 297.678467,421.126587 297.015991,420.343811 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M288.596741,409.052490 
	C288.942596,409.511658 288.963470,409.945190 288.971619,410.705475 
	C288.326752,410.579865 287.694580,410.127502 287.013916,409.360809 
	C287.400848,409.039917 287.836334,409.033417 288.596741,409.052490 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M236.996948,383.000244 
	C238.119492,383.647247 239.242020,384.294281 240.683563,384.968506 
	C241.002579,384.995728 241.015457,384.982727 241.114105,385.216248 
	C241.492447,385.626709 241.772141,385.803650 242.315399,386.133606 
	C243.297974,386.639008 244.016998,386.991425 244.736023,387.343811 
	C245.637863,388.465454 246.539703,389.587067 247.777832,391.144104 
	C248.396301,392.090637 248.678452,392.601807 249.091339,393.330688 
	C249.524582,393.683472 249.827087,393.818542 250.129593,393.953644 
	C251.391388,395.063965 252.653168,396.174316 253.953629,397.975952 
	C254.966583,399.462891 255.940857,400.258575 256.915131,401.054260 
	C256.915131,401.054260 256.982300,400.997437 256.976471,401.400787 
	C258.604095,403.230438 260.237518,404.656738 261.870972,406.083038 
	C261.870972,406.083038 261.951324,406.049988 261.985840,406.388489 
	C262.614166,407.176819 263.207977,407.626709 263.801788,408.076599 
	C263.801788,408.076599 264.008392,408.370270 264.136597,408.838348 
	C264.783325,409.564056 265.301880,409.821655 265.820435,410.079254 
	C265.820435,410.079254 266.027740,410.388519 266.063934,410.932831 
	C268.119507,413.288422 270.138916,415.099670 272.158295,416.910950 
	C272.495819,417.294312 272.833344,417.677673 273.158264,418.711609 
	C274.431976,420.243256 275.718292,421.124359 277.004608,422.005432 
	C277.366425,422.381012 277.728271,422.756561 278.100220,423.771393 
	C279.798157,425.910370 281.485962,427.410095 283.173767,428.909821 
	C283.466278,429.030762 283.698425,429.224152 283.946899,430.069916 
	C284.758789,431.348419 285.493988,432.047028 286.229187,432.745667 
	C286.229187,432.745667 286.102203,432.920349 286.107788,433.225647 
	C287.786530,434.996704 289.459656,436.462463 291.132782,437.928253 
	C291.434937,438.028870 291.679688,438.207947 291.968872,439.036469 
	C294.474640,444.613678 297.741821,448.781342 303.078064,450.939178 
	C303.078064,450.939178 303.003845,450.996429 303.041565,451.294312 
	C303.736298,452.044891 304.393341,452.497559 305.050415,452.950195 
	C305.050415,452.950195 305.000000,453.000000 305.032410,453.342957 
	C305.886139,456.176788 306.869598,458.469788 310.202209,457.896790 
	C310.626282,458.240540 311.050385,458.584320 311.700623,459.087891 
	C311.952820,459.933899 311.978821,460.620087 311.647888,461.647766 
	C310.066406,461.782501 308.841858,461.575745 306.873688,461.243439 
	C310.357056,466.941101 308.600403,470.188019 302.728119,471.914856 
	C300.866364,469.723450 298.924561,467.437836 297.357666,465.147217 
	C299.931549,465.647400 302.130554,466.152496 305.501709,466.926880 
	C304.103790,464.666748 303.478485,463.162018 302.434784,462.049896 
	C296.461823,455.685333 290.453583,449.351044 284.336456,443.125214 
	C273.906281,432.509674 263.338287,422.029388 252.920578,411.401733 
	C245.541977,403.874420 238.315750,396.197723 231.222748,388.338745 
	C233.281647,386.393280 235.139297,384.696747 236.996948,383.000244 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M180.058975,321.487488 
	C178.473007,320.425140 176.870987,319.004639 175.167633,317.275146 
	C176.725159,318.353882 178.384033,319.741608 180.058975,321.487488 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M189.037094,330.569366 
	C187.722336,329.837372 186.401230,328.735718 185.055298,327.306030 
	C186.363876,328.051910 187.697311,329.125824 189.037094,330.569366 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M244.800537,386.976990 
	C244.016998,386.991425 243.297974,386.639008 242.224030,385.895844 
	C241.584579,385.330933 241.300018,385.156830 241.015457,384.982727 
	C241.015457,384.982727 241.002579,384.995728 241.011230,384.987854 
	C240.989334,384.537201 240.958771,384.094421 240.972504,383.321533 
	C242.299545,384.197693 243.582291,385.403931 244.800537,386.976990 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M221.032928,362.581482 
	C220.103333,362.149933 219.165359,361.356018 218.143417,360.259186 
	C219.047821,360.710541 220.036194,361.464844 221.032928,362.581482 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M218.038757,359.578613 
	C217.109818,359.144684 216.175980,358.349152 215.156067,357.251282 
	C216.057968,357.704956 217.045929,358.460968 218.038757,359.578613 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M256.936737,400.755707 
	C255.940857,400.258575 254.966583,399.462891 254.015320,398.293396 
	C254.856323,398.476471 255.674301,399.033356 256.757324,399.726105 
	C257.001038,400.060333 256.979675,400.258759 256.936737,400.755707 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M248.960602,393.112976 
	C248.678452,392.601807 248.396301,392.090637 248.052811,391.293427 
	C248.845764,391.529968 249.700043,392.052551 250.046188,392.814331 
	C249.345566,393.073334 249.153091,393.093140 248.960602,393.112976 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M194.925278,336.716980 
	C194.296539,336.592834 193.652298,336.139862 192.987228,335.363037 
	C193.614182,335.488831 194.261978,335.938477 194.925278,336.716980 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M166.944397,308.725708 
	C166.326782,308.579620 165.693985,308.107483 165.050110,307.312622 
	C165.669098,307.459869 166.299149,307.929779 166.944397,308.725708 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M212.804535,353.892212 
	C212.161743,353.796753 211.552597,353.347290 210.861862,352.619324 
	C211.466248,352.739929 212.152206,353.139069 212.804535,353.892212 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M209.724960,350.865234 
	C209.069977,350.767822 208.480194,350.316315 207.785858,349.594177 
	C208.384262,349.719421 209.087219,350.115295 209.724960,350.865234 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M196.922974,338.690125 
	C196.367416,338.544250 195.773895,338.075897 195.073761,337.333160 
	C195.606430,337.495087 196.245712,337.931366 196.922974,338.690125 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M192.949188,334.699799 
	C192.369446,334.538269 191.777878,334.051086 191.103775,333.281311 
	C191.659943,333.457214 192.298660,333.915680 192.949188,334.699799 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M228.665558,370.046448 
	C228.207367,370.073578 227.722076,369.789490 227.143799,369.232574 
	C227.580017,369.218231 228.109238,369.476715 228.665558,370.046448 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M172.722687,314.027771 
	C172.264099,314.072693 171.747711,313.807587 171.130112,313.263580 
	C171.574234,313.229034 172.119553,313.473358 172.722687,314.027771 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M210.687866,351.928406 
	C210.397919,352.116638 210.159592,351.957825 209.902710,351.501282 
	C210.104813,351.426117 210.389938,351.552063 210.687866,351.928406 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M203.823883,345.886475 
	C203.614487,345.941498 203.330444,345.749481 202.989319,345.299316 
	C203.204559,345.240601 203.476898,345.440002 203.823883,345.886475 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M249.091339,393.330688 
	C249.153091,393.093140 249.345566,393.073334 249.827362,393.021973 
	C250.116653,392.990387 250.177048,393.471436 250.153320,393.712524 
	C249.827087,393.818542 249.524582,393.683472 249.091339,393.330688 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M224.761200,365.938293 
	C224.484512,366.100098 224.221039,365.910706 223.894180,365.427826 
	C224.088440,365.364441 224.402969,365.515350 224.761200,365.938293 
z"
          />
          <path
            fill="#ECD6B1"
            opacity="1.000000"
            stroke="none"
            d="
M233.862854,375.777039 
	C233.692062,375.867188 233.382339,375.741638 232.939056,375.396759 
	C233.111649,375.305389 233.417786,375.433350 233.862854,375.777039 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M366.991241,493.375977 
	C370.648560,496.762848 374.307770,500.514069 378.020813,504.606049 
	C374.380829,501.211304 370.686981,497.475830 366.991241,493.375977 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M352.986389,478.378113 
	C355.975281,481.083923 358.962402,484.154572 361.979065,487.840088 
	C362.005341,488.638672 362.002045,488.822388 361.998779,489.006104 
	C358.994049,485.585052 355.989349,482.164001 352.986389,478.378113 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M348.049072,473.311462 
	C349.669678,474.414337 351.307617,475.866058 352.964691,477.664673 
	C351.344696,476.561127 349.705566,475.110718 348.049072,473.311462 
z"
          />
          <path
            fill="#D6DDDF"
            opacity="1.000000"
            stroke="none"
            d="
M362.037537,489.359253 
	C362.002045,488.822388 362.005341,488.638672 362.020813,488.178528 
	C363.598053,489.399841 365.163086,490.897644 366.858276,492.703003 
	C365.351074,491.911224 363.713684,490.811798 362.037537,489.359253 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M397.957092,524.431702 
	C399.280975,525.479248 400.610748,526.913330 401.955078,528.687195 
	C398.979828,529.198914 397.808929,527.639282 397.957092,524.431702 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M385.099915,512.231262 
	C385.713745,512.377197 386.335266,512.858215 386.995728,513.659424 
	C386.392303,513.508545 385.749939,513.037476 385.099915,512.231262 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M303.026611,450.605469 
	C297.741821,448.781342 294.474640,444.613678 292.070984,439.242981 
	C295.705872,442.676239 299.340515,446.474030 303.026611,450.605469 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M272.075684,416.581543 
	C270.138916,415.099670 268.119507,413.288422 266.122437,411.109558 
	C268.094147,412.578705 270.043610,414.415436 272.075684,416.581543 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M310.133240,457.563568 
	C306.869598,458.469788 305.886139,456.176788 305.057556,453.317688 
	C306.721619,454.376434 308.392944,455.803375 310.133240,457.563568 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M291.064728,437.596130 
	C289.459656,436.462463 287.786530,434.996704 286.189117,433.154602 
	C287.842102,434.273499 289.419403,435.768768 291.064728,437.596130 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M283.104675,428.576294 
	C281.485962,427.410095 279.798157,425.910370 278.159546,424.034790 
	C279.817688,425.186829 281.426636,426.714783 283.104675,428.576294 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M261.778656,405.770569 
	C260.237518,404.656738 258.604095,403.230438 256.957031,401.440247 
	C258.524414,402.536926 260.105377,403.997498 261.778656,405.770569 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M276.897705,421.694641 
	C275.718292,421.124359 274.431976,420.243256 273.206146,418.972473 
	C274.441345,419.516479 275.616089,420.450165 276.897705,421.694641 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M286.190063,432.436188 
	C285.493988,432.047028 284.758789,431.348419 284.039795,430.279633 
	C284.754333,430.648529 285.452667,431.387634 286.190063,432.436188 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M305.013885,452.631897 
	C304.393341,452.497559 303.736298,452.044891 303.069427,451.256683 
	C303.698853,451.385315 304.338104,451.849487 305.013885,452.631897 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M263.750305,407.790100 
	C263.207977,407.626709 262.614166,407.176819 261.970886,406.429260 
	C262.513885,406.588928 263.106323,407.046265 263.750305,407.790100 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M265.737610,409.797485 
	C265.301880,409.821655 264.783325,409.564056 264.191711,409.009216 
	C264.630707,408.979889 265.142761,409.247803 265.737610,409.797485 
z"
          />
          <path
            fill="#F9A61F"
            opacity="1.000000"
            stroke="none"
            d="
M296.982788,465.152191 
	C298.924561,467.437836 300.866364,469.723450 302.728119,471.914856 
	C308.600403,470.188019 310.357056,466.941101 306.873688,461.243439 
	C308.841858,461.575745 310.066406,461.782501 311.653778,461.993408 
	C314.417572,466.171753 317.388153,469.539337 321.550171,472.375732 
	C325.677155,475.188202 328.472534,479.885498 332.121857,483.482300 
	C339.763123,491.013611 347.614929,498.330719 355.315582,505.802521 
	C360.168335,510.511078 364.890625,515.353943 369.715332,520.091797 
	C370.141754,520.510559 370.894104,520.597534 371.851746,520.750977 
	C372.208405,520.663330 372.210052,520.771790 372.153137,521.180237 
	C373.878998,523.002502 375.661743,524.416260 377.444489,525.830078 
	C378.529236,526.691101 379.613953,527.552124 380.800934,528.944519 
	C380.866425,529.653259 380.829681,529.830627 380.488953,530.059692 
	C380.971191,531.609192 381.757416,533.106873 382.543671,534.604614 
	C383.027435,533.791321 383.511230,532.978027 383.995026,532.164734 
	C385.324768,533.491699 386.654541,534.818604 388.123230,536.722107 
	C388.573364,537.439575 388.884521,537.580505 389.195679,537.721497 
	C389.195679,537.721497 389.278503,537.763428 389.176575,538.153992 
	C387.780670,539.405640 386.486755,540.266724 384.811920,541.087830 
	C383.285767,542.022522 382.140564,542.997192 380.584747,543.996277 
	C377.458252,544.370483 374.742371,544.720398 371.865936,544.823730 
	C370.806335,545.021606 369.907257,545.466125 368.558716,545.934082 
	C353.744232,546.266968 339.379211,546.576477 324.942780,546.554199 
	C323.575897,546.440918 322.280426,546.659485 320.579285,546.898010 
	C316.255280,546.289856 312.316620,545.766846 308.422821,545.012268 
	C299.739563,543.329651 291.028564,541.743530 282.425049,539.710938 
	C275.878113,538.164246 269.474792,536.005737 263.015991,534.091003 
	C257.832520,532.554260 252.642334,531.035767 247.489838,529.399841 
	C239.956329,527.007812 232.453903,524.518005 224.948212,522.062073 
	C224.958191,522.054321 224.939209,522.058044 224.922333,521.697876 
	C219.354568,518.499329 213.803665,515.660950 208.231339,512.794922 
	C208.209900,512.767334 208.167328,512.711914 208.123047,512.374390 
	C205.348358,510.073486 202.617935,508.110046 199.945496,506.118896 
	C200.003510,506.091217 199.879166,506.120331 199.794434,505.788574 
	C194.442856,501.333466 189.176010,497.210114 183.765137,492.837646 
	C183.046402,492.093872 182.471695,491.599274 181.909088,490.747009 
	C180.312225,489.235016 178.703262,488.080627 176.991852,486.606689 
	C174.869858,484.237732 172.850281,482.188354 170.883789,479.763641 
	C167.607529,475.270294 164.278168,471.152252 160.870544,466.726379 
	C159.770859,465.348663 158.749435,464.278748 157.798920,462.844910 
	C155.861954,459.689606 153.854050,456.898224 151.723373,453.908600 
	C151.408722,453.459717 151.175156,453.257141 150.921326,452.766907 
	C150.276184,451.630096 149.609589,450.829071 148.882141,449.829041 
	C148.821274,449.630066 148.748184,449.220337 148.806976,448.841614 
	C146.875015,445.329407 144.884247,442.195923 142.823563,438.762817 
	C142.386978,437.735626 142.020309,437.008026 141.749374,435.941803 
	C141.212204,434.750305 140.579300,433.897491 139.948181,433.033997 
	C139.949951,433.023315 139.965591,433.029785 139.983246,432.620239 
	C139.850342,430.900665 139.949600,429.499298 139.509445,428.295105 
	C136.188568,419.209564 132.472244,410.257599 129.462418,401.072876 
	C127.184860,394.122742 125.853149,386.867310 123.917824,379.797760 
	C123.270081,377.431580 122.057983,375.219879 121.103851,372.937561 
	C121.066711,372.508026 121.029572,372.078461 121.004059,371.325653 
	C121.284981,363.117889 121.699326,355.234589 121.765633,347.348389 
	C121.801674,343.061798 120.644608,338.709717 121.068817,334.492065 
	C122.401291,321.244110 110.729958,304.431671 96.373650,303.857361 
	C95.891838,303.838074 95.437119,303.141602 95.828560,303.460571 
	C98.725159,299.538147 102.576866,296.268829 103.717384,292.233246 
	C104.869469,288.156769 103.334229,283.320801 103.288391,278.277161 
	C104.749229,277.484772 105.897934,277.232788 107.321960,277.235596 
	C108.719986,281.664581 109.842690,285.838745 110.956894,290.324402 
	C110.913757,291.049957 110.879120,291.464020 110.523788,291.986023 
	C110.072311,293.252197 109.562256,294.523315 109.868454,295.551300 
	C113.582664,308.020844 127.519012,314.998413 140.409912,310.943665 
	C146.776840,308.940979 147.586685,305.577942 143.011932,300.581207 
	C141.478470,298.906311 140.192841,297.004517 138.846619,295.153687 
	C138.899292,295.100952 139.004272,294.995117 139.382965,294.995361 
	C141.509094,293.661743 143.256561,292.327881 145.004013,290.994049 
	C155.108932,301.043152 165.261688,311.044739 175.303513,321.156494 
	C183.254379,329.162750 191.052261,337.320770 198.949295,345.380798 
	C206.249298,352.831482 213.606888,360.225739 220.906723,367.676605 
	C224.312073,371.152374 227.640839,374.703186 231.022186,378.589417 
	C231.040054,378.958862 230.992416,379.007324 230.613846,379.006531 
	C228.173355,379.659882 226.111450,380.314056 223.739365,380.846436 
	C221.246292,378.516052 219.063385,376.307495 216.902405,373.772217 
	C216.606476,372.649963 216.288620,371.854401 215.978333,370.667236 
	C213.755844,362.419861 211.452286,371.109833 209.193985,369.610016 
	C209.046906,370.032654 208.899841,370.455292 208.752762,370.877930 
	C209.799774,371.592926 210.846786,372.307922 212.007965,373.230652 
	C212.296143,373.718811 212.541367,373.905884 212.872803,374.427551 
	C213.329010,377.517761 213.770218,380.179932 214.152664,383.190613 
	C214.072708,384.009766 214.051529,384.480438 214.037888,385.253662 
	C214.355270,386.037750 214.665115,386.519318 214.989105,387.373657 
	C215.012711,388.492523 215.022156,389.238556 214.754745,390.215088 
	C215.042603,393.792114 213.650452,398.167511 218.995605,399.246338 
	C219.011032,399.483917 219.024582,399.959869 219.117325,400.187897 
	C219.399323,400.700439 219.656235,400.896057 220.008102,401.374023 
	C220.230576,402.540283 220.262360,403.425903 220.645264,404.116943 
	C227.271744,416.076538 234.953888,427.286743 245.257538,436.390564 
	C248.707520,439.438843 252.929001,441.613953 256.906708,444.509583 
	C262.033569,448.386902 265.594452,454.415649 272.970825,454.492004 
	C276.344757,456.619873 279.483856,458.702057 282.892365,460.150208 
	C287.194733,461.978119 291.716766,463.289032 296.361389,464.885681 
	C296.578796,464.948364 296.982788,465.152191 296.982788,465.152191 
M210.926193,384.352814 
	C210.580078,383.765900 210.233963,383.178955 209.887848,382.592041 
	C209.619843,383.096497 209.351822,383.600952 209.083786,384.105408 
	C209.647751,384.404755 210.211700,384.704102 210.926193,384.352814 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M154.961334,296.695251 
	C152.964691,295.286652 150.992401,293.505249 148.978439,291.383545 
	C150.953079,292.802948 152.969376,294.562683 154.961334,296.695251 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M156.944427,298.721313 
	C156.315475,298.600464 155.669693,298.145538 154.977798,297.375793 
	C155.596985,297.503052 156.262299,297.945160 156.944427,298.721313 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M224.938232,522.069824 
	C232.453903,524.518005 239.956329,527.007812 247.489838,529.399841 
	C252.642334,531.035767 257.832520,532.554260 263.015991,534.091003 
	C269.474792,536.005737 275.878113,538.164246 282.425049,539.710938 
	C291.028564,541.743530 299.739563,543.329651 308.422821,545.012268 
	C312.316620,545.766846 316.255280,546.289856 320.981171,546.938110 
	C322.863892,546.934143 323.939056,546.910034 325.014191,546.885925 
	C339.379211,546.576477 353.744232,546.266968 368.892365,545.964355 
	C370.459137,545.670837 371.242798,545.370544 372.026459,545.070312 
	C374.742371,544.720398 377.458252,544.370483 380.947510,544.004517 
	C382.878204,543.034912 384.035522,542.081360 385.192871,541.127808 
	C386.486755,540.266724 387.780670,539.405640 389.209717,538.186462 
	C390.199829,539.301880 391.054779,540.775330 391.882507,542.592285 
	C391.855255,542.935730 391.434448,543.046936 390.905273,543.110718 
	C389.210510,543.769775 388.044891,544.365051 386.470520,544.960571 
	C375.595367,546.328186 365.161163,548.102722 354.652374,548.933777 
	C346.305786,549.593750 337.867371,549.164917 329.470703,549.097656 
	C321.924683,549.037170 314.379944,548.810852 306.454224,548.711182 
	C305.042542,548.809021 304.011353,548.853271 302.980133,548.897583 
	C302.980133,548.897583 302.569550,548.801880 302.255402,548.440063 
	C296.565979,546.404724 291.297485,544.046021 285.795044,543.188416 
	C270.397797,540.788757 255.831497,535.961426 241.579254,529.854858 
	C236.200043,527.550049 230.556870,525.861206 225.017029,523.587524 
	C224.979416,522.878967 224.958817,522.474365 224.938232,522.069824 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M383.899536,531.879761 
	C383.511230,532.978027 383.027435,533.791321 382.543671,534.604614 
	C381.757416,533.106873 380.971191,531.609192 380.816223,530.061279 
	C381.663147,529.990662 381.878845,529.970154 382.094543,529.949707 
	C382.664368,530.498047 383.234192,531.046387 383.899536,531.879761 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M377.338501,525.499023 
	C375.661743,524.416260 373.878998,523.002502 372.120789,521.223816 
	C373.841095,522.295288 375.536804,523.731689 377.338501,525.499023 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M382.002441,529.699463 
	C381.878845,529.970154 381.663147,529.990662 381.120239,530.009521 
	C380.829681,529.830627 380.866425,529.653259 380.951660,529.208130 
	C381.303558,529.109985 381.606964,529.279602 382.002441,529.699463 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M389.099182,537.497253 
	C388.884521,537.580505 388.573364,537.439575 388.225922,537.027222 
	C388.521484,536.832642 388.792511,537.005066 389.099182,537.497253 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M492.183136,301.774872 
	C490.801514,302.158417 489.643341,302.272278 488.247437,302.641693 
	C487.263550,302.891083 486.517334,302.884918 485.411224,302.773071 
	C484.851807,302.207642 484.652344,301.747955 484.228851,301.159729 
	C486.058899,299.245941 488.112946,297.460724 490.083862,295.747742 
	C492.216309,297.358246 493.834290,298.580170 495.876007,300.122131 
	C494.571381,300.642212 493.488983,301.073730 492.183136,301.774872 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M473.618256,303.017975 
	C470.610931,306.742004 467.208588,310.471436 468.047729,316.548218 
	C464.915741,316.018799 464.671906,313.865021 465.522034,311.131073 
	C466.166626,309.058289 466.626862,306.928192 467.303375,304.302643 
	C468.742035,303.990448 470.978729,303.505127 473.618256,303.017975 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M469.810303,286.162292 
	C470.250885,286.261475 470.433716,286.540802 470.808472,286.987549 
	C470.524506,287.595917 470.048584,288.036835 469.572662,288.477722 
	C469.565948,287.765961 469.559265,287.054199 469.810303,286.162292 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M468.775635,279.041870 
	C469.082672,279.451447 469.080048,279.891907 469.067352,280.662537 
	C468.522339,280.760773 467.987366,280.528839 467.452423,280.296875 
	C467.790283,279.888824 468.128143,279.480774 468.775635,279.041870 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M470.449585,273.533081 
	C470.416412,273.477478 470.482788,273.588684 470.449585,273.533081 
z"
          />
          <path
            fill="#F9A61F"
            opacity="1.000000"
            stroke="none"
            d="
M210.407745,238.011993 
	C200.137238,227.991013 190.561691,217.724060 180.438553,208.028854 
	C174.672241,202.506317 171.120102,194.387955 162.668091,191.935059 
	C159.752014,191.088791 156.626373,190.964630 152.164719,190.296066 
	C158.513336,186.877396 165.787888,186.592606 167.114853,179.508835 
	C169.449310,182.909027 171.093903,186.523392 173.833038,188.848145 
	C175.543579,190.299911 179.746506,191.044235 181.362381,189.945740 
	C185.614517,187.055069 189.063812,182.983475 192.753510,179.012512 
	C192.674133,178.642807 192.765533,178.290314 193.226624,178.134369 
	C198.835297,175.060410 203.966293,172.112579 209.137054,169.236252 
	C211.977081,167.656433 214.912582,166.248444 217.755630,164.673767 
	C225.922256,160.150467 233.688751,154.622040 242.303146,151.256241 
	C255.158615,146.233337 268.481171,142.253357 281.842499,138.730652 
	C290.898956,136.342911 300.377960,135.584900 309.637512,133.927597 
	C313.489960,133.238068 317.263062,132.105331 321.072266,131.174133 
	C331.056244,131.118378 341.040222,131.062592 351.486115,131.052307 
	C356.070465,132.051666 360.158539,133.206497 364.322296,133.918839 
	C373.878967,135.553818 383.695038,136.150177 393.000916,138.665787 
	C408.370239,142.820465 423.521515,147.867691 438.555115,153.136673 
	C444.709137,155.293518 450.317657,159.006882 456.535278,162.059723 
	C457.937225,165.731323 460.723816,166.791504 464.545532,167.204132 
	C465.003296,167.404587 465.156403,167.815521 465.156403,167.815521 
	C465.560150,168.196381 465.963928,168.577255 466.661621,169.001984 
	C467.820068,169.673828 468.684570,170.301819 469.924072,170.854294 
	C470.907288,170.894958 471.515503,171.011154 472.468628,171.491394 
	C472.878235,172.233658 472.942993,172.611862 473.061859,173.339432 
	C475.787231,175.102539 478.458496,176.516296 481.129761,177.930069 
	C482.061523,178.735489 482.993286,179.540894 483.748169,180.813538 
	C484.426147,183.937561 484.824524,187.190506 489.207886,185.402359 
	C489.380493,185.340134 489.736786,185.252167 489.736786,185.252167 
	C491.451080,186.945541 493.165375,188.638931 494.966095,190.651901 
	C496.448883,193.294083 497.845245,195.616669 499.583374,198.005341 
	C499.623108,199.794403 499.321045,201.517380 499.009766,203.620880 
	C499.000580,204.001389 499.003601,204.010681 498.679810,204.044556 
	C497.914490,204.728394 497.472931,205.378357 496.999634,206.343323 
	C496.907928,207.076065 496.847931,207.493820 496.608643,208.041260 
	C496.199432,208.372513 496.046509,208.621353 495.766144,209.050507 
	C495.272858,209.344925 495.032135,209.560211 494.538086,209.841156 
	C493.837250,209.913849 493.437927,209.974762 492.687347,210.062317 
	C490.880219,212.046326 489.424286,214.003693 487.961060,216.224091 
	C487.970612,216.661697 487.987457,216.836288 487.799255,217.051300 
	C487.594238,217.091721 487.176910,217.113037 486.798126,217.065491 
	C484.956482,218.358109 483.493652,219.698303 481.901306,221.239517 
	C481.565033,221.692795 481.310760,221.880905 480.643799,222.006165 
	C477.377502,224.092255 474.160278,225.855515 471.643463,228.330933 
	C466.886383,233.009750 462.531860,238.097916 457.958496,243.301086 
	C457.855072,243.967117 457.803192,244.348007 457.751282,244.728912 
	C456.278473,245.961929 454.805695,247.194962 452.790466,248.684601 
	C451.614532,249.117569 450.882050,249.145645 450.362518,249.492630 
	C443.164978,254.299728 442.845337,254.274658 436.639374,248.232635 
	C428.081329,239.900726 418.791351,232.470154 408.024750,227.247360 
	C394.040497,220.463715 380.102539,213.310394 363.961914,212.501648 
	C362.925812,212.147125 361.953308,212.098434 360.583740,212.050522 
	C359.129272,212.004974 358.071930,211.958633 356.948547,211.577545 
	C355.576019,211.193497 354.269470,211.144211 352.498535,211.086487 
	C347.023865,211.054840 342.013580,211.031647 336.922607,210.624298 
	C333.123810,208.298965 329.617645,207.583221 326.565674,211.975983 
	C324.440796,212.038559 322.740051,212.069641 320.828430,211.819244 
	C319.406036,211.991135 318.194550,212.444489 316.590210,212.938736 
	C315.144897,213.021194 314.092468,213.062775 312.838379,212.824066 
	C311.085754,213.331680 309.534851,214.119598 307.601257,214.943924 
	C305.488220,215.340179 303.757782,215.699997 301.805450,215.779053 
	C297.718109,216.979248 293.852692,218.460236 289.662109,220.121140 
	C287.643829,220.583008 285.950745,220.864929 283.890442,221.122742 
	C282.684448,222.078903 281.845642,223.059174 280.685150,224.199402 
	C277.958984,225.269653 275.554443,226.179947 272.752808,227.060120 
	C270.916656,228.046799 269.477631,229.063599 267.874084,230.381927 
	C264.513824,232.808487 261.318085,234.933487 257.870789,237.140335 
	C257.422333,237.504730 257.225433,237.787262 257.020691,238.397583 
	C257.023224,239.161713 257.033569,239.598053 256.995758,240.022888 
	C256.947601,240.011398 256.867798,239.953690 256.674805,240.055786 
	C256.239899,240.337234 256.071594,240.569839 255.769775,240.999939 
	C255.322906,241.377869 255.083221,241.611603 254.514679,241.885895 
	C253.166397,242.324478 252.147003,242.722534 250.737183,243.077057 
	C249.567596,243.029800 248.788452,243.026077 247.855560,242.709167 
	C245.793945,239.787689 243.777084,239.169479 240.721848,242.800430 
	C242.939209,244.304199 244.927963,245.652939 246.930450,247.234802 
	C246.944199,247.467926 246.951202,247.934937 246.795776,248.178497 
	C246.115692,248.632141 245.591064,248.842239 244.686142,249.033569 
	C243.545120,249.013458 242.784393,249.012100 242.023651,249.010773 
	C240.513565,249.438782 238.126953,249.422272 237.645340,250.371887 
	C235.574738,254.454727 232.102859,253.589951 228.950439,253.820389 
	C228.590851,253.296051 228.295883,253.048996 228.240173,252.756424 
	C227.678177,249.804321 228.006760,246.255905 226.450409,244.005661 
	C222.824677,238.763336 217.388596,236.576828 210.407745,238.011993 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M257.043060,273.260834 
	C262.244812,277.742615 267.467957,282.590057 272.754089,287.766754 
	C271.880463,287.853027 270.636627,287.911316 270.056274,287.319214 
	C265.652588,282.826630 261.378754,278.206757 257.043060,273.260834 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M337.305298,370.120300 
	C337.000275,369.815186 337.002655,369.641785 337.047852,369.211334 
	C338.207947,369.144867 339.749634,368.932739 340.374146,369.590881 
	C344.659271,374.106506 348.752319,378.804382 352.886475,383.803650 
	C347.781433,379.526489 342.697083,374.889252 337.305298,370.120300 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M368.851318,399.852112 
	C363.875702,395.403259 358.931641,390.592926 353.921570,385.449524 
	C358.864685,389.907806 363.873779,394.699219 368.851318,399.852112 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M241.863861,249.368042 
	C242.784393,249.012100 243.545120,249.013458 244.623901,249.394440 
	C244.110413,252.205093 240.733978,254.541763 244.668518,257.149475 
	C244.755661,257.293610 244.842789,257.437714 245.098541,257.771637 
	C245.266266,258.676727 245.265366,259.392059 245.314240,260.463806 
	C241.432861,258.943848 240.329926,255.600327 241.863861,249.368042 
z"
          />
          <path
            fill="#F9A61F"
            opacity="1.000000"
            stroke="none"
            d="
M222.239166,249.783875 
	C220.394119,248.555191 218.831543,247.083176 217.128510,245.320679 
	C218.188156,244.627625 220.367767,243.748169 220.439316,243.895096 
	C221.312988,245.689484 221.877213,247.634537 222.239166,249.783875 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M375.049988,406.553528 
	C373.354980,405.216827 371.647675,403.521362 369.862732,401.503235 
	C371.535919,402.851959 373.286804,404.523346 375.049988,406.553528 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M384.980011,416.674683 
	C384.156616,416.793915 383.355957,416.537842 382.259064,416.156525 
	C381.399597,414.879730 380.836395,413.728149 380.176910,412.260803 
	C381.721344,413.396484 383.362061,414.847931 384.980011,416.674683 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M290.197815,307.134583 
	C291.435364,307.652863 292.611176,308.520355 293.909241,309.694519 
	C292.733002,309.162079 291.434540,308.322968 290.197815,307.134583 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M295.760803,312.135620 
	C296.609955,312.455933 297.220978,312.955994 297.929810,313.742615 
	C297.192627,313.457916 296.357635,312.886658 295.760803,312.135620 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M301.998047,318.353180 
	C302.936340,318.787201 303.871307,319.593628 304.898438,320.701050 
	C303.991974,320.243225 302.993347,319.484406 301.998047,318.353180 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M254.522491,270.016785 
	C255.208649,270.421082 255.593491,270.883911 256.074585,271.630493 
	C255.520966,271.301239 254.871063,270.688263 254.522491,270.016785 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M385.098877,402.255249 
	C385.694733,402.401184 386.293396,402.887573 387.019775,403.640747 
	C386.465576,403.470276 385.783661,403.032990 385.098877,402.255249 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M251.739838,267.112091 
	C252.225677,267.183472 252.506592,267.379639 252.834824,267.836792 
	C252.433060,267.810791 251.983994,267.523834 251.739838,267.112091 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M273.047668,288.391113 
	C273.276550,288.201904 273.528717,288.337769 273.759521,288.833679 
	C273.545776,288.957123 273.323364,288.797943 273.047668,288.391113 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M364.025482,212.807449 
	C380.102539,213.310394 394.040497,220.463715 408.024750,227.247360 
	C418.791351,232.470154 428.081329,239.900726 436.639374,248.232635 
	C442.845337,254.274658 443.164978,254.299728 450.362518,249.492630 
	C450.882050,249.145645 451.614532,249.117569 452.619324,248.956696 
	C448.183044,256.595917 443.432404,258.095367 438.215393,253.228806 
	C431.471771,246.938217 424.243652,241.123459 416.878845,235.561035 
	C413.257904,232.826233 408.859406,231.120865 404.444763,228.923767 
	C398.307465,226.255890 392.538208,223.613892 386.384918,220.976089 
	C383.599213,220.300140 381.197479,219.620026 378.179382,218.645203 
	C371.019012,216.942444 364.475006,215.534348 357.931030,214.126251 
	C355.584930,214.068161 353.238831,214.010086 350.150238,213.667084 
	C344.875031,213.169296 340.342285,212.956421 335.881775,212.481293 
	C336.303741,211.815506 336.653534,211.411972 337.003296,211.008438 
	C342.013580,211.031647 347.023865,211.054840 352.745422,211.344940 
	C354.642639,211.712006 355.828583,211.812149 357.014557,211.912292 
	C358.071930,211.958633 359.129272,212.004974 360.802368,212.301376 
	C362.287231,212.636780 363.156342,212.722107 364.025482,212.807449 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M284.257629,221.146851 
	C285.950745,220.864929 287.643829,220.583008 290.050537,220.141388 
	C294.518555,218.674408 298.272949,217.367126 302.027374,216.059845 
	C303.757782,215.699997 305.488220,215.340179 307.956726,214.975510 
	C310.143188,214.348557 311.591614,213.726456 313.040039,213.104340 
	C314.092468,213.062775 315.144897,213.021194 316.954041,212.980911 
	C318.820282,212.688370 319.929779,212.394547 321.039307,212.100723 
	C322.740051,212.069641 324.440796,212.038559 326.978607,212.010010 
	C329.860321,212.255432 331.904999,212.498322 333.957336,213.038971 
	C333.966797,213.535324 333.968506,213.733902 333.970245,213.932480 
	C332.604065,213.969345 331.237854,214.006210 329.028870,214.022583 
	C325.786835,214.339111 323.387604,214.676117 320.988403,215.013138 
	C320.256409,215.025208 319.524445,215.037292 318.429199,215.084351 
	C308.190582,217.872238 298.315186,220.625137 288.217499,223.657867 
	C287.196259,224.208450 286.397339,224.479218 284.954407,224.900467 
	C282.811279,226.310837 281.312195,227.570740 279.813080,228.830612 
	C279.415253,228.876068 279.017395,228.921539 277.954285,229.011841 
	C274.847687,230.362350 272.406342,231.668030 269.964996,232.973724 
	C266.759125,235.101913 263.553253,237.230118 259.763458,239.627792 
	C258.467651,239.942978 257.755798,239.988678 257.043915,240.034393 
	C257.033569,239.598053 257.023224,239.161713 257.249023,238.283844 
	C257.697601,237.581039 257.909973,237.319763 258.122345,237.058472 
	C261.318085,234.933487 264.513824,232.808487 268.212036,230.335419 
	C270.192963,229.021652 271.671448,228.055939 273.149933,227.090240 
	C275.554443,226.179947 277.958984,225.269653 281.024872,224.167450 
	C282.543365,223.032623 283.400513,222.089737 284.257629,221.146851 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M358.019653,214.475143 
	C364.475006,215.534348 371.019012,216.942444 377.790527,218.627701 
	C377.795868,219.139404 377.516022,219.612015 377.359711,219.574173 
	C370.935638,218.019440 364.522644,216.418854 358.019653,214.475143 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M334.257690,214.242218 
	C333.968506,213.733902 333.966797,213.535324 334.268372,213.068695 
	C334.984283,212.781601 335.396942,212.762573 335.809570,212.743530 
	C340.342285,212.956421 344.875031,213.169296 349.709778,213.666031 
	C344.856232,214.150574 339.700653,214.351273 334.257690,214.242218 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M321.052277,215.368408 
	C323.387604,214.676117 325.786835,214.339111 328.619690,214.048218 
	C326.407623,214.637436 323.761871,215.180542 321.052277,215.368408 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M458.010071,243.015976 
	C462.531860,238.097916 466.886383,233.009750 471.643463,228.330933 
	C474.160278,225.855515 477.377502,224.092255 480.647980,222.354431 
	C481.037506,223.165741 481.057617,223.630127 480.910461,224.335693 
	C480.105652,225.020721 479.468048,225.464554 478.496948,225.961182 
	C476.083679,227.966293 474.003906,229.918640 471.924164,231.871002 
	C471.111511,232.447632 470.298859,233.024261 468.974060,233.935364 
	C465.988312,236.864594 463.514709,239.459381 461.041107,242.054169 
	C460.927002,242.362885 460.738770,242.616653 459.925049,242.908340 
	C458.919128,243.006149 458.464600,243.011063 458.010071,243.015976 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M461.371643,242.013214 
	C463.514709,239.459381 465.988312,236.864594 468.789551,234.166382 
	C467.740509,236.082962 466.363861,238.102982 464.876373,240.441925 
	C463.744415,241.164658 462.723328,241.568466 461.371643,242.013214 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M457.958496,243.301086 
	C458.464600,243.011063 458.919128,243.006149 459.714752,243.022949 
	C459.514221,243.648849 458.972595,244.253052 458.091125,244.793076 
	C457.803192,244.348007 457.855072,243.967117 457.958496,243.301086 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M244.775391,256.771484 
	C240.733978,254.541763 244.110413,252.205093 245.004181,249.413208 
	C245.591064,248.842239 246.115692,248.632141 247.106796,248.058258 
	C248.758057,246.169861 249.942841,244.645218 251.127625,243.120590 
	C252.147003,242.722534 253.166397,242.324478 254.571106,242.244019 
	C254.973465,243.042328 254.990479,243.523071 255.007507,244.003799 
	C253.651962,245.377808 252.296432,246.751816 250.570801,248.541626 
	C249.406799,249.926224 248.612900,250.895035 247.819000,251.863846 
	C246.840103,253.373734 245.861191,254.883621 244.775391,256.771484 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M255.373932,244.003586 
	C254.990479,243.523071 254.973465,243.042328 254.899994,242.203476 
	C255.083221,241.611603 255.322906,241.377869 256.008850,240.961685 
	C256.768188,240.591858 256.905731,240.316666 256.867798,239.953690 
	C256.867798,239.953690 256.947601,240.011398 256.995758,240.022888 
	C257.755798,239.988678 258.467651,239.942978 259.533630,239.876007 
	C258.505280,241.237625 257.122833,242.620499 255.373932,244.003586 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M270.347229,232.981079 
	C272.406342,231.668030 274.847687,230.362350 277.656006,229.047043 
	C275.591797,230.354431 273.160614,231.671432 270.347229,232.981079 
z"
          />
          <path
            fill="#D3C9BD"
            opacity="1.000000"
            stroke="none"
            d="
M280.181732,228.859955 
	C281.312195,227.570740 282.811279,226.310837 284.665710,225.038528 
	C283.530823,226.313828 282.040619,227.601562 280.181732,228.859955 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M248.185974,251.881943 
	C248.612900,250.895035 249.406799,249.926224 250.519760,248.871292 
	C250.076859,249.823456 249.314911,250.861755 248.185974,251.881943 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M489.035248,185.464584 
	C484.824524,187.190506 484.426147,183.937561 483.840729,181.109558 
	C485.598602,181.826279 487.086975,182.714233 488.767517,184.206299 
	C488.984863,185.028442 489.010071,185.246521 489.035248,185.464584 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M481.022583,177.662506 
	C478.458496,176.516296 475.787231,175.102539 473.394470,173.338806 
	C474.116486,172.990082 474.560028,172.991348 475.003540,172.992615 
	C475.742096,173.401367 476.480652,173.810120 477.599152,174.585785 
	C478.360229,175.304443 478.741364,175.656204 479.122498,176.007965 
	C479.720123,176.470291 480.317780,176.932632 481.022583,177.662506 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M479.330627,175.841415 
	C478.741364,175.656204 478.360229,175.304443 477.902832,174.701263 
	C478.261505,174.346863 478.696442,174.243866 479.464020,174.142838 
	C479.710724,174.654831 479.624756,175.164841 479.330627,175.841415 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M489.207886,185.402359 
	C489.010071,185.246521 488.984863,185.028442 488.931396,184.483459 
	C489.181213,184.343567 489.459320,184.530594 489.737122,184.984894 
	C489.736786,185.252167 489.380493,185.340134 489.207886,185.402359 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M478.830444,225.908386 
	C479.468048,225.464554 480.105652,225.020721 481.235443,224.270264 
	C482.532776,223.016281 483.337891,222.068924 484.410980,220.946747 
	C485.511597,219.552277 486.344269,218.332657 487.176910,217.113037 
	C487.176910,217.113037 487.594238,217.091721 488.054810,217.001541 
	C488.700348,216.630920 488.885315,216.350479 489.276306,215.831848 
	C490.619598,214.673737 491.756897,213.753830 493.174927,212.792694 
	C493.957153,212.490631 494.458618,212.229782 494.998016,212.004379 
	C495.035950,212.039825 495.108002,212.114548 495.108032,212.114563 
	C494.074310,214.166290 493.040619,216.218033 492.001221,218.636536 
	C491.411865,219.490799 490.828217,219.978302 490.124207,220.730255 
	C486.505707,223.631485 483.007568,226.268265 479.186249,228.531021 
	C478.852173,227.407471 478.841309,226.657928 478.830444,225.908386 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M494.839600,209.829376 
	C495.032135,209.560211 495.272858,209.344925 496.007233,209.085144 
	C496.452698,208.986816 496.922974,208.861710 497.195374,208.788574 
	C497.972900,208.466537 498.478027,208.217621 498.983124,207.968704 
	C497.934692,209.322052 496.886261,210.675385 495.472900,212.071640 
	C495.108002,212.114548 495.035950,212.039825 495.003784,211.647171 
	C494.927612,210.779465 494.883606,210.304428 494.839600,209.829376 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M499.094849,207.750366 
	C498.478027,208.217621 497.972900,208.466537 497.177673,208.549255 
	C496.887512,208.383041 496.787903,207.911560 496.787903,207.911560 
	C496.847931,207.493820 496.907928,207.076065 497.265564,206.222977 
	C498.043335,205.195312 498.523468,204.602997 499.003601,204.010681 
	C499.003601,204.010681 499.000580,204.001389 499.005798,204.002594 
	C499.552185,203.750610 500.093323,203.497391 500.934387,203.206512 
	C500.903900,204.232605 500.573456,205.296387 500.127716,206.679474 
	C499.680359,207.080658 499.411743,207.258408 499.094849,207.750366 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M478.496948,225.961182 
	C478.841309,226.657928 478.852173,227.407471 478.828705,228.527924 
	C478.374634,229.212280 477.954895,229.525711 477.263916,229.890106 
	C475.536591,230.588760 474.080444,231.236450 472.274231,231.877563 
	C474.003906,229.918640 476.083679,227.966293 478.496948,225.961182 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M320.621002,131.087860 
	C317.263062,132.105331 313.489960,133.238068 309.637512,133.927597 
	C300.377960,135.584900 290.898956,136.342911 281.842499,138.730652 
	C268.481171,142.253357 255.158615,146.233337 242.303146,151.256241 
	C233.688751,154.622040 225.922256,160.150467 217.755630,164.673767 
	C214.912582,166.248444 211.977081,167.656433 209.137054,169.236252 
	C203.966293,172.112579 198.835297,175.060410 193.307922,177.971436 
	C198.959579,173.638336 204.800995,169.012833 211.057663,165.041565 
	C230.709976,152.567734 251.878143,143.530579 274.502899,137.972183 
	C279.167969,136.826065 283.854736,135.768387 288.766602,134.387665 
	C289.437531,134.060745 289.873413,134.016129 290.630432,133.902374 
	C297.117706,133.054932 303.283844,132.276642 309.725739,131.212677 
	C310.436859,130.937775 310.872253,130.948547 311.628967,130.897552 
	C314.690125,130.891068 317.429932,130.946335 320.621002,131.087860 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M83.970093,122.379440 
	C88.735016,123.698257 93.505013,125.330849 98.674561,127.081360 
	C96.971016,127.480408 94.867935,127.761536 92.386398,128.009338 
	C91.274445,127.968964 90.540932,127.961922 89.442642,127.951553 
	C87.609894,126.707321 86.141937,125.466408 84.383591,124.083496 
	C84.053871,123.525398 84.014519,123.109306 83.970093,122.379440 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M114.524582,179.033875 
	C115.089584,181.141815 115.296616,183.329071 115.250778,185.757538 
	C112.280090,183.998245 112.147346,181.685623 114.524582,179.033875 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M89.999023,212.031708 
	C89.536263,212.060379 89.073502,212.089050 88.279808,212.228683 
	C85.567291,211.916473 83.185699,211.493286 80.370476,210.690918 
	C79.272423,210.264069 78.607994,210.216431 77.943573,210.168777 
	C68.089378,207.772629 63.682846,197.845322 68.751923,187.164154 
	C70.719246,183.018799 75.221741,180.076569 79.063156,176.256683 
	C79.791412,175.659058 80.025864,175.391022 80.260323,175.122986 
	C80.940300,175.048660 81.620285,174.974335 82.629959,174.804535 
	C83.428688,174.810577 83.897720,174.912079 84.620285,175.428711 
	C83.721390,176.525513 82.568954,177.207214 80.482590,178.441391 
	C82.585068,178.738678 83.649376,178.987976 84.721008,179.024979 
	C92.825569,179.304764 97.630104,183.075089 100.172379,191.209320 
	C101.854408,196.591141 99.251793,202.659470 93.595009,206.942169 
	C92.482155,207.784714 91.718948,209.089081 90.593315,210.345856 
	C90.261108,211.018051 90.130066,211.524887 89.999023,212.031708 
M73.022659,192.029175 
	C73.038757,193.683624 72.840439,195.374054 73.110748,196.985870 
	C73.956955,202.031738 76.875099,205.447144 81.854294,206.738083 
	C87.617683,208.232330 92.407265,206.318329 95.837364,201.595749 
	C98.725281,197.619659 99.912727,193.040131 96.798294,188.721527 
	C93.822243,184.594788 89.841927,181.613739 84.287918,181.957672 
	C78.333649,182.326401 75.316078,186.274292 73.022659,192.029175 
M74.999382,184.399872 
	C75.994072,183.293839 76.988754,182.187820 77.983444,181.081787 
	C77.363510,180.755981 76.743584,180.430161 76.123650,180.104355 
	C75.557838,181.634964 74.992020,183.165588 74.999382,184.399872 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M78.130905,210.396790 
	C78.607994,210.216431 79.272423,210.264069 79.976822,210.598694 
	C79.450607,210.798737 78.884422,210.711777 78.130905,210.396790 
z"
          />
          <path
            fill="#DFD3C0"
            opacity="1.000000"
            stroke="none"
            d="
M79.980019,175.175598 
	C80.025864,175.391022 79.791412,175.659058 79.305145,176.023682 
	C79.268799,175.822906 79.484261,175.525558 79.980019,175.175598 
z"
          />
          <path
            fill="#F9A61F"
            opacity="1.000000"
            stroke="none"
            d="
M90.794479,210.180450 
	C91.718948,209.089081 92.482155,207.784714 93.595009,206.942169 
	C99.251793,202.659470 101.854408,196.591141 100.172379,191.209320 
	C97.630104,183.075089 92.825569,179.304764 84.721008,179.024979 
	C83.649376,178.987976 82.585068,178.738678 80.482590,178.441391 
	C82.568954,177.207214 83.721390,176.525513 84.969940,175.515839 
	C86.102280,175.142532 87.138489,175.097198 88.561462,175.101669 
	C89.295181,175.686295 89.633179,176.680359 89.990448,176.687317 
	C95.717041,176.799088 98.339981,181.406281 100.390068,185.255371 
	C102.356842,188.948044 102.845665,193.771317 102.834160,198.094666 
	C102.816399,204.765045 105.911995,209.393570 110.675011,213.341858 
	C117.817055,219.262192 121.697052,226.042908 119.056435,235.906326 
	C117.497162,241.730621 117.437462,248.001053 117.088165,254.092911 
	C116.684998,261.123932 120.135750,266.735046 124.610535,271.772766 
	C125.197556,272.433594 126.326546,272.613007 127.566818,273.052917 
	C128.074646,273.375366 128.273178,273.616669 128.726288,273.936096 
	C131.842484,277.314209 134.747849,280.578949 137.676605,283.822571 
	C138.742447,285.002991 139.864075,286.133087 140.670471,287.812286 
	C139.921906,290.557343 139.463089,292.776215 139.004272,294.995117 
	C139.004272,294.995117 138.899292,295.100952 138.520844,295.077759 
	C131.310379,288.772919 124.510414,282.455750 117.619583,276.239319 
	C116.228531,274.984406 114.493248,274.111023 112.740982,272.991943 
	C112.565285,272.922089 112.212135,272.786835 112.171158,272.435059 
	C111.016205,269.777161 109.902222,267.471069 108.853500,264.722473 
	C108.283264,261.516479 107.647758,258.753021 107.010178,255.597809 
	C107.041702,254.162277 107.075279,253.118484 107.422729,252.002502 
	C108.097008,251.242630 108.457413,250.554962 108.841064,249.509979 
	C108.858376,248.437210 108.852417,247.721771 109.099052,246.877380 
	C109.210281,246.164291 109.068924,245.580124 108.940865,244.548935 
	C109.007072,241.425415 109.059990,238.748947 109.462967,235.968353 
	C111.371727,233.674698 112.214798,231.569138 109.096756,229.538284 
	C108.428291,227.728699 107.779121,226.307083 107.129959,224.885468 
	C107.129959,224.885468 106.983269,224.519913 106.944061,223.986938 
	C105.570251,221.999802 104.235657,220.545609 102.901062,219.091415 
	C102.901070,219.091415 102.954781,219.006836 102.939423,218.697586 
	C100.944511,216.262512 98.964966,214.136703 96.918465,211.666016 
	C95.862228,210.981262 94.872955,210.641342 93.502190,210.247650 
	C92.345299,210.189407 91.569885,210.184937 90.794479,210.180450 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M89.076431,299.619232 
	C82.923927,299.096252 78.592491,294.703125 78.016243,288.401550 
	C77.439896,282.098969 81.073494,276.729370 86.957336,275.188599 
	C93.307610,273.525757 99.042763,275.921753 101.704735,281.349762 
	C104.768265,287.596558 103.574883,292.562653 97.530411,296.759705 
	C97.748528,294.623718 98.361771,292.804352 98.987213,290.571411 
	C98.981949,288.779083 98.964470,287.400330 98.926659,285.662292 
	C97.352905,281.355652 94.082886,278.758575 90.259026,279.358368 
	C86.733231,279.911377 81.983917,280.571014 81.112862,285.575531 
	C80.307411,290.203094 81.681824,294.035248 85.932426,296.621948 
	C87.140892,297.357361 88.037048,298.605988 89.076431,299.619232 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M98.975021,290.985046 
	C98.361771,292.804352 97.748528,294.623718 97.184830,296.813721 
	C97.234383,297.184357 97.195595,297.171143 96.774033,297.114410 
	C94.540794,297.925842 92.729111,298.793976 90.917435,299.662109 
	C90.504433,299.708130 90.091438,299.754150 89.377434,299.709686 
	C88.037048,298.605988 87.140892,297.357361 85.932426,296.621948 
	C81.681824,294.035248 80.307411,290.203094 81.112862,285.575531 
	C81.983917,280.571014 86.733231,279.911377 90.259026,279.358368 
	C94.082886,278.758575 97.352905,281.355652 98.566093,285.614075 
	C94.634506,283.091583 90.844322,281.590485 86.502441,284.305328 
	C83.116768,286.422272 83.319977,289.822754 84.652740,292.607727 
	C85.233589,293.821503 88.420898,294.582245 90.187134,294.257568 
	C93.214653,293.701019 96.055695,292.130066 98.975021,290.985046 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M107.046646,276.980804 
	C105.897934,277.232788 104.749229,277.484772 103.268646,277.879181 
	C97.163567,272.912537 90.876877,271.027802 83.508255,274.592041 
	C82.712067,274.977173 81.301903,274.092987 80.116241,273.439331 
	C80.055939,273.081085 80.015678,273.061676 80.254440,272.959473 
	C80.793114,272.665314 80.972275,272.393738 81.030701,272.042480 
	C81.030701,272.042480 81.015984,272.025848 81.031288,272.032104 
	C87.720108,270.470642 94.385757,268.762939 101.690414,270.868683 
	C102.113121,270.836273 102.138237,270.862488 102.218201,271.204987 
	C103.880989,273.358582 105.463821,275.169708 107.046646,276.980804 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M91.287560,299.771240 
	C92.729111,298.793976 94.540794,297.925842 96.758072,297.123718 
	C95.328346,298.086639 93.493019,298.983521 91.287560,299.771240 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M108.846458,247.006317 
	C108.852417,247.721771 108.858376,248.437210 108.538734,249.593781 
	C107.845047,250.714813 107.476952,251.394745 107.108856,252.074677 
	C107.075279,253.118484 107.041702,254.162277 106.991394,256.004059 
	C106.631798,258.540253 106.288910,260.278473 105.690323,262.019592 
	C105.264259,262.028900 105.093895,262.035370 104.923523,262.041840 
	C104.915863,261.594818 104.908203,261.147797 104.831833,260.371765 
	C104.835617,258.956879 104.908104,257.871033 104.940849,256.377686 
	C104.939461,255.227081 104.977814,254.483948 105.280128,253.113129 
	C105.645576,250.976334 105.747055,249.467178 105.848541,247.958038 
	C105.908501,247.221130 105.968460,246.484222 106.270737,245.196014 
	C106.567070,244.071487 106.621086,243.498260 106.675110,242.925018 
	C106.789757,241.233765 106.904411,239.542511 107.010284,237.426117 
	C107.012573,233.248550 107.023651,229.496109 107.082336,225.314575 
	C107.779121,226.307083 108.428291,227.728699 109.055244,229.976990 
	C109.059654,232.559937 109.086273,234.316208 109.112900,236.072464 
	C109.059990,238.748947 109.007072,241.425415 108.727180,244.695007 
	C108.615616,245.860855 108.731033,246.433594 108.846458,247.006317 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M96.985420,212.010880 
	C98.964966,214.136703 100.944511,216.262512 102.906891,218.740372 
	C100.581467,217.016098 98.273216,214.939774 96.164352,212.473221 
	C96.570969,212.058960 96.778198,212.034927 96.985420,212.010880 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M90.593315,210.345840 
	C91.569885,210.184937 92.345299,210.189407 93.534729,210.552917 
	C93.978851,211.328949 94.008949,211.745956 94.039047,212.162964 
	C92.836067,212.279587 91.633080,212.396210 90.214561,212.272278 
	C90.130066,211.524887 90.261108,211.018051 90.593315,210.345840 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M102.912704,219.445831 
	C104.235657,220.545609 105.570251,221.999802 106.872879,223.803314 
	C105.535378,222.701843 104.229858,221.251053 102.912704,219.445831 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M94.325287,212.157425 
	C94.008949,211.745956 93.978851,211.328949 93.916214,210.606689 
	C94.872955,210.641342 95.862228,210.981262 96.918465,211.666016 
	C96.778198,212.034927 96.570969,212.058960 96.056732,212.152390 
	C95.370323,212.198486 94.990921,212.175186 94.325287,212.157425 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M105.512024,248.044159 
	C105.747055,249.467178 105.645576,250.976334 105.271576,252.740601 
	C105.057869,251.373932 105.116692,249.752106 105.512024,248.044159 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M106.416550,242.991455 
	C106.621086,243.498260 106.567070,244.071487 106.274483,244.826111 
	C106.076607,244.357605 106.117302,243.707748 106.416550,242.991455 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M104.672134,262.255920 
	C105.093895,262.035370 105.264259,262.028900 105.708435,262.346069 
	C106.036255,263.102417 106.090256,263.535156 106.103981,264.335693 
	C108.113182,267.397980 110.162659,270.092407 112.212135,272.786835 
	C112.212135,272.786835 112.565285,272.922089 112.779617,273.333710 
	C114.141281,275.128662 115.190552,276.609375 116.451866,277.879486 
	C124.499496,285.983459 132.603607,294.031281 140.662323,302.124298 
	C141.888840,303.356049 142.976181,304.726410 144.125458,306.029907 
	C143.377686,306.823792 143.106354,307.357819 142.697418,307.502289 
	C141.154190,308.047516 139.566208,308.466125 138.038757,308.572327 
	C137.787918,306.093842 138.239838,303.329559 137.065521,301.971619 
	C132.692902,296.915222 127.697815,292.403656 123.113754,287.521057 
	C120.473167,284.708496 117.666656,284.294830 113.712234,285.945404 
	C113.712234,289.699646 113.712234,293.476074 113.381226,297.135437 
	C112.314972,295.304901 111.579735,293.591492 110.844498,291.878052 
	C110.879120,291.464020 110.913757,291.049957 111.238350,290.035645 
	C112.851883,279.510132 109.909676,273.690643 102.138237,270.862488 
	C102.138237,270.862488 102.113121,270.836273 102.113693,270.814697 
	C101.813728,270.372467 101.513184,269.951843 101.097961,269.298737 
	C105.075020,268.402710 103.899139,264.994049 104.672134,262.255920 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M80.791969,272.119568 
	C80.972275,272.393738 80.793114,272.665314 80.256393,272.937561 
	C80.197464,272.744141 80.375351,272.470367 80.791969,272.119568 
z"
          />
          <path
            fill="#CACDD0"
            opacity="1.000000"
            stroke="none"
            d="
M193.435303,510.954559 
	C190.008163,507.617035 187.102814,504.142670 183.848557,501.033508 
	C182.119125,499.381165 179.784943,498.361847 177.377106,497.013794 
	C176.229065,495.089447 175.427658,493.208038 174.311981,490.821777 
	C173.975998,489.860016 173.954285,489.403137 173.932571,488.946259 
	C173.932571,488.946259 173.928513,488.496887 174.239532,488.370514 
	C175.330399,488.531738 176.110245,488.819336 176.960022,489.437866 
	C178.049210,491.043610 178.966064,492.418915 180.103592,493.577576 
	C190.627045,504.297028 202.692474,513.014954 215.366592,520.997192 
	C218.872421,523.205139 221.830246,526.283203 225.039520,528.962097 
	C221.808929,527.509277 218.338928,526.427307 215.396622,524.528015 
	C208.875397,520.318237 202.636612,515.672546 196.225937,511.287567 
	C195.628372,510.878815 194.626297,511.061493 193.435303,510.954559 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M176.890076,489.106934 
	C176.110245,488.819336 175.330399,488.531738 174.250900,488.146118 
	C172.151855,486.490051 170.352463,484.932037 168.261124,482.864258 
	C167.315460,481.561707 166.661758,480.768921 166.008057,479.976166 
	C165.220749,479.009216 164.433441,478.042267 163.333878,477.006409 
	C159.459900,471.831268 155.898178,466.725098 152.419891,461.181152 
	C152.694519,460.459076 152.885727,460.174744 153.396484,459.967651 
	C155.053360,461.099548 156.390686,462.154205 157.728012,463.208862 
	C158.749435,464.278748 159.770859,465.348663 160.860596,467.097534 
	C164.229523,471.897278 167.530121,476.018097 170.830704,480.138947 
	C172.850281,482.188354 174.869858,484.237732 176.953705,486.938660 
	C177.040421,488.032776 177.062836,488.475372 177.036453,488.965179 
	C176.987640,489.012421 176.890076,489.106934 176.890076,489.106934 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M165.759064,480.162201 
	C166.661758,480.768921 167.315460,481.561707 167.987030,482.678467 
	C165.475601,483.294830 165.086349,482.880707 165.759064,480.162201 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M173.641022,489.001099 
	C173.954285,489.403137 173.975998,489.860016 173.998260,490.659546 
	C173.782349,490.353455 173.565918,489.704712 173.641022,489.001099 
z"
          />
          <path
            fill="#E2AF55"
            opacity="1.000000"
            stroke="none"
            d="
M121.035736,373.372131 
	C122.057983,375.219879 123.270081,377.431580 123.917824,379.797760 
	C125.853149,386.867310 127.184860,394.122742 129.462418,401.072876 
	C132.472244,410.257599 136.188568,419.209564 139.509445,428.295105 
	C139.949600,429.499298 139.850342,430.900665 139.721863,432.521790 
	C138.954788,432.571838 138.466766,432.310791 137.978745,432.049744 
	C137.978745,432.049744 137.998703,432.002472 137.977386,431.641937 
	C134.979980,424.518311 132.003876,417.755188 129.027771,410.992096 
	C128.986725,410.568726 128.945679,410.145325 128.870972,409.035370 
	C127.863388,405.902588 126.889465,403.456360 125.914886,400.715881 
	C125.673004,399.906464 125.431778,399.391388 125.190552,398.876282 
	C124.332993,394.412842 123.475433,389.949432 122.337021,385.241272 
	C122.018333,384.563721 121.980507,384.130890 121.871750,383.380005 
	C121.523079,379.976868 121.245354,376.891785 121.035736,373.372131 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M137.971069,432.453674 
	C138.466766,432.310791 138.954788,432.571838 139.704193,432.931335 
	C139.965591,433.029785 139.949951,433.023315 139.955750,433.372467 
	C140.525574,434.574554 141.089615,435.427521 141.653656,436.280457 
	C142.020309,437.008026 142.386978,437.735626 142.830994,439.134094 
	C144.854950,442.943420 146.801559,446.081879 148.748184,449.220337 
	C148.748184,449.220337 148.821274,449.630066 148.878082,450.180298 
	C149.589890,451.521240 150.244888,452.311951 150.899872,453.102692 
	C151.175156,453.257141 151.408722,453.459717 151.745575,454.280212 
	C152.286026,456.530182 152.681488,458.210297 153.076950,459.890442 
	C152.885727,460.174744 152.694519,460.459076 152.281158,460.875977 
	C150.622345,459.016388 149.185684,457.024261 147.413605,454.967163 
	C147.056351,454.485321 147.034515,454.068359 146.994720,453.338440 
	C145.229874,450.375488 143.482986,447.725494 141.404297,445.003876 
	C140.036118,440.907349 138.999741,436.882446 137.971069,432.453674 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M128.770050,411.197754 
	C132.003876,417.755188 134.979980,424.518311 137.952759,431.649048 
	C136.946655,431.278503 135.403397,430.746887 135.029419,429.768402 
	C132.710999,423.702545 130.655258,417.536316 128.770050,411.197754 
z"
          />
          <path
            fill="#D2C4B1"
            opacity="1.000000"
            stroke="none"
            d="
M125.915543,401.010162 
	C126.889465,403.456360 127.863388,405.902588 128.798035,408.724579 
	C128.021896,408.808624 127.285065,408.516846 126.266953,408.110809 
	C125.616142,405.904480 125.246597,403.812439 125.114761,401.353485 
	C125.540154,400.994415 125.727852,401.002289 125.915543,401.010162 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M125.914886,400.715881 
	C125.727852,401.002289 125.540154,400.994415 125.068893,401.002502 
	C124.785324,401.018402 124.384392,401.033447 124.183609,401.030090 
	C123.986603,400.578552 123.990379,400.130402 123.994293,399.346619 
	C124.194229,398.997101 124.394028,398.983246 124.892197,398.922821 
	C125.431778,399.391388 125.673004,399.906464 125.914886,400.715881 
z"
          />
          <path
            fill="#B3ADA5"
            opacity="1.000000"
            stroke="none"
            d="
M306.834656,548.657654 
	C314.379944,548.810852 321.924683,549.037170 329.470703,549.097656 
	C337.867371,549.164917 346.305786,549.593750 354.652374,548.933777 
	C365.161163,548.102722 375.595367,546.328186 386.527161,545.225708 
	C387.014740,545.669800 387.036896,545.848877 387.059052,546.027893 
	C380.625366,550.339355 373.339874,551.027283 364.977203,551.002441 
	C362.127899,550.999023 360.146698,550.749329 358.261780,551.068420 
	C356.452240,551.374756 354.742462,552.270569 352.988861,552.907349 
	C349.615448,552.613159 346.242004,552.318909 342.036072,552.013611 
	C340.131714,552.009888 339.059845,552.017212 337.988007,552.024536 
	C334.932526,552.330627 331.877014,552.636658 328.314423,552.550232 
	C323.536163,551.776733 319.265045,551.395691 314.993896,551.014648 
	C314.548218,551.012085 314.102509,551.009583 313.117126,550.735779 
	C311.711792,550.324890 310.846161,550.185303 309.980530,550.045654 
	C309.235565,550.032471 308.490601,550.019287 307.344727,549.661743 
	C306.907440,549.097412 306.871063,548.877563 306.834656,548.657654 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M315.073822,551.386963 
	C319.265045,551.395691 323.536163,551.776733 327.903168,552.542908 
	C325.958405,552.949341 323.917816,552.970581 321.439941,552.999634 
	C319.053040,552.591370 317.103394,552.175293 315.073822,551.386963 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M353.447632,552.939087 
	C354.742462,552.270569 356.452240,551.374756 358.261780,551.068420 
	C360.146698,550.749329 362.127899,550.999023 364.523254,551.007324 
	C363.238220,551.672119 361.543945,552.600891 359.742859,552.912415 
	C357.850647,553.239868 355.856171,552.976257 353.447632,552.939087 
z"
          />
          <path
            fill="#D5D2CD"
            opacity="1.000000"
            stroke="none"
            d="
M387.294983,546.218323 
	C387.036896,545.848877 387.014740,545.669800 386.935913,545.225586 
	C388.044891,544.365051 389.210510,543.769775 390.709412,543.205566 
	C391.084473,546.031799 391.188965,548.858093 387.365021,549.954285 
	C387.177765,548.798035 387.354370,547.603394 387.294983,546.218323 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M338.055115,552.365234 
	C339.059845,552.017212 340.131714,552.009888 341.605347,552.012817 
	C341.147430,554.726990 339.790955,554.604797 338.055115,552.365234 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M225.274475,528.979858 
	C221.830246,526.283203 218.872421,523.205139 215.366592,520.997192 
	C202.692474,513.014954 190.627045,504.297028 180.103592,493.577576 
	C178.966064,492.418915 178.049210,491.043610 176.960022,489.437866 
	C176.890076,489.106934 176.987640,489.012421 177.365128,489.029846 
	C179.127411,489.733063 180.512207,490.418854 181.896988,491.104675 
	C182.471695,491.599274 183.046402,492.093872 183.808136,493.177002 
	C189.289841,497.883789 194.584503,502.002045 199.879166,506.120331 
	C199.879166,506.120331 200.003510,506.091217 199.998505,506.452454 
	C202.718094,508.779755 205.442719,510.745819 208.167328,512.711914 
	C208.167328,512.711914 208.209900,512.767334 208.293549,513.134766 
	C213.897858,516.354065 219.418533,519.206055 224.939209,522.058044 
	C224.939209,522.058044 224.958191,522.054321 224.948212,522.062073 
	C224.958817,522.474365 224.979416,522.878967 225.061462,523.956665 
	C225.731598,525.080505 226.290451,525.629883 226.956787,525.966370 
	C232.289398,528.659912 237.642349,531.313171 242.989075,533.978760 
	C239.299698,532.752197 235.621399,531.490662 231.915924,530.314758 
	C230.238617,529.782471 228.507339,529.420288 226.390381,528.999573 
	C225.980225,529.018250 225.509415,528.997681 225.274475,528.979858 
z"
          />
          <path
            fill="#B3ADA5"
            opacity="1.000000"
            stroke="none"
            d="
M243.321198,533.991943 
	C237.642349,531.313171 232.289398,528.659912 226.956787,525.966370 
	C226.290451,525.629883 225.731598,525.080505 225.078491,524.260681 
	C230.556870,525.861206 236.200043,527.550049 241.579254,529.854858 
	C255.831497,535.961426 270.397797,540.788757 285.795044,543.188416 
	C291.297485,544.046021 296.565979,546.404724 302.045837,548.417664 
	C299.718475,551.460205 297.742889,549.472961 295.093842,547.783875 
	C291.663025,547.273071 288.843018,547.108337 286.022980,546.943665 
	C285.575958,546.943970 285.128967,546.944275 284.265991,546.570435 
	C281.046722,545.145935 278.297913,543.891479 275.419373,543.122864 
	C273.726440,542.670776 271.827423,542.990479 270.021088,542.963013 
	C265.840881,541.820618 261.660706,540.678223 257.167114,538.886230 
	C252.896576,536.830688 248.939438,535.424683 244.982315,534.018677 
	C244.539322,534.014160 244.096329,534.009644 243.321198,533.991943 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M270.022400,543.289734 
	C271.827423,542.990479 273.726440,542.670776 275.419373,543.122864 
	C278.297913,543.891479 281.046722,545.145935 283.931091,546.553223 
	C279.652679,546.254883 275.293213,545.599609 270.507568,544.930786 
	C270.062195,544.483582 270.042969,544.050049 270.022400,543.289734 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M286.250580,547.233887 
	C288.843018,547.108337 291.663025,547.273071 294.737396,547.718933 
	C292.153870,547.841431 289.316040,547.682800 286.250580,547.233887 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M306.454224,548.711182 
	C306.871063,548.877563 306.907440,549.097412 306.972351,549.650146 
	C305.767731,549.807434 304.534576,549.631958 303.140778,549.177002 
	C304.011353,548.853271 305.042542,548.809021 306.454224,548.711182 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M310.032074,550.364258 
	C310.846161,550.185303 311.711792,550.324890 312.782990,550.726257 
	C312.020233,550.886292 311.051941,550.784546 310.032074,550.364258 
z"
          />
          <path
            fill="#BDB4AB"
            opacity="1.000000"
            stroke="none"
            d="
M244.987900,534.383484 
	C248.939438,535.424683 252.896576,536.830688 256.924500,538.598755 
	C253.290665,538.291748 249.585999,537.622620 245.475250,536.941650 
	C245.043945,536.202637 245.018723,535.475464 244.987900,534.383484 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M294.354279,414.013519 
	C292.736298,412.253540 291.316467,410.607574 289.591919,408.841309 
	C289.149628,408.092499 289.012085,407.463959 288.845795,406.516388 
	C294.144348,406.759247 296.275970,411.595673 299.595734,414.649658 
	C305.874664,420.426025 311.625732,426.789551 317.440277,433.053741 
	C324.015930,440.138000 330.420258,447.381287 336.868317,454.928528 
	C333.556213,452.494080 330.274841,449.686462 326.700134,446.734802 
	C319.196381,439.076233 312.000946,431.547302 304.768463,424.054077 
	C301.810333,420.989349 298.772186,418.001801 295.433014,414.915527 
	C294.981232,414.560455 294.800171,414.318970 294.354279,414.013519 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M353.044861,472.328308 
	C354.135223,472.416870 355.664764,472.492249 356.472443,473.294403 
	C370.849274,487.572815 385.160217,501.917938 399.395905,516.337036 
	C400.309479,517.262390 400.495209,518.906311 401.009338,520.597412 
	C390.404755,510.507202 379.753967,500.091827 369.239136,489.540894 
	C363.751923,484.034851 358.504059,478.290253 353.044861,472.328308 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M337.112732,456.298767 
	C342.009491,456.389221 345.121704,459.230774 346.025482,464.582153 
	C343.089844,462.181061 340.150818,459.400452 337.112732,456.298767 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M346.793274,465.491760 
	C348.753296,466.987762 350.811981,468.811554 352.825287,471.015411 
	C350.817230,469.536835 348.854584,467.678192 346.793274,465.491760 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M474.950562,172.659973 
	C474.560028,172.991348 474.116486,172.990082 473.340363,172.989441 
	C472.942993,172.611862 472.878235,172.233658 472.769836,171.573151 
	C473.449982,171.636353 474.173798,171.981842 474.950562,172.659973 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M465.289429,167.717987 
	C465.156403,167.815521 465.003296,167.404587 464.923370,167.199707 
	C465.036438,167.203369 465.229431,167.411911 465.289429,167.717987 
z"
          />
          <path
            fill="#E3E7EB"
            opacity="1.000000"
            stroke="none"
            d="
M91.401505,101.309029 
	C98.535103,95.853928 106.327820,100.312584 107.822510,107.851601 
	C108.727371,112.415642 104.091103,118.226089 98.854652,119.003304 
	C92.411835,119.959557 88.285278,116.872139 87.993965,110.825569 
	C87.826286,107.345116 87.395142,103.745888 91.401505,101.309029 
M91.941925,104.745834 
	C91.627884,105.983177 91.232643,107.206444 91.015175,108.460533 
	C90.385902,112.089500 92.425484,114.710976 95.549965,114.685722 
	C98.266174,114.663773 101.812202,113.185272 103.352776,111.125038 
	C104.267944,109.901184 102.613800,105.818466 101.046242,103.889519 
	C98.524040,100.785851 95.375908,103.003555 91.941925,104.745834 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M132.058304,212.576294 
	C130.976700,212.693893 129.400589,212.812897 128.862152,212.122559 
	C123.841415,205.685532 118.998863,199.109543 114.124664,192.202621 
	C115.299438,192.408188 116.756676,192.713120 117.559387,193.606293 
	C122.344604,198.930786 127.005493,204.368515 131.620911,209.841766 
	C132.067429,210.371323 131.917969,211.403427 132.058304,212.576294 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M139.987732,220.585480 
	C139.451828,221.468964 138.879227,221.999802 137.933838,222.665894 
	C137.288406,222.593567 137.101395,222.326111 137.000000,221.998779 
	C136.025803,219.882385 135.051620,217.765991 134.064789,215.287506 
	C136.018448,216.694534 137.984741,218.463669 139.987732,220.585480 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M165.919128,173.182053 
	C166.348297,183.089050 158.135345,187.037750 152.308548,186.841812 
	C144.959213,186.594666 139.632736,180.174088 140.106949,172.602997 
	C140.553009,165.480988 147.071167,160.353180 154.858490,160.997986 
	C160.309814,161.449371 164.503464,165.913651 165.919128,173.182053 
M144.139053,176.060196 
	C146.219772,181.899628 149.367432,183.956177 154.379349,182.750778 
	C159.719223,181.466492 162.554443,178.357956 161.943024,174.457947 
	C161.066254,168.865555 157.546570,165.820709 152.148605,165.984894 
	C147.267700,166.133331 144.304474,169.517990 144.139053,176.060196 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M492.034912,335.359650 
	C495.646942,334.571838 495.633057,336.724396 495.015991,339.647522 
	C494.028961,338.572083 493.050598,337.145081 492.034912,335.359650 
z"
          />
          <path
            fill="#DFD6C8"
            opacity="1.000000"
            stroke="none"
            d="
M148.380157,273.886780 
	C145.328491,271.347656 141.737976,269.299591 140.084244,266.213593 
	C136.905151,260.281189 138.823181,254.447159 144.072739,250.358414 
	C148.438309,246.958130 154.630890,247.024170 159.285858,250.520599 
	C165.092163,254.881851 166.097519,259.341370 163.003418,267.612152 
	C162.954147,267.994690 162.783203,268.243225 162.465515,268.550812 
	C158.972855,272.597717 154.797226,274.064758 150.032333,274.193665 
	C149.593628,274.098755 149.154907,274.003845 148.380157,273.886780 
M159.065155,260.564392 
	C158.789734,254.617828 157.114059,252.865143 151.764145,252.927811 
	C146.697769,252.987152 143.101990,256.462219 143.259109,261.147278 
	C143.395203,265.205627 147.431702,268.793945 152.114044,269.019073 
	C156.399414,269.225067 158.845001,266.556854 159.065155,260.564392 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M273.044006,390.538116 
	C272.888977,390.905640 272.716248,390.917053 272.284058,390.932648 
	C261.090393,379.506104 250.156204,368.075348 239.094482,356.334503 
	C242.897827,359.112396 247.038437,361.972198 250.708344,365.344208 
	C255.674347,369.907227 260.435303,374.720734 264.983093,379.701752 
	C267.941467,382.941956 270.363800,386.671600 273.044006,390.538116 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M237.957947,354.672791 
	C231.947586,349.295135 225.918945,343.556427 219.760910,337.499084 
	C223.439224,340.160919 227.432892,342.937836 230.992767,346.189697 
	C233.603256,348.574280 235.644653,351.581818 237.957947,354.672791 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M288.860413,405.798828 
	C283.634094,401.307190 278.465271,396.441315 273.194946,391.256531 
	C275.710632,392.617737 278.647064,393.960510 280.866730,396.060791 
	C283.840912,398.875061 286.260254,402.275696 288.860413,405.798828 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M150.337006,274.447479 
	C154.797226,274.064758 158.972855,272.597717 162.462906,268.701599 
	C161.599472,274.937439 160.212418,275.641083 150.337006,274.447479 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M219.033661,336.528137 
	C217.336227,335.187317 215.625443,333.488159 213.819153,331.466187 
	C215.489197,332.818848 217.254761,334.494324 219.033661,336.528137 
z"
          />
          <path
            fill="#AC794A"
            opacity="1.000000"
            stroke="none"
            d="
M212.822815,329.988281 
	C212.596375,330.047485 212.306473,329.819122 211.916397,329.328094 
	C212.130585,329.277191 212.444962,329.488983 212.822815,329.988281 
z"
          />
          <path
            fill="#F9FCFA"
            opacity="1.000000"
            stroke="none"
            d="
M136.653290,221.963470 
	C137.101395,222.326111 137.288406,222.593567 137.779602,222.919037 
	C141.186325,226.844070 144.374466,230.651260 147.770706,234.722687 
	C142.874802,237.162079 137.740616,239.272156 132.709549,241.604691 
	C132.155518,241.861557 132.347122,243.469574 131.926315,244.318832 
	C130.629333,246.936371 129.203110,249.489868 127.827072,252.068237 
	C127.476204,251.860672 127.125328,251.653122 126.774460,251.445572 
	C127.309639,239.458344 127.844818,227.471130 128.403702,214.953232 
	C131.240997,217.457382 133.773804,219.692780 136.653290,221.963470 
z"
          />
          <path
            fill="#F9A61F"
            opacity="1.000000"
            stroke="none"
            d="
M236.702011,382.850281 
	C235.139297,384.696747 233.281647,386.393280 230.913452,388.283691 
	C229.854462,387.352173 229.306046,386.226776 229.157440,385.010864 
	C230.035660,382.949310 230.514038,380.978333 230.992416,379.007324 
	C230.992416,379.007324 231.040054,378.958862 231.064789,378.933044 
	C232.862030,380.171570 234.634552,381.435944 236.702011,382.850281 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M139.382965,294.995361 
	C139.463089,292.776215 139.921906,290.557343 140.720184,288.157227 
	C142.285156,288.788330 143.510651,289.600616 144.870087,290.703491 
	C143.256561,292.327881 141.509094,293.661743 139.382965,294.995361 
z"
          />
          <path
            fill="#CDB88E"
            opacity="1.000000"
            stroke="none"
            d="
M228.757614,385.101379 
	C229.306046,386.226776 229.854462,387.352173 230.712189,388.532654 
	C238.315750,396.197723 245.541977,403.874420 252.920578,411.401733 
	C263.338287,422.029388 273.906281,432.509674 284.336456,443.125214 
	C290.453583,449.351044 296.461823,455.685333 302.434784,462.049896 
	C303.478485,463.162018 304.103790,464.666748 305.501709,466.926880 
	C302.130554,466.152496 299.931549,465.647400 297.357666,465.147217 
	C296.982788,465.152191 296.578796,464.948364 296.323212,464.573181 
	C296.010010,463.564331 295.952393,462.930634 296.129059,462.067322 
	C295.602051,460.526459 294.840820,459.215149 293.935425,457.634583 
	C292.884705,456.557159 291.978180,455.749023 290.916870,454.642731 
	C285.524292,448.876404 280.286469,443.408234 274.895111,437.647308 
	C270.539642,433.193237 266.337738,429.031921 262.063599,424.541077 
	C260.637115,423.142120 259.282837,422.072693 257.673462,420.860199 
	C256.638031,420.140503 255.857742,419.563843 255.064880,418.627686 
	C253.378647,416.173065 251.705017,414.078003 249.893402,411.694336 
	C248.503906,410.267853 247.252411,409.129974 245.876724,407.729187 
	C245.166046,406.980408 244.579544,406.494476 243.857758,405.703674 
	C241.850784,403.880859 239.979095,402.362946 237.951141,400.552551 
	C235.167816,397.493652 232.540756,394.727295 229.758377,391.707153 
	C228.747330,390.638977 227.891602,389.824554 227.001556,388.665405 
	C226.628387,387.231049 226.289551,386.141388 226.303131,385.022461 
	C227.356247,385.029236 228.056931,385.065308 228.757614,385.101379 
z"
          />
          <path
            fill="#E6AF4F"
            opacity="1.000000"
            stroke="none"
            d="
M241.114105,385.216248 
	C241.300018,385.156830 241.584579,385.330933 241.960480,385.742828 
	C241.772141,385.803650 241.492447,385.626709 241.114105,385.216248 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M110.523796,291.986023 
	C111.579735,293.591492 112.314972,295.304901 113.532455,297.403015 
	C114.337608,298.534088 114.660515,299.280518 115.017838,300.371277 
	C117.310532,302.538116 119.568810,304.360596 122.126373,306.340088 
	C123.585495,307.116180 124.745338,307.735352 126.146271,308.642883 
	C130.256577,308.931549 134.125778,308.931854 137.994995,308.932129 
	C139.566208,308.466125 141.154190,308.047516 142.697418,307.502289 
	C143.106354,307.357819 143.377686,306.823792 144.125458,306.029907 
	C142.976181,304.726410 141.888840,303.356049 140.662323,302.124298 
	C132.603607,294.031281 124.499496,285.983459 116.451866,277.879486 
	C115.190552,276.609375 114.141281,275.128662 112.955315,273.403564 
	C114.493248,274.111023 116.228531,274.984406 117.619583,276.239319 
	C124.510414,282.455750 131.310379,288.772919 138.468155,295.130493 
	C140.192841,297.004517 141.478470,298.906311 143.011932,300.581207 
	C147.586685,305.577942 146.776840,308.940979 140.409912,310.943665 
	C127.519012,314.998413 113.582664,308.020844 109.868454,295.551300 
	C109.562256,294.523315 110.072311,293.252197 110.523796,291.986023 
z"
          />
          <path
            fill="#E2AF55"
            opacity="1.000000"
            stroke="none"
            d="
M214.030334,384.951080 
	C214.051529,384.480438 214.072708,384.009766 214.447083,383.236450 
	C215.400742,383.005798 216.001190,383.077850 216.683258,383.556946 
	C217.253906,386.318176 217.742950,388.672333 218.208221,391.385620 
	C222.031494,399.244476 225.249374,407.165100 229.904449,414.124390 
	C234.465591,420.943298 240.489838,426.783539 246.010986,433.336731 
	C247.102066,434.413818 248.054108,435.207520 249.117645,436.303223 
	C250.132507,437.111755 251.035873,437.618256 252.079254,438.371094 
	C252.798065,439.087189 253.376862,439.556915 254.080353,440.327515 
	C255.111343,441.116516 256.017639,441.604645 256.957458,442.046265 
	C256.990967,441.999817 256.906799,442.077820 256.907166,442.384949 
	C256.970123,443.096954 257.032715,443.501801 257.021423,443.977539 
	C256.947571,444.048462 256.797852,444.188171 256.797852,444.188171 
	C252.929001,441.613953 248.707520,439.438843 245.257538,436.390564 
	C234.953888,427.286743 227.271744,416.076538 220.645264,404.116943 
	C220.262360,403.425903 220.230576,402.540283 219.912476,401.148315 
	C219.602036,400.266968 219.347046,400.069794 219.024582,399.959869 
	C219.024582,399.959869 219.011032,399.483917 218.968719,398.884888 
	C217.628143,395.518768 216.329880,392.751678 215.031616,389.984589 
	C215.022156,389.238556 215.012711,388.492523 214.982117,387.072937 
	C214.650726,385.916626 214.340530,385.433838 214.030334,384.951080 
z"
          />
          <path
            fill="#CDB88E"
            opacity="1.000000"
            stroke="none"
            d="
M216.601654,383.149902 
	C216.001190,383.077850 215.400742,383.005798 214.505859,382.887939 
	C213.770218,380.179932 213.329010,377.517761 213.280121,374.435181 
	C214.741806,374.042816 215.811142,374.070862 216.880493,374.098907 
	C219.063385,376.307495 221.246292,378.516052 223.735291,381.193359 
	C224.106964,382.351288 224.172546,383.040466 223.873810,383.790253 
	C221.588669,382.611176 219.667862,381.371521 217.530151,379.991882 
	C217.136505,381.330719 216.869080,382.240326 216.601654,383.149902 
z"
          />
          <path
            fill="#E2AF55"
            opacity="1.000000"
            stroke="none"
            d="
M295.894775,462.296936 
	C295.952393,462.930634 296.010010,463.564331 296.105835,464.510498 
	C291.716766,463.289032 287.194733,461.978119 282.892365,460.150208 
	C279.483856,458.702057 276.344757,456.619873 273.060577,454.384888 
	C273.035126,453.950531 273.213654,453.735443 273.566956,453.804565 
	C276.621552,454.906891 279.322845,455.940155 282.193970,457.044495 
	C282.363800,457.115570 282.731323,457.093658 282.985474,457.368652 
	C284.200195,457.850952 285.160767,458.058289 286.275269,458.332886 
	C286.429169,458.400177 286.707703,458.212280 286.743958,458.203308 
	C286.780182,458.194336 286.838776,458.148102 286.853455,458.479431 
	C287.598145,459.207367 288.328217,459.604004 289.330566,460.203857 
	C291.066833,460.888489 292.530762,461.369904 294.307678,461.940369 
	C295.045349,462.118622 295.470062,462.207764 295.894775,462.296936 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M102.218201,271.204987 
	C109.909676,273.690643 112.851883,279.510132 111.246849,289.724121 
	C109.842690,285.838745 108.719986,281.664581 107.321960,277.235596 
	C105.463821,275.169708 103.880989,273.358582 102.218201,271.204987 
z"
          />
          <path
            fill="#E2AF55"
            opacity="1.000000"
            stroke="none"
            d="
M272.945374,454.057648 
	C265.594452,454.415649 262.033569,448.386902 256.906708,444.509583 
	C256.797852,444.188171 256.947571,444.048462 257.360168,444.061890 
	C260.821320,445.748627 263.869843,447.421967 266.952759,449.073303 
	C266.987152,449.051331 266.921509,449.082550 267.049744,449.392792 
	C269.189850,451.047150 271.201752,452.391296 273.213654,453.735443 
	C273.213654,453.735443 273.035126,453.950531 272.945374,454.057648 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M199.794434,505.788574 
	C194.584503,502.002045 189.289841,497.883789 183.952179,493.426147 
	C189.176010,497.210114 194.442856,501.333466 199.794434,505.788574 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M224.922348,521.697876 
	C219.418533,519.206055 213.897858,516.354065 208.314972,513.162354 
	C213.803665,515.660950 219.354568,518.499329 224.922348,521.697876 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M224.238129,383.729675 
	C224.172546,383.040466 224.106964,382.351288 224.045456,381.315186 
	C226.111450,380.314056 228.173355,379.659882 230.613846,379.006531 
	C230.514038,380.978333 230.035660,382.949310 229.157440,385.010864 
	C228.056931,385.065308 227.356247,385.029236 226.075317,384.877014 
	C225.076111,384.417114 224.657120,384.073395 224.238129,383.729675 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M170.883789,479.763641 
	C167.530121,476.018097 164.229523,471.897278 160.938873,467.405334 
	C164.278168,471.152252 167.607529,475.270294 170.883789,479.763641 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M211.893799,373.022919 
	C210.846786,372.307922 209.799774,371.592926 208.752762,370.877930 
	C208.899841,370.455292 209.046906,370.032654 209.193985,369.610016 
	C211.452286,371.109833 213.755844,362.419861 215.604584,370.653748 
	C214.113434,371.695526 213.003616,372.359222 211.893799,373.022919 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M148.806976,448.841614 
	C146.801559,446.081879 144.854950,442.943420 142.900909,439.433716 
	C144.884247,442.195923 146.875015,445.329407 148.806976,448.841614 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M214.754761,390.215088 
	C216.329880,392.751678 217.628143,395.518768 218.953293,398.647278 
	C213.650452,398.167511 215.042603,393.792114 214.754761,390.215088 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M208.123047,512.374390 
	C205.442719,510.745819 202.718094,508.779755 199.940491,506.480133 
	C202.617935,508.110046 205.348358,510.073486 208.123047,512.374390 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M153.396484,459.967651 
	C152.681488,458.210297 152.286026,456.530182 151.868362,454.478455 
	C153.854050,456.898224 155.861954,459.689606 157.798920,462.844940 
	C156.390686,462.154205 155.053360,461.099548 153.396484,459.967651 
z"
          />
          <path
            fill="#E2AF55"
            opacity="1.000000"
            stroke="none"
            d="
M212.007965,373.230652 
	C213.003616,372.359222 214.113434,371.695526 215.597015,371.045349 
	C216.288620,371.854401 216.606476,372.649963 216.902405,373.772217 
	C215.811142,374.070862 214.741806,374.042816 213.265121,374.007202 
	C212.541367,373.905884 212.296143,373.718811 212.007965,373.230652 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M181.909088,490.747009 
	C180.512207,490.418854 179.127411,489.733063 177.413940,488.982605 
	C177.062836,488.475372 177.040421,488.032776 177.056152,487.258240 
	C178.703262,488.080627 180.312225,489.235016 181.909088,490.747009 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M384.811951,541.087830 
	C384.035522,542.081360 382.878204,543.034912 381.358124,543.980225 
	C382.140564,542.997192 383.285767,542.022522 384.811951,541.087830 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M210.850922,384.678131 
	C210.211700,384.704102 209.647751,384.404755 209.083801,384.105408 
	C209.351822,383.600952 209.619843,383.096497 209.887848,382.592041 
	C210.233963,383.178955 210.580078,383.765900 210.850922,384.678131 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M324.942780,546.554199 
	C323.939056,546.910034 322.863892,546.934143 321.386841,546.918152 
	C322.280426,546.659485 323.575897,546.440918 324.942780,546.554199 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M150.921326,452.766907 
	C150.244888,452.311951 149.589890,451.521240 148.938950,450.379272 
	C149.609589,450.829071 150.276184,451.630096 150.921326,452.766907 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M371.865936,544.823669 
	C371.242798,545.370544 370.459137,545.670837 369.341858,545.940918 
	C369.907257,545.466125 370.806335,545.021606 371.865936,544.823669 
z"
          />
          <path
            fill="#D5A95B"
            opacity="1.000000"
            stroke="none"
            d="
M141.749374,435.941803 
	C141.089615,435.427521 140.525574,434.574554 139.953979,433.383118 
	C140.579300,433.897491 141.212204,434.750305 141.749374,435.941803 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M214.037888,385.253662 
	C214.340530,385.433838 214.650726,385.916626 214.967941,386.700134 
	C214.665115,386.519318 214.355270,386.037750 214.037888,385.253662 
z"
          />
          <path
            fill="#F2A727"
            opacity="1.000000"
            stroke="none"
            d="
M219.117325,400.187897 
	C219.347046,400.069794 219.602036,400.266968 219.885162,400.777100 
	C219.656235,400.896057 219.399323,400.700439 219.117325,400.187897 
z"
          />
          <path
            fill="#F6A71E"
            opacity="1.000000"
            stroke="none"
            d="
M246.916718,247.001678 
	C244.927963,245.652939 242.939209,244.304199 240.721848,242.800430 
	C243.777084,239.169479 245.793945,239.787689 247.823242,243.052887 
	C247.602051,244.807068 247.259384,245.904373 246.916718,247.001678 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M335.881775,212.481293 
	C335.396942,212.762573 334.984283,212.781601 334.260651,212.770905 
	C331.904999,212.498322 329.860321,212.255432 327.402710,211.978516 
	C329.617645,207.583221 333.123810,208.298965 336.922607,210.624298 
	C336.653534,211.411972 336.303741,211.815506 335.881775,212.481293 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M301.805450,215.779053 
	C298.272949,217.367126 294.518555,218.674408 290.375702,219.961456 
	C293.852692,218.460236 297.718109,216.979248 301.805450,215.779053 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M492.894165,212.833923 
	C491.756897,213.753830 490.619598,214.673737 489.000549,215.801239 
	C488.335358,215.992920 488.151886,215.977005 487.968384,215.961060 
	C489.424286,214.003693 490.880219,212.046326 492.677551,210.413345 
	C492.977417,211.436462 492.935791,212.135193 492.894165,212.833923 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M486.798126,217.065491 
	C486.344269,218.332657 485.511597,219.552277 484.058960,220.906342 
	C482.969635,221.040009 482.500214,221.039261 482.030823,221.038483 
	C483.493652,219.698303 484.956482,218.358109 486.798126,217.065491 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M246.930450,247.234802 
	C247.259384,245.904373 247.602051,244.807068 247.977005,243.366058 
	C248.788452,243.026077 249.567596,243.029800 250.737183,243.077057 
	C249.942841,244.645218 248.758057,246.169861 247.262238,247.814713 
	C246.951202,247.934937 246.944199,247.467926 246.930450,247.234802 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M312.838379,212.824051 
	C311.591614,213.726456 310.143188,214.348557 308.339355,214.939087 
	C309.534851,214.119598 311.085754,213.331680 312.838379,212.824051 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M272.752808,227.060120 
	C271.671448,228.055939 270.192963,229.021652 268.376526,230.033875 
	C269.477631,229.063599 270.916656,228.046799 272.752808,227.060120 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M356.948547,211.577545 
	C355.828583,211.812149 354.642639,211.712006 353.209778,211.353394 
	C354.269470,211.144211 355.576019,211.193497 356.948547,211.577545 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M320.828430,211.819244 
	C319.929779,212.394547 318.820282,212.688370 317.346924,212.940018 
	C318.194550,212.444489 319.406036,211.991135 320.828430,211.819244 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M283.890442,221.122742 
	C283.400513,222.089737 282.543365,223.032623 281.346527,224.007477 
	C281.845642,223.059174 282.684448,222.078903 283.890442,221.122742 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M481.901306,221.239532 
	C482.500214,221.039261 482.969635,221.040009 483.791016,221.081177 
	C483.337891,222.068924 482.532776,223.016281 481.402649,224.029083 
	C481.057617,223.630127 481.037506,223.165741 481.013245,222.353104 
	C481.310760,221.880905 481.565033,221.692795 481.901306,221.239532 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M363.961914,212.501648 
	C363.156342,212.722107 362.287231,212.636780 361.199463,212.300583 
	C361.953308,212.098434 362.925812,212.147125 363.961914,212.501648 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M493.174927,212.792694 
	C492.935791,212.135193 492.977417,211.436462 493.028809,210.386719 
	C493.437927,209.974762 493.837250,209.913849 494.538086,209.841156 
	C494.883606,210.304428 494.927612,210.779465 494.965881,211.611725 
	C494.458618,212.229782 493.957153,212.490631 493.174927,212.792694 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M498.679810,204.044556 
	C498.523468,204.602997 498.043335,205.195312 497.297302,205.907974 
	C497.472931,205.378357 497.914490,204.728394 498.679810,204.044556 
z"
          />
          <path
            fill="#F2A92C"
            opacity="1.000000"
            stroke="none"
            d="
M257.870789,237.140350 
	C257.909973,237.319763 257.697601,237.581039 257.256866,237.956055 
	C257.225433,237.787262 257.422333,237.504730 257.870789,237.140350 
z"
          />
          <path
            fill="#DCB77B"
            opacity="1.000000"
            stroke="none"
            d="
M487.961090,216.224091 
	C488.151886,215.977005 488.335358,215.992920 488.794556,216.039429 
	C488.885315,216.350479 488.700348,216.630920 488.259827,216.961121 
	C487.987457,216.836288 487.970612,216.661697 487.961090,216.224091 
z"
          />
          <path
            fill="#E5AC4A"
            opacity="1.000000"
            stroke="none"
            d="
M496.608643,208.041260 
	C496.787903,207.911560 496.887512,208.383041 496.905243,208.622375 
	C496.922974,208.861710 496.452698,208.986816 496.211609,208.952164 
	C496.046509,208.621353 496.199432,208.372513 496.608643,208.041260 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M256.674805,240.055786 
	C256.905731,240.316666 256.768188,240.591858 256.216064,240.817505 
	C256.071594,240.569839 256.239899,240.337234 256.674805,240.055786 
z"
          />
          <path
            fill="#E5DCD5"
            opacity="1.000000"
            stroke="none"
            d="
M73.086342,191.625839 
	C75.316078,186.274292 78.333649,182.326401 84.287918,181.957672 
	C89.841927,181.613739 93.822243,184.594788 96.798294,188.721527 
	C99.912727,193.040131 98.725281,197.619659 95.837364,201.595749 
	C92.407265,206.318329 87.617683,208.232330 81.854294,206.738083 
	C76.875099,205.447144 73.956955,202.031738 73.110748,196.985870 
	C72.840439,195.374054 73.038757,193.683624 73.086342,191.625839 
M89.490021,188.497818 
	C86.640320,188.879425 83.025764,188.306305 81.103859,189.846008 
	C77.372002,192.835709 78.758804,197.192596 80.217621,200.887817 
	C83.347122,201.156097 86.228142,201.403076 89.140602,201.652756 
	C92.106560,197.700745 94.399261,193.646591 89.490021,188.497818 
z"
          />
          <path
            fill="#F9A61F"
            opacity="1.000000"
            stroke="none"
            d="
M74.712799,184.548035 
	C74.992020,183.165588 75.557838,181.634964 76.123650,180.104355 
	C76.743584,180.430161 77.363510,180.755981 77.983444,181.081787 
	C76.988754,182.187820 75.994072,183.293839 74.712799,184.548035 
z"
          />
          <path
            fill="#E0B468"
            opacity="1.000000"
            stroke="none"
            d="
M112.171158,272.435059 
	C110.162659,270.092407 108.113182,267.397980 106.363220,264.472046 
	C107.371239,264.548645 108.079742,264.856812 108.788239,265.164978 
	C109.902222,267.471069 111.016205,269.777161 112.171158,272.435059 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M108.853500,264.722473 
	C108.079742,264.856812 107.371239,264.548645 106.403496,264.104187 
	C106.090256,263.535156 106.036255,263.102417 105.964142,262.343201 
	C106.288910,260.278473 106.631798,258.540253 106.993462,256.395782 
	C107.647758,258.753021 108.283264,261.516479 108.853500,264.722473 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M109.462959,235.968353 
	C109.086273,234.316208 109.059654,232.559937 109.074547,230.364960 
	C112.214798,231.569138 111.371727,233.674698 109.462959,235.968353 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M109.099052,246.877380 
	C108.731033,246.433594 108.615616,245.860855 108.713882,245.142059 
	C109.068924,245.580124 109.210281,246.164291 109.099052,246.877380 
z"
          />
          <path
            fill="#E9AB3E"
            opacity="1.000000"
            stroke="none"
            d="
M107.422729,252.002502 
	C107.476952,251.394745 107.845047,250.714813 108.515472,249.951080 
	C108.457413,250.554962 108.097008,251.242630 107.422729,252.002502 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M98.987228,290.571411 
	C96.055695,292.130066 93.214653,293.701019 90.187134,294.257568 
	C88.420898,294.582245 85.233589,293.821503 84.652740,292.607727 
	C83.319977,289.822754 83.116768,286.422272 86.502441,284.305328 
	C90.844322,281.590485 94.634506,283.091583 98.586433,285.973358 
	C98.964470,287.400330 98.981949,288.779083 98.987228,290.571411 
z"
          />
          <path
            fill="#E4E5E5"
            opacity="1.000000"
            stroke="none"
            d="
M114.983429,300.026947 
	C114.660515,299.280518 114.337608,298.534088 113.863464,297.520081 
	C113.712234,293.476074 113.712234,289.699646 113.712234,285.945404 
	C117.666656,284.294830 120.473167,284.708496 123.113754,287.521057 
	C127.697815,292.403656 132.692902,296.915222 137.065521,301.971619 
	C138.239838,303.329559 137.787918,306.093842 138.038757,308.572327 
	C134.125778,308.931854 130.256577,308.931549 126.224731,308.228271 
	C128.927307,306.504730 131.792526,305.484192 134.926682,304.367859 
	C131.756149,300.880341 129.195801,297.642303 126.193405,294.885742 
	C123.454437,292.371063 121.703735,287.394684 116.034508,289.806458 
	C116.034508,293.261200 116.034508,296.572754 115.771988,299.921753 
	C115.334114,299.981812 115.158775,300.004395 114.983429,300.026947 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M92.253174,104.503532 
	C95.375908,103.003555 98.524040,100.785851 101.046242,103.889519 
	C102.613800,105.818466 104.267944,109.901184 103.352776,111.125038 
	C101.812202,113.185272 98.266174,114.663773 95.549965,114.685722 
	C92.425484,114.710976 90.385902,112.089500 91.015175,108.460533 
	C91.232643,107.206444 91.627884,105.983177 92.253174,104.503532 
z"
          />
          <path
            fill="#E9EDEF"
            opacity="1.000000"
            stroke="none"
            d="
M144.082214,175.661804 
	C144.304474,169.517990 147.267700,166.133331 152.148605,165.984894 
	C157.546570,165.820709 161.066254,168.865555 161.943024,174.457947 
	C162.554443,178.357956 159.719223,181.466492 154.379349,182.750778 
	C149.367432,183.956177 146.219772,181.899628 144.082214,175.661804 
M155.203720,178.992859 
	C156.430420,177.421600 159.004410,175.006592 158.643173,174.429779 
	C157.305862,172.294357 155.187424,169.598526 153.019333,169.250351 
	C148.437881,168.514648 147.137436,172.371735 146.080536,177.217941 
	C148.917130,177.828766 151.638733,178.414810 155.203720,178.992859 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M159.066910,260.997833 
	C158.845001,266.556854 156.399414,269.225067 152.114044,269.019073 
	C147.431702,268.793945 143.395203,265.205627 143.259109,261.147278 
	C143.101990,256.462219 146.697769,252.987152 151.764145,252.927811 
	C157.114059,252.865143 158.789734,254.617828 159.066910,260.997833 
z"
          />
          <path
            fill="#EBE6DF"
            opacity="1.000000"
            stroke="none"
            d="
M245.871933,433.053314 
	C240.489838,426.783539 234.465591,420.943298 229.904449,414.124390 
	C225.249374,407.165100 222.031494,399.244476 218.410797,391.378601 
	C218.637161,391.012451 219.044067,390.985016 219.333588,391.121948 
	C221.417267,390.514343 223.211411,389.769806 225.343750,389.026672 
	C226.133255,389.022095 226.584579,389.016113 227.035889,389.010132 
	C227.891602,389.824554 228.747330,390.638977 229.475388,391.865967 
	C229.580444,393.694916 229.551773,395.226410 230.111755,396.498810 
	C230.820389,398.109009 232.007980,399.508453 232.588089,401.001282 
	C229.973343,400.463837 227.759521,399.923920 225.618088,399.401642 
	C227.749893,403.691101 229.402618,408.092987 231.953583,411.891693 
	C235.586853,417.302155 239.992371,422.188141 243.820023,427.477600 
	C244.937775,429.022247 245.211395,431.177795 245.871933,433.053314 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M275.048645,437.940063 
	C280.286469,443.408234 285.524292,448.876404 290.889587,454.665894 
	C291.017120,454.987213 290.964600,455.035767 290.570679,455.023834 
	C289.123413,455.002136 288.070068,454.992340 286.717010,454.833923 
	C285.277832,453.124512 284.138336,451.563751 282.974792,449.679871 
	C282.292389,448.574860 281.634003,447.792969 280.629578,446.972015 
	C278.515808,444.963104 276.748169,442.993225 274.986633,440.650299 
	C274.980042,439.533295 274.967316,438.789337 274.978638,438.019531 
	C275.002655,437.993652 275.048645,437.940063 275.048645,437.940063 
z"
          />
          <path
            fill="#EBE6DF"
            opacity="1.000000"
            stroke="none"
            d="
M255.077454,418.987213 
	C255.857742,419.563843 256.638031,420.140503 257.685242,421.225006 
	C258.305328,422.816467 258.658478,423.900055 259.152527,425.289734 
	C260.864044,428.059662 262.434662,430.523499 263.648468,432.954041 
	C261.793427,431.528351 260.276184,430.155731 258.802765,428.737518 
	C257.545837,427.527679 256.553802,425.698639 255.068741,425.136444 
	C251.155609,423.655121 249.554764,420.806885 249.381454,417.033142 
	C251.518509,417.710327 253.297974,418.348755 255.077454,418.987213 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M255.064880,418.627686 
	C253.297974,418.348755 251.518509,417.710327 249.371185,417.032166 
	C249.003342,416.992462 249.004715,416.976654 248.969269,416.630798 
	C247.866943,415.143890 246.690384,414.085205 245.757263,412.843567 
	C244.088013,410.622467 242.565430,408.291107 241.358063,406.003540 
	C242.487396,406.003662 243.240219,406.006104 243.993057,406.008545 
	C244.579544,406.494476 245.166046,406.980408 245.878113,408.107788 
	C247.346252,409.827148 248.688812,410.905060 250.031372,411.982941 
	C251.705017,414.078003 253.378647,416.173065 255.064880,418.627686 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M219.044067,390.985016 
	C219.044067,390.985016 218.637161,391.012451 218.434586,391.019470 
	C217.742950,388.672333 217.253906,386.318176 216.683258,383.556946 
	C216.869080,382.240326 217.136505,381.330719 217.530151,379.991882 
	C219.667862,381.371521 221.588669,382.611176 223.873810,383.790253 
	C224.657120,384.073395 225.076111,384.417114 225.722900,384.906311 
	C226.289551,386.141388 226.628387,387.231049 227.001556,388.665405 
	C226.584579,389.016113 226.133255,389.022095 225.167633,388.695984 
	C220.132629,385.996826 219.519073,386.283539 219.044067,390.985016 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M262.135803,424.870605 
	C266.337738,429.031921 270.539642,433.193237 274.895111,437.647308 
	C275.048645,437.940063 275.002655,437.993652 274.615936,438.000671 
	C272.829102,437.662018 271.428986,437.316376 269.963440,436.631714 
	C268.937195,435.859680 267.976379,435.426605 267.008911,434.995972 
	C267.002289,434.998352 267.002411,434.984833 266.902710,434.723145 
	C266.542236,433.966248 266.281494,433.471008 265.982910,432.624817 
	C264.624237,429.855377 263.303406,427.436829 262.020569,424.981018 
	C262.058533,424.943756 262.135803,424.870605 262.135803,424.870605 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M232.989014,400.998779 
	C232.007980,399.508453 230.820389,398.109009 230.111755,396.498810 
	C229.551773,395.226410 229.580444,393.694916 229.630707,392.119690 
	C232.540756,394.727295 235.167816,397.493652 237.914001,400.913879 
	C238.021912,402.048126 238.010696,402.528473 237.654114,402.954407 
	C235.873032,402.270325 234.437317,401.640656 233.000763,401.006287 
	C232.999908,401.001556 232.989014,400.998779 232.989014,400.998779 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M237.999481,403.008850 
	C238.010696,402.528473 238.021912,402.048126 238.070267,401.206421 
	C239.979095,402.362946 241.850784,403.880859 243.857758,405.703674 
	C243.240219,406.006104 242.487396,406.003662 241.081055,405.864380 
	C239.618195,404.821320 238.808838,403.915100 237.999481,403.008850 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M259.011627,424.983643 
	C258.658478,423.900055 258.305328,422.816467 257.940369,421.368073 
	C259.282837,422.072693 260.637115,423.142120 262.063599,424.541077 
	C262.135803,424.870605 262.058533,424.943756 261.649445,424.974060 
	C260.497437,424.997498 259.754547,424.990570 259.011627,424.983643 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M296.129028,462.067322 
	C295.470062,462.207764 295.045349,462.118622 294.304993,461.562622 
	C293.977142,460.079529 293.964935,459.063232 293.985107,458.011780 
	C294.017456,457.976593 294.079559,457.903870 294.079559,457.903870 
	C294.840820,459.215149 295.602051,460.526459 296.129028,462.067322 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M249.893387,411.694336 
	C248.688812,410.905060 247.346252,409.827148 246.002304,408.370667 
	C247.252411,409.129974 248.503906,410.267853 249.893387,411.694336 
z"
          />
          <path
            fill="#CACCC9"
            opacity="1.000000"
            stroke="none"
            d="
M291.044373,454.964050 
	C291.978180,455.749023 292.884705,456.557159 293.935425,457.634583 
	C294.079559,457.903870 294.017456,457.976593 293.620880,457.989197 
	C292.471069,457.013153 291.717834,456.024445 290.964600,455.035767 
	C290.964600,455.035767 291.017120,454.987213 291.044373,454.964050 
z"
          />
          <path
            fill="#F0F3F4"
            opacity="1.000000"
            stroke="none"
            d="
M116.034515,299.884308 
	C116.034508,296.572754 116.034508,293.261200 116.034508,289.806458 
	C121.703735,287.394684 123.454437,292.371063 126.193405,294.885742 
	C129.195801,297.642303 131.756149,300.880341 134.926682,304.367859 
	C131.792526,305.484192 128.927307,306.504730 125.983635,307.939880 
	C124.745338,307.735352 123.585495,307.116180 122.067200,306.005890 
	C119.817329,303.637939 117.925919,301.761108 116.034515,299.884308 
z"
          />
          <path
            fill="#DACFBB"
            opacity="1.000000"
            stroke="none"
            d="
M115.771988,299.921753 
	C117.925919,301.761108 119.817329,303.637939 121.767914,305.848938 
	C119.568810,304.360596 117.310532,302.538116 115.017838,300.371277 
	C115.158775,300.004395 115.334114,299.981812 115.771988,299.921753 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M249.013611,416.993439 
	C249.554764,420.806885 251.155609,423.655121 255.068741,425.136444 
	C256.553802,425.698639 257.545837,427.527679 258.802765,428.737518 
	C260.276184,430.155731 261.793427,431.528351 263.646912,432.959961 
	C264.002197,432.999146 264.012421,432.993927 264.062744,433.338654 
	C265.076202,434.117188 266.039307,434.550995 267.002411,434.984833 
	C267.002411,434.984833 267.002289,434.998352 267.006012,435.368042 
	C270.175140,439.577637 273.415558,443.359161 276.471985,447.283966 
	C277.847351,449.050079 278.855377,451.102295 279.659790,452.980103 
	C275.166779,451.651184 271.044159,450.366852 266.921509,449.082550 
	C266.921509,449.082550 266.987152,449.051331 266.955994,448.713409 
	C265.076630,443.904266 261.036407,442.919952 256.906799,442.077820 
	C256.906799,442.077820 256.990967,441.999817 256.942200,441.686340 
	C255.914169,440.924103 254.934906,440.475372 253.955658,440.026642 
	C253.376862,439.556915 252.798065,439.087189 252.059280,438.011780 
	C250.934906,436.937836 249.970535,436.469513 249.006149,436.001221 
	C248.054108,435.207520 247.102066,434.413818 246.010986,433.336731 
	C245.211395,431.177795 244.937775,429.022247 243.820023,427.477600 
	C239.992371,422.188141 235.586853,417.302155 231.953583,411.891693 
	C229.402618,408.092987 227.749893,403.691101 225.618088,399.401642 
	C227.759521,399.923920 229.973343,400.463837 232.588089,401.001282 
	C232.989014,400.998779 232.999908,401.001556 233.034134,401.351410 
	C237.758163,407.442291 241.415588,414.260406 249.004715,416.976654 
	C249.004715,416.976654 249.003342,416.992462 249.013611,416.993439 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M256.907166,442.384949 
	C261.036407,442.919952 265.076630,443.904266 266.921631,448.735382 
	C263.869843,447.421967 260.821320,445.748627 257.434052,443.990967 
	C257.032715,443.501801 256.970123,443.096954 256.907166,442.384949 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M254.080353,440.327515 
	C254.934906,440.475372 255.914169,440.924103 256.908691,441.732788 
	C256.017639,441.604645 255.111343,441.116516 254.080353,440.327515 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M249.117645,436.303223 
	C249.970535,436.469513 250.934906,436.937836 251.919266,437.765442 
	C251.035873,437.618256 250.132507,437.111755 249.117645,436.303223 
z"
          />
          <path
            fill="#EBE6DF"
            opacity="1.000000"
            stroke="none"
            d="
M280.030121,453.024689 
	C278.855377,451.102295 277.847351,449.050079 276.471985,447.283966 
	C273.415558,443.359161 270.175140,439.577637 267.012634,435.365631 
	C267.976379,435.426605 268.937195,435.859680 270.095276,436.937744 
	C271.855194,438.729645 273.417877,439.876495 274.980530,441.023376 
	C276.748169,442.993225 278.515808,444.963104 280.640869,447.324585 
	C281.665100,448.478455 282.331970,449.240723 282.998810,450.002991 
	C284.138336,451.563751 285.277832,453.124512 286.706848,455.239868 
	C286.900146,456.600372 286.803925,457.406342 286.707703,458.212280 
	C286.707703,458.212280 286.429169,458.400177 286.054749,458.012756 
	C284.697327,457.448090 283.714325,457.270874 282.731323,457.093658 
	C282.731323,457.093658 282.363800,457.115570 282.157898,456.717255 
	C281.311340,455.220856 280.670746,454.122772 280.030121,453.024689 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M279.659790,452.980103 
	C280.670746,454.122772 281.311340,455.220856 281.988068,456.646179 
	C279.322845,455.940155 276.621552,454.906891 273.566956,453.804565 
	C271.201752,452.391296 269.189850,451.047150 267.049744,449.392792 
	C271.044159,450.366852 275.166779,451.651184 279.659790,452.980103 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M286.743958,458.203308 
	C286.803925,457.406342 286.900146,456.600372 287.006531,455.388489 
	C288.070068,454.992340 289.123413,455.002136 290.570679,455.023834 
	C291.717834,456.024445 292.471069,457.013153 293.588531,458.024384 
	C293.964935,459.063232 293.977142,460.079529 293.992004,461.473572 
	C292.530762,461.369904 291.066833,460.888489 289.267914,459.873230 
	C288.234894,458.942291 287.536835,458.545197 286.838776,458.148102 
	C286.838776,458.148102 286.780182,458.194336 286.743958,458.203308 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M286.853455,458.479431 
	C287.536835,458.545197 288.234894,458.942291 288.995605,459.670044 
	C288.328217,459.604004 287.598145,459.207367 286.853455,458.479431 
z"
          />
          <path
            fill="#F4ECDA"
            opacity="1.000000"
            stroke="none"
            d="
M282.985474,457.368652 
	C283.714325,457.270874 284.697327,457.448090 285.900818,457.945435 
	C285.160767,458.058289 284.200195,457.850952 282.985474,457.368652 
z"
          />
          <path
            fill="#F8F9F9"
            opacity="1.000000"
            stroke="none"
            d="
M89.745956,188.805893 
	C94.399261,193.646591 92.106560,197.700745 89.140602,201.652756 
	C86.228142,201.403076 83.347122,201.156097 80.217621,200.887817 
	C78.758804,197.192596 77.372002,192.835709 81.103859,189.846008 
	C83.025764,188.306305 86.640320,188.879425 89.745956,188.805893 
z"
          />
          <path
            fill="#F4F7F6"
            opacity="1.000000"
            stroke="none"
            d="
M154.782043,178.996857 
	C151.638733,178.414810 148.917130,177.828766 146.080536,177.217941 
	C147.137436,172.371735 148.437881,168.514648 153.019333,169.250351 
	C155.187424,169.598526 157.305862,172.294357 158.643173,174.429779 
	C159.004410,175.006592 156.430420,177.421600 154.782043,178.996857 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M219.333588,391.121948 
	C219.519073,386.283539 220.132629,385.996826 224.829437,388.694580 
	C223.211411,389.769806 221.417267,390.514343 219.333588,391.121948 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M274.986633,440.650299 
	C273.417877,439.876495 271.855194,438.729645 270.160706,437.276764 
	C271.428986,437.316376 272.829102,437.662018 274.591919,438.026550 
	C274.967316,438.789337 274.980042,439.533295 274.986633,440.650299 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M282.974792,449.679871 
	C282.331970,449.240723 281.665100,448.478455 280.986938,447.363647 
	C281.634003,447.792969 282.292389,448.574860 282.974792,449.679871 
z"
          />
          <path
            fill="#D3D8DA"
            opacity="1.000000"
            stroke="none"
            d="
M259.152527,425.289734 
	C259.754547,424.990570 260.497437,424.997498 261.611450,425.011353 
	C263.303406,427.436829 264.624237,429.855377 265.647827,432.631897 
	C264.904572,432.991272 264.458496,432.992584 264.012421,432.993927 
	C264.012421,432.993927 264.002197,432.999146 264.003723,432.993256 
	C262.434662,430.523499 260.864044,428.059662 259.152527,425.289734 
z"
          />
          <path
            fill="#EBE6DF"
            opacity="1.000000"
            stroke="none"
            d="
M248.969269,416.630798 
	C241.415588,414.260406 237.758163,407.442291 233.034973,401.356140 
	C234.437317,401.640656 235.873032,402.270325 237.654114,402.954407 
	C238.808838,403.915100 239.618195,404.821320 240.704559,405.866699 
	C242.565430,408.291107 244.088013,410.622467 245.757263,412.843567 
	C246.690384,414.085205 247.866943,415.143890 248.969269,416.630798 
z"
          />
          <path
            fill="#EBE6DF"
            opacity="1.000000"
            stroke="none"
            d="
M264.062744,433.338654 
	C264.458496,432.992584 264.904572,432.991272 265.685699,432.982849 
	C266.281494,433.471008 266.542236,433.966248 266.902710,434.723145 
	C266.039307,434.550995 265.076202,434.117188 264.062744,433.338654 
z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
